// @ts-nocheck -- Generated file
import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client/react';
import * as ApolloReactHooks from '@apollo/client/react';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AnnotationType: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Date: { input: string | number | Date; output: number; }
  JSON: { input: any; output: any; }
  PropertyValue: { input: any; output: any; }
};

export type ApiKeyByLicenseKeyResult = {
  __typename?: 'APIKeyByLicenseKeyResult';
  apiKey: Scalars['String']['output'];
  organisationId: Scalars['String']['output'];
};

export enum ApiKeyType {
  Default = 'DEFAULT',
  WithLicenseKey = 'WITH_LICENSE_KEY'
}

export type AddAdditionalPointAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  pointCloudId: Scalars['String']['input'];
  pointIndex: Scalars['Int']['input'];
  position: InputPosition;
};

export type AddAreaAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  points: Array<InputPoint>;
};

export type AddBoxAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  position: InputPosition;
  rotation: InputPosition;
  scale: InputPosition;
};

export type AddCadLayerAction = {
  cadLayerId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddDistanceAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  points: Array<InputPoint>;
};

export type AddGroupAction = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  groupIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<GroupType>;
};

export type AddOrthophotoLayerAction = {
  identifier: Scalars['String']['input'];
  layerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AddPointAction = {
  annotationIdentifier: Scalars['String']['input'];
  classification?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<InputColor>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  intensity?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  pointCloudId?: InputMaybe<Scalars['String']['input']>;
  position: InputPosition;
};

export type AddPointClusterAction = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  segments: Array<InputSegment>;
};

export type AddRoomAction = {
  annotationIdentifier: Scalars['String']['input'];
  base: InputPlaneDefinition;
  ceiling: InputPlaneDefinition;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  polygon: Array<InputPosition>;
};

export type AddWallSketchAction = {
  annotationIdentifier: Scalars['String']['input'];
  edges: Array<InputSkeletonEdgeData>;
  floorHeight: Scalars['Float']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  nodes: Array<InputSkeletonNodeData>;
};

export type AddWmsLayerAction = {
  identifier: Scalars['String']['input'];
  layerId: Scalars['String']['input'];
  layerName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  type: WmsType;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type Annotation = {
  __typename?: 'Annotation';
  groupIdentifier?: Maybe<Scalars['String']['output']>;
  identifier: Scalars['ID']['output'];
  type: Scalars['AnnotationType']['output'];
};

export type AnnotationGroup = Group & {
  __typename?: 'AnnotationGroup';
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentIdentifier?: Maybe<Scalars['String']['output']>;
  type: GroupType;
};

export type ApiKey = {
  apiKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ApiKeyWithLicenseKey = ApiKey & {
  __typename?: 'ApiKeyWithLicenseKey';
  apiKey: Scalars['String']['output'];
  licenseKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * A simulation of superadminSetBillingDate with the same arguments: the term then renews on renewalDate and
 * runs until endDate; the months it gains are billed at the price of the plan it ends on, as a draft invoice;
 * the months it loses are not refunded. movesPendingChange: a change waiting at the end of the term (a cheaper
 * plan, the subscription's end) moves with it. odooLinked: the date is written to the Odoo subscription too.
 */
export type BillingDatePreview = {
  __typename?: 'BillingDatePreview';
  chargedCents: Scalars['Int']['output'];
  currentEndDate?: Maybe<Scalars['Date']['output']>;
  dueCents: Scalars['Int']['output'];
  endDate: Scalars['Date']['output'];
  monthlyPriceCents: Scalars['Int']['output'];
  monthsAdded: Scalars['Int']['output'];
  movesPendingChange: Scalars['Boolean']['output'];
  odooLinked: Scalars['Boolean']['output'];
  overridden: Scalars['Boolean']['output'];
  priceLocked: Scalars['Boolean']['output'];
  problems: Array<PlanChangeProblem>;
  renewalDate: Scalars['Date']['output'];
  subscriptionType: SubscriptionType;
};

/** What an invoice needs to know about the customer. Empty strings for what is not filled in yet. */
export type BillingInfo = {
  __typename?: 'BillingInfo';
  city: Scalars['String']['output'];
  companyName: Scalars['String']['output'];
  /** ISO 3166-1 alpha-2. */
  countryCode: Scalars['String']['output'];
  /** Where the invoices go. */
  email: Scalars['String']['output'];
  street: Scalars['String']['output'];
  street2?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
  zip: Scalars['String']['output'];
};

export type CadLayer = {
  __typename?: 'CadLayer';
  fileName: Scalars['String']['output'];
  fileUrl: Scalars['String']['output'];
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  visibleState: Array<CadLayerVisibleState>;
};

export type CadLayerVisibleState = CadLayerVisibleStateDelete | CadLayerVisibleStateHidden;

export type CadLayerVisibleStateDelete = {
  __typename?: 'CadLayerVisibleStateDelete';
  index: Scalars['Int']['output'];
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  isLayer?: Maybe<Scalars['Boolean']['output']>;
  layerIdentifier?: Maybe<Scalars['String']['output']>;
  subIndex?: Maybe<Scalars['Int']['output']>;
};

export type CadLayerVisibleStateHidden = {
  __typename?: 'CadLayerVisibleStateHidden';
  index: Scalars['Int']['output'];
  isGroup?: Maybe<Scalars['Boolean']['output']>;
  isLayer?: Maybe<Scalars['Boolean']['output']>;
  layerIdentifier?: Maybe<Scalars['String']['output']>;
  subIndex?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type Calculation = {
  annotationIdentifier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  pointCloudIdentifier: Scalars['String']['output'];
  status: GeneralStatus;
};

export enum CalculationBaseSurfaces {
  CustomHeight = 'CUSTOM_HEIGHT',
  Polygon = 'POLYGON'
}

export enum ClipMethods {
  Heatmap = 'HEATMAP',
  Hide = 'HIDE',
  Highlight = 'HIGHLIGHT',
  Isolate = 'ISOLATE'
}

export type Color = {
  __typename?: 'Color';
  a: Scalars['Int']['output'];
  b: Scalars['Int']['output'];
  g: Scalars['Int']['output'];
  r: Scalars['Int']['output'];
};

export type Comment = {
  __typename?: 'Comment';
  comment: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  referenceIdentifier: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  user?: Maybe<User>;
};

export type ConvertCadIdentifiers = {
  annotationIdentifier: Scalars['String']['input'];
  groupIdentifier: Scalars['String']['input'];
};

export type ConvertCadObjectAction = {
  cadObjects: Array<InputCadObject>;
  identifier: Scalars['String']['input'];
};

export type CreditLedgerEntry = {
  __typename?: 'CreditLedgerEntry';
  amount: Scalars['Int']['output'];
  /** A pending change that was cancelled after sales had posted its invoice: kept for the invoice's sake. */
  cancelledAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  /** PLAN_DOWNGRADE: the renewal date the change takes effect on. */
  effectiveAt?: Maybe<Scalars['Date']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  grantedBy?: Maybe<Scalars['ID']['output']>;
  /**
   * The account that made the row: a customer buying or changing their plan, or a superadmin. Null for what
   * the daily job writes (allowances, renewals) and rows from before it was recorded.
   */
  grantedByAccount?: Maybe<LedgerAccount>;
  id: Scalars['ID']['output'];
  invoice?: Maybe<Scalars['String']['output']>;
  /**
   * SUBSCRIPTION rows: how the fee is invoiced, and — through the Odoo subscription — the order that bills it
   * (the subscription for a term or renewal, the upsell for an upgrade).
   */
  invoiceVia?: Maybe<InvoiceVia>;
  note?: Maybe<Scalars['String']['output']>;
  /**
   * The invoice in Odoo for this row (the draft made for it, or the one Odoo's subscription generated), and
   * its page there. Internal: customers read the same rows.
   */
  odooInvoiceId?: Maybe<Scalars['Int']['output']>;
  /** The Odoo invoice's number once it is posted; null while it is a draft. */
  odooInvoiceNumber?: Maybe<Scalars['String']['output']>;
  odooInvoiceUrl?: Maybe<Scalars['String']['output']>;
  odooOrderId?: Maybe<Scalars['Int']['output']>;
  odooOrderUrl?: Maybe<Scalars['String']['output']>;
  organisationId: Scalars['ID']['output'];
  /** Whether the row's invoice is paid, as Odoo has it; null without an invoice, or for one cancelled or credited. */
  paymentStatus?: Maybe<InvoicePaymentStatus>;
  pointCountTotal?: Maybe<Scalars['Float']['output']>;
  /**
   * CHARGE rows, in the superadmin's full ledger: the project the credits were spent on (its name while it still
   * exists), the processing task, and the points it counted.
   */
  projectId?: Maybe<Scalars['ID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
  remaining?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of the invoice sales sent for this row from Odoo; null until it is sent (a draft, or posted but
   * not sent). Its PDF is then there to download through organisationInvoicePdf.
   */
  sentInvoiceNumber?: Maybe<Scalars['String']['output']>;
  /** CHARGE rows: the part that could not be funded when it settled (legacy debt). */
  shortfall?: Maybe<Scalars['Int']['output']>;
  source: CreditLedgerEntrySource;
  subscriptionId?: Maybe<Scalars['String']['output']>;
  /** SUBSCRIPTION rows: the plan the fee or the scheduled change is for. */
  subscriptionType?: Maybe<SubscriptionType>;
  /**
   * A priced pending change that a later change replaced from its day on: what it sold stays counted as covered,
   * but it never takes effect as such.
   */
  supersededAt?: Maybe<Scalars['Date']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  totalPriceCents?: Maybe<Scalars['Int']['output']>;
  type: CreditLedgerEntryType;
  /** Prices in cents. Absent when the entry was not priced. */
  unitPriceCents?: Maybe<Scalars['Int']['output']>;
};

/** Why an entry exists. Derived server-side so clients never match on notes. */
export enum CreditLedgerEntrySource {
  Charge = 'CHARGE',
  Manual = 'MANUAL',
  MonthlyAllowance = 'MONTHLY_ALLOWANCE',
  /** A downgrade scheduled for the renewal date (effectiveAt); stays in the history once applied. */
  PlanDowngrade = 'PLAN_DOWNGRADE',
  /** The monthly projects an upgrade added to the running period. */
  PlanUpgrade = 'PLAN_UPGRADE',
  Purchase = 'PURCHASE',
  /** The bonus projects earned at a referral milestone (10, 50, ... referred sales). */
  ReferralMilestone = 'REFERRAL_MILESTONE',
  /** The project earned for a subscription sale to an organisation this one referred. Individual project purchases earn nothing. */
  ReferralReward = 'REFERRAL_REWARD',
  /** The extra free project for signing up through a referral link. */
  ReferralWelcome = 'REFERRAL_WELCOME',
  /** Credits a superadmin took off a grant (superadmin history only): a charge without a project. */
  Removed = 'REMOVED',
  /** The fee of a term that renewed on the same plan, dated for the renewal day (effectiveAt). */
  Renewal = 'RENEWAL',
  /** An upgrade, or a term sold ahead of time, scheduled for effectiveAt with the fee it bills that day. */
  ScheduledUpgrade = 'SCHEDULED_UPGRADE',
  Subscription = 'SUBSCRIPTION',
  /** An upgrade taking effect now: the difference for the rest of the term, billed as an upsell on the Odoo subscription. */
  Upgrade = 'UPGRADE',
  Welcome = 'WELCOME'
}

export enum CreditLedgerEntryType {
  Charge = 'CHARGE',
  Grant = 'GRANT',
  Subscription = 'SUBSCRIPTION'
}

export type CreditsPurchasedNotification = Notification & {
  __typename?: 'CreditsPurchasedNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  /** The grant the purchase wrote, with its draft invoice in Odoo for sales to complete. */
  ledgerEntry?: Maybe<CreditLedgerEntry>;
  meta: CreditsPurchasedNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type CreditsPurchasedNotificationMeta = {
  __typename?: 'CreditsPurchasedNotificationMeta';
  amount: Scalars['Int']['output'];
  organisationName: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type CursorPaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomClass = {
  __typename?: 'CustomClass';
  code: Scalars['Int']['output'];
  color: Color;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * To a partner's admins (organisationId = the partner): a customer billed to it renews on renewsAt
 * (CUSTOMER_RENEWAL_DUE, the partner may still cancel), or renewed that day (CUSTOMER_RENEWED).
 */
export type CustomerRenewalNotification = Notification & {
  __typename?: 'CustomerRenewalNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: CustomerRenewalNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type CustomerRenewalNotificationMeta = {
  __typename?: 'CustomerRenewalNotificationMeta';
  customerName: Scalars['String']['output'];
  customerOrganisationId: Scalars['ID']['output'];
  renewsAt: Scalars['Date']['output'];
  subscriptionType: SubscriptionType;
};

export enum DateFormats {
  Ddmmyyyy = 'DDMMYYYY',
  Mmddyyyy = 'MMDDYYYY',
  Yyyymmdd = 'YYYYMMDD'
}

export type DebugDailyStep = {
  __typename?: 'DebugDailyStep';
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** One of Odoo's own subscription jobs (scheduled actions): it runs on Odoo's date, not a chosen one. */
export type DebugOdooCron = {
  __typename?: 'DebugOdooCron';
  active: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  nextCall?: Maybe<Scalars['String']['output']>;
};

export type DebugStepResult = {
  __typename?: 'DebugStepResult';
  durationMs: Scalars['Int']['output'];
  error?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  ok: Scalars['Boolean']['output'];
  /** What the step returned (a count, mostly), as JSON. */
  result?: Maybe<Scalars['String']['output']>;
};

export type DebugTools = {
  __typename?: 'DebugTools';
  enabled: Scalars['Boolean']['output'];
  /** Empty without Odoo, or when Odoo does not let the API user see its scheduled actions. */
  odooCrons: Array<DebugOdooCron>;
  steps: Array<DebugDailyStep>;
};

export type DefaultApiKey = ApiKey & {
  __typename?: 'DefaultApiKey';
  apiKey: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type DeleteAnnotationAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type DeleteAnnotationMultiAction = {
  identifier: Scalars['String']['input'];
  identifiers: Array<Scalars['String']['input']>;
};

export type DeleteCadLayerAction = {
  cadLayerIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type DeleteCadObjectAction = {
  cadLayerIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  subIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type DeleteCadObjectGroupAction = {
  cadLayerIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
};

export type DeleteGroupAction = {
  groupIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type DeleteOrthophotoLayerAction = {
  identifier: Scalars['String']['input'];
  orthophotoLayerIdentifier: Scalars['String']['input'];
};

export type DeletePointAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  pointIndex: Scalars['Int']['input'];
};

export type DeleteWmsLayerAction = {
  identifier: Scalars['String']['input'];
  wmsLayerIdentifier: Scalars['String']['input'];
};

export type DistanceProjection = {
  __typename?: 'DistanceProjection';
  distance: Scalars['Float']['output'];
  height: Scalars['Float']['output'];
};

export type EditBoxAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  position: InputPosition;
  rotation: InputPosition;
  scale: InputPosition;
};

export type EditPointClusterAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  segments: Array<InputSegment>;
};

export type EditRoomAction = {
  annotationIdentifier: Scalars['String']['input'];
  base: InputPlaneDefinition;
  ceiling: InputPlaneDefinition;
  identifier: Scalars['String']['input'];
  polygon: Array<InputPosition>;
};

export type EditWallSketchAction = {
  annotationIdentifier: Scalars['String']['input'];
  edges: Array<InputSkeletonEdgeData>;
  floorHeight: Scalars['Float']['input'];
  identifier: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  nodes: Array<InputSkeletonNodeData>;
};

export type Export = {
  __typename?: 'Export';
  createdAt?: Maybe<Scalars['Date']['output']>;
  exportId?: Maybe<Scalars['String']['output']>;
  fileSize?: Maybe<Scalars['BigInt']['output']>;
  paramInfo: ExportParamInfo;
  seen?: Maybe<Scalars['Boolean']['output']>;
  status: GeneralStatus;
  type: Scalars['String']['output'];
};

export type ExportParamInfo = PointCloudExportParamInfo;

/**
 * A point cloud whose conversion failed, for the superadmins to follow up. The names are kept from the time of
 * the failure, so a record stays readable after its project was deleted.
 */
export type FailedPointCloud = {
  __typename?: 'FailedPointCloud';
  cloudName: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  failureCount: Scalars['Int']['output'];
  fileNames: Array<Scalars['String']['output']>;
  firstFailedAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** What failed, when it is known (a failure of the whole project says what it was doing). */
  lastError?: Maybe<Scalars['String']['output']>;
  lastFailedAt: Scalars['Date']['output'];
  /** The Azure execution of the last failed conversion, to find its logs. */
  lastJobId?: Maybe<Scalars['String']['output']>;
  organisationId?: Maybe<Scalars['ID']['output']>;
  organisationName?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  projectName?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['Date']['output']>;
  sizeBytes?: Maybe<Scalars['Float']['output']>;
  status: FailedPointCloudStatus;
};

export type FailedPointCloudCounts = {
  __typename?: 'FailedPointCloudCounts';
  deleted: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
};

/**
 * Where a failed conversion stands: FAILED needs attention, RESOLVED converted after all (a relaunch), DELETED
 * was deleted while still failed.
 */
export enum FailedPointCloudStatus {
  Deleted = 'DELETED',
  Failed = 'FAILED',
  Resolved = 'RESOLVED'
}

/** How a subscription fee came about: the kind of plan change, or a renewal. */
export enum FeePricingKind {
  NewSubscription = 'NEW_SUBSCRIPTION',
  Renewal = 'RENEWAL',
  ScheduledDowngrade = 'SCHEDULED_DOWNGRADE',
  Unchanged = 'UNCHANGED',
  Upgrade = 'UPGRADE'
}

export enum FileTypes {
  E57 = 'E57',
  Las = 'LAS',
  Laz = 'LAZ',
  Ppc = 'PPC',
  Ppch = 'PPCH',
  Pts = 'PTS',
  Txt = 'TXT',
  TxtXyz = 'TXT_XYZ'
}

export type FilteredPropertyGroup = {
  __typename?: 'FilteredPropertyGroup';
  properties: Array<PropertyDefinition>;
  propertyIdentifier: Scalars['String']['output'];
};

export type Floor = Group & {
  __typename?: 'Floor';
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentIdentifier?: Maybe<Scalars['String']['output']>;
  type: GroupType;
};

export enum GeneralStatus {
  Error = 'ERROR',
  Progress = 'PROGRESS',
  Success = 'SUCCESS'
}

export type Group = {
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentIdentifier?: Maybe<Scalars['String']['output']>;
  type: GroupType;
};

export enum GroupType {
  Default = 'DEFAULT',
  Floor = 'FLOOR',
  Room = 'ROOM',
  Surface = 'SURFACE'
}

export type HideCadObjectAction = {
  cadLayerIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isLayer?: InputMaybe<Scalars['Boolean']['input']>;
  layerIdentifier?: InputMaybe<Scalars['String']['input']>;
  subIndex?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
};

export type InputBillingInfo = {
  city: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
  street: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
};

export type InputCadObject = {
  annotationIdentifier: Scalars['String']['input'];
  cadLayerId: Scalars['String']['input'];
  cadObjectGroupId: Scalars['String']['input'];
  color?: InputMaybe<InputColor>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  originalIdentifier?: InputMaybe<Scalars['String']['input']>;
  points?: InputMaybe<Array<InputPosition>>;
  position?: InputMaybe<InputPosition>;
  type: Scalars['String']['input'];
};

export type InputColor = {
  a: Scalars['Int']['input'];
  b: Scalars['Int']['input'];
  g: Scalars['Int']['input'];
  r: Scalars['Int']['input'];
};

export type InputObjectGroup = {
  cadLayerId: Scalars['String']['input'];
  cadObjects: Array<InputCadObject>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type InputPlaneDefinition = {
  normal: InputPosition;
  position: InputPosition;
};

export type InputPoint = {
  pointCloudId?: InputMaybe<Scalars['String']['input']>;
  position: InputPosition;
};

export type InputPosition = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
  z: Scalars['Float']['input'];
};

export type InputProjectAction = {
  DeleteAnnotationMultiAction?: InputMaybe<DeleteAnnotationMultiAction>;
  addAdditionalPointAction?: InputMaybe<AddAdditionalPointAction>;
  addAreaAction?: InputMaybe<AddAreaAction>;
  addBoxAction?: InputMaybe<AddBoxAction>;
  addCadLayerAction?: InputMaybe<AddCadLayerAction>;
  addDistanceAction?: InputMaybe<AddDistanceAction>;
  addGroupAction?: InputMaybe<AddGroupAction>;
  addOrthophotoLayerAction?: InputMaybe<AddOrthophotoLayerAction>;
  addPointAction?: InputMaybe<AddPointAction>;
  addPointClusterAction?: InputMaybe<AddPointClusterAction>;
  addRoomAction?: InputMaybe<AddRoomAction>;
  addSkeletonAction?: InputMaybe<AddWallSketchAction>;
  addWmsLayerAction?: InputMaybe<AddWmsLayerAction>;
  convertCadObjectAction?: InputMaybe<ConvertCadObjectAction>;
  deleteAnnotationAction?: InputMaybe<DeleteAnnotationAction>;
  deleteCadLayerAction?: InputMaybe<DeleteCadLayerAction>;
  deleteCadObjectAction?: InputMaybe<DeleteCadObjectAction>;
  deleteCadObjectGroupAction?: InputMaybe<DeleteCadObjectGroupAction>;
  deleteGroupAction?: InputMaybe<DeleteGroupAction>;
  deleteOrthophotoLayerAction?: InputMaybe<DeleteOrthophotoLayerAction>;
  deletePointAction?: InputMaybe<DeletePointAction>;
  deleteWmsLayerAction?: InputMaybe<DeleteWmsLayerAction>;
  editBoxAction?: InputMaybe<EditBoxAction>;
  editPointClusterAction?: InputMaybe<EditPointClusterAction>;
  editRoomAction?: InputMaybe<EditRoomAction>;
  editSkeletonAction?: InputMaybe<EditWallSketchAction>;
  hideCadObjectAction?: InputMaybe<HideCadObjectAction>;
  moveAnnotationsToGroupAction?: InputMaybe<MoveAnnotationsToGroupAction>;
  moveLineAction?: InputMaybe<MoveLineAction>;
  movePointAction?: InputMaybe<MovePointAction>;
  setAnnotationPointsAction?: InputMaybe<SetAnnotationPointsAction>;
  unGroupAction?: InputMaybe<UnGroupAction>;
  updateNameAction?: InputMaybe<UpdateNameAction>;
  updatePositionAction?: InputMaybe<UpdatePositionAction>;
  updatePositionOrthophotoLayerAction?: InputMaybe<UpdatePositionOrthophotoLayerAction>;
  updatePositionWmsLayerAction?: InputMaybe<UpdatePositionWmsLayerAction>;
  updateWmsLayerAction?: InputMaybe<UpdateWmsLayerAction>;
};

export type InputProjectDebugState = {
  /** Projects already settled for it; left out, unchanged. */
  creditsCharged?: InputMaybe<Scalars['Int']['input']>;
  /** False takes the waiver off (charged like any project again), true makes it free; left out, unchanged. */
  creditsWaived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Total points of the converted point clouds; left out, they stay as they are. */
  pointCount?: InputMaybe<Scalars['Float']['input']>;
  uploadStatus: UploadStatus;
};

export type InputProjectSettings = {
  projectionSystem?: InputMaybe<Scalars['String']['input']>;
};

export type InputReferralSettings = {
  customersCanCancel?: InputMaybe<Scalars['Boolean']['input']>;
  firstCutBasisPoints: Scalars['Int']['input'];
  minPayoutCents?: InputMaybe<Scalars['Int']['input']>;
  payoutCadence: ReferralPayoutCadence;
  recurringCutBasisPoints: Scalars['Int']['input'];
  role: ReferralRole;
};

export type InputSegment = {
  pointcloudId: Scalars['String']['input'];
  segmentId: Scalars['Int']['input'];
};

export type InputSkeletonEdgeData = {
  endNodeId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  leftSize: Scalars['Float']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  rightSize: Scalars['Float']['input'];
  roomIds: Array<Scalars['String']['input']>;
  startNodeId: Scalars['String']['input'];
  wallType: SkeletonWallType;
};

export type InputSkeletonNodeData = {
  edgeIds: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['String']['input']>;
  position: InputPosition;
  roomIds: Array<Scalars['String']['input']>;
};

export type InputSubscriptionCustomLimits = {
  monthlyCredits?: InputMaybe<Scalars['Int']['input']>;
  projectUnitPrice?: InputMaybe<Scalars['Int']['input']>;
  subscriptionPrice?: InputMaybe<Scalars['Int']['input']>;
};

/** Within a filter the values add up (any of them); the filters narrow each other. An empty list filters nothing. */
export type InputSuperadminOrganisationFilters = {
  acquiredBy?: InputMaybe<Array<PartnerRelationFilter>>;
  billedTo?: InputMaybe<Array<PartnerRelationFilter>>;
  managedBy?: InputMaybe<Array<PartnerRelationFilter>>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The organisation's own role (CUSTOMER also matches organisations without one). */
  partnerRole?: InputMaybe<Array<ReferralRole>>;
  subscriptionStatus?: InputMaybe<Array<SubscriptionStatusFilter>>;
  /** FLEX also matches organisations without a subscription. */
  subscriptionType?: InputMaybe<Array<SubscriptionType>>;
};

export type InputUser = {
  agreeReceiveNews?: InputMaybe<Scalars['Boolean']['input']>;
  agreeTerms?: InputMaybe<Scalars['Boolean']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type InviteInfo = {
  __typename?: 'InviteInfo';
  email: Scalars['String']['output'];
  inviteId?: Maybe<Scalars['String']['output']>;
  isNewUser: Scalars['Boolean']['output'];
  organisationName: Scalars['String']['output'];
};

export type InvoiceCounts = {
  __typename?: 'InvoiceCounts';
  cancelled: Scalars['Int']['output'];
  draft: Scalars['Int']['output'];
  noInvoice: Scalars['Int']['output'];
  paid: Scalars['Int']['output'];
  unpaid: Scalars['Int']['output'];
};

export enum InvoicePaymentStatus {
  Paid = 'PAID',
  /** Part of it is paid. */
  Partial = 'PARTIAL',
  Unpaid = 'UNPAID'
}

export type InvoicePdf = {
  __typename?: 'InvoicePdf';
  base64: Scalars['String']['output'];
  filename: Scalars['String']['output'];
};

/**
 * Where an invoiced sale stands for sales. NO_INVOICE: none made in Odoo yet. DRAFT: made, still to send.
 * UNPAID: sent, (part of it) still due. PAID. CANCELLED: cancelled or reversed in Odoo.
 */
export enum InvoiceTrackingStatus {
  Cancelled = 'CANCELLED',
  Draft = 'DRAFT',
  NoInvoice = 'NO_INVOICE',
  Paid = 'PAID',
  Unpaid = 'UNPAID'
}

/**
 * How a subscription fee is invoiced: a draft invoice Pointorama makes in Odoo, or the invoice Odoo's own
 * subscription generates for the cycle or the upsell.
 */
export enum InvoiceVia {
  Draft = 'DRAFT',
  OdooSubscription = 'ODOO_SUBSCRIPTION'
}

export enum Language {
  De = 'DE',
  En = 'EN',
  Fr = 'FR',
  Ja = 'JA',
  Nl = 'NL',
  Pt = 'PT'
}

export type LedgerAccount = {
  __typename?: 'LedgerAccount';
  isSuperAdmin: Scalars['Boolean']['output'];
  /**
   * Full name, or the email without one. Null for a superadmin's account when a customer asks: Pointorama
   * did it.
   */
  name?: Maybe<Scalars['String']['output']>;
};

export enum MeasurementUnits {
  Feet = 'FEET',
  Meters = 'METERS'
}

export type MonthlyAllowance = {
  __typename?: 'MonthlyAllowance';
  remaining: Scalars['Int']['output'];
  /** End of the current subscription period: unused allowance vanishes and the next one is granted. */
  renewsAt: Scalars['Date']['output'];
  total: Scalars['Int']['output'];
};

export type MoveAnnotationsToGroupAction = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
};

export type MoveLineAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  p1: InputPosition;
  p2: InputPosition;
  pointCloudId: Scalars['String']['input'];
};

export type MovePointAction = {
  annotationIdentifier: Scalars['String']['input'];
  classification?: InputMaybe<Scalars['Int']['input']>;
  color?: InputMaybe<InputColor>;
  identifier: Scalars['String']['input'];
  intensity?: InputMaybe<Scalars['Float']['input']>;
  pointCloudId: Scalars['String']['input'];
  pointIndex: Scalars['Int']['input'];
  position: InputPosition;
};

export type Mutation = {
  __typename?: 'Mutation';
  createApiKey: Organisation;
  /**
   * Sets the next invoice date of the organisation's linked Odoo subscription to today, so Odoo's recurring invoice job
   * renews it on its next run. Fails with NO_ODOO_ORDER without a linked order.
   */
  debugMakeOdooOrderDue: Organisation;
  /**
   * Runs the daily job (all of its steps, or those named) as if it were `now`, the way the cron does every night.
   * Fails with JOB_BUSY while a run holds the job's lock.
   */
  debugRunDailyJob: Array<DebugStepResult>;
  /** Runs one of Odoo's subscription jobs now (Odoo's "Run manually"). Fails with NOT_A_SUBSCRIPTION_JOB for any other. */
  debugRunOdooCron: Scalars['Boolean']['output'];
  deleteApiKey: Organisation;
  navvisAuthenticate: NavVisAuthResult;
  navvisImportDataset: Project;
  notificationsDelete: Scalars['Boolean']['output'];
  notificationsDeleteAll: Scalars['Boolean']['output'];
  notificationsMarkAsRead: Scalars['Boolean']['output'];
  /**
   * Makes an older (or the latest) published version what projects render, without a new publish. A draft without
   * unpublished changes follows along; one with changes is kept. Fails with NOT_FOUND for an unknown version and
   * MISSING_ASSET when its 3D model is gone.
   */
  objectDefinitionActivateVersion: ObjectDefinition;
  /**
   * Records a blob uploaded with organisationObjectLibraryUploadSAS as an asset of the definition. Fails with
   * NOT_FOUND when the blob is not in the organisation's container.
   */
  objectDefinitionAttachAsset: ObjectDefinitionAsset;
  /**
   * A new draft: from a template, a copy of a built-in type (basedOnBuiltinId) or of another definition
   * (duplicateOfDefinitionId, whose assets are shared), or blank. smart makes it a smart object (AI-designed).
   * Fails with INVALID_SPEC listing the issues.
   */
  objectDefinitionCreate: ObjectDefinition;
  /**
   * Deletes a definition that was never published. Published ones may be placed in projects: archive them instead
   * (fails with PUBLISHED).
   */
  objectDefinitionDelete: Scalars['Boolean']['output'];
  /** Removes a version from the history. The active version cannot be deleted (fails with ACTIVE_VERSION). */
  objectDefinitionDeleteVersion: Scalars['Boolean']['output'];
  /** Throws away unpublished edits: the draft becomes the published spec again. Fails with NOT_PUBLISHED on a draft. */
  objectDefinitionDiscardDraft: ObjectDefinition;
  /**
   * Asks the AI (Claude) to design an object from a description (prompt, max 4000 characters) and an optional
   * reference image (data URL: png, jpeg, webp or gif, at most 4 MB). With spec, the AI modifies that spec instead of
   * starting over. kind picks what to design (default OBJECT; with spec, the spec's own kind — a different kind fails
   * with KIND_MISMATCH): doors and windows get their own instructions and always come back as that kind.
   * Nothing is stored: the caller creates or saves the returned spec. Per-user rate limited.
   * Fails with AI_NOT_CONFIGURED (no API key on the server), INVALID_PROMPT, INVALID_SPEC, INVALID_IMAGE,
   * RATE_LIMITED, AI_UNAVAILABLE, AI_REFUSED, AI_OFF_TOPIC (not an object request; the reason is in the extensions) or AI_INVALID_SPEC (no valid spec after several attempts; the last
   * issues are in the extensions), INVALID_PROGRESS_CHANNEL. With progressChannel (a random client id matching
   * [a-z0-9-]{16,64}) live progress is sent as Pusher event "progress" on the public channel object-ai-<id>:
   * { stage: thinking|drawing|checking|fixing|done|failed, attempt, maxAttempts, thought?, chars?, issues?, name?, elapsedMs }.
   */
  objectDefinitionGenerate: ObjectDefinitionGeneration;
  /**
   * Makes the draft what projects render (every placed object of this type updates). Fails with MISSING_ASSET when
   * the spec's 3D model is not one of the definition's assets.
   */
  objectDefinitionPublish: ObjectDefinition;
  /**
   * Makes an older published version the draft (projects keep the current version until it is published again).
   * Fails with NOT_FOUND for an unknown version.
   */
  objectDefinitionRestoreVersion: ObjectDefinition;
  /** Saves the draft (autosave). Fails with INVALID_SPEC listing the issues; the stored draft is then unchanged. */
  objectDefinitionSaveDraft: ObjectDefinition;
  objectDefinitionSetArchived: ObjectDefinition;
  objectDefinitionUpdateDetails: ObjectDefinition;
  /**
   * Stops the subscription from renewing: the running term keeps its plan and monthly projects until its end date,
   * then the organisation is on FLEX.
   */
  organisationCancelSubscription: Organisation;
  /**
   * Moves the organisation to a standard plan (LAUNCH, GROW, SCALE) by itself: an upgrade takes effect today and is
   * invoiced now; a cheaper plan takes effect at the end of the term; the current plan again, while a cheaper one is
   * scheduled, cancels that. Fails with SAME_PLAN when nothing would change, INVALID_PLAN for any other plan,
   * BILLING_INFO_MISSING while the billing details are incomplete.
   */
  organisationChangePlan: Organisation;
  /** Sends a message from an organisation member to every superadmin (sales). */
  organisationContactSales: Scalars['Boolean']['output'];
  organisationCreate: Organisation;
  organisationDelete: Scalars['Boolean']['output'];
  /**
   * Links an organisation without a customer in Odoo: to the customer sales made from its registration lead, else an
   * existing one with its owner's email, else a new one attached to its registration lead. An organisation without a
   * lead and without a match is not given one: linked stays false, and it is for sales to make.
   */
  organisationLinkBilling: OrganisationBilling;
  organisationObjectLibraryUpdateConfig: ObjectLibraryConfig;
  /**
   * Adds a font uploaded under print-brand/ to the brand kit. TrueType or OpenType only, at most 10 MB. Fails with
   * INVALID_FILE, TOO_LARGE or TOO_MANY_FONTS.
   */
  organisationPrintFontAttach: TemplateLibraryConfig;
  organisationPrintFontRemove: TemplateLibraryConfig;
  /** Fails with BILLING_INFO_MISSING while the organisation's billing details are incomplete. */
  organisationPurchaseCredits: CreditLedgerEntry;
  /**
   * A reseller or full-service partner makes an organisation for a customer it brings in: acquired by (and billed to,
   * and for a full-service partner managed by) the partner from now on, empty, with the people at the addresses
   * invited as its admins (none is fine: people can be invited later). Fails with NOT_PARTNER for any other
   * organisation, ALREADY_EXISTS on a name that is taken, INVALID_EMAIL on a malformed address.
   */
  organisationReferralCustomerCreate: ReferralOverview;
  /** Makes the organisation's referral link, once: the token never changes afterwards. */
  organisationReferralLinkGenerate: ReferralOverview;
  /**
   * Sets the brand logo from a blob uploaded under print-brand/ (PNG, JPEG or SVG, at most 20 MB), or removes it
   * (blobName null).
   */
  organisationTemplateLibrarySetLogo: TemplateLibraryConfig;
  organisationTemplateLibraryUpdateConfig: TemplateLibraryConfig;
  organisationUpdate: Organisation;
  /**
   * Writes the billing details to the organisation's customer in Odoo (linked first, as organisationLinkBilling does, when
   * it is not yet). Fails with NO_ODOO_CUSTOMER when there is none to link, INVALID_VAT when Odoo refuses the VAT number,
   * INVALID_COUNTRY for a country code Odoo does not know.
   */
  organisationUpdateBilling: OrganisationBilling;
  organizationBatchUpdateProperties: Scalars['Boolean']['output'];
  organizationUpdateProperty: Scalars['Boolean']['output'];
  /** The partner cancels a customer's subscription at the end of its term (organisationCancelSubscription). */
  partnerCustomerCancelSubscription: ReferralOverview;
  /**
   * The partner orders a plan change for a customer billed to it, as the customer would (organisationChangePlan).
   * Answers with the partner's overview.
   */
  partnerCustomerChangePlan: ReferralOverview;
  /** The partner invites people into a customer billed to it, as its admins. Fails with INVALID_EMAIL on a malformed address. */
  partnerCustomerInviteUsers: Scalars['Boolean']['output'];
  /** The partner pauses or resumes a customer's running term. */
  partnerCustomerPauseSubscription: ReferralOverview;
  /** The partner buys extra projects for a customer billed to it (organisationPurchaseCredits). */
  partnerCustomerPurchaseCredits: ReferralOverview;
  /** The partner moves a customer's billing date, at the computed price. */
  partnerCustomerSetBillingDate: ReferralOverview;
  /**
   * Records a blob uploaded with organisationTemplateLibraryUploadSAS (under print-templates/<templateId>/) as an
   * image of the template. PNG, JPEG or SVG, at most 20 MB. Fails with NOT_FOUND, INVALID_FILE or TOO_LARGE.
   */
  printTemplateAttachAsset: PrintTemplateAsset;
  /**
   * A new draft: a copy of a built-in (basedOnBuiltinId) or of another template (duplicateOfTemplateId, whose assets are
   * shared), or the given spec. Fails with INVALID_SPEC listing the issues.
   */
  printTemplateCreate: PrintTemplate;
  /**
   * Deletes a template that was never published. Published ones may be pinned by sheets: archive them instead
   * (fails with PUBLISHED).
   */
  printTemplateDelete: Scalars['Boolean']['output'];
  /**
   * Removes a version from the history. Fails with LATEST_VERSION for the latest publish and VERSION_IN_USE when
   * sheets pin it (sheetCount in the extensions).
   */
  printTemplateDeleteVersion: Scalars['Boolean']['output'];
  /** Throws away unpublished edits. Fails with NOT_PUBLISHED on a never-published template. */
  printTemplateDiscardDraft: PrintTemplate;
  /**
   * Designs a template from a description (or changes the given spec) with the AI; stores nothing. Optional reference
   * image (data URL). Live progress on the Pusher channel object-ai-<progressChannel>. Fails with INVALID_PROMPT,
   * INVALID_SPEC, INVALID_IMAGE, INVALID_PROGRESS_CHANNEL, RATE_LIMITED, AI_NOT_CONFIGURED, AI_UNAVAILABLE, AI_REFUSED,
   * AI_OFF_TOPIC or AI_INVALID_SPEC.
   */
  printTemplateGenerate: PrintTemplateGeneration;
  /**
   * Publishes the draft as a new version (new sheets pin it; existing sheets keep theirs until upgraded). Fails with
   * MISSING_ASSET when an image or font the spec uses is not in the template / brand kit.
   */
  printTemplatePublish: PrintTemplate;
  /** Makes an older published version the draft. Fails with NOT_FOUND for an unknown version. */
  printTemplateRestoreVersion: PrintTemplate;
  /** Saves the draft (autosave). Fails with INVALID_SPEC listing the issues; the stored draft is then unchanged. */
  printTemplateSaveDraft: PrintTemplate;
  printTemplateSetArchived: PrintTemplate;
  printTemplateUpdateDetails: PrintTemplate;
  projectActivate: Project;
  projectAddComment: Project;
  projectAddCustomClass: Project;
  projectAddGuest: User;
  projectBatchupdateProperties: Project;
  projectChargeCredits: Project;
  projectCloneFromCloud: Project;
  projectConfirmPointCloudUpload?: Maybe<Scalars['Boolean']['output']>;
  projectConvertCadObject: Project;
  /**
   * A soft copy into another organisation (COPY tag), linked to the source's storage container. Superadmins copy into
   * any organisation; a partner copies a referred organisation's project into its own.
   */
  projectCopyToOrganisation: Project;
  projectCreateAnnotation: Project;
  projectCreateCadLayer: Project;
  projectCreateGroup: Project;
  projectCreateOrthophotoLayer: Project;
  projectCreateWmsLayer: Project;
  projectDelete: Scalars['Boolean']['output'];
  projectDeleteCadLayer: Project;
  projectDeleteCadObject: Project;
  projectDeleteCadObjectGroup: Project;
  projectDeleteCalculation: Project;
  projectDeleteComment: Project;
  projectDeleteCustomClass: Project;
  projectDeleteExport: Project;
  projectDeleteOrthophotoLayer: Project;
  projectDeleteSelected: Project;
  projectDeleteWmsLayer: Project;
  /** A duplicate in the same organisation, linked to the source's storage container (no blob copy). */
  projectDuplicate: Project;
  projectEditComment: Project;
  projectEditCustomClassColor: Project;
  projectEditCustomClassName: Project;
  projectEditLayerElevation: Project;
  /** Exporting is viewing in another format: any viewer may start one, share-link visitors included. */
  projectExportPointcloud: Project;
  projectGenerateClassifications: Project;
  projectHideCadObject: Project;
  projectInitialize: Project;
  projectMarkExportsSeen: Project;
  projectMoveAnnotationsToGroup: Project;
  projectPointCloudDelete: Project;
  /**
   * Superadmin: rebuild one point cloud from its own source files, the project's other point clouds untouched.
   * Submitted before it returns, so the answer shows it processing. Costs the organisation nothing, like
   * projectRelaunch.
   */
  projectPointCloudRelaunch: Project;
  projectProjectionCalculate: Project;
  /**
   * Rebuilds the project's point clouds from their source files: a superadmin's, or a partner's on a failed project of
   * an organisation it referred (fails with NOT_IN_ERROR otherwise; only a superadmin's relaunch is free of charge).
   */
  projectRelaunch: Project;
  projectRemoveGuest: User;
  projectSetGuestAccessLevel: User;
  projectShareReset: Project;
  projectShareSet: Project;
  /**
   * A new sheet pinning the template's latest published version. Fails with UNKNOWN_TEMPLATE for a hidden built-in or
   * an organisation template that isn't published.
   */
  projectSheetCreate: ProjectSheet;
  projectSheetDelete: Scalars['Boolean']['output'];
  projectSheetDuplicate: ProjectSheet;
  /** Records that the sheet was exported to PDF (shown in the sheet list). */
  projectSheetMarkExported: ProjectSheet;
  projectSheetRename: ProjectSheet;
  /**
   * Saves the document (autosave). expectedUpdatedAt is the updatedAt the editor last loaded: fails with CONFLICT when
   * someone else saved in between, INVALID_DOC (issues in the extensions) or TEMPLATE_CHANGED when the doc pins another
   * template (use projectSheetUpgradeTemplate).
   */
  projectSheetSave: ProjectSheet;
  /**
   * Pins the template's latest published version. Viewport settings and field values are kept (the client lists those
   * the new version no longer uses). Fails with UNKNOWN_TEMPLATE when the organisation template is gone.
   */
  projectSheetUpgradeTemplate: ProjectSheet;
  projectStart: Project;
  /** Pre-built Pythagoras export (superadmin-only). pointCount comes from the export's header and sets the credit tier. */
  projectStartWithPythagorasFiles: Project;
  projectToggleObjectVisibility: Project;
  projectUngroup: Project;
  projectUpdate: Project;
  projectUpdateEntityName: Project;
  projectUpdateOrdering: Project;
  projectUpdateOrthophotoLayerOrdering: Project;
  projectUpdatePreviewImage: Project;
  projectUpdateProperty: Project;
  projectUpdateSettings: Project;
  projectUpdateWmsLayer: Project;
  projectUpdateWmsLayerOrdering: Project;
  projectValidatePointCloud: Project;
  projectVolumeCalculate: Project;
  /**
   * Cancels the subscription. By default at the end of the term: it runs to its end, then ends instead of
   * renewing (the Odoo subscription ends that day). immediately voids the term now: its monthly projects are
   * removed, the organisation is on pay-as-you-go from today, the Odoo subscription ends today; nothing is
   * refunded or credited. Fails with NO_ACTIVE_SUBSCRIPTION without a running term.
   */
  superadminCancelSubscription: Organisation;
  /** Makes the draft invoice in Odoo for a priced history row that has none (Odoo was down, or the row predates invoicing). */
  superadminCreateOdooInvoice: CreditLedgerEntry;
  /**
   * Makes the organisation's customer in Odoo from what the organisation is (its name, its owner's email) —
   * for one without a registration lead, which the automatic link never makes one for. Never a duplicate: a
   * customer found after all (on the lead, or by email) is linked instead.
   */
  superadminCreateOdooPartner: Organisation;
  /**
   * Pays out everything payable now as one payout with its draft vendor bill, whatever the minimum; null when
   * nothing is payable.
   * Fails with PAYOUT_BUSY while the daily job is paying the organisation out.
   */
  superadminCreateReferralPayout?: Maybe<ReferralPayout>;
  /**
   * Debug tool: puts the project in the state given, to try every state without uploading. The point count goes
   * on the first converted point cloud (the others get none); with none converted, the first point cloud is marked
   * converted to carry it. Fails with NO_POINT_CLOUD for a project without any. Nothing is charged or settled; what
   * is overwritten is kept in the audit log.
   */
  superadminDebugSetProjectState: Project;
  /**
   * expiresAt is a calendar day: the credits last until the end of it; without it they never expire. A price makes
   * the grant a sale, with its draft invoice in Odoo like any other; 0 or no price makes it free.
   */
  superadminGrantCredits: CreditLedgerEntry;
  /**
   * An organisation made for a customer: empty, with the people at the addresses invited as its admins (none is fine:
   * it can be set up first and people invited later). Fails with ALREADY_EXISTS on a name that is taken,
   * INVALID_EMAIL on a malformed address.
   */
  superadminOrganisationCreate: Organisation;
  /**
   * Pauses the running term (paused: true) or resumes it: the same pause sales makes in Odoo, written there
   * first. Paused, the customer is blocked (no uploads, nothing ordered) while the term runs on: projects are
   * granted, changes apply and it renews as usual. Resumed, the block is lifted; no date moves. Already so: no change.
   * Fails with NO_ACTIVE_SUBSCRIPTION when there is no running term to pause.
   */
  superadminPauseSubscription: Organisation;
  /**
   * Forgets what is cached from Odoo about the organisation's invoices (numbers, payment status), so the
   * history read next shows them as Odoo has them now. True when done.
   */
  superadminRefreshInvoices: Scalars['Boolean']['output'];
  /** Attributes the organisation's referred sales and asks Odoo which are paid, now rather than on the next daily run. */
  superadminRefreshReferrals: ReferralHistory;
  /**
   * Takes unspent credits off one grant and returns the grant. Fails with INSUFFICIENT_REMAINING when the grant
   * no longer holds that many (they were spent meanwhile). Invoices are not touched: crediting one is for sales.
   */
  superadminRemoveCredits: CreditLedgerEntry;
  /**
   * Confirms the organisation's billing details are left blank on purpose (blank: true), or takes that back: while
   * they are incomplete, nothing is sold from the admin panel until someone either fills them in or says so —
   * the sale then goes ahead, free. Saving details clears it by itself.
   */
  superadminSetBillingBlank: OrganisationBilling;
  /**
   * Moves the billing date: the term renews on renewalDate (a calendar day) and runs until the day before, in
   * Odoo too (the subscription's next invoice date — written first; refused there, nothing moves here). The
   * months gained are billed as superadminBillingDatePreview says, chargeCents replacing the computed fee;
   * months lost are not refunded. Fails with the preview's first problem.
   */
  superadminSetBillingDate: Organisation;
  /**
   * The subscription order in Odoo that bills the organisation's running term — for the terms the daily
   * matcher could not pair with sales' subscription (none, or several, for the customer). Checked against
   * Odoo; the organisation's customer is taken from it when it has none. null unlinks.
   */
  superadminSetOdooOrder: Organisation;
  /** The Odoo customer an organisation's invoices are made out to; null clears it (the next invoice finds or makes one again). */
  superadminSetOdooPartner: Organisation;
  /**
   * Links the organisation to the partner by hand, as if the partner had made or referred it: acquired by it, and
   * managed by and billed to it where its role says (the other relations back to Pythagoras / the organisation
   * itself, taking it from any partner it had). Unlinked, every relation with the partner is dropped. A relation that
   * changes dates from now: sales already attributed stay where they are. Fails with SELF_REFERRAL for an
   * organisation linked to itself.
   */
  superadminSetPartnerLink: Organisation;
  /**
   * The organisation's role, cuts (basis points, 0..10000; a CUSTOMER's are always 0), payout cadence, minimum payout
   * (cents; omitted keeps the current one) and whether its billed customers may cancel themselves. Earlier sales
   * keep the role and cut they were attributed with. A new role reapplies to every customer linked to it: managed
   * by and billed to it where the role takes that on, back to Pythagoras / the customer itself where it no longer does.
   */
  superadminSetReferralSettings: Organisation;
  /**
   * Unlocks a project waiting for projects without charging the organisation: its tier is claimed for free and it
   * is activated. Also marks a project that is not waiting as free, so a later conversion never parks it.
   */
  superadminUnlockProject: Project;
  /**
   * Applies the change superadminPlanChangePreview describes for the same arguments. effectiveAt is the day the
   * change takes effect (today, or a later day — it then waits for it); endDate the last day of the term after
   * it; chargeCents replaces the computed fee. All default to the preview's values. force voids the current term now
   * (the customer did not pay for it): its monthly projects are removed, nothing of it counts as paid, and the change
   * starts a fresh term — or ends the subscription, for FLEX — instead of waiting for the end of the term.
   */
  superadminUpdatePlan: Organisation;
  userAcceptInvitation?: Maybe<Scalars['Boolean']['output']>;
  userAddToOrganisation: User;
  userBatchUpdateProperties: Scalars['Boolean']['output'];
  userChangeDateFormat: User;
  userChangeLanguage: User;
  userChangeRole: User;
  userChangeUnits: User;
  userDeleteFromOrganisation: Scalars['Boolean']['output'];
  userDisable: User;
  userEnable: User;
  userResendInvitation: User;
  /**
   * Grants or takes back a member's right to edit the object library. Fails with NOT_A_MEMBER for admins (they
   * always have it) and guests (never).
   */
  userSetObjectLibraryAccess: User;
  /**
   * Grants or takes back a member's right to edit the print templates. Fails with NOT_A_MEMBER for admins (they always
   * have it) and guests (never).
   */
  userSetTemplateLibraryAccess: User;
  userUpdate: User;
  userUpdateFavorites: User;
  userUpdateProperty: Scalars['Boolean']['output'];
};


export type MutationCreateApiKeyArgs = {
  keyType: ApiKeyType;
  licenseKey?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationDebugMakeOdooOrderDueArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationDebugRunDailyJobArgs = {
  now: Scalars['Date']['input'];
  steps?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationDebugRunOdooCronArgs = {
  cronId: Scalars['Int']['input'];
};


export type MutationDeleteApiKeyArgs = {
  apiKey: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationNavvisAuthenticateArgs = {
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationNavvisImportDatasetArgs = {
  accessToken: Scalars['String']['input'];
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  datasetName: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  projectDescription?: InputMaybe<Scalars['String']['input']>;
  projectName: Scalars['String']['input'];
  referenceSystemId?: InputMaybe<Scalars['BigInt']['input']>;
  siteId: Scalars['BigInt']['input'];
  siteName: Scalars['String']['input'];
};


export type MutationNotificationsDeleteArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationNotificationsMarkAsReadArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationObjectDefinitionActivateVersionArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationObjectDefinitionAttachAssetArgs = {
  blobName: Scalars['String']['input'];
  definitionId: Scalars['ID']['input'];
  kind: ObjectDefinitionAssetKind;
  organisationId: Scalars['ID']['input'];
  originalName: Scalars['String']['input'];
};


export type MutationObjectDefinitionCreateArgs = {
  basedOnBuiltinId?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  duplicateOfDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  smart?: InputMaybe<Scalars['Boolean']['input']>;
  spec: Scalars['JSON']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationObjectDefinitionDeleteArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationObjectDefinitionDeleteVersionArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationObjectDefinitionDiscardDraftArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationObjectDefinitionGenerateArgs = {
  image?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ObjectDefinitionKind>;
  organisationId: Scalars['ID']['input'];
  progressChannel?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  spec?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationObjectDefinitionPublishArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationObjectDefinitionRestoreVersionArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationObjectDefinitionSaveDraftArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  spec: Scalars['JSON']['input'];
};


export type MutationObjectDefinitionSetArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationObjectDefinitionUpdateDetailsArgs = {
  categoryId: Scalars['String']['input'];
  definitionId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};


export type MutationOrganisationCancelSubscriptionArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationChangePlanArgs = {
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
};


export type MutationOrganisationContactSalesArgs = {
  message: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationCreateArgs = {
  name: Scalars['String']['input'];
};


export type MutationOrganisationDeleteArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationLinkBillingArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationObjectLibraryUpdateConfigArgs = {
  config: ObjectLibraryConfigInput;
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationPrintFontAttachArgs = {
  blobName: Scalars['String']['input'];
  family: Scalars['String']['input'];
  italic: Scalars['Boolean']['input'];
  organisationId: Scalars['ID']['input'];
  originalName: Scalars['String']['input'];
  weight: PrintFontWeight;
};


export type MutationOrganisationPrintFontRemoveArgs = {
  fontId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationPurchaseCreditsArgs = {
  amount: Scalars['Int']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationReferralCustomerCreateArgs = {
  emails: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationReferralLinkGenerateArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationTemplateLibrarySetLogoArgs = {
  blobName?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  originalName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationOrganisationTemplateLibraryUpdateConfigArgs = {
  config: TemplateLibraryConfigInput;
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationUpdateArgs = {
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganisationUpdateBillingArgs = {
  info: InputBillingInfo;
  organisationId: Scalars['ID']['input'];
};


export type MutationOrganizationBatchUpdatePropertiesArgs = {
  organizationId: Scalars['ID']['input'];
  updates: Array<PropertyUpdateInput>;
};


export type MutationOrganizationUpdatePropertyArgs = {
  identifier: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  propertyIdentifier: Scalars['String']['input'];
  value: Scalars['PropertyValue']['input'];
  valueType: PropertyValueType;
};


export type MutationPartnerCustomerCancelSubscriptionArgs = {
  customerOrganisationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationPartnerCustomerChangePlanArgs = {
  customerOrganisationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
};


export type MutationPartnerCustomerInviteUsersArgs = {
  customerOrganisationId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type MutationPartnerCustomerPauseSubscriptionArgs = {
  customerOrganisationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
};


export type MutationPartnerCustomerPurchaseCreditsArgs = {
  amount: Scalars['Int']['input'];
  customerOrganisationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationPartnerCustomerSetBillingDateArgs = {
  customerOrganisationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  renewalDate: Scalars['Date']['input'];
};


export type MutationPrintTemplateAttachAssetArgs = {
  blobName: Scalars['String']['input'];
  kind: PrintTemplateAssetKind;
  organisationId: Scalars['ID']['input'];
  originalName: Scalars['String']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationPrintTemplateCreateArgs = {
  basedOnBuiltinId?: InputMaybe<Scalars['String']['input']>;
  duplicateOfTemplateId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  spec: Scalars['JSON']['input'];
};


export type MutationPrintTemplateDeleteArgs = {
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationPrintTemplateDeleteVersionArgs = {
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPrintTemplateDiscardDraftArgs = {
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationPrintTemplateGenerateArgs = {
  image?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  progressChannel?: InputMaybe<Scalars['String']['input']>;
  prompt: Scalars['String']['input'];
  spec?: InputMaybe<Scalars['JSON']['input']>;
};


export type MutationPrintTemplatePublishArgs = {
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationPrintTemplateRestoreVersionArgs = {
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type MutationPrintTemplateSaveDraftArgs = {
  organisationId: Scalars['ID']['input'];
  spec: Scalars['JSON']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationPrintTemplateSetArchivedArgs = {
  archived: Scalars['Boolean']['input'];
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationPrintTemplateUpdateDetailsArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type MutationProjectActivateArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationProjectAddCommentArgs = {
  comment: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  referenceIdentifier: Scalars['String']['input'];
};


export type MutationProjectAddCustomClassArgs = {
  color: InputColor;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectAddGuestArgs = {
  email: Scalars['String']['input'];
  level?: InputMaybe<ProjectAccessLevel>;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectBatchupdatePropertiesArgs = {
  projectId: Scalars['ID']['input'];
  updates: Array<PropertyUpdateInput>;
};


export type MutationProjectChargeCreditsArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationProjectCloneFromCloudArgs = {
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  targetOrganisationId: Scalars['ID']['input'];
};


export type MutationProjectConfirmPointCloudUploadArgs = {
  fileNames: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  shouldMerge?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProjectConvertCadObjectArgs = {
  cadObjects: Array<InputCadObject>;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectCopyToOrganisationArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  targetOrganisationId: Scalars['ID']['input'];
};


export type MutationProjectCreateAnnotationArgs = {
  clientId?: InputMaybe<Scalars['String']['input']>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  initialProperties?: InputMaybe<Array<PropertyUpdateInput>>;
  projectId: Scalars['ID']['input'];
  type: Scalars['AnnotationType']['input'];
};


export type MutationProjectCreateCadLayerArgs = {
  cadLayerId: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectCreateGroupArgs = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  parentIdentifier?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  type?: InputMaybe<GroupType>;
};


export type MutationProjectCreateOrthophotoLayerArgs = {
  layerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectCreateWmsLayerArgs = {
  layerId: Scalars['String']['input'];
  layerName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  type: WmsType;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProjectDeleteArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteCadLayerArgs = {
  cadLayerIdentifier: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteCadObjectArgs = {
  cadLayerIdentifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  projectId: Scalars['ID']['input'];
  subIndex?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectDeleteCadObjectGroupArgs = {
  cadLayerIdentifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteCalculationArgs = {
  calculationId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteCommentArgs = {
  commentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteCustomClassArgs = {
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteExportArgs = {
  exportId: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteOrthophotoLayerArgs = {
  orthophotoLayerIdentifier: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteSelectedArgs = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  clientId?: InputMaybe<Scalars['String']['input']>;
  groupIdentifiers: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectDeleteWmsLayerArgs = {
  projectId: Scalars['ID']['input'];
  wmsLayerIdentifier: Scalars['String']['input'];
};


export type MutationProjectDuplicateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectEditCommentArgs = {
  commentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  updatedComment: Scalars['String']['input'];
};


export type MutationProjectEditCustomClassColorArgs = {
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  updatedColor: InputColor;
};


export type MutationProjectEditCustomClassNameArgs = {
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  updatedName: Scalars['String']['input'];
};


export type MutationProjectEditLayerElevationArgs = {
  layerIds: Array<Scalars['ID']['input']>;
  newElevation: Scalars['Float']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectExportPointcloudArgs = {
  classificationFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
  fileType?: InputMaybe<FileTypes>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pointCloudId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectGenerateClassificationsArgs = {
  cloudName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectHideCadObjectArgs = {
  cadLayerIdentifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isLayer?: InputMaybe<Scalars['Boolean']['input']>;
  projectId: Scalars['ID']['input'];
  subIndex?: InputMaybe<Scalars['Int']['input']>;
  visible: Scalars['Boolean']['input'];
};


export type MutationProjectInitializeArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationProjectMarkExportsSeenArgs = {
  exportIds: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectMoveAnnotationsToGroupArgs = {
  annotationIdentifiers: Array<Scalars['String']['input']>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectPointCloudDeleteArgs = {
  pointCloudId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectPointCloudRelaunchArgs = {
  pointCloudId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectProjectionCalculateArgs = {
  annotationIdentifier: Scalars['String']['input'];
  classificationFilters?: InputMaybe<Array<Scalars['Int']['input']>>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pointCloudId: Scalars['ID']['input'];
  profileGroupIdentifier: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationProjectRelaunchArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationProjectRemoveGuestArgs = {
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationProjectSetGuestAccessLevelArgs = {
  level: ProjectAccessLevel;
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationProjectShareResetArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationProjectShareSetArgs = {
  enabled: Scalars['Boolean']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectSheetCreateArgs = {
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  templateId: Scalars['String']['input'];
  templateSource: PrintTemplateSource;
};


export type MutationProjectSheetDeleteArgs = {
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type MutationProjectSheetDuplicateArgs = {
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type MutationProjectSheetMarkExportedArgs = {
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type MutationProjectSheetRenameArgs = {
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type MutationProjectSheetSaveArgs = {
  doc: Scalars['JSON']['input'];
  expectedUpdatedAt: Scalars['Date']['input'];
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type MutationProjectSheetUpgradeTemplateArgs = {
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type MutationProjectStartArgs = {
  cloudNames?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  fileNames: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  shouldMerge?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationProjectStartWithPythagorasFilesArgs = {
  cloudName: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  pointCount?: InputMaybe<Scalars['BigInt']['input']>;
  projectId: Scalars['ID']['input'];
};


export type MutationProjectToggleObjectVisibilityArgs = {
  identifiers: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  visible: Scalars['Boolean']['input'];
};


export type MutationProjectUngroupArgs = {
  identifier: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectUpdateArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectUpdateEntityNameArgs = {
  cadLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  orthophotoLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
  pointCloudIdentifier?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  wmsLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProjectUpdateOrderingArgs = {
  identifiers: Array<UpdateOrderingIdentifier>;
  projectId: Scalars['ID']['input'];
  toGroupIdentifier?: InputMaybe<Scalars['String']['input']>;
  toIndex: Scalars['Int']['input'];
};


export type MutationProjectUpdateOrthophotoLayerOrderingArgs = {
  identifiers: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  toIndex: Scalars['Int']['input'];
};


export type MutationProjectUpdatePreviewImageArgs = {
  previewImageFileName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectUpdatePropertyArgs = {
  identifier: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
  propertyIdentifier: Scalars['String']['input'];
  propertyType: PropertyType;
  value: Scalars['PropertyValue']['input'];
  valueType: PropertyValueType;
};


export type MutationProjectUpdateSettingsArgs = {
  projectId: Scalars['ID']['input'];
  settings: InputProjectSettings;
};


export type MutationProjectUpdateWmsLayerArgs = {
  layerId: Scalars['String']['input'];
  layerName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  type: WmsType;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProjectUpdateWmsLayerOrderingArgs = {
  identifiers: Array<Scalars['String']['input']>;
  projectId: Scalars['ID']['input'];
  toIndex: Scalars['Int']['input'];
};


export type MutationProjectValidatePointCloudArgs = {
  cloudName: Scalars['String']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationProjectVolumeCalculateArgs = {
  annotationIdentifier: Scalars['String']['input'];
  baseSurface: CalculationBaseSurfaces;
  classificationFilters?: InputMaybe<Array<Scalars['Int']['input']>>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pointCloudId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  referenceHeight?: InputMaybe<Scalars['Float']['input']>;
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSuperadminCancelSubscriptionArgs = {
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type MutationSuperadminCreateOdooInvoiceArgs = {
  entryId: Scalars['ID']['input'];
};


export type MutationSuperadminCreateOdooPartnerArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationSuperadminCreateReferralPayoutArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationSuperadminDebugSetProjectStateArgs = {
  projectId: Scalars['ID']['input'];
  state: InputProjectDebugState;
};


export type MutationSuperadminGrantCreditsArgs = {
  amount: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  unitPriceCents?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSuperadminOrganisationCreateArgs = {
  emails: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};


export type MutationSuperadminPauseSubscriptionArgs = {
  organisationId: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
};


export type MutationSuperadminRefreshInvoicesArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationSuperadminRefreshReferralsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type MutationSuperadminRemoveCreditsArgs = {
  amount: Scalars['Int']['input'];
  entryId: Scalars['ID']['input'];
};


export type MutationSuperadminSetBillingBlankArgs = {
  blank: Scalars['Boolean']['input'];
  organisationId: Scalars['ID']['input'];
};


export type MutationSuperadminSetBillingDateArgs = {
  chargeCents?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['ID']['input'];
  renewalDate: Scalars['Date']['input'];
};


export type MutationSuperadminSetOdooOrderArgs = {
  orderId?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type MutationSuperadminSetOdooPartnerArgs = {
  organisationId: Scalars['ID']['input'];
  partnerId?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationSuperadminSetPartnerLinkArgs = {
  linked: Scalars['Boolean']['input'];
  organisationId: Scalars['ID']['input'];
  partnerOrganisationId: Scalars['ID']['input'];
};


export type MutationSuperadminSetReferralSettingsArgs = {
  input: InputReferralSettings;
  organisationId: Scalars['ID']['input'];
};


export type MutationSuperadminUnlockProjectArgs = {
  projectId: Scalars['ID']['input'];
};


export type MutationSuperadminUpdatePlanArgs = {
  chargeCents?: InputMaybe<Scalars['Int']['input']>;
  customLimits: InputSubscriptionCustomLimits;
  effectiveAt?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
};


export type MutationUserAcceptInvitationArgs = {
  inviteId: Scalars['String']['input'];
  user?: InputMaybe<InputUser>;
  userEmail: Scalars['String']['input'];
};


export type MutationUserAddToOrganisationArgs = {
  email: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  role: UserRole;
};


export type MutationUserBatchUpdatePropertiesArgs = {
  updates: Array<PropertyUpdateInput>;
};


export type MutationUserChangeDateFormatArgs = {
  inFormat: DateFormats;
};


export type MutationUserChangeLanguageArgs = {
  language: Language;
};


export type MutationUserChangeRoleArgs = {
  organisationId: Scalars['ID']['input'];
  role: UserRole;
  userId: Scalars['ID']['input'];
};


export type MutationUserChangeUnitsArgs = {
  inUnit: MeasurementUnits;
};


export type MutationUserDeleteFromOrganisationArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserDisableArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserEnableArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserResendInvitationArgs = {
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserSetObjectLibraryAccessArgs = {
  enabled: Scalars['Boolean']['input'];
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserSetTemplateLibraryAccessArgs = {
  enabled: Scalars['Boolean']['input'];
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationUserUpdateArgs = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUserUpdateFavoritesArgs = {
  inFavorites: Scalars['Boolean']['input'];
  projectId: Scalars['ID']['input'];
};


export type MutationUserUpdatePropertyArgs = {
  identifier: Scalars['String']['input'];
  propertyIdentifier: Scalars['String']['input'];
  value: Scalars['PropertyValue']['input'];
  valueType: PropertyValueType;
};

export type NavVisAuthResult = {
  __typename?: 'NavVisAuthResult';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  sites: Array<NavVisSite>;
};

export type NavVisDataset = {
  __typename?: 'NavVisDataset';
  name: Scalars['String']['output'];
  pointCloudType: Scalars['String']['output'];
  referenceSystemId?: Maybe<Scalars['BigInt']['output']>;
  siteId: Scalars['BigInt']['output'];
  siteName: Scalars['String']['output'];
};

export type NavVisSite = {
  __typename?: 'NavVisSite';
  id: Scalars['BigInt']['output'];
  name: Scalars['String']['output'];
};

export type Notification = {
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  type: NotificationType;
};

export enum NotificationType {
  CreditsPurchased = 'CREDITS_PURCHASED',
  CustomerRenewalDue = 'CUSTOMER_RENEWAL_DUE',
  CustomerRenewed = 'CUSTOMER_RENEWED',
  OrganisationInvite = 'ORGANISATION_INVITE',
  PointcloudCalculationDone = 'POINTCLOUD_CALCULATION_DONE',
  PointcloudConvertDone = 'POINTCLOUD_CONVERT_DONE',
  PointcloudExportDone = 'POINTCLOUD_EXPORT_DONE',
  ProjectAwaitingCredits = 'PROJECT_AWAITING_CREDITS',
  ProjectCustomDeal = 'PROJECT_CUSTOM_DEAL',
  ProjectInvite = 'PROJECT_INVITE',
  SalesRequest = 'SALES_REQUEST',
  SubscriptionPurchased = 'SUBSCRIPTION_PURCHASED',
  UserAcceptedInvitation = 'USER_ACCEPTED_INVITATION',
  UserGotMentioned = 'USER_GOT_MENTIONED'
}

/**
 * A custom object type of an organisation's library, authored in the Object Editor. Specs are ObjectDefinitionSpec
 * JSON (libs/shared-types objectDefinition); every write is validated.
 */
export type ObjectDefinition = {
  __typename?: 'ObjectDefinition';
  /** The version projects render: the latest publish, or an older one made active again (objectDefinitionActivateVersion). */
  activeVersion: Scalars['Int']['output'];
  assets: Array<ObjectDefinitionAsset>;
  basedOnBuiltinId?: Maybe<Scalars['String']['output']>;
  /** A built-in category (BATHROOM, KITCHEN, FURNITURE, FIXTURES, STRUCTURE) or one of the organisation's own. */
  categoryId: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The spec being edited: only for those who can edit the library (null otherwise). */
  draftSpec?: Maybe<Scalars['JSON']['output']>;
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  /** What projects render; null until the first publish. */
  publishedSpec?: Maybe<Scalars['JSON']['output']>;
  /** A smart object: designed by the AI (generated, or a smart copy of a normal object) and only changed through the AI. */
  smart: Scalars['Boolean']['output'];
  status: ObjectDefinitionStatus;
  tags: Array<Scalars['String']['output']>;
  templateId?: Maybe<Scalars['String']['output']>;
  /** The sketch-object type id placed objects carry: c_<id>. */
  typeId: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  /** Bumped on every publish; 0 before the first. */
  version: Scalars['Int']['output'];
};

export type ObjectDefinitionAsset = {
  __typename?: 'ObjectDefinitionAsset';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  kind: ObjectDefinitionAssetKind;
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  /** Download URL with a read SAS (valid for hours, not forever: refetch the library for fresh ones). */
  url: Scalars['String']['output'];
};

export enum ObjectDefinitionAssetKind {
  ModelGlb = 'MODEL_GLB',
  Source_2D = 'SOURCE_2D',
  Source_3D = 'SOURCE_3D',
  Thumbnail = 'THUMBNAIL'
}

/** What the object-generating AI made: a validated spec plus what it did, for the user. */
export type ObjectDefinitionGeneration = {
  __typename?: 'ObjectDefinitionGeneration';
  /** A short name suggestion for the object. */
  name?: Maybe<Scalars['String']['output']>;
  spec: Scalars['JSON']['output'];
  /** One to three sentences on what was made or changed. */
  summary: Scalars['String']['output'];
};

/** What the object-designing AI makes: a placeable object, or a door / window symbol (a spec with an opening marker). */
export enum ObjectDefinitionKind {
  Door = 'DOOR',
  Object = 'OBJECT',
  Window = 'WINDOW'
}

/**
 * DRAFT: never published, invisible to projects. PUBLISHED: projects use publishedSpec (the draft may hold unpublished
 * edits). ARCHIVED: gone from the library picker; objects already placed keep rendering the published version.
 */
export enum ObjectDefinitionStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** One published version of an object, as projects rendered it from that publish on. */
export type ObjectDefinitionVersion = {
  __typename?: 'ObjectDefinitionVersion';
  categoryId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** The version projects render now. */
  isCurrent: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publishedAt: Scalars['Date']['output'];
  /** Who published it; null for versions published before history was kept. */
  publishedByName?: Maybe<Scalars['String']['output']>;
  spec: Scalars['JSON']['output'];
  version: Scalars['Int']['output'];
};

export type ObjectLibrary = {
  __typename?: 'ObjectLibrary';
  /** Whether the caller may create and edit objects and change the configuration. */
  canEdit: Scalars['Boolean']['output'];
  config: ObjectLibraryConfig;
  definitions: Array<ObjectDefinition>;
  organisationId: Scalars['ID']['output'];
};

export type ObjectLibraryCategory = {
  __typename?: 'ObjectLibraryCategory';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  order: Scalars['Int']['output'];
};

export type ObjectLibraryCategoryInput = {
  id: Scalars['String']['input'];
  label: Scalars['String']['input'];
  order: Scalars['Int']['input'];
};

/** How the organisation shaped its library: hidden types (built-in ids or c_<id>), its own categories and the order. */
export type ObjectLibraryConfig = {
  __typename?: 'ObjectLibraryConfig';
  categories: Array<ObjectLibraryCategory>;
  hiddenTypeIds: Array<Scalars['String']['output']>;
  typeOrder: Array<ObjectLibraryTypePlacement>;
};

export type ObjectLibraryConfigInput = {
  categories: Array<ObjectLibraryCategoryInput>;
  hiddenTypeIds: Array<Scalars['String']['input']>;
  typeOrder: Array<ObjectLibraryTypePlacementInput>;
};

export type ObjectLibraryTypePlacement = {
  __typename?: 'ObjectLibraryTypePlacement';
  categoryId: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  typeId: Scalars['String']['output'];
};

export type ObjectLibraryTypePlacementInput = {
  categoryId: Scalars['String']['input'];
  order: Scalars['Int']['input'];
  typeId: Scalars['String']['input'];
};

export type OdooOrderCandidate = {
  __typename?: 'OdooOrderCandidate';
  id: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export enum OdooOrderLinkStatus {
  Ambiguous = 'AMBIGUOUS',
  NoMatch = 'NO_MATCH'
}

export enum OdooOrderOrigin {
  Created = 'CREATED',
  Linked = 'LINKED'
}

export type Organisation = {
  __typename?: 'Organisation';
  apiKeys: Array<ApiKey>;
  createdAt: Scalars['Date']['output'];
  credits: OrganisationCredits;
  id: Scalars['ID']['output'];
  isRootOrganisation?: Maybe<Scalars['Boolean']['output']>;
  licenseKey?: Maybe<Scalars['String']['output']>;
  myPermissions: Array<Permissions>;
  name: Scalars['String']['output'];
  odoo: OrganisationOdoo;
  prohibitedActions: Array<PossibleActions>;
  projects: Array<Project>;
  properties: Array<PropertyGroup>;
  referral: OrganisationReferral;
  stats: OrganisationStats;
  subscription: OrganisationSubscription;
  usersAmount: Scalars['Int']['output'];
};

/** An organisation's billing details. They live on its customer in Odoo and are read and written there. */
export type OrganisationBilling = {
  __typename?: 'OrganisationBilling';
  /**
   * Not complete, and a superadmin confirmed that is on purpose (superadminSetBillingBlank): sales from the admin
   * panel go ahead, free. Saving details clears it.
   */
  blank: Scalars['Boolean']['output'];
  /** Whether everything an invoice needs is filled in; purchases are blocked until it is. */
  complete: Scalars['Boolean']['output'];
  /** False where Odoo is not configured: there is nothing to fill in, and nothing is blocked. */
  enabled: Scalars['Boolean']['output'];
  /** The organisation's id. */
  id: Scalars['ID']['output'];
  info?: Maybe<BillingInfo>;
  /**
   * Whether the organisation has a customer in Odoo. Without one nothing can be ordered or filled in:
   * organisationLinkBilling looks for it, and when there is none it is for sales to make.
   */
  linked: Scalars['Boolean']['output'];
  /** The organisation as it is after the lookup: finding or making its customer in Odoo changes its odoo link. */
  organisation: Organisation;
};

export type OrganisationCredits = {
  __typename?: 'OrganisationCredits';
  available: Scalars['Int']['output'];
  balance: Scalars['Int']['output'];
  /**
   * The grants that still hold projects, in the order they are spent: expiring ones first by expiry, then the
   * rest. The monthly allowance and an upgrade's extra projects are among them (their source says so).
   */
  liveGrants: Array<CreditLedgerEntry>;
  /** The current period's allowance; null for plans without one. */
  monthlyAllowance?: Maybe<MonthlyAllowance>;
  nextExpiry?: Maybe<Scalars['Date']['output']>;
  /** Credits owed by uploads already underway; available is what a new upload may draw on. */
  pending: Scalars['Int']['output'];
};

export type OrganisationInviteNotification = Notification & {
  __typename?: 'OrganisationInviteNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: OrganisationInviteNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type OrganisationInviteNotificationMeta = {
  __typename?: 'OrganisationInviteNotificationMeta';
  /** Signed invite token, the same one the invitation mail links to (register-invite?token=…). */
  inviteToken: Scalars['String']['output'];
  invitedByName: Scalars['String']['output'];
  organisationName: Scalars['String']['output'];
  projectId?: Maybe<Scalars['ID']['output']>;
  projectName?: Maybe<Scalars['String']['output']>;
};

/**
 * The organisation's records in Odoo: the CRM lead its registration created and the customer invoices are
 * made out to (found from the lead once sales converts it, or set by a superadmin), with links to them.
 */
export type OrganisationOdoo = {
  __typename?: 'OrganisationOdoo';
  leadId?: Maybe<Scalars['Int']['output']>;
  leadUrl?: Maybe<Scalars['String']['output']>;
  orderCandidates: Array<OdooOrderCandidate>;
  orderCloseReason?: Maybe<Scalars['String']['output']>;
  orderConfirmed?: Maybe<Scalars['Boolean']['output']>;
  orderEndsAt?: Maybe<Scalars['Date']['output']>;
  /**
   * The subscription order (Odoo Subscriptions) billing the running term: made by Pointorama, or sales' own
   * subscription linked to it; what Odoo last said about it; and, unlinked, why the daily matcher could not
   * pair the term (no subscription for the customer, or several — listed) for a superadmin to pick.
   */
  orderId?: Maybe<Scalars['Int']['output']>;
  orderLinkStatus?: Maybe<OdooOrderLinkStatus>;
  /** The order's reference in Odoo (S00077), once known. */
  orderName?: Maybe<Scalars['String']['output']>;
  orderOrigin?: Maybe<OdooOrderOrigin>;
  orderState?: Maybe<Scalars['String']['output']>;
  orderSyncedAt?: Maybe<Scalars['Date']['output']>;
  orderUrl?: Maybe<Scalars['String']['output']>;
  partnerId?: Maybe<Scalars['Int']['output']>;
  partnerUrl?: Maybe<Scalars['String']['output']>;
};

/**
 * The organisation's referral settings as a superadmin set them (defaults: CUSTOMER, no cut, monthly; a partner
 * without cuts set earns its role's), and its commercial relations as a customer.
 */
export type OrganisationReferral = {
  __typename?: 'OrganisationReferral';
  /** Who brought the organisation in; null = Pythagoras (direct). */
  acquiredBy?: Maybe<ReferralPartnerLink>;
  /**
   * The partner Pythagoras invoices for the organisation; null = the organisation itself. A billed organisation
   * orders nothing itself: its partner does (and cancels, unless the partner lets its customers cancel).
   */
  billedTo?: Maybe<ReferralPartnerLink>;
  /** Billed to a partner that lets its customers cancel their subscription themselves. */
  canCancelSubscription: Scalars['Boolean']['output'];
  /** Whether the customers billed to this partner may cancel their subscription themselves. */
  customersCanCancel: Scalars['Boolean']['output'];
  /** The cut on a customer's opening subscription sale, and on everything after it, in basis points. */
  firstCutBasisPoints: Scalars['Int']['output'];
  hasToken: Scalars['Boolean']['output'];
  /** Who owns the commercial relationship today; null = Pythagoras. */
  managedBy?: Maybe<ReferralPartnerLink>;
  /** Below this much payable, the period's automatic payout waits for the next one (default €100). */
  minPayoutCents: Scalars['Int']['output'];
  payoutCadence: ReferralPayoutCadence;
  recurringCutBasisPoints: Scalars['Int']['output'];
  referredAt?: Maybe<Scalars['Date']['output']>;
  referredById?: Maybe<Scalars['ID']['output']>;
  referredByName?: Maybe<Scalars['String']['output']>;
  role: ReferralRole;
};

export type OrganisationStats = {
  __typename?: 'OrganisationStats';
  totalPointCount: Scalars['BigInt']['output'];
  totalProjects: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type OrganisationSubscription = {
  __typename?: 'OrganisationSubscription';
  canAddSimultaneousUploads: Scalars['Boolean']['output'];
  /** Whether organisationCancelSubscription would go ahead: a paid term that has not ended and is not already set to end. */
  cancellable: Scalars['Boolean']['output'];
  customLimits?: Maybe<SubscriptionCustomLimits>;
  endDate?: Maybe<Scalars['Date']['output']>;
  isFlex: Scalars['Boolean']['output'];
  maxPurchaseAmount: Scalars['Int']['output'];
  /** Bounds of one organisationPurchaseCredits order. */
  minPurchaseAmount: Scalars['Int']['output'];
  /**
   * Paused in Odoo since pausedAt (a customer that did not pay): uploads are refused (SUBSCRIPTION_PAUSED) and
   * nothing is ordered for it. The term runs on: its dates do not move.
   */
  paused: Scalars['Boolean']['output'];
  pausedAt?: Maybe<Scalars['Date']['output']>;
  /** Prices in cents. */
  projectUnitPrice: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  /** A plan change waiting for scheduledAt: a downgrade at the end of the term, an upgrade on the day it was scheduled for. */
  scheduledType?: Maybe<SubscriptionType>;
  simultaneousUploadsLeft: Scalars['Int']['output'];
  /** The term's first day (in the future for a term sold ahead of time) and last day. */
  startDate?: Maybe<Scalars['Date']['output']>;
  subscriptionPrice: Scalars['Int']['output'];
  type: SubscriptionType;
};

/** How many organisations were created in a month (YYYY-MM, UTC). */
export type OrganisationsPerMonth = {
  __typename?: 'OrganisationsPerMonth';
  count: Scalars['Int']['output'];
  month: Scalars['String']['output'];
};

export type OrthophotoLayer = {
  __typename?: 'OrthophotoLayer';
  elevation?: Maybe<Scalars['Float']['output']>;
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  visible: Scalars['Boolean']['output'];
};

export type PaginatedCreditLedger = {
  __typename?: 'PaginatedCreditLedger';
  data: Array<CreditLedgerEntry>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type PaginatedFailedPointClouds = {
  __typename?: 'PaginatedFailedPointClouds';
  data: Array<FailedPointCloud>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type PaginatedOrganisation = {
  __typename?: 'PaginatedOrganisation';
  data: Array<Organisation>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type PaginatedTrackedInvoices = {
  __typename?: 'PaginatedTrackedInvoices';
  data: Array<TrackedInvoice>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

/**
 * A relation filter of the admin center: PYTHAGORAS = no partner in that relation (acquired directly, managed by
 * Pythagoras, billed to the organisation itself), PARTNER = a partner.
 */
export enum PartnerRelationFilter {
  Partner = 'PARTNER',
  Pythagoras = 'PYTHAGORAS'
}

export enum Permissions {
  All = 'ALL',
  ApiKey = 'API_KEY',
  Billing = 'BILLING',
  /**
   * Create and edit the organisation's custom library objects. Granted per member (userSetObjectLibraryAccess); admins
   * have it through ALL, guests never.
   */
  ObjectLibrary = 'OBJECT_LIBRARY',
  Organisations = 'ORGANISATIONS',
  /**
   * A partner's admin on an organisation the partner referred: visit it, relaunch its projects, invite people. Never
   * stored on a membership; derived (see partnerScope).
   */
  Partner = 'PARTNER',
  Projects = 'PROJECTS',
  ProjectsComment = 'PROJECTS_COMMENT',
  ProjectsEdit = 'PROJECTS_EDIT',
  ProjectsRead = 'PROJECTS_READ',
  /**
   * Create and edit the organisation's print templates and brand kit. Granted per member (userSetTemplateLibraryAccess);
   * admins have it through ALL, guests never.
   */
  TemplateLibrary = 'TEMPLATE_LIBRARY',
  Users = 'USERS'
}

/** What superadminUpdatePlan will do for a given target plan. */
export enum PlanChangeKind {
  /** No active subscription: a new term starts on the effective date (today or later). */
  NewSubscription = 'NEW_SUBSCRIPTION',
  /**
   * A cheaper plan (by yearly price): stored and applied at the very end of the term, after every planned upgrade;
   * the current plan stays until then. The subscription then continues on the new plan for a new term (a year by
   * default, ending on endDate) billed the day it starts — nothing now. FLEX ends the subscription instead.
   */
  ScheduledDowngrade = 'SCHEDULED_DOWNGRADE',
  /** Same plan: only the end date and a custom deal's values move; a scheduled downgrade is cancelled. */
  Unchanged = 'UNCHANGED',
  /**
   * Takes effect on the effective date — now, or stored and applied that day. The subscription and its
   * renewal cycle stay; the monthly projects of the period it lands in are kept and the new plan's
   * difference is added to them.
   */
  Upgrade = 'UPGRADE'
}

/** A simulation of superadminUpdatePlan with the same arguments: what changes, when, and what it costs. */
export type PlanChangePreview = {
  __typename?: 'PlanChangePreview';
  /**
   * The term as it stands the moment the change has taken effect. For a downgrade: the term as it stands, on the plan it
   * ends on, with the downgrade waiting at its end (scheduledType, scheduledAt).
   */
  after: PlanTermState;
  alreadyPaidCents: Scalars['Int']['output'];
  alreadyScheduled: Scalars['Boolean']['output'];
  /**
   * The term's value after the change minus what the current term already covered, signed: below zero when the
   * change (a shorter term) is worth less than what was sold — a balance in the customer's favour, not refunded.
   */
  balanceCents: Scalars['Int']['output'];
  /** The monthly period the change lands in: its number in the term (from 1) and its days. */
  changeMonth?: Maybe<Scalars['Int']['output']>;
  changePeriodEnd?: Maybe<Scalars['Date']['output']>;
  changePeriodStart?: Maybe<Scalars['Date']['output']>;
  chargedCents: Scalars['Int']['output'];
  current: PlanTermState;
  currentTermValueCents: Scalars['Int']['output'];
  dueCents: Scalars['Int']['output'];
  /**
   * The day the change takes effect (the end of the term for a downgrade), defaults filled in: today, or the
   * day already pending for the same plan. scheduled when that is later than now: the change is then stored
   * and applied that day. alreadyScheduled when the same change is pending for the same day and end.
   */
  effectiveAt: Scalars['Date']['output'];
  /** The last day of the term after the change: the running term's, or a year for a new term. */
  endDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Monthly projects granted when the change takes effect (the difference an upgrade adds, free, valid until the
   * end of the period it lands in, or a new term's first month), the day they land, and when they expire.
   */
  extraCredits: Scalars['Int']['output'];
  extraCreditsAt?: Maybe<Scalars['Date']['output']>;
  extraCreditsExpireAt?: Maybe<Scalars['Date']['output']>;
  /**
   * How the change's fee is invoiced: through the subscription in Odoo (a new term makes the order, an upgrade
   * an upsell or a line on the term's draft, a continued plan the next cycle), or as a draft invoice.
   */
  invoiceVia: InvoiceVia;
  /**
   * What confirming does to the changes already pending: keeps the ones before its day (they stay in the
   * schedule), supersedes the rest (what they sold stays counted as covered).
   */
  keepsPending: Scalars['Boolean']['output'];
  kind: PlanChangeKind;
  /**
   * What the change costs, part by part (summing to dueCents, never below zero); the term's value after the change;
   * what was paid for the current term (its value, for a legacy term with nothing on record); and what will be billed:
   * the entered amount when there is one. alreadyPaidCents is what the ledger holds for the subscription, for information.
   * A downgrade has no lines and no amount: the year that follows is billed at the plan's price the day it starts.
   */
  lines: Array<PlanChargeLine>;
  maxEffectiveAt?: Maybe<Scalars['Date']['output']>;
  /** Bounds for the effective date: today, and the term's last day. */
  minEffectiveAt: Scalars['Date']['output'];
  /** A downgrade: what follows the term — the cheaper plan for a year from the day after (its startDate, endDate), or FLEX. */
  next?: Maybe<PlanTermState>;
  overridden: Scalars['Boolean']['output'];
  /** The organisation has no billing details to invoice: whatever the change is worth, 0 is billed. */
  priceLocked: Scalars['Boolean']['output'];
  problems: Array<PlanChangeProblem>;
  scheduled: Scalars['Boolean']['output'];
  subscriptionType: SubscriptionType;
  supersedesPending: Scalars['Boolean']['output'];
  /** The whole term after the change, day by day. Empty while the request is invalid. */
  timeline: Array<PlanTimelineSegment>;
  totalValueCents: Scalars['Int']['output'];
  /** The current term is voided now (force): its monthly projects are removed and nothing of it counts as paid. */
  voidsCurrentTerm: Scalars['Boolean']['output'];
};

/** Why a plan change cannot be confirmed as entered. superadminUpdatePlan fails with the first one. */
export enum PlanChangeProblem {
  /**
   * The organisation's billing details are incomplete and nobody confirmed that is on purpose: fill them in, or
   * mark them blank (superadminSetBillingBlank), before selling anything.
   */
  BillingDetailsUnset = 'BILLING_DETAILS_UNSET',
  /** A term sold ahead of time: a change to it lands on its first day at the earliest. */
  EffectiveDateBeforeTerm = 'EFFECTIVE_DATE_BEFORE_TERM',
  EffectiveDateInPast = 'EFFECTIVE_DATE_IN_PAST',
  EndDateBeforeStart = 'END_DATE_BEFORE_START',
  EndDateInPast = 'END_DATE_IN_PAST',
  InvalidCharge = 'INVALID_CHARGE',
  /** No running term to move the billing date of. */
  NoTerm = 'NO_TERM',
  /** An upgrade is pending on or after the day entered: it was sold for the term as it stands. */
  PendingChangeAfterEnd = 'PENDING_CHANGE_AFTER_END',
  /** The subscription is paused in Odoo: only a downgrade can be planned until it resumes. */
  SubscriptionPaused = 'SUBSCRIPTION_PAUSED',
  TermTooLong = 'TERM_TOO_LONG'
}

/**
 * One plan's share of the term's value: whole months at a twelfth of the yearly price. A month the term cuts short
 * is not billed; the month an upgrade lands in stays on the plan before, the upgrade is billed from the next month.
 */
export type PlanChargeLine = {
  __typename?: 'PlanChargeLine';
  from: Scalars['Date']['output'];
  monthlyPriceCents: Scalars['Int']['output'];
  months: Scalars['Int']['output'];
  subscriptionType: SubscriptionType;
  to: Scalars['Date']['output'];
  totalCents: Scalars['Int']['output'];
};

/** A subscription term: the plan, its values (prices in cents) and where it stands in its monthly cycle. */
export type PlanTermState = {
  __typename?: 'PlanTermState';
  active: Scalars['Boolean']['output'];
  endDate?: Maybe<Scalars['Date']['output']>;
  monthlyCredits: Scalars['Int']['output'];
  monthsElapsed?: Maybe<Scalars['Int']['output']>;
  monthsLeft?: Maybe<Scalars['Int']['output']>;
  /** Monthly periods in the term, how many are over, and how many are left (the running one included). */
  monthsTotal?: Maybe<Scalars['Int']['output']>;
  nextRenewal?: Maybe<Scalars['Date']['output']>;
  /** Paused in Odoo since then (a customer that did not pay): blocked, while its term runs on. */
  pausedAt?: Maybe<Scalars['Date']['output']>;
  projectUnitPriceCents: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  /** A plan change waiting for scheduledAt. */
  scheduledType?: Maybe<SubscriptionType>;
  startDate?: Maybe<Scalars['Date']['output']>;
  subscriptionType: SubscriptionType;
  yearlyPriceCents: Scalars['Int']['output'];
};

/**
 * A stretch of the term after a change on one plan with one allowance: a monthly period, or the part of it
 * before or after the change day. to is its last instant.
 */
export type PlanTimelineSegment = {
  __typename?: 'PlanTimelineSegment';
  extraCredits: Scalars['Int']['output'];
  from: Scalars['Date']['output'];
  /** The period's number in the term, from 1. */
  month: Scalars['Int']['output'];
  /**
   * Projects available during the stretch, and how many of them are an upgrade's extra ones, valid until the
   * end of the period the upgrade landed in.
   */
  monthlyCredits: Scalars['Int']['output'];
  subscriptionType: SubscriptionType;
  to: Scalars['Date']['output'];
};

export type PointCloud = {
  __typename?: 'PointCloud';
  availableClasses: Array<Scalars['Int']['output']>;
  availableSources: Array<Scalars['Int']['output']>;
  cloudName: Scalars['String']['output'];
  convertedSize?: Maybe<Scalars['BigInt']['output']>;
  displayName: Scalars['String']['output'];
  hasClassifications: Scalars['Boolean']['output'];
  hasSources: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  pointCount?: Maybe<Scalars['BigInt']['output']>;
  uploadStatus: UploadStatus;
  validation?: Maybe<PointCloudValidation>;
  visible: Scalars['Boolean']['output'];
};

export type PointCloudCalculationDoneNotification = Notification & {
  __typename?: 'PointCloudCalculationDoneNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: PointCloudCalculationDoneNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type PointCloudCalculationDoneNotificationMeta = {
  __typename?: 'PointCloudCalculationDoneNotificationMeta';
  annotationIdentifier?: Maybe<Scalars['ID']['output']>;
  pointCloudIdentifier?: Maybe<Scalars['ID']['output']>;
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  status?: Maybe<GeneralStatus>;
};

export type PointCloudConvertDoneNotification = Notification & {
  __typename?: 'PointCloudConvertDoneNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: PointCloudConvertDoneNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type PointCloudConvertDoneNotificationMeta = {
  __typename?: 'PointCloudConvertDoneNotificationMeta';
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  status?: Maybe<UploadStatus>;
};

export type PointCloudExportDoneNotification = Notification & {
  __typename?: 'PointCloudExportDoneNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: PointCloudExportDoneNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type PointCloudExportDoneNotificationMeta = {
  __typename?: 'PointCloudExportDoneNotificationMeta';
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  status?: Maybe<GeneralStatus>;
  thisExport?: Maybe<Export>;
};

export type PointCloudExportParamInfo = {
  __typename?: 'PointCloudExportParamInfo';
  classificationFilters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  clippingFilter?: Maybe<Scalars['Int']['output']>;
  fileType?: Maybe<FileTypes>;
  heightFilters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  resolutionFilter?: Maybe<Scalars['Int']['output']>;
};

export type PointCloudValidation = {
  __typename?: 'PointCloudValidation';
  errorReason?: Maybe<Scalars['String']['output']>;
  finishedAt?: Maybe<Scalars['Date']['output']>;
  isValid?: Maybe<Scalars['Boolean']['output']>;
  issues: Array<PointCloudValidationIssue>;
  status: GeneralStatus;
};

export type PointCloudValidationIssue = {
  __typename?: 'PointCloudValidationIssue';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Position = {
  __typename?: 'Position';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
  z: Scalars['Float']['output'];
};

export enum PossibleActions {
  ToolFloorPlan = 'TOOL_FLOOR_PLAN',
  ToolPlane = 'TOOL_PLANE'
}

/** Contact details for the {org.*} placeholders. */
export type PrintBrand = {
  __typename?: 'PrintBrand';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type PrintBrandInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A font the organisation uploaded (TTF/OTF), embedded into exported PDFs. Templates reference it by id
 * ({ source: 'org', assetId: id }); bold / italic variants are picked by family.
 */
export type PrintFont = {
  __typename?: 'PrintFont';
  createdAt: Scalars['Date']['output'];
  family: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  italic: Scalars['Boolean']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
  weight: PrintFontWeight;
};

export enum PrintFontWeight {
  Bold = 'BOLD',
  Normal = 'NORMAL'
}

export type PrintLogo = {
  __typename?: 'PrintLogo';
  contentType: Scalars['String']['output'];
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
  url: Scalars['String']['output'];
};

/**
 * A print template of an organisation, authored in the Template Editor. Specs are PrintTemplateSpec JSON
 * (libs/shared-types printTemplate); every write is validated.
 */
export type PrintTemplate = {
  __typename?: 'PrintTemplate';
  assets: Array<PrintTemplateAsset>;
  basedOnBuiltinId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description?: Maybe<Scalars['String']['output']>;
  /** The spec being edited: only for those who can edit the templates (null otherwise). */
  draftSpec?: Maybe<Scalars['JSON']['output']>;
  hasUnpublishedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['Date']['output']>;
  /** The latest published spec; null until the first publish. */
  publishedSpec?: Maybe<Scalars['JSON']['output']>;
  status: PrintTemplateStatus;
  updatedAt: Scalars['Date']['output'];
  /** Bumped on every publish; 0 before the first. New sheets pin this version. */
  version: Scalars['Int']['output'];
};

export type PrintTemplateAsset = {
  __typename?: 'PrintTemplateAsset';
  contentType: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  kind: PrintTemplateAssetKind;
  originalName: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  /** Download URL with a read SAS (valid for hours, not forever: refetch for fresh ones). */
  url: Scalars['String']['output'];
};

export enum PrintTemplateAssetKind {
  Image = 'IMAGE',
  Thumbnail = 'THUMBNAIL'
}

/** A template the AI designed or changed (not stored: the client creates the template or applies it to its draft). */
export type PrintTemplateGeneration = {
  __typename?: 'PrintTemplateGeneration';
  /** A suggested template name. */
  name?: Maybe<Scalars['String']['output']>;
  spec: Scalars['JSON']['output'];
  /** What was made or changed, for the user (1–3 sentences). */
  summary: Scalars['String']['output'];
};

export type PrintTemplateRef = {
  __typename?: 'PrintTemplateRef';
  id: Scalars['String']['output'];
  source: PrintTemplateSource;
};

export type PrintTemplateRefInput = {
  id: Scalars['String']['input'];
  source: PrintTemplateSource;
};

/** Where a sheet's template comes from: a shipped built-in (shared-types BUILTIN_PRINT_TEMPLATES) or the organisation. */
export enum PrintTemplateSource {
  Builtin = 'BUILTIN',
  Org = 'ORG'
}

/**
 * DRAFT: never published, not offered to projects. PUBLISHED: new sheets pin the latest publish (the draft may hold
 * unpublished edits). ARCHIVED: gone from the template picker; sheets already pinned to it keep exporting their version.
 */
export enum PrintTemplateStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

/** One published version of a template, as sheets pinned to it export it. */
export type PrintTemplateVersion = {
  __typename?: 'PrintTemplateVersion';
  id: Scalars['ID']['output'];
  /** The latest publish (what new sheets pin). */
  isLatest: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  publishedAt: Scalars['Date']['output'];
  publishedByName?: Maybe<Scalars['String']['output']>;
  /** How many sheets pin this version (it can't be deleted while any do). */
  sheetCount: Scalars['Int']['output'];
  spec: Scalars['JSON']['output'];
  version: Scalars['Int']['output'];
};

export type Project = {
  __typename?: 'Project';
  assignee?: Maybe<User>;
  assigneeId?: Maybe<Scalars['ID']['output']>;
  calculations: Array<Calculation>;
  comments?: Maybe<Array<Comment>>;
  /** Set on a project made from another one: a duplicate or a soft copy. Absent on an original upload. */
  copy?: Maybe<ProjectCopy>;
  creditBreakdown: ProjectCreditBreakdown;
  creditsOutstanding: Scalars['Int']['output'];
  /** Free for the organisation: uploaded by a superadmin, or unlocked by one (superadminUnlockProject). */
  creditsWaived: Scalars['Boolean']['output'];
  customClasses?: Maybe<Array<CustomClass>>;
  description?: Maybe<Scalars['String']['output']>;
  exports: Array<Export>;
  id: Scalars['ID']['output'];
  isInitializing?: Maybe<Scalars['Boolean']['output']>;
  isLocal?: Maybe<Scalars['Boolean']['output']>;
  mapVisible: Scalars['Boolean']['output'];
  /** What the current caller may do here: guests per project, members/admins EDIT, share-link visitors VIEW. */
  myAccessLevel: ProjectAccessLevel;
  name: Scalars['String']['output'];
  pointClouds: Array<PointCloud>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  settings?: Maybe<ProjectSettings>;
  share?: Maybe<ProjectShare>;
  state: ProjectState;
  stateByLayer: Array<StateByLayer>;
  stateByUser: Array<StateByUser>;
  storageBaseUrl?: Maybe<Scalars['String']['output']>;
  /** Blob container holding the project's files. Decoupled from the id: a duplicate shares its source's container. */
  storageContainer: Scalars['String']['output'];
  uploadStatus: UploadStatus;
};

export type ProjectAccess = {
  __typename?: 'ProjectAccess';
  level: ProjectAccessLevel;
  projectId: Scalars['ID']['output'];
};

/** What a guest may do on one project. Members and admins are not scoped this way. */
export enum ProjectAccessLevel {
  Comment = 'COMMENT',
  Edit = 'EDIT',
  View = 'VIEW'
}

export type ProjectAwaitingCreditsNotification = Notification & {
  __typename?: 'ProjectAwaitingCreditsNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: ProjectAwaitingCreditsNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type ProjectAwaitingCreditsNotificationMeta = {
  __typename?: 'ProjectAwaitingCreditsNotificationMeta';
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
  requiredCredits: Scalars['Int']['output'];
};

export type ProjectCopy = {
  __typename?: 'ProjectCopy';
  createdAt: Scalars['Date']['output'];
  sourceProjectId: Scalars['ID']['output'];
  type: ProjectCopyType;
};

/**
 * How a project was made from another one. DUPLICATE: in the same organisation, it counts as the owner's. COPY (a soft
 * copy): into another organisation by a superadmin or a partner; it borrows the data and is deleted once the owner has no
 * project left on it, and only a superadmin may download its sources.
 */
export enum ProjectCopyType {
  Copy = 'COPY',
  Duplicate = 'DUPLICATE'
}

/**
 * What activating the project costs, and why: the points of its converted point clouds against the largest point
 * count one project covers.
 */
export type ProjectCreditBreakdown = {
  __typename?: 'ProjectCreditBreakdown';
  pointCount: Scalars['Float']['output'];
  /** Projects the point count costs in total (what was already charged included). */
  required: Scalars['Int']['output'];
  /** Point clouds up to this many points cost one project; above it, two. */
  singleProjectMaxPoints: Scalars['Float']['output'];
};

export type ProjectCustomDealNotification = Notification & {
  __typename?: 'ProjectCustomDealNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: ProjectCustomDealNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type ProjectCustomDealNotificationMeta = {
  __typename?: 'ProjectCustomDealNotificationMeta';
  organisationId: Scalars['ID']['output'];
  pointCountTotal: Scalars['Float']['output'];
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
};

export type ProjectInviteNotification = Notification & {
  __typename?: 'ProjectInviteNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: ProjectInviteNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type ProjectInviteNotificationMeta = {
  __typename?: 'ProjectInviteNotificationMeta';
  invitedByName: Scalars['String']['output'];
  organisationName: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  projectName: Scalars['String']['output'];
};

export type ProjectSettings = {
  __typename?: 'ProjectSettings';
  projectionSystem?: Maybe<Scalars['String']['output']>;
};

/** "Anyone with the link can view" access. Only visible to users who may manage the project (PROJECTS permission). */
export type ProjectShare = {
  __typename?: 'ProjectShare';
  createdAt: Scalars['Date']['output'];
  enabled: Scalars['Boolean']['output'];
  token: Scalars['String']['output'];
};

/**
 * A printable document of a project: a print template (one pinned published version) filled in with field values,
 * revisions and framed viewports. The document is SheetDoc JSON (libs/shared-types printTemplate); every write is
 * validated. PDFs are made on the client from it.
 */
export type ProjectSheet = {
  __typename?: 'ProjectSheet';
  createdAt: Scalars['Date']['output'];
  doc: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  lastExportedAt?: Maybe<Scalars['Date']['output']>;
  /**
   * The template's latest version (greater than templateVersion: projectSheetUpgradeTemplate can move the sheet on);
   * null when the organisation template is gone.
   */
  latestTemplateVersion?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  number?: Maybe<Scalars['String']['output']>;
  projectId: Scalars['ID']['output'];
  templateId: Scalars['String']['output'];
  templateSource: PrintTemplateSource;
  /** The template version the sheet pins. */
  templateVersion: Scalars['Int']['output'];
  updatedAt: Scalars['Date']['output'];
};

/**
 * A file at the root of a project's storage (its uploaded sources, whatever their type), with a signed
 * link to download it.
 */
export type ProjectSourceFile = {
  __typename?: 'ProjectSourceFile';
  name: Scalars['String']['output'];
  sizeBytes: Scalars['Float']['output'];
  url: Scalars['String']['output'];
};

export type ProjectState = {
  __typename?: 'ProjectState';
  annotations: Array<Annotation>;
  cadLayers: Array<CadLayer>;
  groups: Array<Group>;
  orderedIdentifiers: Array<OrderedIdentifier>;
  orthophotoLayerOrderedIdentifiers: Array<OrderedIdentifier>;
  orthophotoLayers: Array<OrthophotoLayer>;
  properties: Array<PropertyGroup>;
  wmsLayerOrderedIdentifiers: Array<OrderedIdentifier>;
  wmsLayers: Array<WmsLayer>;
};


export type ProjectStatePropertiesArgs = {
  propertyIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ProjectionCalculation = Calculation & {
  __typename?: 'ProjectionCalculation';
  annotationIdentifier: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isOutDated: Scalars['Boolean']['output'];
  paramInfo: ProjectionCalculationParamInfo;
  pointCloudIdentifier: Scalars['String']['output'];
  profileGroupIdentifier: Scalars['String']['output'];
  result?: Maybe<ProjectionCalculationResult>;
  status: GeneralStatus;
};

export type ProjectionCalculationParamInfo = {
  __typename?: 'ProjectionCalculationParamInfo';
  classificationFilters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  clippingFilter?: Maybe<Scalars['Int']['output']>;
  heightFilters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  intensityFilters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  resolutionFilter?: Maybe<Scalars['Int']['output']>;
};

export type ProjectionCalculationResult = {
  __typename?: 'ProjectionCalculationResult';
  projection: Array<DistanceProjection>;
};

export type PropertyDefinition = {
  __typename?: 'PropertyDefinition';
  createdAt: Scalars['Date']['output'];
  identifier: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
  value: Scalars['PropertyValue']['output'];
  valueType: PropertyValueType;
};

export type PropertyGroup = {
  __typename?: 'PropertyGroup';
  properties: Array<PropertyDefinition>;
  propertyIdentifier: Scalars['String']['output'];
};

export enum PropertyType {
  GlobalState = 'GLOBAL_STATE',
  Organization = 'ORGANIZATION',
  StateByUser = 'STATE_BY_USER',
  User = 'USER'
}

export type PropertyUpdateInput = {
  identifier: Scalars['String']['input'];
  propertyIdentifier: Scalars['String']['input'];
  propertyType: PropertyType;
  value: Scalars['PropertyValue']['input'];
  valueType: PropertyValueType;
};

export type PropertyUpdateNotification = {
  __typename?: 'PropertyUpdateNotification';
  identifier: Scalars['String']['output'];
  propertyIdentifier: Scalars['String']['output'];
  propertyType: PropertyType;
  value: Scalars['PropertyValue']['output'];
  valueType: PropertyValueType;
};

export enum PropertyValueType {
  Boolean = 'BOOLEAN',
  Color = 'COLOR',
  Coordinate = 'COORDINATE',
  Float = 'FLOAT',
  FloatArray = 'FLOAT_ARRAY',
  Gradient = 'GRADIENT',
  Int = 'INT',
  Json = 'JSON',
  MinMax = 'MIN_MAX',
  Range = 'RANGE',
  Select = 'SELECT',
  String = 'STRING'
}

export type Query = {
  __typename?: 'Query';
  currentUser?: Maybe<User>;
  debugTools: DebugTools;
  isLocalStorageEnabled: Scalars['Boolean']['output'];
  navvisListDatasets: Array<NavVisDataset>;
  notifications: Array<Notification>;
  objectDefinition: ObjectDefinition;
  /** Every published version of the object, newest first. */
  objectDefinitionVersions: Array<ObjectDefinitionVersion>;
  organisationAPIKeyByLicenseKey: ApiKeyByLicenseKeyResult;
  organisationBilling: OrganisationBilling;
  organisationById: Organisation;
  organisationCreditLedger: PaginatedCreditLedger;
  /**
   * The PDF of the invoice sales sent for a row of the organisation's credit ledger (a row with a sentInvoiceNumber).
   * Fails with INVOICE_NOT_SENT while there is none.
   */
  organisationInvoicePdf: InvoicePdf;
  organisationJwtToken: Scalars['String']['output'];
  /**
   * The organisation's library for its library page and editor: its configuration and every definition that is not
   * archived (archived ones too with includeArchived). Drafts are only listed for those who can edit.
   */
  organisationObjectLibrary: ObjectLibrary;
  /** A write SAS on the organisation's container, for uploading object assets (then objectDefinitionAttachAsset). */
  organisationObjectLibraryUploadSAS: Scalars['String']['output'];
  /**
   * Simulates organisationChangePlan: what moving to the plan means and costs, with the customer's defaults
   * (today, the renewal date as it is, the computed price).
   */
  organisationPlanChangePreview: PlanChangePreview;
  /**
   * The organisation's referrals: its link, its counts, and for a reseller or partner its money. Sales to its
   * referred organisations are attributed first, so the page is current.
   */
  organisationReferralOverview: ReferralOverview;
  /**
   * The PDF of the bill behind one of the organisation's paid payouts. Fails with BILL_NOT_AVAILABLE while Odoo
   * holds no PDF for it, or the payout is not paid.
   */
  organisationReferralPayoutPdf: InvoicePdf;
  /**
   * The organisation's templates for its library page and editor: the configuration and every template that is not
   * archived (archived ones too with includeArchived). Drafts are only listed for those who can edit.
   */
  organisationTemplateLibrary: TemplateLibrary;
  /** A write SAS on the organisation's container, for uploading template images, the logo and fonts (then attach them). */
  organisationTemplateLibraryUploadSAS: Scalars['String']['output'];
  organisations: Array<Organisation>;
  /** Simulates partnerCustomerSetBillingDate. */
  partnerCustomerBillingDatePreview: BillingDatePreview;
  /**
   * Simulates partnerCustomerChangePlan: what moving the customer to the plan means and what the partner is invoiced.
   * The partnerCustomer* fields fail with NOT_YOUR_CUSTOMER unless the customer is billed to the partner
   * (organisationId) and the partner orders for its customers (a RESELLER or FULL_SERVICE).
   */
  partnerCustomerPlanChangePreview: PlanChangePreview;
  printTemplate: PrintTemplate;
  /** Every published version of the template, newest first. */
  printTemplateVersions: Array<PrintTemplateVersion>;
  projectById: Project;
  projectCommentsByObjectId: PaginatedComments;
  /**
   * What a project renders: the configuration and every published definition of the project's organisation,
   * archived ones included (objects placed before the archive keep their look). Open to share-link visitors.
   */
  projectObjectLibrary: ObjectLibrary;
  /** The exact template version a sheet pins (also archived templates and older versions). Fails with NOT_FOUND. */
  projectPrintTemplateVersion: PrintTemplateVersion;
  projectRequestDownloadToken: Scalars['String']['output'];
  projectRequestReadSASToken: Scalars['String']['output'];
  projectRequestUploadSAS: Scalars['String']['output'];
  projectSheet: ProjectSheet;
  /** The project's sheets, oldest first. */
  projectSheets: Array<ProjectSheet>;
  /** What a project's sheets may use: the configuration (brand kit included) and every published, non-archived template. */
  projectTemplateLibrary: TemplateLibrary;
  projectsByOrganisationId: Array<Project>;
  /** Who is behind a referral link, for the register page. Fails with NOT_FOUND for a token nobody has. */
  referralInfo: ReferralInfo;
  sharedProjectInfo?: Maybe<SharedProjectInfo>;
  /** Simulates superadminSetBillingDate with the same arguments. */
  superadminBillingDatePreview: BillingDatePreview;
  /**
   * The organisation's grants, fees and removals. includeCharges: every row of the ledger, the charges for
   * processed projects too.
   */
  superadminCreditLedger: PaginatedCreditLedger;
  superadminFailedPointCloudCounts: FailedPointCloudCounts;
  /** The failed conversions, the most recent failure first; all statuses when none is given. */
  superadminFailedPointClouds: PaginatedFailedPointClouds;
  superadminInvoiceCounts: InvoiceCounts;
  /** Every sale to invoice across the organisations, the most recent first; all statuses when none is given. */
  superadminInvoices: PaginatedTrackedInvoices;
  /**
   * The grants that still hold credits (remaining above zero, not expired), in the order they are spent:
   * expiring ones first by expiry, then the others oldest first.
   */
  superadminLiveGrants: Array<CreditLedgerEntry>;
  superadminOrganisations: PaginatedOrganisation;
  /** New organisations per month, oldest first; months without any are left out. */
  superadminOrganisationsPerMonth: Array<OrganisationsPerMonth>;
  /** Simulates superadminUpdatePlan with the same arguments. */
  superadminPlanChangePreview: PlanChangePreview;
  /**
   * Every file at the root of the project's storage — the uploaded sources, a zip included — with a
   * download link. Unlike the point cloud download, it does not need a point cloud entry: it works on a
   * project whose relaunch cleared them, or whose source never became one.
   */
  superadminProjectSourceFiles: Array<ProjectSourceFile>;
  /** Every sale attributed to the organisation and every payout made to it, newest first, with their Odoo records. */
  superadminReferralHistory: ReferralHistory;
  /** The organisations linked to the organisation, and the others (those matching the search) to link to it. */
  superadminReferrals: SuperadminReferrals;
  userInviteInfo: InviteInfo;
  usersByOrganisationId: Array<User>;
};


export type QueryNavvisListDatasetsArgs = {
  accessToken: Scalars['String']['input'];
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  siteId: Scalars['BigInt']['input'];
};


export type QueryObjectDefinitionArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type QueryObjectDefinitionVersionsArgs = {
  definitionId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationApiKeyByLicenseKeyArgs = {
  licenseKey: Scalars['String']['input'];
};


export type QueryOrganisationBillingArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationByIdArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationCreditLedgerArgs = {
  organisationId: Scalars['ID']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QueryOrganisationInvoicePdfArgs = {
  entryId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationJwtTokenArgs = {
  apiKey?: InputMaybe<Scalars['String']['input']>;
  licenseKey?: InputMaybe<Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationObjectLibraryArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationObjectLibraryUploadSasArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationPlanChangePreviewArgs = {
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
};


export type QueryOrganisationReferralOverviewArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationReferralPayoutPdfArgs = {
  organisationId: Scalars['ID']['input'];
  payoutId: Scalars['ID']['input'];
};


export type QueryOrganisationTemplateLibraryArgs = {
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationTemplateLibraryUploadSasArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryOrganisationsArgs = {
  includeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPartnerCustomerBillingDatePreviewArgs = {
  customerOrganisationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  renewalDate: Scalars['Date']['input'];
};


export type QueryPartnerCustomerPlanChangePreviewArgs = {
  customerOrganisationId: Scalars['ID']['input'];
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
};


export type QueryPrintTemplateArgs = {
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type QueryPrintTemplateVersionsArgs = {
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
};


export type QueryProjectByIdArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectCommentsByObjectIdArgs = {
  objectId: Scalars['ID']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
  projectId: Scalars['ID']['input'];
};


export type QueryProjectObjectLibraryArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectPrintTemplateVersionArgs = {
  projectId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
};


export type QueryProjectRequestDownloadTokenArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectRequestReadSasTokenArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectRequestUploadSasArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectSheetArgs = {
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
};


export type QueryProjectSheetsArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectTemplateLibraryArgs = {
  projectId: Scalars['ID']['input'];
};


export type QueryProjectsByOrganisationIdArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QueryReferralInfoArgs = {
  token: Scalars['String']['input'];
};


export type QuerySuperadminBillingDatePreviewArgs = {
  chargeCents?: InputMaybe<Scalars['Int']['input']>;
  organisationId: Scalars['ID']['input'];
  renewalDate: Scalars['Date']['input'];
};


export type QuerySuperadminCreditLedgerArgs = {
  includeCharges?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId: Scalars['ID']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QuerySuperadminFailedPointCloudsArgs = {
  pagination?: InputMaybe<CursorPaginationInput>;
  status?: InputMaybe<FailedPointCloudStatus>;
};


export type QuerySuperadminInvoicesArgs = {
  pagination?: InputMaybe<CursorPaginationInput>;
  status?: InputMaybe<InvoiceTrackingStatus>;
};


export type QuerySuperadminLiveGrantsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QuerySuperadminOrganisationsArgs = {
  filters?: InputMaybe<InputSuperadminOrganisationFilters>;
  pagination?: InputMaybe<CursorPaginationInput>;
};


export type QuerySuperadminOrganisationsPerMonthArgs = {
  filters?: InputMaybe<InputSuperadminOrganisationFilters>;
};


export type QuerySuperadminPlanChangePreviewArgs = {
  chargeCents?: InputMaybe<Scalars['Int']['input']>;
  customLimits?: InputMaybe<InputSubscriptionCustomLimits>;
  effectiveAt?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
};


export type QuerySuperadminProjectSourceFilesArgs = {
  projectId: Scalars['ID']['input'];
};


export type QuerySuperadminReferralHistoryArgs = {
  organisationId: Scalars['ID']['input'];
};


export type QuerySuperadminReferralsArgs = {
  organisationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUserInviteInfoArgs = {
  token: Scalars['String']['input'];
};


export type QueryUsersByOrganisationIdArgs = {
  organisationId: Scalars['ID']['input'];
};

/** FIRST: the customer's opening subscription sale (once per customer and partner). RECURRING: everything after it. */
export enum ReferralDealKind {
  First = 'FIRST',
  Recurring = 'RECURRING'
}

export type ReferralHistory = {
  __typename?: 'ReferralHistory';
  payouts: Array<ReferralPayout>;
  sales: Array<ReferralSale>;
};

/** What a visitor of the register page may know about a referral link. */
export type ReferralInfo = {
  __typename?: 'ReferralInfo';
  organisationName: Scalars['String']['output'];
};

export type ReferralMilestone = {
  __typename?: 'ReferralMilestone';
  projects: Scalars['Int']['output'];
  reached: Scalars['Boolean']['output'];
  sales: Scalars['Int']['output'];
};

export type ReferralOverview = {
  __typename?: 'ReferralOverview';
  customersCanCancel: Scalars['Boolean']['output'];
  /**
   * Partners, in cents: the cut of every paid sale; of what is not paid out yet (payable, or in a
   * payout whose bill is not paid); and of what was paid out (the payout's bill is paid).
   */
  earnedCents: Scalars['Int']['output'];
  firstCutBasisPoints: Scalars['Int']['output'];
  /** The customer bonuses, at so many paid subscription sales, and how far along the organisation is. */
  milestones: Array<ReferralMilestone>;
  minPayoutCents: Scalars['Int']['output'];
  organisationId: Scalars['ID']['output'];
  paidOutCents: Scalars['Int']['output'];
  payoutCadence: ReferralPayoutCadence;
  /** Partners: the payouts whose bill Pointorama paid, newest first — the ones with a bill to download. */
  payouts: Array<ReferralPayout>;
  /** Partners: the cut of the sales awaiting payment, in cents. */
  pendingCents: Scalars['Int']['output'];
  pendingSalesCount: Scalars['Int']['output'];
  recurringCutBasisPoints: Scalars['Int']['output'];
  /** Organisations that registered through the link, whether they bought anything yet or not. */
  referredCount: Scalars['Int']['output'];
  /** RESELLER and FULL_SERVICE: the customers the partner acquired, manages or is billed for; empty for the others. */
  referredOrganisations: Array<ReferredOrganisation>;
  role: ReferralRole;
  /** Partners: every sale attributed to the partner (voided ones left out), newest first; empty for a CUSTOMER. */
  sales: Array<ReferralSale>;
  /**
   * Sales whose invoice the customer paid: the ones that count. Sales still awaiting payment are counted apart.
   * For a CUSTOMER referrer only subscription sales are counted: an individual project purchase awards nothing.
   */
  salesCount: Scalars['Int']['output'];
  /** The link's token, null until organisationReferralLinkGenerate. The link is <origin>/register?ref=<token>. */
  token?: Maybe<Scalars['String']['output']>;
  unpaidCents: Scalars['Int']['output'];
};

/** A partner organisation a customer is linked to. */
export type ReferralPartnerLink = {
  __typename?: 'ReferralPartnerLink';
  at: Scalars['Date']['output'];
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
};

export type ReferralPayout = {
  __typename?: 'ReferralPayout';
  cadence: ReferralPayoutCadence;
  claimedAt?: Maybe<Scalars['Date']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  manual: Scalars['Boolean']['output'];
  odooVendorBillId?: Maybe<Scalars['Int']['output']>;
  odooVendorBillUrl?: Maybe<Scalars['String']['output']>;
  /** When Odoo reported the vendor bill paid: the cut is paid out from then on. */
  paidAt?: Maybe<Scalars['Date']['output']>;
  periodEnd: Scalars['Date']['output'];
  periodKey: Scalars['String']['output'];
  periodStart: Scalars['Date']['output'];
  saleCount: Scalars['Int']['output'];
  totalCents: Scalars['Int']['output'];
};

export enum ReferralPayoutCadence {
  Monthly = 'MONTHLY',
  Yearly = 'YEARLY'
}

/**
 * What an organisation is to the referral programme: a CUSTOMER (the default) earns a project per sale to the
 * organisations it referred. The partners earn a cut of their customers' sales, paid out as a draft vendor bill:
 * a LEAD_GENERATOR brings customers in that Pythagoras bills (a commission on the opening sale); a RESELLER orders
 * for its customers and is billed for them (a margin on every sale); a FULL_SERVICE partner does the same and
 * supports them too (it may look into their organisations).
 */
export enum ReferralRole {
  Customer = 'CUSTOMER',
  FullService = 'FULL_SERVICE',
  LeadGenerator = 'LEAD_GENERATOR',
  Reseller = 'RESELLER'
}

export type ReferralSale = {
  __typename?: 'ReferralSale';
  /** What Pythagoras invoiced for the sale, before VAT. */
  amountCents: Scalars['Int']['output'];
  credits?: Maybe<Scalars['Int']['output']>;
  cutBasisPoints: Scalars['Int']['output'];
  cutCents: Scalars['Int']['output'];
  dealKind: ReferralDealKind;
  /** A margin on a customer billed to the partner: deducted on the partner's invoice as a discount, never paid out. */
  deductedOnInvoice: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  invoicePaidAt?: Maybe<Scalars['Date']['output']>;
  ledgerEntryId: Scalars['ID']['output'];
  ledgerEntryType: CreditLedgerEntryType;
  odooInvoiceId?: Maybe<Scalars['Int']['output']>;
  odooInvoiceUrl?: Maybe<Scalars['String']['output']>;
  payoutId?: Maybe<Scalars['ID']['output']>;
  /** What was sold: a subscription fee's kind and plan, or the projects a purchase granted. */
  pricingKind?: Maybe<FeePricingKind>;
  referredOrganisationId: Scalars['ID']['output'];
  referredOrganisationName: Scalars['String']['output'];
  rewardGrantId?: Maybe<Scalars['ID']['output']>;
  roleAtSale: ReferralRole;
  soldAt: Scalars['Date']['output'];
  state: ReferralSaleState;
  subscriptionType?: Maybe<SubscriptionType>;
  voidReason?: Maybe<ReferralSaleVoidReason>;
  voidedAt?: Maybe<Scalars['Date']['output']>;
};

/**
 * PENDING until Odoo reports the customer invoice paid, PAYABLE until a payout takes it, PAID_OUT once one has;
 * VOID when the sale fell through.
 */
export enum ReferralSaleState {
  PaidOut = 'PAID_OUT',
  Payable = 'PAYABLE',
  Pending = 'PENDING',
  Void = 'VOID'
}

export enum ReferralSaleVoidReason {
  Cancelled = 'CANCELLED',
  Deleted = 'DELETED',
  InvoiceCancelled = 'INVOICE_CANCELLED'
}

export type ReferredOrganisation = {
  __typename?: 'ReferredOrganisation';
  acquiredByYou: Scalars['Boolean']['output'];
  /** Of those, the ones whose invoice is not paid yet. */
  awaitingPaymentCount: Scalars['Int']['output'];
  /** The partner is invoiced for this customer and orders for it. */
  billedToYou: Scalars['Boolean']['output'];
  /** Whether the partner may open the organisation (a full-service partner, which supports its customers). */
  canVisit: Scalars['Boolean']['output'];
  cutCents: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  joinedAt: Scalars['Date']['output'];
  managedByYou: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  /** What one extra project costs the customer's plan, in cents (what the partner is invoiced per project). */
  projectUnitPriceCents: Scalars['Int']['output'];
  projectsCount: Scalars['Int']['output'];
  salesAmountCents: Scalars['Int']['output'];
  /** The customer's sales that did not fall through, paid or awaiting payment, and their amounts and the cut on them. */
  salesCount: Scalars['Int']['output'];
  scheduledAt?: Maybe<Scalars['Date']['output']>;
  /** The next pending plan change (FLEX = the subscription ends then). */
  scheduledType?: Maybe<SubscriptionType>;
  status: ReferredOrganisationStatus;
  subscriptionEndsAt?: Maybe<Scalars['Date']['output']>;
  subscriptionPaused: Scalars['Boolean']['output'];
  subscriptionType: SubscriptionType;
  usersCount: Scalars['Int']['output'];
};

export enum ReferredOrganisationStatus {
  HasSales = 'HAS_SALES',
  NoSales = 'NO_SALES'
}

export type RoomGroup = Group & {
  __typename?: 'RoomGroup';
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentIdentifier?: Maybe<Scalars['String']['output']>;
  type: GroupType;
};

export type SalesRequestNotification = Notification & {
  __typename?: 'SalesRequestNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: SalesRequestNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type SalesRequestNotificationMeta = {
  __typename?: 'SalesRequestNotificationMeta';
  message: Scalars['String']['output'];
  organisationName: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type SetAnnotationPointsAction = {
  annotationIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
  points: Array<SetAnnotationPointsActionPoint>;
};

export type SetAnnotationPointsActionPoint = {
  pointCloudId?: InputMaybe<Scalars['String']['input']>;
  position: InputPosition;
};

/** The project a share token unlocks; null when the request carries no valid, enabled token. */
export type SharedProjectInfo = {
  __typename?: 'SharedProjectInfo';
  name: Scalars['String']['output'];
  organisationId: Scalars['ID']['output'];
  projectId: Scalars['ID']['output'];
};

export enum SkeletonWallType {
  Block = 'BLOCK',
  Inner = 'INNER',
  Outer = 'OUTER'
}

export type StateByUser = {
  __typename?: 'StateByUser';
  hiddenIdentifiers: Array<Scalars['String']['output']>;
  properties: Array<PropertyGroup>;
  userId: Scalars['ID']['output'];
};


export type StateByUserPropertiesArgs = {
  propertyIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Subscription = {
  __typename?: 'Subscription';
  organizationPropertyUpdates: PropertyUpdateNotification;
  projectPropertyUpdates: PropertyUpdateNotification;
  userPropertyUpdates: PropertyUpdateNotification;
};


export type SubscriptionOrganizationPropertyUpdatesArgs = {
  organizationId: Scalars['ID']['input'];
};


export type SubscriptionProjectPropertyUpdatesArgs = {
  projectId: Scalars['ID']['input'];
};


export type SubscriptionUserPropertyUpdatesArgs = {
  userId: Scalars['ID']['input'];
};

export type SubscriptionCustomLimits = {
  __typename?: 'SubscriptionCustomLimits';
  monthlyCredits?: Maybe<Scalars['Int']['output']>;
  projectUnitPrice?: Maybe<Scalars['Int']['output']>;
  subscriptionPrice?: Maybe<Scalars['Int']['output']>;
};

/** A customer bought a subscription, or upgraded theirs, by themselves. For superadmins. */
export type SubscriptionPurchasedNotification = Notification & {
  __typename?: 'SubscriptionPurchasedNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  /** The fee the sale wrote, with its invoice in Odoo. */
  ledgerEntry?: Maybe<CreditLedgerEntry>;
  meta: SubscriptionPurchasedNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type SubscriptionPurchasedNotificationMeta = {
  __typename?: 'SubscriptionPurchasedNotificationMeta';
  /** Set on an upgrade: the plan it was upgraded from. */
  fromSubscriptionType?: Maybe<SubscriptionType>;
  organisationName: Scalars['String']['output'];
  subscriptionType: SubscriptionType;
  userName: Scalars['String']['output'];
};

/**
 * What stands out about an organisation's subscription: PAUSED (paused in Odoo), CANCELLED (its next change ends it:
 * it does not renew). Both can apply at once.
 */
export enum SubscriptionStatusFilter {
  Cancelled = 'CANCELLED',
  Paused = 'PAUSED'
}

export enum SubscriptionType {
  Custom = 'CUSTOM',
  Flex = 'FLEX',
  Grow = 'GROW',
  Launch = 'LAUNCH',
  Scale = 'SCALE'
}

/** An organisation as the superadmin's manage window lists it: with who refers (acquired) it today, if anyone. */
export type SuperadminReferralOrganisation = {
  __typename?: 'SuperadminReferralOrganisation';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  referredAt?: Maybe<Scalars['Date']['output']>;
  referredById?: Maybe<Scalars['ID']['output']>;
  referredByName?: Maybe<Scalars['String']['output']>;
};

export type SuperadminReferrals = {
  __typename?: 'SuperadminReferrals';
  /** Every other organisation whose name matches the search, by name: the first 50 of othersTotal. */
  others: Array<SuperadminReferralOrganisation>;
  othersTotal: Scalars['Int']['output'];
  /** The organisations linked to the organisation in any way (acquired, managed or billed), by name. */
  referred: Array<SuperadminReferralOrganisation>;
};

export type SurfaceGroup = Group & {
  __typename?: 'SurfaceGroup';
  identifier: Scalars['String']['output'];
  name: Scalars['String']['output'];
  parentIdentifier?: Maybe<Scalars['String']['output']>;
  type: GroupType;
};

export type TemplateLibrary = {
  __typename?: 'TemplateLibrary';
  /** Whether the caller may create and edit templates and change the configuration. */
  canEdit: Scalars['Boolean']['output'];
  config: TemplateLibraryConfig;
  organisationId: Scalars['ID']['output'];
  templates: Array<PrintTemplate>;
};

/** The organisation's print setup: which built-ins it hides, the default template for new sheets and the brand kit. */
export type TemplateLibraryConfig = {
  __typename?: 'TemplateLibraryConfig';
  brand: PrintBrand;
  defaultTemplate?: Maybe<PrintTemplateRef>;
  fonts: Array<PrintFont>;
  hiddenBuiltinIds: Array<Scalars['String']['output']>;
  logo?: Maybe<PrintLogo>;
};

export type TemplateLibraryConfigInput = {
  brand: PrintBrandInput;
  defaultTemplate?: InputMaybe<PrintTemplateRefInput>;
  hiddenBuiltinIds: Array<Scalars['String']['input']>;
};

/** A sale to invoice (a priced project purchase or subscription fee), with where its invoice stands. */
export type TrackedInvoice = {
  __typename?: 'TrackedInvoice';
  entry: CreditLedgerEntry;
  organisation?: Maybe<Organisation>;
  status: InvoiceTrackingStatus;
};

export type UnGroupAction = {
  groupIdentifier: Scalars['String']['input'];
  identifier: Scalars['String']['input'];
};

export type UpdateNameAction = {
  annotationIdentifier?: InputMaybe<Scalars['String']['input']>;
  cadLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  orthophotoLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
  pointCloudIdentifier?: InputMaybe<Scalars['String']['input']>;
  wmsLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderingIdentifier = {
  identifier: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePositionAction = {
  identifier: Scalars['String']['input'];
  identifiers: Array<UpdatePositionActionIdentifiers>;
  toGroupIdentifier?: InputMaybe<Scalars['String']['input']>;
  toIndex: Scalars['Int']['input'];
};

export type UpdatePositionActionIdentifiers = {
  identifier: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type UpdatePositionOrthophotoLayerAction = {
  identifier: Scalars['String']['input'];
  identifiers: Array<UpdatePositionOrthophotoLayerActionIdentifiers>;
  toIndex: Scalars['Int']['input'];
};

export type UpdatePositionOrthophotoLayerActionIdentifiers = {
  identifier: Scalars['String']['input'];
};

export type UpdatePositionWmsLayerAction = {
  identifier: Scalars['String']['input'];
  identifiers: Array<UpdatePositionWmsLayerActionIdentifiers>;
  toIndex: Scalars['Int']['input'];
};

export type UpdatePositionWmsLayerActionIdentifiers = {
  identifier: Scalars['String']['input'];
};

export type UpdateWmsLayerAction = {
  identifier: Scalars['String']['input'];
  layerId: Scalars['String']['input'];
  layerName: Scalars['String']['input'];
  name: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  type: WmsType;
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum UploadStatus {
  AwaitingCredits = 'AWAITING_CREDITS',
  Error = 'ERROR',
  Progress = 'PROGRESS',
  Success = 'SUCCESS',
  Suspended = 'SUSPENDED'
}

export type User = {
  __typename?: 'User';
  allowedProjectIds: Array<Scalars['ID']['output']>;
  allowedProjects: Array<Project>;
  /** Whether the user may edit the organisation's object library (admins always; members when granted). */
  canEditObjectLibrary: Scalars['Boolean']['output'];
  /** Whether the user may edit the organisation's print templates (admins always; members when granted). */
  canEditTemplateLibrary: Scalars['Boolean']['output'];
  dateFormat: DateFormats;
  email: Scalars['String']['output'];
  favoriteProjectIds: Array<Scalars['ID']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isSuperAdmin?: Maybe<Scalars['Boolean']['output']>;
  joinDate?: Maybe<Scalars['Date']['output']>;
  language: Language;
  lastName: Scalars['String']['output'];
  measurementUnit: MeasurementUnits;
  name: Scalars['String']['output'];
  organisations: Array<Organisation>;
  /** A guest's level per allowed project (empty for other roles: they can do everything on every project). */
  projectAccess: Array<ProjectAccess>;
  properties: Array<PropertyGroup>;
  role: UserRole;
  rolesByOrganisation: Array<UserRoleOrganisation>;
  status?: Maybe<UserStatus>;
};


export type UserAllowedProjectIdsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserAllowedProjectsArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserCanEditObjectLibraryArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserCanEditTemplateLibraryArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserJoinDateArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserProjectAccessArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserRoleArgs = {
  organisationId: Scalars['ID']['input'];
};


export type UserStatusArgs = {
  organisationId: Scalars['ID']['input'];
};

export type UserAcceptedInvitationNotification = Notification & {
  __typename?: 'UserAcceptedInvitationNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: UserAcceptedInvitationNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type UserAcceptedInvitationNotificationMeta = {
  __typename?: 'UserAcceptedInvitationNotificationMeta';
  organisationName: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type UserGotMentionedNotification = Notification & {
  __typename?: 'UserGotMentionedNotification';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  isRead?: Maybe<Scalars['Boolean']['output']>;
  meta: UserGotMentionedNotificationMeta;
  organisationId: Scalars['ID']['output'];
  type: NotificationType;
};

export type UserGotMentionedNotificationMeta = {
  __typename?: 'UserGotMentionedNotificationMeta';
  commentId: Scalars['ID']['output'];
  mentioningUserId: Scalars['ID']['output'];
  mentioningUserName: Scalars['String']['output'];
  projectId: Scalars['ID']['output'];
  referenceObjectIdentifier: Scalars['String']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  ApiKey = 'API_KEY',
  Guest = 'GUEST',
  Member = 'MEMBER'
}

export type UserRoleOrganisation = {
  __typename?: 'UserRoleOrganisation';
  organisationId: Scalars['ID']['output'];
  role: UserRole;
};

export enum UserStatus {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  InvitePending = 'INVITE_PENDING'
}

export type VolumeCalculation = Calculation & {
  __typename?: 'VolumeCalculation';
  annotationIdentifier: Scalars['String']['output'];
  baseSurface: CalculationBaseSurfaces;
  id: Scalars['ID']['output'];
  isOutDated: Scalars['Boolean']['output'];
  paramInfo: VolumeCalculationParamInfo;
  pointCloudIdentifier: Scalars['String']['output'];
  result?: Maybe<VolumeCalculationResult>;
  status: GeneralStatus;
};

export type VolumeCalculationParamInfo = {
  __typename?: 'VolumeCalculationParamInfo';
  classificationFilters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  clippingFilter?: Maybe<Scalars['Int']['output']>;
  heightFilters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  intensityFilters?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  referenceHeight?: Maybe<Scalars['Float']['output']>;
  resolutionFilter?: Maybe<Scalars['Int']['output']>;
};

export type VolumeCalculationResult = {
  __typename?: 'VolumeCalculationResult';
  area: Scalars['Float']['output'];
  volume: Scalars['Float']['output'];
  volumeNegative: Scalars['Float']['output'];
  volumePositive: Scalars['Float']['output'];
};

export type WmsLayer = {
  __typename?: 'WMSLayer';
  identifier: Scalars['String']['output'];
  layerName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  type: WmsType;
  url: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
  visible: Scalars['Boolean']['output'];
};

export enum WmsType {
  Wms = 'WMS',
  Wmts = 'WMTS'
}

export type OrderedIdentifier = {
  __typename?: 'orderedIdentifier';
  identifier: Scalars['String']['output'];
  index: Scalars['Int']['output'];
};

export type PaginatedComments = {
  __typename?: 'paginatedComments';
  data: Array<Comment>;
  hasMore: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type StateByLayer = {
  __typename?: 'stateByLayer';
  layerElevation?: Maybe<Scalars['Float']['output']>;
  layerId: Scalars['String']['output'];
};

type ApiKey_ApiKeyWithLicenseKey_Fragment = { __typename?: 'ApiKeyWithLicenseKey', licenseKey: string, name: string, apiKey: string };

type ApiKey_DefaultApiKey_Fragment = { __typename?: 'DefaultApiKey', name: string, apiKey: string };

export type ApiKeyFragment =
  | ApiKey_ApiKeyWithLicenseKey_Fragment
  | ApiKey_DefaultApiKey_Fragment
;

export type CreateApiKeyMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  keyType: ApiKeyType;
  licenseKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey: { __typename?: 'Organisation', id: string, apiKeys: Array<
      | { __typename?: 'ApiKeyWithLicenseKey', licenseKey: string, name: string, apiKey: string }
      | { __typename?: 'DefaultApiKey', name: string, apiKey: string }
    > } };

export type DeleteApiKeyMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  apiKey: Scalars['String']['input'];
}>;


export type DeleteApiKeyMutation = { __typename?: 'Mutation', deleteApiKey: { __typename?: 'Organisation', id: string, apiKeys: Array<
      | { __typename?: 'ApiKeyWithLicenseKey', licenseKey: string, name: string, apiKey: string }
      | { __typename?: 'DefaultApiKey', name: string, apiKey: string }
    > } };

export type ApiKeysQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type ApiKeysQuery = { __typename?: 'Query', organisation: { __typename?: 'Organisation', id: string, apiKeys: Array<
      | { __typename?: 'ApiKeyWithLicenseKey', licenseKey: string, name: string, apiKey: string }
      | { __typename?: 'DefaultApiKey', name: string, apiKey: string }
    > } };

export type DebugToolsQueryVariables = Exact<{ [key: string]: never; }>;


export type DebugToolsQuery = { __typename?: 'Query', debugTools: { __typename?: 'DebugTools', enabled: boolean, steps: Array<{ __typename?: 'DebugDailyStep', key: string, label: string }>, odooCrons: Array<{ __typename?: 'DebugOdooCron', id: number, name: string, active: boolean, nextCall?: string | null }> } };

export type DebugRunDailyJobMutationVariables = Exact<{
  now: Scalars['Date']['input'];
  steps?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type DebugRunDailyJobMutation = { __typename?: 'Mutation', debugRunDailyJob: Array<{ __typename?: 'DebugStepResult', key: string, label: string, ok: boolean, result?: string | null, error?: string | null, durationMs: number }> };

export type DebugRunOdooCronMutationVariables = Exact<{
  cronId: Scalars['Int']['input'];
}>;


export type DebugRunOdooCronMutation = { __typename?: 'Mutation', debugRunOdooCron: boolean };

export type DebugMakeOdooOrderDueMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type DebugMakeOdooOrderDueMutation = { __typename?: 'Mutation', debugMakeOdooOrderDue: { __typename?: 'Organisation', id: string } };

export type NavvisAuthenticateMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
  baseUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type NavvisAuthenticateMutation = { __typename?: 'Mutation', navvisAuthenticate: { __typename?: 'NavVisAuthResult', accessToken: string, refreshToken: string, sites: Array<{ __typename?: 'NavVisSite', id: any, name: string }> } };

export type NavvisListDatasetsQueryVariables = Exact<{
  accessToken: Scalars['String']['input'];
  siteId: Scalars['BigInt']['input'];
  baseUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type NavvisListDatasetsQuery = { __typename?: 'Query', navvisListDatasets: Array<{ __typename?: 'NavVisDataset', name: string, pointCloudType: string, referenceSystemId?: any | null, siteId: any, siteName: string }> };

export type NavvisImportDatasetMutationVariables = Exact<{
  accessToken: Scalars['String']['input'];
  siteId: Scalars['BigInt']['input'];
  siteName: Scalars['String']['input'];
  datasetName: Scalars['String']['input'];
  referenceSystemId?: InputMaybe<Scalars['BigInt']['input']>;
  organisationId: Scalars['ID']['input'];
  projectName: Scalars['String']['input'];
  projectDescription?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
}>;


export type NavvisImportDatasetMutation = { __typename?: 'Mutation', navvisImportDataset: { __typename?: 'Project', id: string, name: string, uploadStatus: UploadStatus } };

export type NotificationsQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationsQuery = { __typename?: 'Query', notifications: Array<
    | { __typename?: 'CreditsPurchasedNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'CreditsPurchasedNotificationMeta', organisationName: string, userName: string, amount: number }, ledgerEntry?: { __typename?: 'CreditLedgerEntry', id: string, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, odooInvoiceNumber?: string | null } | null }
    | { __typename?: 'CustomerRenewalNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'CustomerRenewalNotificationMeta', customerOrganisationId: string, customerName: string, subscriptionType: SubscriptionType, renewsAt: number } }
    | { __typename?: 'OrganisationInviteNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'OrganisationInviteNotificationMeta', organisationName: string, invitedByName: string, inviteToken: string, inviteProjectId?: string | null, inviteProjectName?: string | null } }
    | { __typename?: 'PointCloudCalculationDoneNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'PointCloudCalculationDoneNotificationMeta', projectId: string, projectName: string, status?: GeneralStatus | null, annotationIdentifier?: string | null } }
    | { __typename?: 'PointCloudConvertDoneNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'PointCloudConvertDoneNotificationMeta', projectId: string, projectName: string, uploadStatus?: UploadStatus | null } }
    | { __typename?: 'PointCloudExportDoneNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'PointCloudExportDoneNotificationMeta', projectId: string, projectName: string, status?: GeneralStatus | null, thisExport?: { __typename?: 'Export', exportId?: string | null, type: string, status: GeneralStatus, createdAt?: number | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } } | null } }
    | { __typename?: 'ProjectAwaitingCreditsNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'ProjectAwaitingCreditsNotificationMeta', projectId: string, projectName: string, requiredCredits: number } }
    | { __typename?: 'ProjectCustomDealNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'ProjectCustomDealNotificationMeta', projectId: string, projectName: string, organisationId: string, pointCountTotal: number } }
    | { __typename?: 'ProjectInviteNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'ProjectInviteNotificationMeta', projectId: string, projectName: string, organisationName: string, invitedByName: string } }
    | { __typename?: 'SalesRequestNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'SalesRequestNotificationMeta', organisationName: string, userName: string, userEmail: string, message: string } }
    | { __typename?: 'SubscriptionPurchasedNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'SubscriptionPurchasedNotificationMeta', organisationName: string, userName: string, subscriptionType: SubscriptionType, fromSubscriptionType?: SubscriptionType | null }, ledgerEntry?: { __typename?: 'CreditLedgerEntry', id: string, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, odooInvoiceNumber?: string | null } | null }
    | { __typename?: 'UserAcceptedInvitationNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'UserAcceptedInvitationNotificationMeta', organisationName: string, userName: string } }
    | { __typename?: 'UserGotMentionedNotification', organisationId: string, id: string, type: NotificationType, isRead?: boolean | null, createdAt: number, meta: { __typename?: 'UserGotMentionedNotificationMeta', projectId: string, mentioningUserId: string, mentioningUserName: string, referenceObjectIdentifier: string, commentId: string } }
  > };

export type NotificationsMarkAsReadMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type NotificationsMarkAsReadMutation = { __typename?: 'Mutation', notificationsMarkAsRead: boolean };

export type NotificationsDeleteMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type NotificationsDeleteMutation = { __typename?: 'Mutation', notificationsDelete: boolean };

export type NotificationsDeleteAllMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationsDeleteAllMutation = { __typename?: 'Mutation', notificationsDeleteAll: boolean };

export type ObjectDefinitionFieldsFragment = { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> };

export type ObjectLibraryFieldsFragment = { __typename?: 'ObjectLibrary', organisationId: string, canEdit: boolean, config: { __typename?: 'ObjectLibraryConfig', hiddenTypeIds: Array<string>, categories: Array<{ __typename?: 'ObjectLibraryCategory', id: string, label: string, order: number }>, typeOrder: Array<{ __typename?: 'ObjectLibraryTypePlacement', typeId: string, categoryId: string, order: number }> }, definitions: Array<{ __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> }> };

export type ProjectObjectLibraryQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectObjectLibraryQuery = { __typename?: 'Query', projectObjectLibrary: { __typename?: 'ObjectLibrary', organisationId: string, canEdit: boolean, config: { __typename?: 'ObjectLibraryConfig', hiddenTypeIds: Array<string>, categories: Array<{ __typename?: 'ObjectLibraryCategory', id: string, label: string, order: number }>, typeOrder: Array<{ __typename?: 'ObjectLibraryTypePlacement', typeId: string, categoryId: string, order: number }> }, definitions: Array<{ __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> }> } };

export type OrganisationObjectLibraryQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganisationObjectLibraryQuery = { __typename?: 'Query', organisationObjectLibrary: { __typename?: 'ObjectLibrary', organisationId: string, canEdit: boolean, config: { __typename?: 'ObjectLibraryConfig', hiddenTypeIds: Array<string>, categories: Array<{ __typename?: 'ObjectLibraryCategory', id: string, label: string, order: number }>, typeOrder: Array<{ __typename?: 'ObjectLibraryTypePlacement', typeId: string, categoryId: string, order: number }> }, definitions: Array<{ __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> }> } };

export type ObjectDefinitionQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
}>;


export type ObjectDefinitionQuery = { __typename?: 'Query', objectDefinition: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type OrganisationObjectLibraryUploadSasQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationObjectLibraryUploadSasQuery = { __typename?: 'Query', organisationObjectLibraryUploadSAS: string };

export type ObjectDefinitionCreateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  categoryId: Scalars['String']['input'];
  spec: Scalars['JSON']['input'];
  templateId?: InputMaybe<Scalars['String']['input']>;
  basedOnBuiltinId?: InputMaybe<Scalars['String']['input']>;
  duplicateOfDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  smart?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ObjectDefinitionCreateMutation = { __typename?: 'Mutation', objectDefinitionCreate: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type ObjectDefinitionUpdateDetailsMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  categoryId: Scalars['String']['input'];
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ObjectDefinitionUpdateDetailsMutation = { __typename?: 'Mutation', objectDefinitionUpdateDetails: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type ObjectDefinitionSaveDraftMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
  spec: Scalars['JSON']['input'];
}>;


export type ObjectDefinitionSaveDraftMutation = { __typename?: 'Mutation', objectDefinitionSaveDraft: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type ObjectDefinitionPublishMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
}>;


export type ObjectDefinitionPublishMutation = { __typename?: 'Mutation', objectDefinitionPublish: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type ObjectDefinitionDiscardDraftMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
}>;


export type ObjectDefinitionDiscardDraftMutation = { __typename?: 'Mutation', objectDefinitionDiscardDraft: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type ObjectDefinitionSetArchivedMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type ObjectDefinitionSetArchivedMutation = { __typename?: 'Mutation', objectDefinitionSetArchived: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type ObjectDefinitionDeleteMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
}>;


export type ObjectDefinitionDeleteMutation = { __typename?: 'Mutation', objectDefinitionDelete: boolean };

export type ObjectDefinitionAttachAssetMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
  kind: ObjectDefinitionAssetKind;
  blobName: Scalars['String']['input'];
  originalName: Scalars['String']['input'];
}>;


export type ObjectDefinitionAttachAssetMutation = { __typename?: 'Mutation', objectDefinitionAttachAsset: { __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number } };

export type OrganisationObjectLibraryUpdateConfigMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  config: ObjectLibraryConfigInput;
}>;


export type OrganisationObjectLibraryUpdateConfigMutation = { __typename?: 'Mutation', organisationObjectLibraryUpdateConfig: { __typename?: 'ObjectLibraryConfig', hiddenTypeIds: Array<string>, categories: Array<{ __typename?: 'ObjectLibraryCategory', id: string, label: string, order: number }>, typeOrder: Array<{ __typename?: 'ObjectLibraryTypePlacement', typeId: string, categoryId: string, order: number }> } };

export type ObjectDefinitionVersionsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
}>;


export type ObjectDefinitionVersionsQuery = { __typename?: 'Query', objectDefinitionVersions: Array<{ __typename?: 'ObjectDefinitionVersion', id: string, version: number, spec: any, name: string, categoryId: string, publishedAt: number, publishedByName?: string | null, isCurrent: boolean }> };

export type ObjectDefinitionRestoreVersionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type ObjectDefinitionRestoreVersionMutation = { __typename?: 'Mutation', objectDefinitionRestoreVersion: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type ObjectDefinitionActivateVersionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type ObjectDefinitionActivateVersionMutation = { __typename?: 'Mutation', objectDefinitionActivateVersion: { __typename?: 'ObjectDefinition', id: string, organisationId: string, typeId: string, name: string, description?: string | null, categoryId: string, tags: Array<string>, status: ObjectDefinitionStatus, version: number, activeVersion: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, templateId?: string | null, smart: boolean, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'ObjectDefinitionAsset', id: string, kind: ObjectDefinitionAssetKind, originalName: string, size: number, url: string, createdAt: number }> } };

export type ObjectDefinitionDeleteVersionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  definitionId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type ObjectDefinitionDeleteVersionMutation = { __typename?: 'Mutation', objectDefinitionDeleteVersion: boolean };

export type ObjectDefinitionGenerateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
  spec?: InputMaybe<Scalars['JSON']['input']>;
  kind?: InputMaybe<ObjectDefinitionKind>;
  image?: InputMaybe<Scalars['String']['input']>;
  progressChannel?: InputMaybe<Scalars['String']['input']>;
}>;


export type ObjectDefinitionGenerateMutation = { __typename?: 'Mutation', objectDefinitionGenerate: { __typename?: 'ObjectDefinitionGeneration', spec: any, summary: string, name?: string | null } };

export type OrganisationsFragment = { __typename?: 'Organisation', id: string, name: string, usersAmount: number, myPermissions: Array<Permissions>, isRootOrganisation?: boolean | null, prohibitedActions: Array<PossibleActions>, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, isFlex: boolean, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, cancellable: boolean, minPurchaseAmount: number, maxPurchaseAmount: number, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number }, referral: { __typename?: 'OrganisationReferral', canCancelSubscription: boolean, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null, liveGrants: Array<{ __typename?: 'CreditLedgerEntry', id: string, source: CreditLedgerEntrySource, remaining?: number | null, expiresAt?: number | null }> } };

export type OrganisationsQueryVariables = Exact<{
  includeIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type OrganisationsQuery = { __typename?: 'Query', organisations: Array<{ __typename?: 'Organisation', id: string, name: string, usersAmount: number, myPermissions: Array<Permissions>, isRootOrganisation?: boolean | null, prohibitedActions: Array<PossibleActions>, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, isFlex: boolean, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, cancellable: boolean, minPurchaseAmount: number, maxPurchaseAmount: number, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number }, referral: { __typename?: 'OrganisationReferral', canCancelSubscription: boolean, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null, liveGrants: Array<{ __typename?: 'CreditLedgerEntry', id: string, source: CreditLedgerEntrySource, remaining?: number | null, expiresAt?: number | null }> } }> };

export type OrganisationUpdateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
}>;


export type OrganisationUpdateMutation = { __typename?: 'Mutation', organisationUpdate: { __typename?: 'Organisation', id: string, name: string } };

export type OrganisationCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type OrganisationCreateMutation = { __typename?: 'Mutation', organisationCreate: { __typename?: 'Organisation', id: string, name: string, usersAmount: number, myPermissions: Array<Permissions>, isRootOrganisation?: boolean | null, prohibitedActions: Array<PossibleActions>, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, isFlex: boolean, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, cancellable: boolean, minPurchaseAmount: number, maxPurchaseAmount: number, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number }, referral: { __typename?: 'OrganisationReferral', canCancelSubscription: boolean, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null, liveGrants: Array<{ __typename?: 'CreditLedgerEntry', id: string, source: CreditLedgerEntrySource, remaining?: number | null, expiresAt?: number | null }> } } };

export type OrganisationDeleteMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationDeleteMutation = { __typename?: 'Mutation', organisationDelete: boolean };

export type OrganisationCreditLedgerQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type OrganisationCreditLedgerQuery = { __typename?: 'Query', organisationCreditLedger: { __typename?: 'PaginatedCreditLedger', nextCursor?: string | null, total: number, hasMore: boolean, data: Array<{ __typename?: 'CreditLedgerEntry', sentInvoiceNumber?: string | null, paymentStatus?: InvoicePaymentStatus | null, id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null }> } };

export type OrganisationInvoicePdfQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  entryId: Scalars['ID']['input'];
}>;


export type OrganisationInvoicePdfQuery = { __typename?: 'Query', organisationInvoicePdf: { __typename?: 'InvoicePdf', filename: string, base64: string } };

export type OrganisationCancelSubscriptionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationCancelSubscriptionMutation = { __typename?: 'Mutation', organisationCancelSubscription: { __typename?: 'Organisation', id: string, name: string, usersAmount: number, myPermissions: Array<Permissions>, isRootOrganisation?: boolean | null, prohibitedActions: Array<PossibleActions>, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, isFlex: boolean, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, cancellable: boolean, minPurchaseAmount: number, maxPurchaseAmount: number, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number }, referral: { __typename?: 'OrganisationReferral', canCancelSubscription: boolean, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null, liveGrants: Array<{ __typename?: 'CreditLedgerEntry', id: string, source: CreditLedgerEntrySource, remaining?: number | null, expiresAt?: number | null }> } } };

export type OrganisationContactSalesMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
}>;


export type OrganisationContactSalesMutation = { __typename?: 'Mutation', organisationContactSales: boolean };

export type OrganisationBillingFieldsFragment = { __typename?: 'OrganisationBilling', id: string, enabled: boolean, linked: boolean, complete: boolean, blank: boolean, info?: { __typename?: 'BillingInfo', companyName: string, street: string, street2?: string | null, city: string, zip: string, countryCode: string, vat?: string | null, email: string } | null };

export type OrganisationBillingQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationBillingQuery = { __typename?: 'Query', organisationBilling: { __typename?: 'OrganisationBilling', id: string, enabled: boolean, linked: boolean, complete: boolean, blank: boolean, info?: { __typename?: 'BillingInfo', companyName: string, street: string, street2?: string | null, city: string, zip: string, countryCode: string, vat?: string | null, email: string } | null } };

export type OrganisationBillingWithOdooQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationBillingWithOdooQuery = { __typename?: 'Query', organisationBilling: { __typename?: 'OrganisationBilling', id: string, enabled: boolean, linked: boolean, complete: boolean, blank: boolean, organisation: { __typename?: 'Organisation', id: string, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null } }, info?: { __typename?: 'BillingInfo', companyName: string, street: string, street2?: string | null, city: string, zip: string, countryCode: string, vat?: string | null, email: string } | null } };

export type OrganisationLinkBillingMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationLinkBillingMutation = { __typename?: 'Mutation', organisationLinkBilling: { __typename?: 'OrganisationBilling', id: string, enabled: boolean, linked: boolean, complete: boolean, blank: boolean, info?: { __typename?: 'BillingInfo', companyName: string, street: string, street2?: string | null, city: string, zip: string, countryCode: string, vat?: string | null, email: string } | null } };

export type OrganisationLinkBillingWithOdooMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationLinkBillingWithOdooMutation = { __typename?: 'Mutation', organisationLinkBilling: { __typename?: 'OrganisationBilling', id: string, enabled: boolean, linked: boolean, complete: boolean, blank: boolean, organisation: { __typename?: 'Organisation', id: string, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null } }, info?: { __typename?: 'BillingInfo', companyName: string, street: string, street2?: string | null, city: string, zip: string, countryCode: string, vat?: string | null, email: string } | null } };

export type OrganisationUpdateBillingMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  info: InputBillingInfo;
}>;


export type OrganisationUpdateBillingMutation = { __typename?: 'Mutation', organisationUpdateBilling: { __typename?: 'OrganisationBilling', id: string, enabled: boolean, linked: boolean, complete: boolean, blank: boolean, info?: { __typename?: 'BillingInfo', companyName: string, street: string, street2?: string | null, city: string, zip: string, countryCode: string, vat?: string | null, email: string } | null } };

export type OrganisationPurchaseCreditsMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
}>;


export type OrganisationPurchaseCreditsMutation = { __typename?: 'Mutation', organisationPurchaseCredits: { __typename?: 'CreditLedgerEntry', id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null } };

export type OrganisationPlanChangePreviewQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
}>;


export type OrganisationPlanChangePreviewQuery = { __typename?: 'Query', organisationPlanChangePreview: { __typename?: 'PlanChangePreview', kind: PlanChangeKind, subscriptionType: SubscriptionType, effectiveAt: number, scheduled: boolean, endDate?: number | null, totalValueCents: number, currentTermValueCents: number, dueCents: number, chargedCents: number, priceLocked: boolean, extraCredits: number, extraCreditsAt?: number | null, extraCreditsExpireAt?: number | null, problems: Array<PlanChangeProblem>, current: { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null }, after: { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null }, next?: { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null } | null, lines: Array<{ __typename?: 'PlanChargeLine', subscriptionType: SubscriptionType, from: number, to: number, months: number, monthlyPriceCents: number, totalCents: number }> } };

export type OrganisationChangePlanMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
}>;


export type OrganisationChangePlanMutation = { __typename?: 'Mutation', organisationChangePlan: { __typename?: 'Organisation', id: string, name: string, usersAmount: number, myPermissions: Array<Permissions>, isRootOrganisation?: boolean | null, prohibitedActions: Array<PossibleActions>, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, isFlex: boolean, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, cancellable: boolean, minPurchaseAmount: number, maxPurchaseAmount: number, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number }, referral: { __typename?: 'OrganisationReferral', canCancelSubscription: boolean, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null, liveGrants: Array<{ __typename?: 'CreditLedgerEntry', id: string, source: CreditLedgerEntrySource, remaining?: number | null, expiresAt?: number | null }> } } };

export type SuperadminSetBillingBlankMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  blank: Scalars['Boolean']['input'];
}>;


export type SuperadminSetBillingBlankMutation = { __typename?: 'Mutation', superadminSetBillingBlank: { __typename?: 'OrganisationBilling', id: string, enabled: boolean, linked: boolean, complete: boolean, blank: boolean, info?: { __typename?: 'BillingInfo', companyName: string, street: string, street2?: string | null, city: string, zip: string, countryCode: string, vat?: string | null, email: string } | null } };

export type ProjectsFragment = { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, isInitializing?: boolean | null, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, previewUrl?: string | null, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType, sourceProjectId: string } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null, cloudName: string, validation?: { __typename?: 'PointCloudValidation', status: GeneralStatus, isValid?: boolean | null, finishedAt?: number | null } | null }> };

export type ProjectStateFragment = { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
    | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
    | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
    | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
    | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
  >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
      | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
      | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
    > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> };

type Calculation_ProjectionCalculation_Fragment = { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } };

type Calculation_VolumeCalculation_Fragment = { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } };

export type CalculationFragment =
  | Calculation_ProjectionCalculation_Fragment
  | Calculation_VolumeCalculation_Fragment
;

export type ExportFragment = { __typename?: 'Export', exportId?: string | null, status: GeneralStatus, type: string, createdAt?: number | null, fileSize?: any | null, seen?: boolean | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } };

export type ProjectShellFragment = { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, myAccessLevel: ProjectAccessLevel, mapVisible: boolean, previewUrl?: string | null, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, hasClassifications: boolean, hasSources: boolean, uploadStatus: UploadStatus, cloudName: string, availableClasses: Array<number>, availableSources: Array<number>, visible: boolean, displayName: string, pointCount?: any | null }>, state: { __typename?: 'ProjectState', wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
        | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
        | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
      > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, settings?: { __typename?: 'ProjectSettings', projectionSystem?: string | null } | null, exports: Array<{ __typename?: 'Export', exportId?: string | null, status: GeneralStatus, type: string, createdAt?: number | null, fileSize?: any | null, seen?: boolean | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, comments?: Array<{ __typename?: 'Comment', id: string, comment: string, referenceIdentifier: string, createdAt: number, updatedAt?: number | null, user?: { __typename?: 'User', id: string, name: string } | null }> | null, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string, code: number, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null };

export type ProjectFragment = { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, myAccessLevel: ProjectAccessLevel, mapVisible: boolean, previewUrl?: string | null, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, hasClassifications: boolean, hasSources: boolean, uploadStatus: UploadStatus, cloudName: string, availableClasses: Array<number>, availableSources: Array<number>, visible: boolean, displayName: string, pointCount?: any | null }>, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
      | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
    >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
        | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
        | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
      > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, settings?: { __typename?: 'ProjectSettings', projectionSystem?: string | null } | null, calculations: Array<
    | { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
    | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
  >, exports: Array<{ __typename?: 'Export', exportId?: string | null, status: GeneralStatus, type: string, createdAt?: number | null, fileSize?: any | null, seen?: boolean | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, comments?: Array<{ __typename?: 'Comment', id: string, comment: string, referenceIdentifier: string, createdAt: number, updatedAt?: number | null, user?: { __typename?: 'User', id: string, name: string } | null }> | null, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string, code: number, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null };

export type ProjectsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type ProjectsQuery = { __typename?: 'Query', projectsByOrganisationId: Array<{ __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, isInitializing?: boolean | null, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, previewUrl?: string | null, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType, sourceProjectId: string } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null, cloudName: string, validation?: { __typename?: 'PointCloudValidation', status: GeneralStatus, isValid?: boolean | null, finishedAt?: number | null } | null }> }> };

export type ProjectByIdQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectByIdQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, myAccessLevel: ProjectAccessLevel, mapVisible: boolean, previewUrl?: string | null, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, hasClassifications: boolean, hasSources: boolean, uploadStatus: UploadStatus, cloudName: string, availableClasses: Array<number>, availableSources: Array<number>, visible: boolean, displayName: string, pointCount?: any | null }>, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, settings?: { __typename?: 'ProjectSettings', projectionSystem?: string | null } | null, calculations: Array<
      | { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
      | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
    >, exports: Array<{ __typename?: 'Export', exportId?: string | null, status: GeneralStatus, type: string, createdAt?: number | null, fileSize?: any | null, seen?: boolean | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }>, comments?: Array<{ __typename?: 'Comment', id: string, comment: string, referenceIdentifier: string, createdAt: number, updatedAt?: number | null, user?: { __typename?: 'User', id: string, name: string } | null }> | null, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string, code: number, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null } };

export type ProjectAnnotationStateQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectAnnotationStateQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }> }, calculations: Array<
      | { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
      | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
    > } };

export type ProjectCalculationsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectCalculationsQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, calculations: Array<
      | { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
      | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
    > } };

export type ProjectExportsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectExportsQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, exports: Array<{ __typename?: 'Export', exportId?: string | null, status: GeneralStatus, type: string, createdAt?: number | null, fileSize?: any | null, seen?: boolean | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectDeleteExportMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  exportId: Scalars['String']['input'];
}>;


export type ProjectDeleteExportMutation = { __typename?: 'Mutation', projectDeleteExport: { __typename?: 'Project', id: string, exports: Array<{ __typename?: 'Export', exportId?: string | null, status: GeneralStatus, type: string, createdAt?: number | null, fileSize?: any | null, seen?: boolean | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectMarkExportsSeenMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  exportIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ProjectMarkExportsSeenMutation = { __typename?: 'Mutation', projectMarkExportsSeen: { __typename?: 'Project', id: string, exports: Array<{ __typename?: 'Export', exportId?: string | null, status: GeneralStatus, type: string, createdAt?: number | null, fileSize?: any | null, seen?: boolean | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectRequestUploadSasQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectRequestUploadSasQuery = { __typename?: 'Query', projectRequestUploadSAS: string };

export type ProjectShareFragment = { __typename?: 'Project', id: string, share?: { __typename?: 'ProjectShare', enabled: boolean, token: string, createdAt: number } | null };

export type ProjectShareQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectShareQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, share?: { __typename?: 'ProjectShare', enabled: boolean, token: string, createdAt: number } | null } };

export type ProjectShareSetMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type ProjectShareSetMutation = { __typename?: 'Mutation', projectShareSet: { __typename?: 'Project', id: string, share?: { __typename?: 'ProjectShare', enabled: boolean, token: string, createdAt: number } | null } };

export type ProjectShareResetMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectShareResetMutation = { __typename?: 'Mutation', projectShareReset: { __typename?: 'Project', id: string, share?: { __typename?: 'ProjectShare', enabled: boolean, token: string, createdAt: number } | null } };

export type SharedProjectInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type SharedProjectInfoQuery = { __typename?: 'Query', sharedProjectInfo?: { __typename?: 'SharedProjectInfo', projectId: string, organisationId: string, name: string } | null };

export type ProjectRequestReadSasTokenQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectRequestReadSasTokenQuery = { __typename?: 'Query', projectRequestReadSASToken: string };

export type ProjectStartMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  fileNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  cloudNames?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  shouldMerge?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectStartMutation = { __typename?: 'Mutation', projectStart: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, isInitializing?: boolean | null, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, previewUrl?: string | null, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType, sourceProjectId: string } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null, cloudName: string, validation?: { __typename?: 'PointCloudValidation', status: GeneralStatus, isValid?: boolean | null, finishedAt?: number | null } | null }> } };

export type ProjectRelaunchMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectRelaunchMutation = { __typename?: 'Mutation', projectRelaunch: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, isInitializing?: boolean | null, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, previewUrl?: string | null, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType, sourceProjectId: string } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null, cloudName: string, validation?: { __typename?: 'PointCloudValidation', status: GeneralStatus, isValid?: boolean | null, finishedAt?: number | null } | null }> } };

export type ProjectValidatePointCloudMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cloudName: Scalars['String']['input'];
}>;


export type ProjectValidatePointCloudMutation = { __typename?: 'Mutation', projectValidatePointCloud: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, isInitializing?: boolean | null, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, previewUrl?: string | null, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType, sourceProjectId: string } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null, cloudName: string, validation?: { __typename?: 'PointCloudValidation', status: GeneralStatus, isValid?: boolean | null, finishedAt?: number | null } | null }> } };

export type ProjectStartWithPythagorasFilesMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cloudName: Scalars['String']['input'];
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  pointCount?: InputMaybe<Scalars['BigInt']['input']>;
}>;


export type ProjectStartWithPythagorasFilesMutation = { __typename?: 'Mutation', projectStartWithPythagorasFiles: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, isInitializing?: boolean | null, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, previewUrl?: string | null, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType, sourceProjectId: string } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null, cloudName: string, validation?: { __typename?: 'PointCloudValidation', status: GeneralStatus, isValid?: boolean | null, finishedAt?: number | null } | null }> } };

export type ProjectUpdateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type ProjectUpdateMutation = { __typename?: 'Mutation', projectUpdate: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, isInitializing?: boolean | null, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, previewUrl?: string | null, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType, sourceProjectId: string } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null, cloudName: string, validation?: { __typename?: 'PointCloudValidation', status: GeneralStatus, isValid?: boolean | null, finishedAt?: number | null } | null }> } };

export type ProjectUpdatePreviewImageMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  previewImageFileName: Scalars['String']['input'];
}>;


export type ProjectUpdatePreviewImageMutation = { __typename?: 'Mutation', projectUpdatePreviewImage: { __typename?: 'Project', id: string, name: string, description?: string | null, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, isInitializing?: boolean | null, isLocal?: boolean | null, storageBaseUrl?: string | null, storageContainer: string, previewUrl?: string | null, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, copy?: { __typename?: 'ProjectCopy', type: ProjectCopyType, sourceProjectId: string } | null, assignee?: { __typename?: 'User', id: string, name: string } | null, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null, cloudName: string, validation?: { __typename?: 'PointCloudValidation', status: GeneralStatus, isValid?: boolean | null, finishedAt?: number | null } | null }> } };

export type ProjectUpdateSettingsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  settings: InputProjectSettings;
}>;


export type ProjectUpdateSettingsMutation = { __typename?: 'Mutation', projectUpdateSettings: { __typename?: 'Project', id: string, settings?: { __typename?: 'ProjectSettings', projectionSystem?: string | null } | null } };

export type ProjectDeleteMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectDeleteMutation = { __typename?: 'Mutation', projectDelete: boolean };

export type ProjectActivateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectActivateMutation = { __typename?: 'Mutation', projectActivate: { __typename?: 'Project', uploadStatus: UploadStatus } };

export type SuperadminUnlockProjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SuperadminUnlockProjectMutation = { __typename?: 'Mutation', superadminUnlockProject: { __typename?: 'Project', id: string, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean } };

export type SuperadminDebugSetProjectStateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  state: InputProjectDebugState;
}>;


export type SuperadminDebugSetProjectStateMutation = { __typename?: 'Mutation', superadminDebugSetProjectState: { __typename?: 'Project', id: string, uploadStatus: UploadStatus, creditsOutstanding: number, creditsWaived: boolean, creditBreakdown: { __typename?: 'ProjectCreditBreakdown', pointCount: number, required: number, singleProjectMaxPoints: number }, pointClouds: Array<{ __typename?: 'PointCloud', id: string, pointCount?: any | null }> } };

export type ProjectChargeCreditsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectChargeCreditsMutation = { __typename?: 'Mutation', projectChargeCredits: { __typename?: 'Project', id: string, uploadStatus: UploadStatus, creditsOutstanding: number } };

export type ProjectDuplicateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
}>;


export type ProjectDuplicateMutation = { __typename?: 'Mutation', projectDuplicate: { __typename?: 'Project', id: string } };

export type ProjectCopyToOrganisationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  targetOrganisationId: Scalars['ID']['input'];
}>;


export type ProjectCopyToOrganisationMutation = { __typename?: 'Mutation', projectCopyToOrganisation: { __typename?: 'Project', id: string } };

export type ProjectCloneFromCloudMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  targetOrganisationId: Scalars['ID']['input'];
}>;


export type ProjectCloneFromCloudMutation = { __typename?: 'Mutation', projectCloneFromCloud: { __typename?: 'Project', id: string } };

export type IsLocalStorageEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type IsLocalStorageEnabledQuery = { __typename?: 'Query', isLocalStorageEnabled: boolean };

export type ProjectConfirmPointCloudUploadMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  fileNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  shouldMerge?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProjectConfirmPointCloudUploadMutation = { __typename?: 'Mutation', projectConfirmPointCloudUpload?: boolean | null };

export type ProjectCreateAnnotationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
  type: Scalars['AnnotationType']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  initialProperties?: InputMaybe<Array<PropertyUpdateInput> | PropertyUpdateInput>;
  clientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectCreateAnnotationMutation = { __typename?: 'Mutation', projectCreateAnnotation: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectCreateGroupMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type?: InputMaybe<GroupType>;
  annotationIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  parentIdentifier?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectCreateGroupMutation = { __typename?: 'Mutation', projectCreateGroup: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectDeleteSelectedMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  annotationIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  groupIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  clientId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectDeleteSelectedMutation = { __typename?: 'Mutation', projectDeleteSelected: { __typename?: 'Project', id: string } };

export type ProjectMoveAnnotationsToGroupMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  annotationIdentifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectMoveAnnotationsToGroupMutation = { __typename?: 'Mutation', projectMoveAnnotationsToGroup: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectUngroupMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
}>;


export type ProjectUngroupMutation = { __typename?: 'Mutation', projectUngroup: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectUpdateOrderingMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifiers: Array<UpdateOrderingIdentifier> | UpdateOrderingIdentifier;
  toIndex: Scalars['Int']['input'];
  toGroupIdentifier?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectUpdateOrderingMutation = { __typename?: 'Mutation', projectUpdateOrdering: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectCreateCadLayerMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cadLayerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
}>;


export type ProjectCreateCadLayerMutation = { __typename?: 'Mutation', projectCreateCadLayer: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectDeleteCadLayerMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cadLayerIdentifier: Scalars['String']['input'];
}>;


export type ProjectDeleteCadLayerMutation = { __typename?: 'Mutation', projectDeleteCadLayer: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectDeleteCadObjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cadLayerIdentifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  subIndex?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectDeleteCadObjectMutation = { __typename?: 'Mutation', projectDeleteCadObject: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectDeleteCadObjectGroupMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cadLayerIdentifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
}>;


export type ProjectDeleteCadObjectGroupMutation = { __typename?: 'Mutation', projectDeleteCadObjectGroup: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectHideCadObjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cadLayerIdentifier: Scalars['String']['input'];
  index: Scalars['Int']['input'];
  subIndex?: InputMaybe<Scalars['Int']['input']>;
  isGroup?: InputMaybe<Scalars['Boolean']['input']>;
  isLayer?: InputMaybe<Scalars['Boolean']['input']>;
  visible: Scalars['Boolean']['input'];
}>;


export type ProjectHideCadObjectMutation = { __typename?: 'Mutation', projectHideCadObject: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectConvertCadObjectMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cadObjects: Array<InputCadObject> | InputCadObject;
}>;


export type ProjectConvertCadObjectMutation = { __typename?: 'Mutation', projectConvertCadObject: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectCreateWmsLayerMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  layerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  layerName: Scalars['String']['input'];
  type: WmsType;
}>;


export type ProjectCreateWmsLayerMutation = { __typename?: 'Mutation', projectCreateWmsLayer: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectDeleteWmsLayerMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  wmsLayerIdentifier: Scalars['String']['input'];
}>;


export type ProjectDeleteWmsLayerMutation = { __typename?: 'Mutation', projectDeleteWmsLayer: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectUpdateWmsLayerMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  layerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  layerName: Scalars['String']['input'];
  type: WmsType;
}>;


export type ProjectUpdateWmsLayerMutation = { __typename?: 'Mutation', projectUpdateWmsLayer: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectUpdateWmsLayerOrderingMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  toIndex: Scalars['Int']['input'];
}>;


export type ProjectUpdateWmsLayerOrderingMutation = { __typename?: 'Mutation', projectUpdateWmsLayerOrdering: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectCreateOrthophotoLayerMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  layerId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type ProjectCreateOrthophotoLayerMutation = { __typename?: 'Mutation', projectCreateOrthophotoLayer: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectDeleteOrthophotoLayerMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  orthophotoLayerIdentifier: Scalars['String']['input'];
}>;


export type ProjectDeleteOrthophotoLayerMutation = { __typename?: 'Mutation', projectDeleteOrthophotoLayer: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectUpdateOrthophotoLayerOrderingMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  toIndex: Scalars['Int']['input'];
}>;


export type ProjectUpdateOrthophotoLayerOrderingMutation = { __typename?: 'Mutation', projectUpdateOrthophotoLayerOrdering: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> } } };

export type ProjectUpdateEntityNameMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  groupIdentifier?: InputMaybe<Scalars['String']['input']>;
  pointCloudIdentifier?: InputMaybe<Scalars['String']['input']>;
  cadLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
  wmsLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
  orthophotoLayerIdentifier?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectUpdateEntityNameMutation = { __typename?: 'Mutation', projectUpdateEntityName: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string, groupIdentifier?: string | null, type: any }>, groups: Array<
        | { __typename?: 'AnnotationGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'Floor', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'RoomGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
        | { __typename?: 'SurfaceGroup', type: GroupType, identifier: string, name: string, parentIdentifier?: string | null }
      >, orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, wmsLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, orthophotoLayerOrderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }>, cadLayers: Array<{ __typename?: 'CadLayer', identifier: string, name: string, fileUrl: string, fileName: string, visibleState: Array<
          | { __typename?: 'CadLayerVisibleStateDelete', index: number, isGroup?: boolean | null, subIndex?: number | null }
          | { __typename?: 'CadLayerVisibleStateHidden', index: number, isGroup?: boolean | null, isLayer?: boolean | null, layerIdentifier?: string | null, subIndex?: number | null, visible: boolean, userId: string }
        > }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, type: WmsType, name: string, url: string, username?: string | null, password?: string | null, layerName: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, name: string, visible: boolean, url: string, elevation?: number | null }> }, pointClouds: Array<{ __typename?: 'PointCloud', id: string, displayName: string }> } };

export type ProjectToggleObjectVisibilityMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifiers: Array<Scalars['String']['input']> | Scalars['String']['input'];
  visible: Scalars['Boolean']['input'];
}>;


export type ProjectToggleObjectVisibilityMutation = { __typename?: 'Mutation', projectToggleObjectVisibility: { __typename?: 'Project', id: string, mapVisible: boolean, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, visible: boolean }> }, pointClouds: Array<{ __typename?: 'PointCloud', id: string, visible: boolean }> } };

export type ProjectVolumeCalculateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
  annotationIdentifier: Scalars['String']['input'];
  referenceHeight?: InputMaybe<Scalars['Float']['input']>;
  baseSurface: CalculationBaseSurfaces;
  classificationFilters?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectVolumeCalculateMutation = { __typename?: 'Mutation', projectVolumeCalculate: { __typename?: 'Project', id: string, calculations: Array<
      | { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
      | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
    > } };

export type ProjectExportPointcloudMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
  fileType?: InputMaybe<FileTypes>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  classificationFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectExportPointcloudMutation = { __typename?: 'Mutation', projectExportPointcloud: { __typename?: 'Project', id: string, exports: Array<{ __typename?: 'Export', exportId?: string | null, status: GeneralStatus, type: string, createdAt?: number | null, fileSize?: any | null, seen?: boolean | null, paramInfo: { __typename?: 'PointCloudExportParamInfo', fileType?: FileTypes | null, heightFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }> } };

export type ProjectProjectionCalculateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
  annotationIdentifier: Scalars['String']['input'];
  profileGroupIdentifier: Scalars['String']['input'];
  classificationFilters?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
  heightFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  intensityFilters?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>> | InputMaybe<Scalars['Int']['input']>>;
  resolutionFilter?: InputMaybe<Scalars['Int']['input']>;
  clippingFilter?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProjectProjectionCalculateMutation = { __typename?: 'Mutation', projectProjectionCalculate: { __typename?: 'Project', id: string, calculations: Array<
      | { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
      | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
    > } };

export type ProjectDeleteCalculationMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  calculationId: Scalars['ID']['input'];
}>;


export type ProjectDeleteCalculationMutation = { __typename?: 'Mutation', projectDeleteCalculation: { __typename?: 'Project', id: string, calculations: Array<
      | { __typename?: 'ProjectionCalculation', profileGroupIdentifier: string, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'ProjectionCalculationResult', projection: Array<{ __typename?: 'DistanceProjection', distance: number, height: number }> } | null, paramInfo: { __typename?: 'ProjectionCalculationParamInfo', heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
      | { __typename?: 'VolumeCalculation', baseSurface: CalculationBaseSurfaces, isOutDated: boolean, id: string, status: GeneralStatus, annotationIdentifier: string, pointCloudIdentifier: string, result?: { __typename?: 'VolumeCalculationResult', volume: number, area: number, volumePositive: number, volumeNegative: number } | null, paramInfo: { __typename?: 'VolumeCalculationParamInfo', referenceHeight?: number | null, heightFilters?: Array<number | null> | null, intensityFilters?: Array<number | null> | null, classificationFilters?: Array<number | null> | null, resolutionFilter?: number | null, clippingFilter?: number | null } }
    > } };

export type ProjectGenerateClassificationsMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  cloudName: Scalars['String']['input'];
}>;


export type ProjectGenerateClassificationsMutation = { __typename?: 'Mutation', projectGenerateClassifications: { __typename?: 'Project', id: string, pointClouds: Array<{ __typename?: 'PointCloud', hasClassifications: boolean }> } };

export type ProjectPointCloudDeleteMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
}>;


export type ProjectPointCloudDeleteMutation = { __typename?: 'Mutation', projectPointCloudDelete: { __typename?: 'Project', id: string, pointClouds: Array<{ __typename?: 'PointCloud', id: string, hasClassifications: boolean, hasSources: boolean, uploadStatus: UploadStatus, cloudName: string, availableClasses: Array<number>, availableSources: Array<number>, visible: boolean, displayName: string, pointCount?: any | null }>, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string }> } } };

export type PointCloudUploadStatusQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type PointCloudUploadStatusQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, pointClouds: Array<{ __typename?: 'PointCloud', id: string, uploadStatus: UploadStatus }> } };

export type ProjectInitializeMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type ProjectInitializeMutation = { __typename?: 'Mutation', projectInitialize: { __typename?: 'Project', id: string } };

export type ProjectAddCommentMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  comment: Scalars['String']['input'];
  referenceIdentifier: Scalars['String']['input'];
}>;


export type ProjectAddCommentMutation = { __typename?: 'Mutation', projectAddComment: { __typename?: 'Project', comments?: Array<{ __typename?: 'Comment', id: string }> | null } };

export type ProjectDeleteCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type ProjectDeleteCommentMutation = { __typename?: 'Mutation', projectDeleteComment: { __typename?: 'Project', id: string, comments?: Array<{ __typename?: 'Comment', id: string }> | null } };

export type ProjectEditCommentMutationVariables = Exact<{
  commentId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newComment: Scalars['String']['input'];
}>;


export type ProjectEditCommentMutation = { __typename?: 'Mutation', projectEditComment: { __typename?: 'Project', id: string, comments?: Array<{ __typename: 'Comment', id: string, comment: string }> | null } };

export type ProjectAddCustomClassMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  color: InputColor;
}>;


export type ProjectAddCustomClassMutation = { __typename?: 'Mutation', projectAddCustomClass: { __typename?: 'Project', id: string, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string, code: number, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null } };

export type ProjectDeleteCustomClassMutationVariables = Exact<{
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
}>;


export type ProjectDeleteCustomClassMutation = { __typename?: 'Mutation', projectDeleteCustomClass: { __typename?: 'Project', id: string, customClasses?: Array<{ __typename?: 'CustomClass', id: string }> | null } };

export type ProjectEditCustomClassNameMutationVariables = Exact<{
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newName: Scalars['String']['input'];
}>;


export type ProjectEditCustomClassNameMutation = { __typename?: 'Mutation', projectEditCustomClassName: { __typename?: 'Project', id: string, customClasses?: Array<{ __typename?: 'CustomClass', id: string, name: string }> | null } };

export type ProjectEditCustomClassColorMutationVariables = Exact<{
  customClassId: Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newColor: InputColor;
}>;


export type ProjectEditCustomClassColorMutation = { __typename?: 'Mutation', projectEditCustomClassColor: { __typename?: 'Project', id: string, customClasses?: Array<{ __typename?: 'CustomClass', id: string, color: { __typename?: 'Color', r: number, g: number, b: number, a: number } }> | null } };

export type ProjectEditLayerElevationMutationVariables = Exact<{
  layerIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  projectId: Scalars['ID']['input'];
  newElevation: Scalars['Float']['input'];
}>;


export type ProjectEditLayerElevationMutation = { __typename?: 'Mutation', projectEditLayerElevation: { __typename?: 'Project', id: string, state: { __typename?: 'ProjectState', orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, elevation?: number | null }> } } };

export type ProjectAddGuestMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  level?: InputMaybe<ProjectAccessLevel>;
}>;


export type ProjectAddGuestMutation = { __typename?: 'Mutation', projectAddGuest: { __typename?: 'User', id: string } };

export type ProjectSetGuestAccessLevelMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  level: ProjectAccessLevel;
}>;


export type ProjectSetGuestAccessLevelMutation = { __typename?: 'Mutation', projectSetGuestAccessLevel: { __typename?: 'User', id: string } };

export type ProjectRemoveGuestMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type ProjectRemoveGuestMutation = { __typename?: 'Mutation', projectRemoveGuest: { __typename?: 'User', id: string } };

export type ProjectRequestDownloadTokenQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectRequestDownloadTokenQuery = { __typename?: 'Query', projectRequestDownloadToken: string };

export type ProjectCommentsByObjectIdQueryVariables = Exact<{
  pagination?: InputMaybe<CursorPaginationInput>;
  projectId: Scalars['ID']['input'];
  objectId: Scalars['ID']['input'];
}>;


export type ProjectCommentsByObjectIdQuery = { __typename?: 'Query', projectCommentsByObjectId: { __typename?: 'paginatedComments', nextCursor?: string | null, hasMore: boolean, data: Array<{ __typename?: 'Comment', id: string, updatedAt?: number | null, createdAt: number, comment: string, referenceIdentifier: string, user?: { __typename?: 'User', id: string, name: string } | null }> } };

export type ProjectPointCloudRelaunchMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  pointCloudId: Scalars['ID']['input'];
}>;


export type ProjectPointCloudRelaunchMutation = { __typename?: 'Mutation', projectPointCloudRelaunch: { __typename?: 'Project', id: string, uploadStatus: UploadStatus, pointClouds: Array<{ __typename?: 'PointCloud', id: string, hasClassifications: boolean, hasSources: boolean, uploadStatus: UploadStatus, cloudName: string, availableClasses: Array<number>, availableSources: Array<number>, visible: boolean, displayName: string, pointCount?: any | null }> } };

export type ProjectSheetFieldsFragment = { __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number };

export type ProjectSheetsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectSheetsQuery = { __typename?: 'Query', projectSheets: Array<{ __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number }> };

export type ProjectSheetQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type ProjectSheetQuery = { __typename?: 'Query', projectSheet: { __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number } };

export type ProjectSheetCreateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  templateSource: PrintTemplateSource;
  templateId: Scalars['String']['input'];
}>;


export type ProjectSheetCreateMutation = { __typename?: 'Mutation', projectSheetCreate: { __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number } };

export type ProjectSheetSaveMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
  doc: Scalars['JSON']['input'];
  expectedUpdatedAt: Scalars['Date']['input'];
}>;


export type ProjectSheetSaveMutation = { __typename?: 'Mutation', projectSheetSave: { __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number } };

export type ProjectSheetRenameMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProjectSheetRenameMutation = { __typename?: 'Mutation', projectSheetRename: { __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number } };

export type ProjectSheetDuplicateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type ProjectSheetDuplicateMutation = { __typename?: 'Mutation', projectSheetDuplicate: { __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number } };

export type ProjectSheetDeleteMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type ProjectSheetDeleteMutation = { __typename?: 'Mutation', projectSheetDelete: boolean };

export type ProjectSheetUpgradeTemplateMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type ProjectSheetUpgradeTemplateMutation = { __typename?: 'Mutation', projectSheetUpgradeTemplate: { __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number } };

export type ProjectSheetMarkExportedMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  sheetId: Scalars['ID']['input'];
}>;


export type ProjectSheetMarkExportedMutation = { __typename?: 'Mutation', projectSheetMarkExported: { __typename?: 'ProjectSheet', id: string, projectId: string, name: string, number?: string | null, doc: any, templateSource: PrintTemplateSource, templateId: string, templateVersion: number, latestTemplateVersion?: number | null, lastExportedAt?: number | null, createdAt: number, updatedAt: number } };

export type ProjectPropertyUpdatesSubscriptionVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectPropertyUpdatesSubscription = { __typename?: 'Subscription', projectPropertyUpdates: { __typename?: 'PropertyUpdateNotification', identifier: string, value: any, valueType: PropertyValueType, propertyType: PropertyType, propertyIdentifier: string } };

export type OrganizationPropertyUpdatesSubscriptionVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationPropertyUpdatesSubscription = { __typename?: 'Subscription', organizationPropertyUpdates: { __typename?: 'PropertyUpdateNotification', identifier: string, value: any, valueType: PropertyValueType, propertyType: PropertyType, propertyIdentifier: string } };

export type UserPropertyUpdatesSubscriptionVariables = Exact<{
  userId: Scalars['ID']['input'];
}>;


export type UserPropertyUpdatesSubscription = { __typename?: 'Subscription', userPropertyUpdates: { __typename?: 'PropertyUpdateNotification', identifier: string, value: any, valueType: PropertyValueType, propertyType: PropertyType, propertyIdentifier: string } };

export type ProjectPropertyStateFragment = { __typename?: 'Project', id: string, stateByUser: Array<{ __typename?: 'StateByUser', userId: string, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> }>, state: { __typename?: 'ProjectState', properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> } };

export type GetProjectPropertiesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectPropertiesQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, stateByUser: Array<{ __typename?: 'StateByUser', userId: string, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> }>, state: { __typename?: 'ProjectState', properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> } } };

export type GetProjectPropertiesForObjectsQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  propertyIdentifiers?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetProjectPropertiesForObjectsQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, stateByUser: Array<{ __typename?: 'StateByUser', userId: string, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> }>, state: { __typename?: 'ProjectState', properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> } } };

export type GetProjectPropertyStateQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type GetProjectPropertyStateQuery = { __typename?: 'Query', projectById: { __typename?: 'Project', id: string, stateByUser: Array<{ __typename?: 'StateByUser', userId: string, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> }>, state: { __typename?: 'ProjectState', properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> } } };

export type ProjectUpdatePropertyMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
  value: Scalars['PropertyValue']['input'];
  propertyType: PropertyType;
  propertyIdentifier: Scalars['String']['input'];
  valueType: PropertyValueType;
}>;


export type ProjectUpdatePropertyMutation = { __typename?: 'Mutation', projectUpdateProperty: { __typename?: 'Project', id: string } };

export type ProjectBatchUpdatePropertiesMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  updates: Array<PropertyUpdateInput> | PropertyUpdateInput;
}>;


export type ProjectBatchUpdatePropertiesMutation = { __typename?: 'Mutation', projectBatchupdateProperties: { __typename?: 'Project', id: string } };

export type GetOrganizationPropertiesQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrganizationPropertiesQuery = { __typename?: 'Query', organisationById: { __typename?: 'Organisation', id: string, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> } };

export type OrganizationUpdatePropertyMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  identifier: Scalars['String']['input'];
  value: Scalars['PropertyValue']['input'];
  propertyIdentifier: Scalars['String']['input'];
  valueType: PropertyValueType;
}>;


export type OrganizationUpdatePropertyMutation = { __typename?: 'Mutation', organizationUpdateProperty: boolean };

export type OrganizationBatchUpdatePropertiesMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  updates: Array<PropertyUpdateInput> | PropertyUpdateInput;
}>;


export type OrganizationBatchUpdatePropertiesMutation = { __typename?: 'Mutation', organizationBatchUpdateProperties: boolean };

export type GetUserPropertiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserPropertiesQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> } | null };

export type UserUpdatePropertyMutationVariables = Exact<{
  identifier: Scalars['String']['input'];
  value: Scalars['PropertyValue']['input'];
  propertyIdentifier: Scalars['String']['input'];
  valueType: PropertyValueType;
}>;


export type UserUpdatePropertyMutation = { __typename?: 'Mutation', userUpdateProperty: boolean };

export type UserBatchUpdatePropertiesMutationVariables = Exact<{
  updates: Array<PropertyUpdateInput> | PropertyUpdateInput;
}>;


export type UserBatchUpdatePropertiesMutation = { __typename?: 'Mutation', userBatchUpdateProperties: boolean };

export type ReferralPayoutFieldsFragment = { __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number };

export type ReferralSaleFieldsFragment = { __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null };

export type ReferralOverviewFieldsFragment = { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> };

export type OrganisationReferralPayoutPdfQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  payoutId: Scalars['ID']['input'];
}>;


export type OrganisationReferralPayoutPdfQuery = { __typename?: 'Query', organisationReferralPayoutPdf: { __typename?: 'InvoicePdf', filename: string, base64: string } };

export type ReferralInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type ReferralInfoQuery = { __typename?: 'Query', referralInfo: { __typename?: 'ReferralInfo', organisationName: string } };

export type OrganisationReferralOverviewQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationReferralOverviewQuery = { __typename?: 'Query', organisationReferralOverview: { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type OrganisationReferralCustomerCreateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OrganisationReferralCustomerCreateMutation = { __typename?: 'Mutation', organisationReferralCustomerCreate: { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type OrganisationReferralLinkGenerateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationReferralLinkGenerateMutation = { __typename?: 'Mutation', organisationReferralLinkGenerate: { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type SuperadminReferralHistoryQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SuperadminReferralHistoryQuery = { __typename?: 'Query', superadminReferralHistory: { __typename?: 'ReferralHistory', sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type SuperadminSetReferralSettingsMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  input: InputReferralSettings;
}>;


export type SuperadminSetReferralSettingsMutation = { __typename?: 'Mutation', superadminSetReferralSettings: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminCreateReferralPayoutMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SuperadminCreateReferralPayoutMutation = { __typename?: 'Mutation', superadminCreateReferralPayout?: { __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number } | null };

export type SuperadminReferralOrganisationFieldsFragment = { __typename?: 'SuperadminReferralOrganisation', id: string, name: string, referredById?: string | null, referredByName?: string | null, referredAt?: number | null };

export type SuperadminReferralsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type SuperadminReferralsQuery = { __typename?: 'Query', superadminReferrals: { __typename?: 'SuperadminReferrals', othersTotal: number, referred: Array<{ __typename?: 'SuperadminReferralOrganisation', id: string, name: string, referredById?: string | null, referredByName?: string | null, referredAt?: number | null }>, others: Array<{ __typename?: 'SuperadminReferralOrganisation', id: string, name: string, referredById?: string | null, referredByName?: string | null, referredAt?: number | null }> } };

export type SuperadminSetPartnerLinkMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  partnerOrganisationId: Scalars['ID']['input'];
  linked: Scalars['Boolean']['input'];
}>;


export type SuperadminSetPartnerLinkMutation = { __typename?: 'Mutation', superadminSetPartnerLink: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminRefreshReferralsMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SuperadminRefreshReferralsMutation = { __typename?: 'Mutation', superadminRefreshReferrals: { __typename?: 'ReferralHistory', sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type PartnerCustomerPlanChangePreviewQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customerOrganisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
}>;


export type PartnerCustomerPlanChangePreviewQuery = { __typename?: 'Query', partnerCustomerPlanChangePreview: { __typename?: 'PlanChangePreview', kind: PlanChangeKind, subscriptionType: SubscriptionType, effectiveAt: number, scheduled: boolean, endDate?: number | null, currentTermValueCents: number, dueCents: number, chargedCents: number, priceLocked: boolean, problems: Array<PlanChangeProblem>, current: { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null }, after: { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null }, lines: Array<{ __typename?: 'PlanChargeLine', subscriptionType: SubscriptionType, from: number, months: number, totalCents: number }> } };

export type PartnerCustomerChangePlanMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customerOrganisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
}>;


export type PartnerCustomerChangePlanMutation = { __typename?: 'Mutation', partnerCustomerChangePlan: { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type PartnerCustomerPurchaseCreditsMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customerOrganisationId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
}>;


export type PartnerCustomerPurchaseCreditsMutation = { __typename?: 'Mutation', partnerCustomerPurchaseCredits: { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type PartnerCustomerCancelSubscriptionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customerOrganisationId: Scalars['ID']['input'];
}>;


export type PartnerCustomerCancelSubscriptionMutation = { __typename?: 'Mutation', partnerCustomerCancelSubscription: { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type PartnerCustomerPauseSubscriptionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customerOrganisationId: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
}>;


export type PartnerCustomerPauseSubscriptionMutation = { __typename?: 'Mutation', partnerCustomerPauseSubscription: { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type PartnerCustomerBillingDatePreviewQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customerOrganisationId: Scalars['ID']['input'];
  renewalDate: Scalars['Date']['input'];
}>;


export type PartnerCustomerBillingDatePreviewQuery = { __typename?: 'Query', partnerCustomerBillingDatePreview: { __typename?: 'BillingDatePreview', renewalDate: number, endDate: number, currentEndDate?: number | null, subscriptionType: SubscriptionType, monthsAdded: number, dueCents: number, chargedCents: number, priceLocked: boolean, problems: Array<PlanChangeProblem> } };

export type PartnerCustomerSetBillingDateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customerOrganisationId: Scalars['ID']['input'];
  renewalDate: Scalars['Date']['input'];
}>;


export type PartnerCustomerSetBillingDateMutation = { __typename?: 'Mutation', partnerCustomerSetBillingDate: { __typename?: 'ReferralOverview', organisationId: string, role: ReferralRole, token?: string | null, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, referredCount: number, salesCount: number, pendingSalesCount: number, pendingCents: number, earnedCents: number, unpaidCents: number, paidOutCents: number, milestones: Array<{ __typename?: 'ReferralMilestone', sales: number, projects: number, reached: boolean }>, referredOrganisations: Array<{ __typename?: 'ReferredOrganisation', id: string, name: string, joinedAt: number, usersCount: number, projectsCount: number, subscriptionType: SubscriptionType, status: ReferredOrganisationStatus, salesCount: number, salesAmountCents: number, cutCents: number, awaitingPaymentCount: number, acquiredByYou: boolean, managedByYou: boolean, billedToYou: boolean, canVisit: boolean, subscriptionEndsAt?: number | null, subscriptionPaused: boolean, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, projectUnitPriceCents: number }>, sales: Array<{ __typename?: 'ReferralSale', id: string, referredOrganisationId: string, referredOrganisationName: string, ledgerEntryId: string, ledgerEntryType: CreditLedgerEntryType, pricingKind?: FeePricingKind | null, subscriptionType?: SubscriptionType | null, credits?: number | null, soldAt: number, amountCents: number, roleAtSale: ReferralRole, dealKind: ReferralDealKind, deductedOnInvoice: boolean, cutBasisPoints: number, cutCents: number, state: ReferralSaleState, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoicePaidAt?: number | null, payoutId?: string | null, rewardGrantId?: string | null, voidedAt?: number | null, voidReason?: ReferralSaleVoidReason | null }>, payouts: Array<{ __typename?: 'ReferralPayout', id: string, periodKey: string, periodStart: number, periodEnd: number, cadence: ReferralPayoutCadence, manual: boolean, saleCount: number, totalCents: number, claimedAt?: number | null, odooVendorBillId?: number | null, odooVendorBillUrl?: string | null, paidAt?: number | null, createdAt: number }> } };

export type PartnerCustomerInviteUsersMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customerOrganisationId: Scalars['ID']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type PartnerCustomerInviteUsersMutation = { __typename?: 'Mutation', partnerCustomerInviteUsers: boolean };

export type SuperadminOrganisationFragment = { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } };

export type CreditLedgerEntryFieldsFragment = { __typename?: 'CreditLedgerEntry', id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null };

export type SuperadminCreditLedgerEntryFieldsFragment = { __typename?: 'CreditLedgerEntry', odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoiceVia?: InvoiceVia | null, odooOrderId?: number | null, odooOrderUrl?: string | null, id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null };

export type SuperadminSetOdooPartnerMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  partnerId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperadminSetOdooPartnerMutation = { __typename?: 'Mutation', superadminSetOdooPartner: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminCreateOdooPartnerMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SuperadminCreateOdooPartnerMutation = { __typename?: 'Mutation', superadminCreateOdooPartner: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminSetOdooOrderMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  orderId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperadminSetOdooOrderMutation = { __typename?: 'Mutation', superadminSetOdooOrder: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminCreateOdooInvoiceMutationVariables = Exact<{
  entryId: Scalars['ID']['input'];
}>;


export type SuperadminCreateOdooInvoiceMutation = { __typename?: 'Mutation', superadminCreateOdooInvoice: { __typename?: 'CreditLedgerEntry', odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoiceVia?: InvoiceVia | null, odooOrderId?: number | null, odooOrderUrl?: string | null, id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null } };

export type SuperadminRefreshInvoicesMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SuperadminRefreshInvoicesMutation = { __typename?: 'Mutation', superadminRefreshInvoices: boolean };

export type SuperadminCreditLedgerQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type SuperadminCreditLedgerQuery = { __typename?: 'Query', superadminCreditLedger: { __typename?: 'PaginatedCreditLedger', nextCursor?: string | null, total: number, hasMore: boolean, data: Array<{ __typename?: 'CreditLedgerEntry', sentInvoiceNumber?: string | null, paymentStatus?: InvoicePaymentStatus | null, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoiceVia?: InvoiceVia | null, odooOrderId?: number | null, odooOrderUrl?: string | null, id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null }> } };

export type SuperadminFullCreditLedgerQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type SuperadminFullCreditLedgerQuery = { __typename?: 'Query', superadminCreditLedger: { __typename?: 'PaginatedCreditLedger', nextCursor?: string | null, total: number, hasMore: boolean, data: Array<{ __typename?: 'CreditLedgerEntry', sentInvoiceNumber?: string | null, paymentStatus?: InvoicePaymentStatus | null, projectId?: string | null, projectName?: string | null, taskId?: string | null, pointCountTotal?: number | null, shortfall?: number | null, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoiceVia?: InvoiceVia | null, odooOrderId?: number | null, odooOrderUrl?: string | null, id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null }> } };

export type SuperadminLiveGrantsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SuperadminLiveGrantsQuery = { __typename?: 'Query', superadminLiveGrants: Array<{ __typename?: 'CreditLedgerEntry', id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null }> };

export type SuperadminRemoveCreditsMutationVariables = Exact<{
  entryId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
}>;


export type SuperadminRemoveCreditsMutation = { __typename?: 'Mutation', superadminRemoveCredits: { __typename?: 'CreditLedgerEntry', id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null } };

export type SuperadminGrantCreditsMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['Date']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  unitPriceCents?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperadminGrantCreditsMutation = { __typename?: 'Mutation', superadminGrantCredits: { __typename?: 'CreditLedgerEntry', odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoiceVia?: InvoiceVia | null, odooOrderId?: number | null, odooOrderUrl?: string | null, id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null } };

export type SuperadminOrganisationCreateMutationVariables = Exact<{
  name: Scalars['String']['input'];
  emails: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SuperadminOrganisationCreateMutation = { __typename?: 'Mutation', superadminOrganisationCreate: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminOrganisationsQueryVariables = Exact<{
  pagination?: InputMaybe<CursorPaginationInput>;
  filters?: InputMaybe<InputSuperadminOrganisationFilters>;
}>;


export type SuperadminOrganisationsQuery = { __typename?: 'Query', superadminOrganisations: { __typename?: 'PaginatedOrganisation', nextCursor?: string | null, total: number, hasMore: boolean, data: Array<{ __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } }> } };

export type SuperadminOrganisationByIdQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type SuperadminOrganisationByIdQuery = { __typename?: 'Query', organisationById: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminOrganisationsPerMonthQueryVariables = Exact<{
  filters?: InputMaybe<InputSuperadminOrganisationFilters>;
}>;


export type SuperadminOrganisationsPerMonthQuery = { __typename?: 'Query', superadminOrganisationsPerMonth: Array<{ __typename?: 'OrganisationsPerMonth', month: string, count: number }> };

export type PlanTermStateFieldsFragment = { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null };

export type SuperadminPlanChangePreviewQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  subscriptionType: SubscriptionType;
  effectiveAt?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  chargeCents?: InputMaybe<Scalars['Int']['input']>;
  customLimits?: InputMaybe<InputSubscriptionCustomLimits>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SuperadminPlanChangePreviewQuery = { __typename?: 'Query', superadminPlanChangePreview: { __typename?: 'PlanChangePreview', kind: PlanChangeKind, subscriptionType: SubscriptionType, effectiveAt: number, scheduled: boolean, alreadyScheduled: boolean, endDate?: number | null, minEffectiveAt: number, maxEffectiveAt?: number | null, changeMonth?: number | null, changePeriodStart?: number | null, changePeriodEnd?: number | null, totalValueCents: number, currentTermValueCents: number, alreadyPaidCents: number, dueCents: number, balanceCents: number, chargedCents: number, overridden: boolean, priceLocked: boolean, extraCredits: number, extraCreditsAt?: number | null, extraCreditsExpireAt?: number | null, invoiceVia: InvoiceVia, voidsCurrentTerm: boolean, keepsPending: boolean, supersedesPending: boolean, problems: Array<PlanChangeProblem>, current: { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null }, after: { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null }, next?: { __typename?: 'PlanTermState', subscriptionType: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, active: boolean, pausedAt?: number | null, monthlyCredits: number, yearlyPriceCents: number, projectUnitPriceCents: number, startDate?: number | null, endDate?: number | null, nextRenewal?: number | null, monthsTotal?: number | null, monthsElapsed?: number | null, monthsLeft?: number | null } | null, lines: Array<{ __typename?: 'PlanChargeLine', subscriptionType: SubscriptionType, from: number, to: number, months: number, monthlyPriceCents: number, totalCents: number }>, timeline: Array<{ __typename?: 'PlanTimelineSegment', from: number, to: number, subscriptionType: SubscriptionType, monthlyCredits: number, extraCredits: number, month: number }> } };

export type SuperadminUpdatePlanMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  customLimits: InputSubscriptionCustomLimits;
  subscriptionType: SubscriptionType;
  effectiveAt?: InputMaybe<Scalars['Date']['input']>;
  endDate?: InputMaybe<Scalars['Date']['input']>;
  chargeCents?: InputMaybe<Scalars['Int']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SuperadminUpdatePlanMutation = { __typename?: 'Mutation', superadminUpdatePlan: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminBillingDatePreviewQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  renewalDate: Scalars['Date']['input'];
  chargeCents?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperadminBillingDatePreviewQuery = { __typename?: 'Query', superadminBillingDatePreview: { __typename?: 'BillingDatePreview', renewalDate: number, endDate: number, currentEndDate?: number | null, subscriptionType: SubscriptionType, monthsAdded: number, monthlyPriceCents: number, dueCents: number, chargedCents: number, overridden: boolean, priceLocked: boolean, odooLinked: boolean, movesPendingChange: boolean, problems: Array<PlanChangeProblem> } };

export type SuperadminSetBillingDateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  renewalDate: Scalars['Date']['input'];
  chargeCents?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuperadminSetBillingDateMutation = { __typename?: 'Mutation', superadminSetBillingDate: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminPauseSubscriptionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  paused: Scalars['Boolean']['input'];
}>;


export type SuperadminPauseSubscriptionMutation = { __typename?: 'Mutation', superadminPauseSubscription: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminCancelSubscriptionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SuperadminCancelSubscriptionMutation = { __typename?: 'Mutation', superadminCancelSubscription: { __typename?: 'Organisation', id: string, name: string, createdAt: number, stats: { __typename?: 'OrganisationStats', totalPointCount: any, totalUsers: number, totalProjects: number }, subscription: { __typename?: 'OrganisationSubscription', type: SubscriptionType, scheduledType?: SubscriptionType | null, scheduledAt?: number | null, paused: boolean, pausedAt?: number | null, startDate?: number | null, endDate?: number | null, projectUnitPrice: number, subscriptionPrice: number, customLimits?: { __typename?: 'SubscriptionCustomLimits', monthlyCredits?: number | null, projectUnitPrice?: number | null, subscriptionPrice?: number | null } | null }, credits: { __typename?: 'OrganisationCredits', balance: number, pending: number, available: number, nextExpiry?: number | null, monthlyAllowance?: { __typename?: 'MonthlyAllowance', total: number, remaining: number, renewsAt: number } | null }, odoo: { __typename?: 'OrganisationOdoo', leadId?: number | null, partnerId?: number | null, leadUrl?: string | null, partnerUrl?: string | null, orderId?: number | null, orderName?: string | null, orderUrl?: string | null, orderOrigin?: OdooOrderOrigin | null, orderState?: string | null, orderConfirmed?: boolean | null, orderEndsAt?: number | null, orderCloseReason?: string | null, orderSyncedAt?: number | null, orderLinkStatus?: OdooOrderLinkStatus | null, orderCandidates: Array<{ __typename?: 'OdooOrderCandidate', id: number, url?: string | null }> }, referral: { __typename?: 'OrganisationReferral', role: ReferralRole, firstCutBasisPoints: number, recurringCutBasisPoints: number, customersCanCancel: boolean, payoutCadence: ReferralPayoutCadence, minPayoutCents: number, hasToken: boolean, referredById?: string | null, referredByName?: string | null, referredAt?: number | null, acquiredBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, managedBy?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null, billedTo?: { __typename?: 'ReferralPartnerLink', organisationId: string, name: string, at: number } | null } } };

export type SuperadminFailedPointCloudsQueryVariables = Exact<{
  status?: InputMaybe<FailedPointCloudStatus>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type SuperadminFailedPointCloudsQuery = { __typename?: 'Query', superadminFailedPointClouds: { __typename?: 'PaginatedFailedPointClouds', nextCursor?: string | null, total: number, hasMore: boolean, data: Array<{ __typename?: 'FailedPointCloud', id: string, projectId: string, organisationId?: string | null, projectName?: string | null, organisationName?: string | null, cloudName: string, displayName?: string | null, fileNames: Array<string>, sizeBytes?: number | null, status: FailedPointCloudStatus, failureCount: number, firstFailedAt: number, lastFailedAt: number, lastJobId?: string | null, lastError?: string | null, resolvedAt?: number | null, deletedAt?: number | null }> } };

export type SuperadminFailedPointCloudCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperadminFailedPointCloudCountsQuery = { __typename?: 'Query', superadminFailedPointCloudCounts: { __typename?: 'FailedPointCloudCounts', failed: number, resolved: number, deleted: number } };

export type SuperadminInvoicesQueryVariables = Exact<{
  status?: InputMaybe<InvoiceTrackingStatus>;
  pagination?: InputMaybe<CursorPaginationInput>;
}>;


export type SuperadminInvoicesQuery = { __typename?: 'Query', superadminInvoices: { __typename?: 'PaginatedTrackedInvoices', nextCursor?: string | null, total: number, hasMore: boolean, data: Array<{ __typename?: 'TrackedInvoice', status: InvoiceTrackingStatus, organisation?: { __typename?: 'Organisation', id: string, name: string } | null, entry: { __typename?: 'CreditLedgerEntry', odooInvoiceNumber?: string | null, odooInvoiceId?: number | null, odooInvoiceUrl?: string | null, invoiceVia?: InvoiceVia | null, odooOrderId?: number | null, odooOrderUrl?: string | null, id: string, organisationId: string, type: CreditLedgerEntryType, source: CreditLedgerEntrySource, subscriptionType?: SubscriptionType | null, amount: number, remaining?: number | null, expiresAt?: number | null, subscriptionId?: string | null, invoice?: string | null, note?: string | null, grantedBy?: string | null, effectiveAt?: number | null, supersededAt?: number | null, cancelledAt?: number | null, createdAt: number, unitPriceCents?: number | null, totalPriceCents?: number | null, currency?: string | null, grantedByAccount?: { __typename?: 'LedgerAccount', name?: string | null, isSuperAdmin: boolean } | null } }> } };

export type SuperadminInvoiceCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type SuperadminInvoiceCountsQuery = { __typename?: 'Query', superadminInvoiceCounts: { __typename?: 'InvoiceCounts', noInvoice: number, draft: number, unpaid: number, paid: number, cancelled: number } };

export type SuperadminProjectSourceFilesQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type SuperadminProjectSourceFilesQuery = { __typename?: 'Query', superadminProjectSourceFiles: Array<{ __typename?: 'ProjectSourceFile', name: string, sizeBytes: number, url: string }> };

export type PrintTemplateFieldsFragment = { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> };

export type TemplateLibraryConfigFieldsFragment = { __typename?: 'TemplateLibraryConfig', hiddenBuiltinIds: Array<string>, defaultTemplate?: { __typename?: 'PrintTemplateRef', source: PrintTemplateSource, id: string } | null, brand: { __typename?: 'PrintBrand', address?: string | null, phone?: string | null, email?: string | null, website?: string | null, vat?: string | null }, logo?: { __typename?: 'PrintLogo', originalName: string, contentType: string, size: number, url: string, updatedAt: number } | null, fonts: Array<{ __typename?: 'PrintFont', id: string, family: string, weight: PrintFontWeight, italic: boolean, originalName: string, size: number, url: string, createdAt: number }> };

export type TemplateLibraryFieldsFragment = { __typename?: 'TemplateLibrary', organisationId: string, canEdit: boolean, config: { __typename?: 'TemplateLibraryConfig', hiddenBuiltinIds: Array<string>, defaultTemplate?: { __typename?: 'PrintTemplateRef', source: PrintTemplateSource, id: string } | null, brand: { __typename?: 'PrintBrand', address?: string | null, phone?: string | null, email?: string | null, website?: string | null, vat?: string | null }, logo?: { __typename?: 'PrintLogo', originalName: string, contentType: string, size: number, url: string, updatedAt: number } | null, fonts: Array<{ __typename?: 'PrintFont', id: string, family: string, weight: PrintFontWeight, italic: boolean, originalName: string, size: number, url: string, createdAt: number }> }, templates: Array<{ __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> }> };

export type PrintTemplateVersionFieldsFragment = { __typename?: 'PrintTemplateVersion', id: string, version: number, spec: any, name: string, publishedAt: number, publishedByName?: string | null, isLatest: boolean, sheetCount: number };

export type OrganisationTemplateLibraryQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrganisationTemplateLibraryQuery = { __typename?: 'Query', organisationTemplateLibrary: { __typename?: 'TemplateLibrary', organisationId: string, canEdit: boolean, config: { __typename?: 'TemplateLibraryConfig', hiddenBuiltinIds: Array<string>, defaultTemplate?: { __typename?: 'PrintTemplateRef', source: PrintTemplateSource, id: string } | null, brand: { __typename?: 'PrintBrand', address?: string | null, phone?: string | null, email?: string | null, website?: string | null, vat?: string | null }, logo?: { __typename?: 'PrintLogo', originalName: string, contentType: string, size: number, url: string, updatedAt: number } | null, fonts: Array<{ __typename?: 'PrintFont', id: string, family: string, weight: PrintFontWeight, italic: boolean, originalName: string, size: number, url: string, createdAt: number }> }, templates: Array<{ __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> }> } };

export type ProjectTemplateLibraryQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
}>;


export type ProjectTemplateLibraryQuery = { __typename?: 'Query', projectTemplateLibrary: { __typename?: 'TemplateLibrary', organisationId: string, canEdit: boolean, config: { __typename?: 'TemplateLibraryConfig', hiddenBuiltinIds: Array<string>, defaultTemplate?: { __typename?: 'PrintTemplateRef', source: PrintTemplateSource, id: string } | null, brand: { __typename?: 'PrintBrand', address?: string | null, phone?: string | null, email?: string | null, website?: string | null, vat?: string | null }, logo?: { __typename?: 'PrintLogo', originalName: string, contentType: string, size: number, url: string, updatedAt: number } | null, fonts: Array<{ __typename?: 'PrintFont', id: string, family: string, weight: PrintFontWeight, italic: boolean, originalName: string, size: number, url: string, createdAt: number }> }, templates: Array<{ __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> }> } };

export type ProjectPrintTemplateVersionQueryVariables = Exact<{
  projectId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type ProjectPrintTemplateVersionQuery = { __typename?: 'Query', projectPrintTemplateVersion: { __typename?: 'PrintTemplateVersion', id: string, version: number, spec: any, name: string, publishedAt: number, publishedByName?: string | null, isLatest: boolean, sheetCount: number } };

export type PrintTemplateQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
}>;


export type PrintTemplateQuery = { __typename?: 'Query', printTemplate: { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplateVersionsQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
}>;


export type PrintTemplateVersionsQuery = { __typename?: 'Query', printTemplateVersions: Array<{ __typename?: 'PrintTemplateVersion', id: string, version: number, spec: any, name: string, publishedAt: number, publishedByName?: string | null, isLatest: boolean, sheetCount: number }> };

export type OrganisationTemplateLibraryUploadSasQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type OrganisationTemplateLibraryUploadSasQuery = { __typename?: 'Query', organisationTemplateLibraryUploadSAS: string };

export type PrintTemplateCreateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  spec: Scalars['JSON']['input'];
  basedOnBuiltinId?: InputMaybe<Scalars['String']['input']>;
  duplicateOfTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type PrintTemplateCreateMutation = { __typename?: 'Mutation', printTemplateCreate: { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplateUpdateDetailsMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type PrintTemplateUpdateDetailsMutation = { __typename?: 'Mutation', printTemplateUpdateDetails: { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplateSaveDraftMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  spec: Scalars['JSON']['input'];
}>;


export type PrintTemplateSaveDraftMutation = { __typename?: 'Mutation', printTemplateSaveDraft: { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplatePublishMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
}>;


export type PrintTemplatePublishMutation = { __typename?: 'Mutation', printTemplatePublish: { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplateDiscardDraftMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
}>;


export type PrintTemplateDiscardDraftMutation = { __typename?: 'Mutation', printTemplateDiscardDraft: { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplateRestoreVersionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type PrintTemplateRestoreVersionMutation = { __typename?: 'Mutation', printTemplateRestoreVersion: { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplateDeleteVersionMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
}>;


export type PrintTemplateDeleteVersionMutation = { __typename?: 'Mutation', printTemplateDeleteVersion: boolean };

export type PrintTemplateSetArchivedMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type PrintTemplateSetArchivedMutation = { __typename?: 'Mutation', printTemplateSetArchived: { __typename?: 'PrintTemplate', id: string, organisationId: string, name: string, description?: string | null, status: PrintTemplateStatus, version: number, hasUnpublishedChanges: boolean, draftSpec?: any | null, publishedSpec?: any | null, publishedAt?: number | null, basedOnBuiltinId?: string | null, createdAt: number, updatedAt: number, assets: Array<{ __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplateDeleteMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
}>;


export type PrintTemplateDeleteMutation = { __typename?: 'Mutation', printTemplateDelete: boolean };

export type PrintTemplateAttachAssetMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  templateId: Scalars['ID']['input'];
  kind: PrintTemplateAssetKind;
  blobName: Scalars['String']['input'];
  originalName: Scalars['String']['input'];
}>;


export type PrintTemplateAttachAssetMutation = { __typename?: 'Mutation', printTemplateAttachAsset: { __typename?: 'PrintTemplateAsset', id: string, kind: PrintTemplateAssetKind, originalName: string, contentType: string, size: number, url: string, createdAt: number } };

export type OrganisationTemplateLibraryUpdateConfigMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  config: TemplateLibraryConfigInput;
}>;


export type OrganisationTemplateLibraryUpdateConfigMutation = { __typename?: 'Mutation', organisationTemplateLibraryUpdateConfig: { __typename?: 'TemplateLibraryConfig', hiddenBuiltinIds: Array<string>, defaultTemplate?: { __typename?: 'PrintTemplateRef', source: PrintTemplateSource, id: string } | null, brand: { __typename?: 'PrintBrand', address?: string | null, phone?: string | null, email?: string | null, website?: string | null, vat?: string | null }, logo?: { __typename?: 'PrintLogo', originalName: string, contentType: string, size: number, url: string, updatedAt: number } | null, fonts: Array<{ __typename?: 'PrintFont', id: string, family: string, weight: PrintFontWeight, italic: boolean, originalName: string, size: number, url: string, createdAt: number }> } };

export type OrganisationTemplateLibrarySetLogoMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  blobName?: InputMaybe<Scalars['String']['input']>;
  originalName?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganisationTemplateLibrarySetLogoMutation = { __typename?: 'Mutation', organisationTemplateLibrarySetLogo: { __typename?: 'TemplateLibraryConfig', hiddenBuiltinIds: Array<string>, defaultTemplate?: { __typename?: 'PrintTemplateRef', source: PrintTemplateSource, id: string } | null, brand: { __typename?: 'PrintBrand', address?: string | null, phone?: string | null, email?: string | null, website?: string | null, vat?: string | null }, logo?: { __typename?: 'PrintLogo', originalName: string, contentType: string, size: number, url: string, updatedAt: number } | null, fonts: Array<{ __typename?: 'PrintFont', id: string, family: string, weight: PrintFontWeight, italic: boolean, originalName: string, size: number, url: string, createdAt: number }> } };

export type OrganisationPrintFontAttachMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  blobName: Scalars['String']['input'];
  originalName: Scalars['String']['input'];
  family: Scalars['String']['input'];
  weight: PrintFontWeight;
  italic: Scalars['Boolean']['input'];
}>;


export type OrganisationPrintFontAttachMutation = { __typename?: 'Mutation', organisationPrintFontAttach: { __typename?: 'TemplateLibraryConfig', hiddenBuiltinIds: Array<string>, defaultTemplate?: { __typename?: 'PrintTemplateRef', source: PrintTemplateSource, id: string } | null, brand: { __typename?: 'PrintBrand', address?: string | null, phone?: string | null, email?: string | null, website?: string | null, vat?: string | null }, logo?: { __typename?: 'PrintLogo', originalName: string, contentType: string, size: number, url: string, updatedAt: number } | null, fonts: Array<{ __typename?: 'PrintFont', id: string, family: string, weight: PrintFontWeight, italic: boolean, originalName: string, size: number, url: string, createdAt: number }> } };

export type OrganisationPrintFontRemoveMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  fontId: Scalars['ID']['input'];
}>;


export type OrganisationPrintFontRemoveMutation = { __typename?: 'Mutation', organisationPrintFontRemove: { __typename?: 'TemplateLibraryConfig', hiddenBuiltinIds: Array<string>, defaultTemplate?: { __typename?: 'PrintTemplateRef', source: PrintTemplateSource, id: string } | null, brand: { __typename?: 'PrintBrand', address?: string | null, phone?: string | null, email?: string | null, website?: string | null, vat?: string | null }, logo?: { __typename?: 'PrintLogo', originalName: string, contentType: string, size: number, url: string, updatedAt: number } | null, fonts: Array<{ __typename?: 'PrintFont', id: string, family: string, weight: PrintFontWeight, italic: boolean, originalName: string, size: number, url: string, createdAt: number }> } };

export type PrintTemplateGenerateMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  prompt: Scalars['String']['input'];
  spec?: InputMaybe<Scalars['JSON']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  progressChannel?: InputMaybe<Scalars['String']['input']>;
}>;


export type PrintTemplateGenerateMutation = { __typename?: 'Mutation', printTemplateGenerate: { __typename?: 'PrintTemplateGeneration', spec: any, summary: string, name?: string | null } };

export type CurrentUserFragment = { __typename?: 'User', id: string, name: string, email: string, firstName: string, lastName: string, isSuperAdmin?: boolean | null, favoriteProjectIds: Array<string>, measurementUnit: MeasurementUnits, dateFormat: DateFormats, language: Language, rolesByOrganisation: Array<{ __typename?: 'UserRoleOrganisation', organisationId: string, role: UserRole }>, organisations: Array<{ __typename?: 'Organisation', id: string, name: string, myPermissions: Array<Permissions>, prohibitedActions: Array<PossibleActions>, referral: { __typename?: 'OrganisationReferral', role: ReferralRole }, projects: Array<{ __typename?: 'Project', id: string }>, subscription: { __typename?: 'OrganisationSubscription', isFlex: boolean, endDate?: number | null, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number }, credits: { __typename?: 'OrganisationCredits', available: number } }>, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> };

export type UserFragment = { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> };

export type UsersQueryVariables = Exact<{
  organisationId: Scalars['ID']['input'];
}>;


export type UsersQuery = { __typename?: 'Query', usersByOrganisationId: Array<{ __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> }> };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, name: string, email: string, firstName: string, lastName: string, isSuperAdmin?: boolean | null, favoriteProjectIds: Array<string>, measurementUnit: MeasurementUnits, dateFormat: DateFormats, language: Language, rolesByOrganisation: Array<{ __typename?: 'UserRoleOrganisation', organisationId: string, role: UserRole }>, organisations: Array<{ __typename?: 'Organisation', id: string, name: string, myPermissions: Array<Permissions>, prohibitedActions: Array<PossibleActions>, referral: { __typename?: 'OrganisationReferral', role: ReferralRole }, projects: Array<{ __typename?: 'Project', id: string }>, subscription: { __typename?: 'OrganisationSubscription', isFlex: boolean, endDate?: number | null, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number }, credits: { __typename?: 'OrganisationCredits', available: number } }>, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> } | null };

export type UserAddToOrganisationMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  role: UserRole;
}>;


export type UserAddToOrganisationMutation = { __typename?: 'Mutation', userAddToOrganisation: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> } };

export type UserResendInvitationMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserResendInvitationMutation = { __typename?: 'Mutation', userResendInvitation: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> } };

export type UserDeleteFromOrganisationMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserDeleteFromOrganisationMutation = { __typename?: 'Mutation', userDeleteFromOrganisation: boolean };

export type UserChangeRoleMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  role: UserRole;
}>;


export type UserChangeRoleMutation = { __typename?: 'Mutation', userChangeRole: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> } };

export type UserDisableMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserDisableMutation = { __typename?: 'Mutation', userDisable: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> } };

export type UserEnableMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type UserEnableMutation = { __typename?: 'Mutation', userEnable: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> } };

export type UserInviteInfoQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type UserInviteInfoQuery = { __typename?: 'Query', userInviteInfo: { __typename?: 'InviteInfo', email: string, organisationName: string, isNewUser: boolean, inviteId?: string | null } };

export type UserAcceptInvitationMutationVariables = Exact<{
  inviteId: Scalars['String']['input'];
  userEmail: Scalars['String']['input'];
  user?: InputMaybe<InputUser>;
}>;


export type UserAcceptInvitationMutation = { __typename?: 'Mutation', userAcceptInvitation?: boolean | null };

export type UserUpdateMutationVariables = Exact<{
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type UserUpdateMutation = { __typename?: 'Mutation', userUpdate: { __typename?: 'User', id: string, name: string, email: string, firstName: string, lastName: string, isSuperAdmin?: boolean | null, favoriteProjectIds: Array<string>, measurementUnit: MeasurementUnits, dateFormat: DateFormats, language: Language, rolesByOrganisation: Array<{ __typename?: 'UserRoleOrganisation', organisationId: string, role: UserRole }>, organisations: Array<{ __typename?: 'Organisation', id: string, name: string, myPermissions: Array<Permissions>, prohibitedActions: Array<PossibleActions>, referral: { __typename?: 'OrganisationReferral', role: ReferralRole }, projects: Array<{ __typename?: 'Project', id: string }>, subscription: { __typename?: 'OrganisationSubscription', isFlex: boolean, endDate?: number | null, canAddSimultaneousUploads: boolean, simultaneousUploadsLeft: number }, credits: { __typename?: 'OrganisationCredits', available: number } }>, properties: Array<{ __typename?: 'PropertyGroup', propertyIdentifier: string, properties: Array<{ __typename?: 'PropertyDefinition', identifier: string, value: any, valueType: PropertyValueType, createdAt: number, updatedAt: number }> }> } };

export type UserUpdateFavoritesMutationVariables = Exact<{
  projectId: Scalars['ID']['input'];
  inFavorites: Scalars['Boolean']['input'];
}>;


export type UserUpdateFavoritesMutation = { __typename?: 'Mutation', userUpdateFavorites: { __typename?: 'User', id: string, favoriteProjectIds: Array<string> } };

export type UserChangeUnitsMutationVariables = Exact<{
  inUnit: MeasurementUnits;
}>;


export type UserChangeUnitsMutation = { __typename?: 'Mutation', userChangeUnits: { __typename?: 'User', id: string, measurementUnit: MeasurementUnits } };

export type UserChangeDateFormatMutationVariables = Exact<{
  inFormat: DateFormats;
}>;


export type UserChangeDateFormatMutation = { __typename?: 'Mutation', userChangeDateFormat: { __typename?: 'User', id: string, dateFormat: DateFormats } };

export type UserChangeLanguageMutationVariables = Exact<{
  language: Language;
}>;


export type UserChangeLanguageMutation = { __typename?: 'Mutation', userChangeLanguage: { __typename?: 'User', id: string, language: Language } };

export type UserSetTemplateLibraryAccessMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UserSetTemplateLibraryAccessMutation = { __typename?: 'Mutation', userSetTemplateLibraryAccess: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> } };

export type UserSetObjectLibraryAccessMutationVariables = Exact<{
  organisationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type UserSetObjectLibraryAccessMutation = { __typename?: 'Mutation', userSetObjectLibraryAccess: { __typename?: 'User', id: string, name: string, role: UserRole, joinDate?: number | null, status?: UserStatus | null, allowedProjectIds: Array<string>, canEditObjectLibrary: boolean, canEditTemplateLibrary: boolean, email: string, allowedProjects: Array<{ __typename?: 'Project', id: string, name: string }>, projectAccess: Array<{ __typename?: 'ProjectAccess', projectId: string, level: ProjectAccessLevel }> } };

export type ProjectVisibilityFragment = { __typename?: 'Project', id: string, mapVisible: boolean, state: { __typename?: 'ProjectState', annotations: Array<{ __typename?: 'Annotation', identifier: string }>, wmsLayers: Array<{ __typename?: 'WMSLayer', identifier: string, visible: boolean }>, orthophotoLayers: Array<{ __typename?: 'OrthophotoLayer', identifier: string, visible: boolean }> }, pointClouds: Array<{ __typename?: 'PointCloud', id: string, visible: boolean }> };

export type OrderedEntityFragment = { __typename?: 'orderedIdentifier', identifier: string, index: number };

export type ProjectOrderedIndicesFragment = { __typename?: 'Project', state: { __typename?: 'ProjectState', orderedIdentifiers: Array<{ __typename?: 'orderedIdentifier', identifier: string, index: number }> } };

export type ProjectGroupTypenamesFragment = { __typename?: 'Project', state: { __typename?: 'ProjectState', groups: Array<
      | { __typename: 'AnnotationGroup', identifier: string }
      | { __typename: 'Floor', identifier: string }
      | { __typename: 'RoomGroup', identifier: string }
      | { __typename: 'SurfaceGroup', identifier: string }
    > } };

export type NewAnnotationEntityFragment = { __typename?: 'Annotation', identifier: string, type: any, groupIdentifier?: string | null };

export type NewAnnotationGroupEntityFragment = { __typename?: 'AnnotationGroup', identifier: string, name: string, type: GroupType, parentIdentifier?: string | null };

export type NewFloorEntityFragment = { __typename?: 'Floor', identifier: string, name: string, type: GroupType, parentIdentifier?: string | null };

export type NewSurfaceGroupEntityFragment = { __typename?: 'SurfaceGroup', identifier: string, name: string, type: GroupType, parentIdentifier?: string | null };

export type NewRoomGroupEntityFragment = { __typename?: 'RoomGroup', identifier: string, name: string, type: GroupType, parentIdentifier?: string | null };

type GroupRename_AnnotationGroup_Fragment = { __typename?: 'AnnotationGroup', identifier: string, name: string };

type GroupRename_Floor_Fragment = { __typename?: 'Floor', identifier: string, name: string };

type GroupRename_RoomGroup_Fragment = { __typename?: 'RoomGroup', identifier: string, name: string };

type GroupRename_SurfaceGroup_Fragment = { __typename?: 'SurfaceGroup', identifier: string, name: string };

export type GroupRenameFragment =
  | GroupRename_AnnotationGroup_Fragment
  | GroupRename_Floor_Fragment
  | GroupRename_RoomGroup_Fragment
  | GroupRename_SurfaceGroup_Fragment
;

export const ApiKeyFragmentDoc = gql`
    fragment ApiKey on ApiKey {
  name
  apiKey
  ... on ApiKeyWithLicenseKey {
    licenseKey
  }
}
    `;
export const ObjectDefinitionFieldsFragmentDoc = gql`
    fragment ObjectDefinitionFields on ObjectDefinition {
  id
  organisationId
  typeId
  name
  description
  categoryId
  tags
  status
  version
  activeVersion
  hasUnpublishedChanges
  draftSpec
  publishedSpec
  publishedAt
  assets {
    id
    kind
    originalName
    size
    url
    createdAt
  }
  basedOnBuiltinId
  templateId
  smart
  createdAt
  updatedAt
}
    `;
export const ObjectLibraryFieldsFragmentDoc = gql`
    fragment ObjectLibraryFields on ObjectLibrary {
  organisationId
  canEdit
  config {
    hiddenTypeIds
    categories {
      id
      label
      order
    }
    typeOrder {
      typeId
      categoryId
      order
    }
  }
  definitions {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;
export const OrganisationsFragmentDoc = gql`
    fragment Organisations on Organisation {
  id
  name
  usersAmount
  myPermissions
  stats {
    totalPointCount
    totalUsers
    totalProjects
  }
  isRootOrganisation
  subscription {
    type
    scheduledType
    scheduledAt
    paused
    pausedAt
    startDate
    isFlex
    endDate
    projectUnitPrice
    subscriptionPrice
    cancellable
    minPurchaseAmount
    maxPurchaseAmount
    canAddSimultaneousUploads
    simultaneousUploadsLeft
  }
  prohibitedActions
  referral {
    managedBy {
      organisationId
      name
    }
    billedTo {
      organisationId
      name
    }
    canCancelSubscription
  }
  credits {
    balance
    pending
    available
    nextExpiry
    monthlyAllowance {
      total
      remaining
      renewsAt
    }
    liveGrants {
      id
      source
      remaining
      expiresAt
    }
  }
  createdAt
}
    `;
export const OrganisationBillingFieldsFragmentDoc = gql`
    fragment OrganisationBillingFields on OrganisationBilling {
  id
  enabled
  linked
  complete
  blank
  info {
    companyName
    street
    street2
    city
    zip
    countryCode
    vat
    email
  }
}
    `;
export const ProjectsFragmentDoc = gql`
    fragment Projects on Project {
  id
  name
  description
  uploadStatus
  creditsOutstanding
  creditsWaived
  creditBreakdown {
    pointCount
    required
    singleProjectMaxPoints
  }
  isInitializing
  isLocal
  storageBaseUrl
  storageContainer
  copy {
    type
    sourceProjectId
  }
  assignee {
    id
    name
  }
  pointClouds {
    id
    pointCount
    cloudName
    validation {
      status
      isValid
      finishedAt
    }
  }
  previewUrl
}
    `;
export const ExportFragmentDoc = gql`
    fragment Export on Export {
  exportId
  status
  type
  createdAt
  fileSize
  seen
  paramInfo {
    ... on PointCloudExportParamInfo {
      fileType
      heightFilters
      classificationFilters
      resolutionFilter
      clippingFilter
    }
  }
}
    `;
export const ProjectShellFragmentDoc = gql`
    fragment ProjectShell on Project {
  id
  name
  description
  uploadStatus
  isLocal
  storageBaseUrl
  storageContainer
  copy {
    type
  }
  myAccessLevel
  assignee {
    id
    name
  }
  pointClouds {
    id
    hasClassifications
    hasSources
    uploadStatus
    cloudName
    availableClasses
    availableSources
    visible
    displayName
    pointCount
  }
  state {
    wmsLayerOrderedIdentifiers {
      identifier
      index
    }
    orthophotoLayerOrderedIdentifiers {
      identifier
      index
    }
    cadLayers {
      identifier
      name
      fileUrl
      fileName
      visibleState {
        ... on CadLayerVisibleStateDelete {
          index
          isGroup
          subIndex
        }
        ... on CadLayerVisibleStateHidden {
          index
          isGroup
          isLayer
          layerIdentifier
          subIndex
          visible
          userId
        }
      }
    }
    wmsLayers {
      identifier
      type
      name
      url
      username
      password
      layerName
      visible
    }
    orthophotoLayers {
      identifier
      name
      visible
      url
      elevation
    }
  }
  settings {
    projectionSystem
  }
  exports {
    ...Export
  }
  mapVisible
  comments {
    id
    comment
    user {
      id
      name
    }
    referenceIdentifier
    createdAt
    updatedAt
  }
  customClasses {
    id
    name
    color {
      r
      g
      b
      a
    }
    code
  }
  previewUrl
}
    ${ExportFragmentDoc}`;
export const ProjectStateFragmentDoc = gql`
    fragment ProjectState on ProjectState {
  annotations {
    identifier
    groupIdentifier
    type
  }
  groups {
    type
    identifier
    name
    parentIdentifier
  }
  orderedIdentifiers {
    identifier
    index
  }
  wmsLayerOrderedIdentifiers {
    identifier
    index
  }
  orthophotoLayerOrderedIdentifiers {
    identifier
    index
  }
  cadLayers {
    identifier
    name
    fileUrl
    fileName
    visibleState {
      ... on CadLayerVisibleStateDelete {
        index
        isGroup
        subIndex
      }
      ... on CadLayerVisibleStateHidden {
        index
        isGroup
        isLayer
        layerIdentifier
        subIndex
        visible
        userId
      }
    }
  }
  wmsLayers {
    identifier
    type
    name
    url
    username
    password
    layerName
    visible
  }
  orthophotoLayers {
    identifier
    name
    visible
    url
    elevation
  }
}
    `;
export const CalculationFragmentDoc = gql`
    fragment Calculation on Calculation {
  id
  status
  annotationIdentifier
  pointCloudIdentifier
  ... on VolumeCalculation {
    baseSurface
    result {
      volume
      area
      volumePositive
      volumeNegative
    }
    paramInfo {
      referenceHeight
      heightFilters
      intensityFilters
      classificationFilters
      resolutionFilter
      clippingFilter
    }
    isOutDated
  }
  ... on ProjectionCalculation {
    profileGroupIdentifier
    result {
      projection {
        distance
        height
      }
    }
    paramInfo {
      heightFilters
      intensityFilters
      classificationFilters
      resolutionFilter
      clippingFilter
    }
    isOutDated
  }
}
    `;
export const ProjectFragmentDoc = gql`
    fragment Project on Project {
  id
  name
  description
  uploadStatus
  isLocal
  storageBaseUrl
  storageContainer
  copy {
    type
  }
  myAccessLevel
  assignee {
    id
    name
  }
  pointClouds {
    id
    hasClassifications
    hasSources
    uploadStatus
    cloudName
    availableClasses
    availableSources
    visible
    displayName
    pointCount
  }
  state {
    ...ProjectState
  }
  settings {
    projectionSystem
  }
  calculations {
    ...Calculation
  }
  exports {
    ...Export
  }
  mapVisible
  comments {
    id
    comment
    user {
      id
      name
    }
    referenceIdentifier
    createdAt
    updatedAt
  }
  customClasses {
    id
    name
    color {
      r
      g
      b
      a
    }
    code
  }
  previewUrl
}
    ${ProjectStateFragmentDoc}
${CalculationFragmentDoc}
${ExportFragmentDoc}`;
export const ProjectShareFragmentDoc = gql`
    fragment ProjectShare on Project {
  id
  share {
    enabled
    token
    createdAt
  }
}
    `;
export const ProjectSheetFieldsFragmentDoc = gql`
    fragment ProjectSheetFields on ProjectSheet {
  id
  projectId
  name
  number
  doc
  templateSource
  templateId
  templateVersion
  latestTemplateVersion
  lastExportedAt
  createdAt
  updatedAt
}
    `;
export const ProjectPropertyStateFragmentDoc = gql`
    fragment ProjectPropertyState on Project {
  id
  stateByUser {
    userId
    properties {
      propertyIdentifier
      properties {
        identifier
        value
        valueType
        createdAt
        updatedAt
      }
    }
  }
  state {
    properties {
      propertyIdentifier
      properties {
        identifier
        value
        valueType
        createdAt
        updatedAt
      }
    }
  }
}
    `;
export const ReferralSaleFieldsFragmentDoc = gql`
    fragment ReferralSaleFields on ReferralSale {
  id
  referredOrganisationId
  referredOrganisationName
  ledgerEntryId
  ledgerEntryType
  pricingKind
  subscriptionType
  credits
  soldAt
  amountCents
  roleAtSale
  dealKind
  deductedOnInvoice
  cutBasisPoints
  cutCents
  state
  odooInvoiceId
  odooInvoiceUrl
  invoicePaidAt
  payoutId
  rewardGrantId
  voidedAt
  voidReason
}
    `;
export const ReferralPayoutFieldsFragmentDoc = gql`
    fragment ReferralPayoutFields on ReferralPayout {
  id
  periodKey
  periodStart
  periodEnd
  cadence
  manual
  saleCount
  totalCents
  claimedAt
  odooVendorBillId
  odooVendorBillUrl
  paidAt
  createdAt
}
    `;
export const ReferralOverviewFieldsFragmentDoc = gql`
    fragment ReferralOverviewFields on ReferralOverview {
  organisationId
  role
  token
  firstCutBasisPoints
  recurringCutBasisPoints
  customersCanCancel
  payoutCadence
  minPayoutCents
  referredCount
  salesCount
  pendingSalesCount
  pendingCents
  milestones {
    sales
    projects
    reached
  }
  earnedCents
  unpaidCents
  paidOutCents
  referredOrganisations {
    id
    name
    joinedAt
    usersCount
    projectsCount
    subscriptionType
    status
    salesCount
    salesAmountCents
    cutCents
    awaitingPaymentCount
    acquiredByYou
    managedByYou
    billedToYou
    canVisit
    subscriptionEndsAt
    subscriptionPaused
    scheduledType
    scheduledAt
    projectUnitPriceCents
  }
  sales {
    ...ReferralSaleFields
  }
  payouts {
    ...ReferralPayoutFields
  }
}
    ${ReferralSaleFieldsFragmentDoc}
${ReferralPayoutFieldsFragmentDoc}`;
export const SuperadminReferralOrganisationFieldsFragmentDoc = gql`
    fragment SuperadminReferralOrganisationFields on SuperadminReferralOrganisation {
  id
  name
  referredById
  referredByName
  referredAt
}
    `;
export const SuperadminOrganisationFragmentDoc = gql`
    fragment SuperadminOrganisation on Organisation {
  id
  name
  createdAt
  stats {
    totalPointCount
    totalUsers
    totalProjects
  }
  subscription {
    type
    scheduledType
    scheduledAt
    paused
    pausedAt
    startDate
    endDate
    projectUnitPrice
    subscriptionPrice
    customLimits {
      monthlyCredits
      projectUnitPrice
      subscriptionPrice
    }
  }
  credits {
    balance
    pending
    available
    nextExpiry
    monthlyAllowance {
      total
      remaining
      renewsAt
    }
  }
  odoo {
    leadId
    partnerId
    leadUrl
    partnerUrl
    orderId
    orderName
    orderUrl
    orderOrigin
    orderState
    orderConfirmed
    orderEndsAt
    orderCloseReason
    orderSyncedAt
    orderLinkStatus
    orderCandidates {
      id
      url
    }
  }
  referral {
    role
    firstCutBasisPoints
    recurringCutBasisPoints
    customersCanCancel
    payoutCadence
    minPayoutCents
    hasToken
    referredById
    referredByName
    referredAt
    acquiredBy {
      organisationId
      name
      at
    }
    managedBy {
      organisationId
      name
      at
    }
    billedTo {
      organisationId
      name
      at
    }
  }
}
    `;
export const CreditLedgerEntryFieldsFragmentDoc = gql`
    fragment CreditLedgerEntryFields on CreditLedgerEntry {
  id
  organisationId
  type
  source
  subscriptionType
  amount
  remaining
  expiresAt
  subscriptionId
  invoice
  note
  grantedBy
  grantedByAccount {
    name
    isSuperAdmin
  }
  effectiveAt
  supersededAt
  cancelledAt
  createdAt
  unitPriceCents
  totalPriceCents
  currency
}
    `;
export const SuperadminCreditLedgerEntryFieldsFragmentDoc = gql`
    fragment SuperadminCreditLedgerEntryFields on CreditLedgerEntry {
  ...CreditLedgerEntryFields
  odooInvoiceId
  odooInvoiceUrl
  invoiceVia
  odooOrderId
  odooOrderUrl
}
    ${CreditLedgerEntryFieldsFragmentDoc}`;
export const PlanTermStateFieldsFragmentDoc = gql`
    fragment PlanTermStateFields on PlanTermState {
  subscriptionType
  scheduledType
  scheduledAt
  active
  pausedAt
  monthlyCredits
  yearlyPriceCents
  projectUnitPriceCents
  startDate
  endDate
  nextRenewal
  monthsTotal
  monthsElapsed
  monthsLeft
}
    `;
export const TemplateLibraryConfigFieldsFragmentDoc = gql`
    fragment TemplateLibraryConfigFields on TemplateLibraryConfig {
  hiddenBuiltinIds
  defaultTemplate {
    source
    id
  }
  brand {
    address
    phone
    email
    website
    vat
  }
  logo {
    originalName
    contentType
    size
    url
    updatedAt
  }
  fonts {
    id
    family
    weight
    italic
    originalName
    size
    url
    createdAt
  }
}
    `;
export const PrintTemplateFieldsFragmentDoc = gql`
    fragment PrintTemplateFields on PrintTemplate {
  id
  organisationId
  name
  description
  status
  version
  hasUnpublishedChanges
  draftSpec
  publishedSpec
  publishedAt
  assets {
    id
    kind
    originalName
    contentType
    size
    url
    createdAt
  }
  basedOnBuiltinId
  createdAt
  updatedAt
}
    `;
export const TemplateLibraryFieldsFragmentDoc = gql`
    fragment TemplateLibraryFields on TemplateLibrary {
  organisationId
  canEdit
  config {
    ...TemplateLibraryConfigFields
  }
  templates {
    ...PrintTemplateFields
  }
}
    ${TemplateLibraryConfigFieldsFragmentDoc}
${PrintTemplateFieldsFragmentDoc}`;
export const PrintTemplateVersionFieldsFragmentDoc = gql`
    fragment PrintTemplateVersionFields on PrintTemplateVersion {
  id
  version
  spec
  name
  publishedAt
  publishedByName
  isLatest
  sheetCount
}
    `;
export const CurrentUserFragmentDoc = gql`
    fragment CurrentUser on User {
  id
  name
  email
  firstName
  lastName
  isSuperAdmin
  rolesByOrganisation {
    organisationId
    role
  }
  organisations {
    id
    name
    myPermissions
    referral {
      role
    }
    projects {
      id
    }
    subscription {
      isFlex
      endDate
      canAddSimultaneousUploads
      simultaneousUploadsLeft
    }
    credits {
      available
    }
    prohibitedActions
  }
  favoriteProjectIds
  measurementUnit
  dateFormat
  language
  properties {
    propertyIdentifier
    properties {
      identifier
      value
      valueType
      createdAt
      updatedAt
    }
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment User on User {
  id
  name
  role(organisationId: $organisationId)
  joinDate(organisationId: $organisationId)
  status(organisationId: $organisationId)
  status(organisationId: $organisationId)
  allowedProjectIds(organisationId: $organisationId)
  allowedProjects(organisationId: $organisationId) {
    id
    name
  }
  projectAccess(organisationId: $organisationId) {
    projectId
    level
  }
  canEditObjectLibrary(organisationId: $organisationId)
  canEditTemplateLibrary(organisationId: $organisationId)
  name
  email
}
    `;
export const ProjectVisibilityFragmentDoc = gql`
    fragment ProjectVisibility on Project {
  id
  mapVisible
  state {
    annotations {
      identifier
    }
    wmsLayers {
      identifier
      visible
    }
    orthophotoLayers {
      identifier
      visible
    }
  }
  pointClouds {
    id
    visible
  }
}
    `;
export const OrderedEntityFragmentDoc = gql`
    fragment OrderedEntity on orderedIdentifier {
  identifier
  index
}
    `;
export const ProjectOrderedIndicesFragmentDoc = gql`
    fragment ProjectOrderedIndices on Project {
  state {
    orderedIdentifiers {
      identifier
      index
    }
  }
}
    `;
export const ProjectGroupTypenamesFragmentDoc = gql`
    fragment ProjectGroupTypenames on Project {
  state {
    groups {
      __typename
      identifier
    }
  }
}
    `;
export const NewAnnotationEntityFragmentDoc = gql`
    fragment NewAnnotationEntity on Annotation {
  identifier
  type
  groupIdentifier
}
    `;
export const NewAnnotationGroupEntityFragmentDoc = gql`
    fragment NewAnnotationGroupEntity on AnnotationGroup {
  identifier
  name
  type
  parentIdentifier
}
    `;
export const NewFloorEntityFragmentDoc = gql`
    fragment NewFloorEntity on Floor {
  identifier
  name
  type
  parentIdentifier
}
    `;
export const NewSurfaceGroupEntityFragmentDoc = gql`
    fragment NewSurfaceGroupEntity on SurfaceGroup {
  identifier
  name
  type
  parentIdentifier
}
    `;
export const NewRoomGroupEntityFragmentDoc = gql`
    fragment NewRoomGroupEntity on RoomGroup {
  identifier
  name
  type
  parentIdentifier
}
    `;
export const GroupRenameFragmentDoc = gql`
    fragment GroupRename on Group {
  identifier
  name
}
    `;
export const CreateApiKeyDocument = gql`
    mutation createApiKey($organisationId: ID!, $name: String!, $keyType: APIKeyType!, $licenseKey: String) {
  createApiKey(
    organisationId: $organisationId
    name: $name
    keyType: $keyType
    licenseKey: $licenseKey
  ) {
    id
    apiKeys {
      ...ApiKey
    }
  }
}
    ${ApiKeyFragmentDoc}`;

/**
 * __useCreateApiKeyMutation__
 *
 * To run a mutation, you first call `useCreateApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createApiKeyMutation, { data, loading, error }] = useCreateApiKeyMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      keyType: // value for 'keyType'
 *      licenseKey: // value for 'licenseKey'
 *   },
 * });
 */
export function useCreateApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateApiKeyMutation, CreateApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateApiKeyMutation, CreateApiKeyMutationVariables>(CreateApiKeyDocument, options);
      }
export type CreateApiKeyMutationHookResult = ReturnType<typeof useCreateApiKeyMutation>;
export const DeleteApiKeyDocument = gql`
    mutation deleteApiKey($organisationId: ID!, $apiKey: String!) {
  deleteApiKey(organisationId: $organisationId, apiKey: $apiKey) {
    id
    apiKeys {
      ...ApiKey
    }
  }
}
    ${ApiKeyFragmentDoc}`;

/**
 * __useDeleteApiKeyMutation__
 *
 * To run a mutation, you first call `useDeleteApiKeyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteApiKeyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteApiKeyMutation, { data, loading, error }] = useDeleteApiKeyMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      apiKey: // value for 'apiKey'
 *   },
 * });
 */
export function useDeleteApiKeyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteApiKeyMutation, DeleteApiKeyMutationVariables>(DeleteApiKeyDocument, options);
      }
export type DeleteApiKeyMutationHookResult = ReturnType<typeof useDeleteApiKeyMutation>;
export const ApiKeysDocument = gql`
    query apiKeys($organisationId: ID!) {
  organisation: organisationById(organisationId: $organisationId) {
    id
    apiKeys {
      ...ApiKey
    }
  }
}
    ${ApiKeyFragmentDoc}`;

/**
 * __useApiKeysQuery__
 *
 * To run a query within a React component, call `useApiKeysQuery` and pass it any options that fit your needs.
 * When your component renders, `useApiKeysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useApiKeysQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useApiKeysQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables> & ({ variables: ApiKeysQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
      }
export function useApiKeysLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
// @ts-ignore
export function useApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApiKeysQuery, ApiKeysQueryVariables>;
export function useApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ApiKeysQuery | undefined, ApiKeysQueryVariables>;
export function useApiKeysSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ApiKeysQuery, ApiKeysQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ApiKeysQuery, ApiKeysQueryVariables>(ApiKeysDocument, options);
        }
export type ApiKeysQueryHookResult = ReturnType<typeof useApiKeysQuery>;
export type ApiKeysLazyQueryHookResult = ReturnType<typeof useApiKeysLazyQuery>;
export type ApiKeysSuspenseQueryHookResult = ReturnType<typeof useApiKeysSuspenseQuery>;
export const DebugToolsDocument = gql`
    query debugTools {
  debugTools {
    enabled
    steps {
      key
      label
    }
    odooCrons {
      id
      name
      active
      nextCall
    }
  }
}
    `;

/**
 * __useDebugToolsQuery__
 *
 * To run a query within a React component, call `useDebugToolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDebugToolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDebugToolsQuery({
 *   variables: {
 *   },
 * });
 */
export function useDebugToolsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DebugToolsQuery, DebugToolsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DebugToolsQuery, DebugToolsQueryVariables>(DebugToolsDocument, options);
      }
export function useDebugToolsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DebugToolsQuery, DebugToolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DebugToolsQuery, DebugToolsQueryVariables>(DebugToolsDocument, options);
        }
// @ts-ignore
export function useDebugToolsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DebugToolsQuery, DebugToolsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DebugToolsQuery, DebugToolsQueryVariables>;
export function useDebugToolsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DebugToolsQuery, DebugToolsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DebugToolsQuery | undefined, DebugToolsQueryVariables>;
export function useDebugToolsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DebugToolsQuery, DebugToolsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DebugToolsQuery, DebugToolsQueryVariables>(DebugToolsDocument, options);
        }
export type DebugToolsQueryHookResult = ReturnType<typeof useDebugToolsQuery>;
export type DebugToolsLazyQueryHookResult = ReturnType<typeof useDebugToolsLazyQuery>;
export type DebugToolsSuspenseQueryHookResult = ReturnType<typeof useDebugToolsSuspenseQuery>;
export const DebugRunDailyJobDocument = gql`
    mutation debugRunDailyJob($now: Date!, $steps: [String!]) {
  debugRunDailyJob(now: $now, steps: $steps) {
    key
    label
    ok
    result
    error
    durationMs
  }
}
    `;

/**
 * __useDebugRunDailyJobMutation__
 *
 * To run a mutation, you first call `useDebugRunDailyJobMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDebugRunDailyJobMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [debugRunDailyJobMutation, { data, loading, error }] = useDebugRunDailyJobMutation({
 *   variables: {
 *      now: // value for 'now'
 *      steps: // value for 'steps'
 *   },
 * });
 */
export function useDebugRunDailyJobMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DebugRunDailyJobMutation, DebugRunDailyJobMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DebugRunDailyJobMutation, DebugRunDailyJobMutationVariables>(DebugRunDailyJobDocument, options);
      }
export type DebugRunDailyJobMutationHookResult = ReturnType<typeof useDebugRunDailyJobMutation>;
export const DebugRunOdooCronDocument = gql`
    mutation debugRunOdooCron($cronId: Int!) {
  debugRunOdooCron(cronId: $cronId)
}
    `;

/**
 * __useDebugRunOdooCronMutation__
 *
 * To run a mutation, you first call `useDebugRunOdooCronMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDebugRunOdooCronMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [debugRunOdooCronMutation, { data, loading, error }] = useDebugRunOdooCronMutation({
 *   variables: {
 *      cronId: // value for 'cronId'
 *   },
 * });
 */
export function useDebugRunOdooCronMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DebugRunOdooCronMutation, DebugRunOdooCronMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DebugRunOdooCronMutation, DebugRunOdooCronMutationVariables>(DebugRunOdooCronDocument, options);
      }
export type DebugRunOdooCronMutationHookResult = ReturnType<typeof useDebugRunOdooCronMutation>;
export const DebugMakeOdooOrderDueDocument = gql`
    mutation debugMakeOdooOrderDue($organisationId: ID!) {
  debugMakeOdooOrderDue(organisationId: $organisationId) {
    id
  }
}
    `;

/**
 * __useDebugMakeOdooOrderDueMutation__
 *
 * To run a mutation, you first call `useDebugMakeOdooOrderDueMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDebugMakeOdooOrderDueMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [debugMakeOdooOrderDueMutation, { data, loading, error }] = useDebugMakeOdooOrderDueMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useDebugMakeOdooOrderDueMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DebugMakeOdooOrderDueMutation, DebugMakeOdooOrderDueMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DebugMakeOdooOrderDueMutation, DebugMakeOdooOrderDueMutationVariables>(DebugMakeOdooOrderDueDocument, options);
      }
export type DebugMakeOdooOrderDueMutationHookResult = ReturnType<typeof useDebugMakeOdooOrderDueMutation>;
export const NavvisAuthenticateDocument = gql`
    mutation NavvisAuthenticate($username: String!, $password: String!, $baseUrl: String) {
  navvisAuthenticate(username: $username, password: $password, baseUrl: $baseUrl) {
    accessToken
    refreshToken
    sites {
      id
      name
    }
  }
}
    `;

/**
 * __useNavvisAuthenticateMutation__
 *
 * To run a mutation, you first call `useNavvisAuthenticateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNavvisAuthenticateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [navvisAuthenticateMutation, { data, loading, error }] = useNavvisAuthenticateMutation({
 *   variables: {
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useNavvisAuthenticateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NavvisAuthenticateMutation, NavvisAuthenticateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NavvisAuthenticateMutation, NavvisAuthenticateMutationVariables>(NavvisAuthenticateDocument, options);
      }
export type NavvisAuthenticateMutationHookResult = ReturnType<typeof useNavvisAuthenticateMutation>;
export const NavvisListDatasetsDocument = gql`
    query NavvisListDatasets($accessToken: String!, $siteId: BigInt!, $baseUrl: String) {
  navvisListDatasets(
    accessToken: $accessToken
    siteId: $siteId
    baseUrl: $baseUrl
  ) {
    name
    pointCloudType
    referenceSystemId
    siteId
    siteName
  }
}
    `;

/**
 * __useNavvisListDatasetsQuery__
 *
 * To run a query within a React component, call `useNavvisListDatasetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavvisListDatasetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavvisListDatasetsQuery({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      siteId: // value for 'siteId'
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useNavvisListDatasetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables> & ({ variables: NavvisListDatasetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables>(NavvisListDatasetsDocument, options);
      }
export function useNavvisListDatasetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables>(NavvisListDatasetsDocument, options);
        }
// @ts-ignore
export function useNavvisListDatasetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables>;
export function useNavvisListDatasetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NavvisListDatasetsQuery | undefined, NavvisListDatasetsQueryVariables>;
export function useNavvisListDatasetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NavvisListDatasetsQuery, NavvisListDatasetsQueryVariables>(NavvisListDatasetsDocument, options);
        }
export type NavvisListDatasetsQueryHookResult = ReturnType<typeof useNavvisListDatasetsQuery>;
export type NavvisListDatasetsLazyQueryHookResult = ReturnType<typeof useNavvisListDatasetsLazyQuery>;
export type NavvisListDatasetsSuspenseQueryHookResult = ReturnType<typeof useNavvisListDatasetsSuspenseQuery>;
export const NavvisImportDatasetDocument = gql`
    mutation NavvisImportDataset($accessToken: String!, $siteId: BigInt!, $siteName: String!, $datasetName: String!, $referenceSystemId: BigInt, $organisationId: ID!, $projectName: String!, $projectDescription: String, $baseUrl: String) {
  navvisImportDataset(
    accessToken: $accessToken
    siteId: $siteId
    siteName: $siteName
    datasetName: $datasetName
    referenceSystemId: $referenceSystemId
    organisationId: $organisationId
    projectName: $projectName
    projectDescription: $projectDescription
    baseUrl: $baseUrl
  ) {
    id
    name
    uploadStatus
  }
}
    `;

/**
 * __useNavvisImportDatasetMutation__
 *
 * To run a mutation, you first call `useNavvisImportDatasetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNavvisImportDatasetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [navvisImportDatasetMutation, { data, loading, error }] = useNavvisImportDatasetMutation({
 *   variables: {
 *      accessToken: // value for 'accessToken'
 *      siteId: // value for 'siteId'
 *      siteName: // value for 'siteName'
 *      datasetName: // value for 'datasetName'
 *      referenceSystemId: // value for 'referenceSystemId'
 *      organisationId: // value for 'organisationId'
 *      projectName: // value for 'projectName'
 *      projectDescription: // value for 'projectDescription'
 *      baseUrl: // value for 'baseUrl'
 *   },
 * });
 */
export function useNavvisImportDatasetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NavvisImportDatasetMutation, NavvisImportDatasetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NavvisImportDatasetMutation, NavvisImportDatasetMutationVariables>(NavvisImportDatasetDocument, options);
      }
export type NavvisImportDatasetMutationHookResult = ReturnType<typeof useNavvisImportDatasetMutation>;
export const NotificationsDocument = gql`
    query notifications {
  notifications {
    id
    type
    isRead
    createdAt
    ... on PointCloudConvertDoneNotification {
      organisationId
      meta {
        projectId
        projectName
        uploadStatus: status
      }
    }
    ... on PointCloudCalculationDoneNotification {
      organisationId
      meta {
        projectId
        projectName
        status
        annotationIdentifier
      }
    }
    ... on UserAcceptedInvitationNotification {
      organisationId
      meta {
        organisationName
        userName
      }
    }
    ... on PointCloudExportDoneNotification {
      organisationId
      meta {
        projectId
        projectName
        status
        thisExport {
          exportId
          type
          status
          createdAt
          paramInfo {
            ... on PointCloudExportParamInfo {
              fileType
              heightFilters
              classificationFilters
              resolutionFilter
              clippingFilter
            }
          }
        }
      }
    }
    ... on UserGotMentionedNotification {
      organisationId
      meta {
        projectId
        mentioningUserId
        mentioningUserName
        referenceObjectIdentifier
        commentId
      }
    }
    ... on CreditsPurchasedNotification {
      organisationId
      meta {
        organisationName
        userName
        amount
      }
      ledgerEntry {
        id
        odooInvoiceId
        odooInvoiceUrl
        odooInvoiceNumber
      }
    }
    ... on SubscriptionPurchasedNotification {
      organisationId
      meta {
        organisationName
        userName
        subscriptionType
        fromSubscriptionType
      }
      ledgerEntry {
        id
        odooInvoiceId
        odooInvoiceUrl
        odooInvoiceNumber
      }
    }
    ... on ProjectAwaitingCreditsNotification {
      organisationId
      meta {
        projectId
        projectName
        requiredCredits
      }
    }
    ... on ProjectCustomDealNotification {
      organisationId
      meta {
        projectId
        projectName
        organisationId
        pointCountTotal
      }
    }
    ... on SalesRequestNotification {
      organisationId
      meta {
        organisationName
        userName
        userEmail
        message
      }
    }
    ... on OrganisationInviteNotification {
      organisationId
      meta {
        organisationName
        invitedByName
        inviteToken
        inviteProjectId: projectId
        inviteProjectName: projectName
      }
    }
    ... on ProjectInviteNotification {
      organisationId
      meta {
        projectId
        projectName
        organisationName
        invitedByName
      }
    }
    ... on CustomerRenewalNotification {
      organisationId
      meta {
        customerOrganisationId
        customerName
        subscriptionType
        renewsAt
      }
    }
  }
}
    `;

/**
 * __useNotificationsQuery__
 *
 * To run a query within a React component, call `useNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNotificationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
      }
export function useNotificationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
// @ts-ignore
export function useNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotificationsQuery, NotificationsQueryVariables>;
export function useNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<NotificationsQuery | undefined, NotificationsQueryVariables>;
export function useNotificationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NotificationsQuery, NotificationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, options);
        }
export type NotificationsQueryHookResult = ReturnType<typeof useNotificationsQuery>;
export type NotificationsLazyQueryHookResult = ReturnType<typeof useNotificationsLazyQuery>;
export type NotificationsSuspenseQueryHookResult = ReturnType<typeof useNotificationsSuspenseQuery>;
export const NotificationsMarkAsReadDocument = gql`
    mutation notificationsMarkAsRead($ids: [ID!]) {
  notificationsMarkAsRead(ids: $ids)
}
    `;

/**
 * __useNotificationsMarkAsReadMutation__
 *
 * To run a mutation, you first call `useNotificationsMarkAsReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsMarkAsReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsMarkAsReadMutation, { data, loading, error }] = useNotificationsMarkAsReadMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useNotificationsMarkAsReadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NotificationsMarkAsReadMutation, NotificationsMarkAsReadMutationVariables>(NotificationsMarkAsReadDocument, options);
      }
export type NotificationsMarkAsReadMutationHookResult = ReturnType<typeof useNotificationsMarkAsReadMutation>;
export const NotificationsDeleteDocument = gql`
    mutation notificationsDelete($ids: [ID!]!) {
  notificationsDelete(ids: $ids)
}
    `;

/**
 * __useNotificationsDeleteMutation__
 *
 * To run a mutation, you first call `useNotificationsDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsDeleteMutation, { data, loading, error }] = useNotificationsDeleteMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useNotificationsDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NotificationsDeleteMutation, NotificationsDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NotificationsDeleteMutation, NotificationsDeleteMutationVariables>(NotificationsDeleteDocument, options);
      }
export type NotificationsDeleteMutationHookResult = ReturnType<typeof useNotificationsDeleteMutation>;
export const NotificationsDeleteAllDocument = gql`
    mutation notificationsDeleteAll {
  notificationsDeleteAll
}
    `;

/**
 * __useNotificationsDeleteAllMutation__
 *
 * To run a mutation, you first call `useNotificationsDeleteAllMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotificationsDeleteAllMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notificationsDeleteAllMutation, { data, loading, error }] = useNotificationsDeleteAllMutation({
 *   variables: {
 *   },
 * });
 */
export function useNotificationsDeleteAllMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NotificationsDeleteAllMutation, NotificationsDeleteAllMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NotificationsDeleteAllMutation, NotificationsDeleteAllMutationVariables>(NotificationsDeleteAllDocument, options);
      }
export type NotificationsDeleteAllMutationHookResult = ReturnType<typeof useNotificationsDeleteAllMutation>;
export const ProjectObjectLibraryDocument = gql`
    query projectObjectLibrary($projectId: ID!) {
  projectObjectLibrary(projectId: $projectId) {
    ...ObjectLibraryFields
  }
}
    ${ObjectLibraryFieldsFragmentDoc}`;

/**
 * __useProjectObjectLibraryQuery__
 *
 * To run a query within a React component, call `useProjectObjectLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectObjectLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectObjectLibraryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectObjectLibraryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables> & ({ variables: ProjectObjectLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables>(ProjectObjectLibraryDocument, options);
      }
export function useProjectObjectLibraryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables>(ProjectObjectLibraryDocument, options);
        }
// @ts-ignore
export function useProjectObjectLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables>;
export function useProjectObjectLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectObjectLibraryQuery | undefined, ProjectObjectLibraryQueryVariables>;
export function useProjectObjectLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectObjectLibraryQuery, ProjectObjectLibraryQueryVariables>(ProjectObjectLibraryDocument, options);
        }
export type ProjectObjectLibraryQueryHookResult = ReturnType<typeof useProjectObjectLibraryQuery>;
export type ProjectObjectLibraryLazyQueryHookResult = ReturnType<typeof useProjectObjectLibraryLazyQuery>;
export type ProjectObjectLibrarySuspenseQueryHookResult = ReturnType<typeof useProjectObjectLibrarySuspenseQuery>;
export const OrganisationObjectLibraryDocument = gql`
    query organisationObjectLibrary($organisationId: ID!, $includeArchived: Boolean) {
  organisationObjectLibrary(
    organisationId: $organisationId
    includeArchived: $includeArchived
  ) {
    ...ObjectLibraryFields
  }
}
    ${ObjectLibraryFieldsFragmentDoc}`;

/**
 * __useOrganisationObjectLibraryQuery__
 *
 * To run a query within a React component, call `useOrganisationObjectLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationObjectLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationObjectLibraryQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useOrganisationObjectLibraryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables> & ({ variables: OrganisationObjectLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables>(OrganisationObjectLibraryDocument, options);
      }
export function useOrganisationObjectLibraryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables>(OrganisationObjectLibraryDocument, options);
        }
// @ts-ignore
export function useOrganisationObjectLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables>;
export function useOrganisationObjectLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationObjectLibraryQuery | undefined, OrganisationObjectLibraryQueryVariables>;
export function useOrganisationObjectLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationObjectLibraryQuery, OrganisationObjectLibraryQueryVariables>(OrganisationObjectLibraryDocument, options);
        }
export type OrganisationObjectLibraryQueryHookResult = ReturnType<typeof useOrganisationObjectLibraryQuery>;
export type OrganisationObjectLibraryLazyQueryHookResult = ReturnType<typeof useOrganisationObjectLibraryLazyQuery>;
export type OrganisationObjectLibrarySuspenseQueryHookResult = ReturnType<typeof useOrganisationObjectLibrarySuspenseQuery>;
export const ObjectDefinitionDocument = gql`
    query objectDefinition($organisationId: ID!, $definitionId: ID!) {
  objectDefinition(organisationId: $organisationId, definitionId: $definitionId) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionQuery__
 *
 * To run a query within a React component, call `useObjectDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectDefinitionQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *   },
 * });
 */
export function useObjectDefinitionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ObjectDefinitionQuery, ObjectDefinitionQueryVariables> & ({ variables: ObjectDefinitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ObjectDefinitionQuery, ObjectDefinitionQueryVariables>(ObjectDefinitionDocument, options);
      }
export function useObjectDefinitionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ObjectDefinitionQuery, ObjectDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ObjectDefinitionQuery, ObjectDefinitionQueryVariables>(ObjectDefinitionDocument, options);
        }
// @ts-ignore
export function useObjectDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ObjectDefinitionQuery, ObjectDefinitionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ObjectDefinitionQuery, ObjectDefinitionQueryVariables>;
export function useObjectDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ObjectDefinitionQuery, ObjectDefinitionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ObjectDefinitionQuery | undefined, ObjectDefinitionQueryVariables>;
export function useObjectDefinitionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ObjectDefinitionQuery, ObjectDefinitionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ObjectDefinitionQuery, ObjectDefinitionQueryVariables>(ObjectDefinitionDocument, options);
        }
export type ObjectDefinitionQueryHookResult = ReturnType<typeof useObjectDefinitionQuery>;
export type ObjectDefinitionLazyQueryHookResult = ReturnType<typeof useObjectDefinitionLazyQuery>;
export type ObjectDefinitionSuspenseQueryHookResult = ReturnType<typeof useObjectDefinitionSuspenseQuery>;
export const OrganisationObjectLibraryUploadSasDocument = gql`
    query organisationObjectLibraryUploadSAS($organisationId: ID!) {
  organisationObjectLibraryUploadSAS(organisationId: $organisationId)
}
    `;

/**
 * __useOrganisationObjectLibraryUploadSasQuery__
 *
 * To run a query within a React component, call `useOrganisationObjectLibraryUploadSasQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationObjectLibraryUploadSasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationObjectLibraryUploadSasQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationObjectLibraryUploadSasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables> & ({ variables: OrganisationObjectLibraryUploadSasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables>(OrganisationObjectLibraryUploadSasDocument, options);
      }
export function useOrganisationObjectLibraryUploadSasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables>(OrganisationObjectLibraryUploadSasDocument, options);
        }
// @ts-ignore
export function useOrganisationObjectLibraryUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables>;
export function useOrganisationObjectLibraryUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationObjectLibraryUploadSasQuery | undefined, OrganisationObjectLibraryUploadSasQueryVariables>;
export function useOrganisationObjectLibraryUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationObjectLibraryUploadSasQuery, OrganisationObjectLibraryUploadSasQueryVariables>(OrganisationObjectLibraryUploadSasDocument, options);
        }
export type OrganisationObjectLibraryUploadSasQueryHookResult = ReturnType<typeof useOrganisationObjectLibraryUploadSasQuery>;
export type OrganisationObjectLibraryUploadSasLazyQueryHookResult = ReturnType<typeof useOrganisationObjectLibraryUploadSasLazyQuery>;
export type OrganisationObjectLibraryUploadSasSuspenseQueryHookResult = ReturnType<typeof useOrganisationObjectLibraryUploadSasSuspenseQuery>;
export const ObjectDefinitionCreateDocument = gql`
    mutation objectDefinitionCreate($organisationId: ID!, $name: String!, $categoryId: String!, $spec: JSON!, $templateId: String, $basedOnBuiltinId: String, $duplicateOfDefinitionId: ID, $smart: Boolean) {
  objectDefinitionCreate(
    organisationId: $organisationId
    name: $name
    categoryId: $categoryId
    spec: $spec
    templateId: $templateId
    basedOnBuiltinId: $basedOnBuiltinId
    duplicateOfDefinitionId: $duplicateOfDefinitionId
    smart: $smart
  ) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionCreateMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionCreateMutation, { data, loading, error }] = useObjectDefinitionCreateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      categoryId: // value for 'categoryId'
 *      spec: // value for 'spec'
 *      templateId: // value for 'templateId'
 *      basedOnBuiltinId: // value for 'basedOnBuiltinId'
 *      duplicateOfDefinitionId: // value for 'duplicateOfDefinitionId'
 *      smart: // value for 'smart'
 *   },
 * });
 */
export function useObjectDefinitionCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionCreateMutation, ObjectDefinitionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionCreateMutation, ObjectDefinitionCreateMutationVariables>(ObjectDefinitionCreateDocument, options);
      }
export type ObjectDefinitionCreateMutationHookResult = ReturnType<typeof useObjectDefinitionCreateMutation>;
export const ObjectDefinitionUpdateDetailsDocument = gql`
    mutation objectDefinitionUpdateDetails($organisationId: ID!, $definitionId: ID!, $name: String!, $description: String, $categoryId: String!, $tags: [String!]!) {
  objectDefinitionUpdateDetails(
    organisationId: $organisationId
    definitionId: $definitionId
    name: $name
    description: $description
    categoryId: $categoryId
    tags: $tags
  ) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionUpdateDetailsMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionUpdateDetailsMutation, { data, loading, error }] = useObjectDefinitionUpdateDetailsMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      categoryId: // value for 'categoryId'
 *      tags: // value for 'tags'
 *   },
 * });
 */
export function useObjectDefinitionUpdateDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionUpdateDetailsMutation, ObjectDefinitionUpdateDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionUpdateDetailsMutation, ObjectDefinitionUpdateDetailsMutationVariables>(ObjectDefinitionUpdateDetailsDocument, options);
      }
export type ObjectDefinitionUpdateDetailsMutationHookResult = ReturnType<typeof useObjectDefinitionUpdateDetailsMutation>;
export const ObjectDefinitionSaveDraftDocument = gql`
    mutation objectDefinitionSaveDraft($organisationId: ID!, $definitionId: ID!, $spec: JSON!) {
  objectDefinitionSaveDraft(
    organisationId: $organisationId
    definitionId: $definitionId
    spec: $spec
  ) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionSaveDraftMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionSaveDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionSaveDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionSaveDraftMutation, { data, loading, error }] = useObjectDefinitionSaveDraftMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function useObjectDefinitionSaveDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionSaveDraftMutation, ObjectDefinitionSaveDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionSaveDraftMutation, ObjectDefinitionSaveDraftMutationVariables>(ObjectDefinitionSaveDraftDocument, options);
      }
export type ObjectDefinitionSaveDraftMutationHookResult = ReturnType<typeof useObjectDefinitionSaveDraftMutation>;
export const ObjectDefinitionPublishDocument = gql`
    mutation objectDefinitionPublish($organisationId: ID!, $definitionId: ID!) {
  objectDefinitionPublish(
    organisationId: $organisationId
    definitionId: $definitionId
  ) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionPublishMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionPublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionPublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionPublishMutation, { data, loading, error }] = useObjectDefinitionPublishMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *   },
 * });
 */
export function useObjectDefinitionPublishMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionPublishMutation, ObjectDefinitionPublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionPublishMutation, ObjectDefinitionPublishMutationVariables>(ObjectDefinitionPublishDocument, options);
      }
export type ObjectDefinitionPublishMutationHookResult = ReturnType<typeof useObjectDefinitionPublishMutation>;
export const ObjectDefinitionDiscardDraftDocument = gql`
    mutation objectDefinitionDiscardDraft($organisationId: ID!, $definitionId: ID!) {
  objectDefinitionDiscardDraft(
    organisationId: $organisationId
    definitionId: $definitionId
  ) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionDiscardDraftMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionDiscardDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionDiscardDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionDiscardDraftMutation, { data, loading, error }] = useObjectDefinitionDiscardDraftMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *   },
 * });
 */
export function useObjectDefinitionDiscardDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionDiscardDraftMutation, ObjectDefinitionDiscardDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionDiscardDraftMutation, ObjectDefinitionDiscardDraftMutationVariables>(ObjectDefinitionDiscardDraftDocument, options);
      }
export type ObjectDefinitionDiscardDraftMutationHookResult = ReturnType<typeof useObjectDefinitionDiscardDraftMutation>;
export const ObjectDefinitionSetArchivedDocument = gql`
    mutation objectDefinitionSetArchived($organisationId: ID!, $definitionId: ID!, $archived: Boolean!) {
  objectDefinitionSetArchived(
    organisationId: $organisationId
    definitionId: $definitionId
    archived: $archived
  ) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionSetArchivedMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionSetArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionSetArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionSetArchivedMutation, { data, loading, error }] = useObjectDefinitionSetArchivedMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function useObjectDefinitionSetArchivedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionSetArchivedMutation, ObjectDefinitionSetArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionSetArchivedMutation, ObjectDefinitionSetArchivedMutationVariables>(ObjectDefinitionSetArchivedDocument, options);
      }
export type ObjectDefinitionSetArchivedMutationHookResult = ReturnType<typeof useObjectDefinitionSetArchivedMutation>;
export const ObjectDefinitionDeleteDocument = gql`
    mutation objectDefinitionDelete($organisationId: ID!, $definitionId: ID!) {
  objectDefinitionDelete(
    organisationId: $organisationId
    definitionId: $definitionId
  )
}
    `;

/**
 * __useObjectDefinitionDeleteMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionDeleteMutation, { data, loading, error }] = useObjectDefinitionDeleteMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *   },
 * });
 */
export function useObjectDefinitionDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionDeleteMutation, ObjectDefinitionDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionDeleteMutation, ObjectDefinitionDeleteMutationVariables>(ObjectDefinitionDeleteDocument, options);
      }
export type ObjectDefinitionDeleteMutationHookResult = ReturnType<typeof useObjectDefinitionDeleteMutation>;
export const ObjectDefinitionAttachAssetDocument = gql`
    mutation objectDefinitionAttachAsset($organisationId: ID!, $definitionId: ID!, $kind: ObjectDefinitionAssetKind!, $blobName: String!, $originalName: String!) {
  objectDefinitionAttachAsset(
    organisationId: $organisationId
    definitionId: $definitionId
    kind: $kind
    blobName: $blobName
    originalName: $originalName
  ) {
    id
    kind
    originalName
    size
    url
    createdAt
  }
}
    `;

/**
 * __useObjectDefinitionAttachAssetMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionAttachAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionAttachAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionAttachAssetMutation, { data, loading, error }] = useObjectDefinitionAttachAssetMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *      kind: // value for 'kind'
 *      blobName: // value for 'blobName'
 *      originalName: // value for 'originalName'
 *   },
 * });
 */
export function useObjectDefinitionAttachAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionAttachAssetMutation, ObjectDefinitionAttachAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionAttachAssetMutation, ObjectDefinitionAttachAssetMutationVariables>(ObjectDefinitionAttachAssetDocument, options);
      }
export type ObjectDefinitionAttachAssetMutationHookResult = ReturnType<typeof useObjectDefinitionAttachAssetMutation>;
export const OrganisationObjectLibraryUpdateConfigDocument = gql`
    mutation organisationObjectLibraryUpdateConfig($organisationId: ID!, $config: ObjectLibraryConfigInput!) {
  organisationObjectLibraryUpdateConfig(
    organisationId: $organisationId
    config: $config
  ) {
    hiddenTypeIds
    categories {
      id
      label
      order
    }
    typeOrder {
      typeId
      categoryId
      order
    }
  }
}
    `;

/**
 * __useOrganisationObjectLibraryUpdateConfigMutation__
 *
 * To run a mutation, you first call `useOrganisationObjectLibraryUpdateConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationObjectLibraryUpdateConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationObjectLibraryUpdateConfigMutation, { data, loading, error }] = useOrganisationObjectLibraryUpdateConfigMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useOrganisationObjectLibraryUpdateConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationObjectLibraryUpdateConfigMutation, OrganisationObjectLibraryUpdateConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationObjectLibraryUpdateConfigMutation, OrganisationObjectLibraryUpdateConfigMutationVariables>(OrganisationObjectLibraryUpdateConfigDocument, options);
      }
export type OrganisationObjectLibraryUpdateConfigMutationHookResult = ReturnType<typeof useOrganisationObjectLibraryUpdateConfigMutation>;
export const ObjectDefinitionVersionsDocument = gql`
    query objectDefinitionVersions($organisationId: ID!, $definitionId: ID!) {
  objectDefinitionVersions(
    organisationId: $organisationId
    definitionId: $definitionId
  ) {
    id
    version
    spec
    name
    categoryId
    publishedAt
    publishedByName
    isCurrent
  }
}
    `;

/**
 * __useObjectDefinitionVersionsQuery__
 *
 * To run a query within a React component, call `useObjectDefinitionVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useObjectDefinitionVersionsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *   },
 * });
 */
export function useObjectDefinitionVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables> & ({ variables: ObjectDefinitionVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables>(ObjectDefinitionVersionsDocument, options);
      }
export function useObjectDefinitionVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables>(ObjectDefinitionVersionsDocument, options);
        }
// @ts-ignore
export function useObjectDefinitionVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables>;
export function useObjectDefinitionVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ObjectDefinitionVersionsQuery | undefined, ObjectDefinitionVersionsQueryVariables>;
export function useObjectDefinitionVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ObjectDefinitionVersionsQuery, ObjectDefinitionVersionsQueryVariables>(ObjectDefinitionVersionsDocument, options);
        }
export type ObjectDefinitionVersionsQueryHookResult = ReturnType<typeof useObjectDefinitionVersionsQuery>;
export type ObjectDefinitionVersionsLazyQueryHookResult = ReturnType<typeof useObjectDefinitionVersionsLazyQuery>;
export type ObjectDefinitionVersionsSuspenseQueryHookResult = ReturnType<typeof useObjectDefinitionVersionsSuspenseQuery>;
export const ObjectDefinitionRestoreVersionDocument = gql`
    mutation objectDefinitionRestoreVersion($organisationId: ID!, $definitionId: ID!, $version: Int!) {
  objectDefinitionRestoreVersion(
    organisationId: $organisationId
    definitionId: $definitionId
    version: $version
  ) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionRestoreVersionMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionRestoreVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionRestoreVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionRestoreVersionMutation, { data, loading, error }] = useObjectDefinitionRestoreVersionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useObjectDefinitionRestoreVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionRestoreVersionMutation, ObjectDefinitionRestoreVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionRestoreVersionMutation, ObjectDefinitionRestoreVersionMutationVariables>(ObjectDefinitionRestoreVersionDocument, options);
      }
export type ObjectDefinitionRestoreVersionMutationHookResult = ReturnType<typeof useObjectDefinitionRestoreVersionMutation>;
export const ObjectDefinitionActivateVersionDocument = gql`
    mutation objectDefinitionActivateVersion($organisationId: ID!, $definitionId: ID!, $version: Int!) {
  objectDefinitionActivateVersion(
    organisationId: $organisationId
    definitionId: $definitionId
    version: $version
  ) {
    ...ObjectDefinitionFields
  }
}
    ${ObjectDefinitionFieldsFragmentDoc}`;

/**
 * __useObjectDefinitionActivateVersionMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionActivateVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionActivateVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionActivateVersionMutation, { data, loading, error }] = useObjectDefinitionActivateVersionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useObjectDefinitionActivateVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionActivateVersionMutation, ObjectDefinitionActivateVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionActivateVersionMutation, ObjectDefinitionActivateVersionMutationVariables>(ObjectDefinitionActivateVersionDocument, options);
      }
export type ObjectDefinitionActivateVersionMutationHookResult = ReturnType<typeof useObjectDefinitionActivateVersionMutation>;
export const ObjectDefinitionDeleteVersionDocument = gql`
    mutation objectDefinitionDeleteVersion($organisationId: ID!, $definitionId: ID!, $version: Int!) {
  objectDefinitionDeleteVersion(
    organisationId: $organisationId
    definitionId: $definitionId
    version: $version
  )
}
    `;

/**
 * __useObjectDefinitionDeleteVersionMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionDeleteVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionDeleteVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionDeleteVersionMutation, { data, loading, error }] = useObjectDefinitionDeleteVersionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      definitionId: // value for 'definitionId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useObjectDefinitionDeleteVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionDeleteVersionMutation, ObjectDefinitionDeleteVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionDeleteVersionMutation, ObjectDefinitionDeleteVersionMutationVariables>(ObjectDefinitionDeleteVersionDocument, options);
      }
export type ObjectDefinitionDeleteVersionMutationHookResult = ReturnType<typeof useObjectDefinitionDeleteVersionMutation>;
export const ObjectDefinitionGenerateDocument = gql`
    mutation objectDefinitionGenerate($organisationId: ID!, $prompt: String!, $spec: JSON, $kind: ObjectDefinitionKind, $image: String, $progressChannel: String) {
  objectDefinitionGenerate(
    organisationId: $organisationId
    prompt: $prompt
    spec: $spec
    kind: $kind
    image: $image
    progressChannel: $progressChannel
  ) {
    spec
    summary
    name
  }
}
    `;

/**
 * __useObjectDefinitionGenerateMutation__
 *
 * To run a mutation, you first call `useObjectDefinitionGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useObjectDefinitionGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [objectDefinitionGenerateMutation, { data, loading, error }] = useObjectDefinitionGenerateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      prompt: // value for 'prompt'
 *      spec: // value for 'spec'
 *      kind: // value for 'kind'
 *      image: // value for 'image'
 *      progressChannel: // value for 'progressChannel'
 *   },
 * });
 */
export function useObjectDefinitionGenerateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ObjectDefinitionGenerateMutation, ObjectDefinitionGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ObjectDefinitionGenerateMutation, ObjectDefinitionGenerateMutationVariables>(ObjectDefinitionGenerateDocument, options);
      }
export type ObjectDefinitionGenerateMutationHookResult = ReturnType<typeof useObjectDefinitionGenerateMutation>;
export const OrganisationsDocument = gql`
    query organisations($includeIds: [ID!]) {
  organisations(includeIds: $includeIds) {
    ...Organisations
  }
}
    ${OrganisationsFragmentDoc}`;

/**
 * __useOrganisationsQuery__
 *
 * To run a query within a React component, call `useOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationsQuery({
 *   variables: {
 *      includeIds: // value for 'includeIds'
 *   },
 * });
 */
export function useOrganisationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
      }
export function useOrganisationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
        }
// @ts-ignore
export function useOrganisationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationsQuery, OrganisationsQueryVariables>;
export function useOrganisationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationsQuery | undefined, OrganisationsQueryVariables>;
export function useOrganisationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationsQuery, OrganisationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationsQuery, OrganisationsQueryVariables>(OrganisationsDocument, options);
        }
export type OrganisationsQueryHookResult = ReturnType<typeof useOrganisationsQuery>;
export type OrganisationsLazyQueryHookResult = ReturnType<typeof useOrganisationsLazyQuery>;
export type OrganisationsSuspenseQueryHookResult = ReturnType<typeof useOrganisationsSuspenseQuery>;
export const OrganisationUpdateDocument = gql`
    mutation organisationUpdate($organisationId: ID!, $name: String!) {
  organisationUpdate(organisationId: $organisationId, name: $name) {
    id
    name
  }
}
    `;

/**
 * __useOrganisationUpdateMutation__
 *
 * To run a mutation, you first call `useOrganisationUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationUpdateMutation, { data, loading, error }] = useOrganisationUpdateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOrganisationUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationUpdateMutation, OrganisationUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationUpdateMutation, OrganisationUpdateMutationVariables>(OrganisationUpdateDocument, options);
      }
export type OrganisationUpdateMutationHookResult = ReturnType<typeof useOrganisationUpdateMutation>;
export const OrganisationCreateDocument = gql`
    mutation organisationCreate($name: String!) {
  organisationCreate(name: $name) {
    ...Organisations
  }
}
    ${OrganisationsFragmentDoc}`;

/**
 * __useOrganisationCreateMutation__
 *
 * To run a mutation, you first call `useOrganisationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationCreateMutation, { data, loading, error }] = useOrganisationCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useOrganisationCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationCreateMutation, OrganisationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationCreateMutation, OrganisationCreateMutationVariables>(OrganisationCreateDocument, options);
      }
export type OrganisationCreateMutationHookResult = ReturnType<typeof useOrganisationCreateMutation>;
export const OrganisationDeleteDocument = gql`
    mutation organisationDelete($organisationId: ID!) {
  organisationDelete(organisationId: $organisationId)
}
    `;

/**
 * __useOrganisationDeleteMutation__
 *
 * To run a mutation, you first call `useOrganisationDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationDeleteMutation, { data, loading, error }] = useOrganisationDeleteMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationDeleteMutation, OrganisationDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationDeleteMutation, OrganisationDeleteMutationVariables>(OrganisationDeleteDocument, options);
      }
export type OrganisationDeleteMutationHookResult = ReturnType<typeof useOrganisationDeleteMutation>;
export const OrganisationCreditLedgerDocument = gql`
    query organisationCreditLedger($organisationId: ID!, $pagination: CursorPaginationInput) {
  organisationCreditLedger(
    organisationId: $organisationId
    pagination: $pagination
  ) {
    data {
      ...CreditLedgerEntryFields
      sentInvoiceNumber
      paymentStatus
    }
    nextCursor
    total
    hasMore
  }
}
    ${CreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useOrganisationCreditLedgerQuery__
 *
 * To run a query within a React component, call `useOrganisationCreditLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationCreditLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationCreditLedgerQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useOrganisationCreditLedgerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables> & ({ variables: OrganisationCreditLedgerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables>(OrganisationCreditLedgerDocument, options);
      }
export function useOrganisationCreditLedgerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables>(OrganisationCreditLedgerDocument, options);
        }
// @ts-ignore
export function useOrganisationCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables>;
export function useOrganisationCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationCreditLedgerQuery | undefined, OrganisationCreditLedgerQueryVariables>;
export function useOrganisationCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationCreditLedgerQuery, OrganisationCreditLedgerQueryVariables>(OrganisationCreditLedgerDocument, options);
        }
export type OrganisationCreditLedgerQueryHookResult = ReturnType<typeof useOrganisationCreditLedgerQuery>;
export type OrganisationCreditLedgerLazyQueryHookResult = ReturnType<typeof useOrganisationCreditLedgerLazyQuery>;
export type OrganisationCreditLedgerSuspenseQueryHookResult = ReturnType<typeof useOrganisationCreditLedgerSuspenseQuery>;
export const OrganisationInvoicePdfDocument = gql`
    query organisationInvoicePdf($organisationId: ID!, $entryId: ID!) {
  organisationInvoicePdf(organisationId: $organisationId, entryId: $entryId) {
    filename
    base64
  }
}
    `;

/**
 * __useOrganisationInvoicePdfQuery__
 *
 * To run a query within a React component, call `useOrganisationInvoicePdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationInvoicePdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationInvoicePdfQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useOrganisationInvoicePdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables> & ({ variables: OrganisationInvoicePdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables>(OrganisationInvoicePdfDocument, options);
      }
export function useOrganisationInvoicePdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables>(OrganisationInvoicePdfDocument, options);
        }
// @ts-ignore
export function useOrganisationInvoicePdfSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables>;
export function useOrganisationInvoicePdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationInvoicePdfQuery | undefined, OrganisationInvoicePdfQueryVariables>;
export function useOrganisationInvoicePdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationInvoicePdfQuery, OrganisationInvoicePdfQueryVariables>(OrganisationInvoicePdfDocument, options);
        }
export type OrganisationInvoicePdfQueryHookResult = ReturnType<typeof useOrganisationInvoicePdfQuery>;
export type OrganisationInvoicePdfLazyQueryHookResult = ReturnType<typeof useOrganisationInvoicePdfLazyQuery>;
export type OrganisationInvoicePdfSuspenseQueryHookResult = ReturnType<typeof useOrganisationInvoicePdfSuspenseQuery>;
export const OrganisationCancelSubscriptionDocument = gql`
    mutation organisationCancelSubscription($organisationId: ID!) {
  organisationCancelSubscription(organisationId: $organisationId) {
    ...Organisations
  }
}
    ${OrganisationsFragmentDoc}`;

/**
 * __useOrganisationCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useOrganisationCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationCancelSubscriptionMutation, { data, loading, error }] = useOrganisationCancelSubscriptionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationCancelSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationCancelSubscriptionMutation, OrganisationCancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationCancelSubscriptionMutation, OrganisationCancelSubscriptionMutationVariables>(OrganisationCancelSubscriptionDocument, options);
      }
export type OrganisationCancelSubscriptionMutationHookResult = ReturnType<typeof useOrganisationCancelSubscriptionMutation>;
export const OrganisationContactSalesDocument = gql`
    mutation organisationContactSales($organisationId: ID!, $message: String!) {
  organisationContactSales(organisationId: $organisationId, message: $message)
}
    `;

/**
 * __useOrganisationContactSalesMutation__
 *
 * To run a mutation, you first call `useOrganisationContactSalesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationContactSalesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationContactSalesMutation, { data, loading, error }] = useOrganisationContactSalesMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useOrganisationContactSalesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationContactSalesMutation, OrganisationContactSalesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationContactSalesMutation, OrganisationContactSalesMutationVariables>(OrganisationContactSalesDocument, options);
      }
export type OrganisationContactSalesMutationHookResult = ReturnType<typeof useOrganisationContactSalesMutation>;
export const OrganisationBillingDocument = gql`
    query organisationBilling($organisationId: ID!) {
  organisationBilling(organisationId: $organisationId) {
    ...OrganisationBillingFields
  }
}
    ${OrganisationBillingFieldsFragmentDoc}`;

/**
 * __useOrganisationBillingQuery__
 *
 * To run a query within a React component, call `useOrganisationBillingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationBillingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationBillingQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationBillingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationBillingQuery, OrganisationBillingQueryVariables> & ({ variables: OrganisationBillingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationBillingQuery, OrganisationBillingQueryVariables>(OrganisationBillingDocument, options);
      }
export function useOrganisationBillingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationBillingQuery, OrganisationBillingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationBillingQuery, OrganisationBillingQueryVariables>(OrganisationBillingDocument, options);
        }
// @ts-ignore
export function useOrganisationBillingSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationBillingQuery, OrganisationBillingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationBillingQuery, OrganisationBillingQueryVariables>;
export function useOrganisationBillingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationBillingQuery, OrganisationBillingQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationBillingQuery | undefined, OrganisationBillingQueryVariables>;
export function useOrganisationBillingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationBillingQuery, OrganisationBillingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationBillingQuery, OrganisationBillingQueryVariables>(OrganisationBillingDocument, options);
        }
export type OrganisationBillingQueryHookResult = ReturnType<typeof useOrganisationBillingQuery>;
export type OrganisationBillingLazyQueryHookResult = ReturnType<typeof useOrganisationBillingLazyQuery>;
export type OrganisationBillingSuspenseQueryHookResult = ReturnType<typeof useOrganisationBillingSuspenseQuery>;
export const OrganisationBillingWithOdooDocument = gql`
    query organisationBillingWithOdoo($organisationId: ID!) {
  organisationBilling(organisationId: $organisationId) {
    ...OrganisationBillingFields
    organisation {
      id
      odoo {
        leadId
        partnerId
        leadUrl
        partnerUrl
        orderId
        orderName
      }
    }
  }
}
    ${OrganisationBillingFieldsFragmentDoc}`;

/**
 * __useOrganisationBillingWithOdooQuery__
 *
 * To run a query within a React component, call `useOrganisationBillingWithOdooQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationBillingWithOdooQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationBillingWithOdooQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationBillingWithOdooQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables> & ({ variables: OrganisationBillingWithOdooQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables>(OrganisationBillingWithOdooDocument, options);
      }
export function useOrganisationBillingWithOdooLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables>(OrganisationBillingWithOdooDocument, options);
        }
// @ts-ignore
export function useOrganisationBillingWithOdooSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables>;
export function useOrganisationBillingWithOdooSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationBillingWithOdooQuery | undefined, OrganisationBillingWithOdooQueryVariables>;
export function useOrganisationBillingWithOdooSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationBillingWithOdooQuery, OrganisationBillingWithOdooQueryVariables>(OrganisationBillingWithOdooDocument, options);
        }
export type OrganisationBillingWithOdooQueryHookResult = ReturnType<typeof useOrganisationBillingWithOdooQuery>;
export type OrganisationBillingWithOdooLazyQueryHookResult = ReturnType<typeof useOrganisationBillingWithOdooLazyQuery>;
export type OrganisationBillingWithOdooSuspenseQueryHookResult = ReturnType<typeof useOrganisationBillingWithOdooSuspenseQuery>;
export const OrganisationLinkBillingDocument = gql`
    mutation organisationLinkBilling($organisationId: ID!) {
  organisationLinkBilling(organisationId: $organisationId) {
    ...OrganisationBillingFields
  }
}
    ${OrganisationBillingFieldsFragmentDoc}`;

/**
 * __useOrganisationLinkBillingMutation__
 *
 * To run a mutation, you first call `useOrganisationLinkBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationLinkBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationLinkBillingMutation, { data, loading, error }] = useOrganisationLinkBillingMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationLinkBillingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationLinkBillingMutation, OrganisationLinkBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationLinkBillingMutation, OrganisationLinkBillingMutationVariables>(OrganisationLinkBillingDocument, options);
      }
export type OrganisationLinkBillingMutationHookResult = ReturnType<typeof useOrganisationLinkBillingMutation>;
export const OrganisationLinkBillingWithOdooDocument = gql`
    mutation organisationLinkBillingWithOdoo($organisationId: ID!) {
  organisationLinkBilling(organisationId: $organisationId) {
    ...OrganisationBillingFields
    organisation {
      id
      odoo {
        leadId
        partnerId
        leadUrl
        partnerUrl
      }
    }
  }
}
    ${OrganisationBillingFieldsFragmentDoc}`;

/**
 * __useOrganisationLinkBillingWithOdooMutation__
 *
 * To run a mutation, you first call `useOrganisationLinkBillingWithOdooMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationLinkBillingWithOdooMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationLinkBillingWithOdooMutation, { data, loading, error }] = useOrganisationLinkBillingWithOdooMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationLinkBillingWithOdooMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationLinkBillingWithOdooMutation, OrganisationLinkBillingWithOdooMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationLinkBillingWithOdooMutation, OrganisationLinkBillingWithOdooMutationVariables>(OrganisationLinkBillingWithOdooDocument, options);
      }
export type OrganisationLinkBillingWithOdooMutationHookResult = ReturnType<typeof useOrganisationLinkBillingWithOdooMutation>;
export const OrganisationUpdateBillingDocument = gql`
    mutation organisationUpdateBilling($organisationId: ID!, $info: InputBillingInfo!) {
  organisationUpdateBilling(organisationId: $organisationId, info: $info) {
    ...OrganisationBillingFields
  }
}
    ${OrganisationBillingFieldsFragmentDoc}`;

/**
 * __useOrganisationUpdateBillingMutation__
 *
 * To run a mutation, you first call `useOrganisationUpdateBillingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationUpdateBillingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationUpdateBillingMutation, { data, loading, error }] = useOrganisationUpdateBillingMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      info: // value for 'info'
 *   },
 * });
 */
export function useOrganisationUpdateBillingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationUpdateBillingMutation, OrganisationUpdateBillingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationUpdateBillingMutation, OrganisationUpdateBillingMutationVariables>(OrganisationUpdateBillingDocument, options);
      }
export type OrganisationUpdateBillingMutationHookResult = ReturnType<typeof useOrganisationUpdateBillingMutation>;
export const OrganisationPurchaseCreditsDocument = gql`
    mutation organisationPurchaseCredits($organisationId: ID!, $amount: Int!) {
  organisationPurchaseCredits(organisationId: $organisationId, amount: $amount) {
    ...CreditLedgerEntryFields
  }
}
    ${CreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useOrganisationPurchaseCreditsMutation__
 *
 * To run a mutation, you first call `useOrganisationPurchaseCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPurchaseCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationPurchaseCreditsMutation, { data, loading, error }] = useOrganisationPurchaseCreditsMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useOrganisationPurchaseCreditsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationPurchaseCreditsMutation, OrganisationPurchaseCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationPurchaseCreditsMutation, OrganisationPurchaseCreditsMutationVariables>(OrganisationPurchaseCreditsDocument, options);
      }
export type OrganisationPurchaseCreditsMutationHookResult = ReturnType<typeof useOrganisationPurchaseCreditsMutation>;
export const OrganisationPlanChangePreviewDocument = gql`
    query organisationPlanChangePreview($organisationId: ID!, $subscriptionType: SubscriptionType!) {
  organisationPlanChangePreview(
    organisationId: $organisationId
    subscriptionType: $subscriptionType
  ) {
    kind
    subscriptionType
    effectiveAt
    scheduled
    endDate
    current {
      ...PlanTermStateFields
    }
    after {
      ...PlanTermStateFields
    }
    next {
      ...PlanTermStateFields
    }
    lines {
      subscriptionType
      from
      to
      months
      monthlyPriceCents
      totalCents
    }
    totalValueCents
    currentTermValueCents
    dueCents
    chargedCents
    priceLocked
    extraCredits
    extraCreditsAt
    extraCreditsExpireAt
    problems
  }
}
    ${PlanTermStateFieldsFragmentDoc}`;

/**
 * __useOrganisationPlanChangePreviewQuery__
 *
 * To run a query within a React component, call `useOrganisationPlanChangePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPlanChangePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationPlanChangePreviewQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      subscriptionType: // value for 'subscriptionType'
 *   },
 * });
 */
export function useOrganisationPlanChangePreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables> & ({ variables: OrganisationPlanChangePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables>(OrganisationPlanChangePreviewDocument, options);
      }
export function useOrganisationPlanChangePreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables>(OrganisationPlanChangePreviewDocument, options);
        }
// @ts-ignore
export function useOrganisationPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables>;
export function useOrganisationPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationPlanChangePreviewQuery | undefined, OrganisationPlanChangePreviewQueryVariables>;
export function useOrganisationPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationPlanChangePreviewQuery, OrganisationPlanChangePreviewQueryVariables>(OrganisationPlanChangePreviewDocument, options);
        }
export type OrganisationPlanChangePreviewQueryHookResult = ReturnType<typeof useOrganisationPlanChangePreviewQuery>;
export type OrganisationPlanChangePreviewLazyQueryHookResult = ReturnType<typeof useOrganisationPlanChangePreviewLazyQuery>;
export type OrganisationPlanChangePreviewSuspenseQueryHookResult = ReturnType<typeof useOrganisationPlanChangePreviewSuspenseQuery>;
export const OrganisationChangePlanDocument = gql`
    mutation organisationChangePlan($organisationId: ID!, $subscriptionType: SubscriptionType!) {
  organisationChangePlan(
    organisationId: $organisationId
    subscriptionType: $subscriptionType
  ) {
    ...Organisations
  }
}
    ${OrganisationsFragmentDoc}`;

/**
 * __useOrganisationChangePlanMutation__
 *
 * To run a mutation, you first call `useOrganisationChangePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationChangePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationChangePlanMutation, { data, loading, error }] = useOrganisationChangePlanMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      subscriptionType: // value for 'subscriptionType'
 *   },
 * });
 */
export function useOrganisationChangePlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationChangePlanMutation, OrganisationChangePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationChangePlanMutation, OrganisationChangePlanMutationVariables>(OrganisationChangePlanDocument, options);
      }
export type OrganisationChangePlanMutationHookResult = ReturnType<typeof useOrganisationChangePlanMutation>;
export const SuperadminSetBillingBlankDocument = gql`
    mutation superadminSetBillingBlank($organisationId: ID!, $blank: Boolean!) {
  superadminSetBillingBlank(organisationId: $organisationId, blank: $blank) {
    ...OrganisationBillingFields
  }
}
    ${OrganisationBillingFieldsFragmentDoc}`;

/**
 * __useSuperadminSetBillingBlankMutation__
 *
 * To run a mutation, you first call `useSuperadminSetBillingBlankMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminSetBillingBlankMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminSetBillingBlankMutation, { data, loading, error }] = useSuperadminSetBillingBlankMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      blank: // value for 'blank'
 *   },
 * });
 */
export function useSuperadminSetBillingBlankMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminSetBillingBlankMutation, SuperadminSetBillingBlankMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminSetBillingBlankMutation, SuperadminSetBillingBlankMutationVariables>(SuperadminSetBillingBlankDocument, options);
      }
export type SuperadminSetBillingBlankMutationHookResult = ReturnType<typeof useSuperadminSetBillingBlankMutation>;
export const ProjectsDocument = gql`
    query projects($organisationId: ID!) {
  projectsByOrganisationId(organisationId: $organisationId) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;

/**
 * __useProjectsQuery__
 *
 * To run a query within a React component, call `useProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useProjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectsQuery, ProjectsQueryVariables> & ({ variables: ProjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
      }
export function useProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
// @ts-ignore
export function useProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsQuery, ProjectsQueryVariables>;
export function useProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectsQuery | undefined, ProjectsQueryVariables>;
export function useProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectsQuery, ProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectsQuery, ProjectsQueryVariables>(ProjectsDocument, options);
        }
export type ProjectsQueryHookResult = ReturnType<typeof useProjectsQuery>;
export type ProjectsLazyQueryHookResult = ReturnType<typeof useProjectsLazyQuery>;
export type ProjectsSuspenseQueryHookResult = ReturnType<typeof useProjectsSuspenseQuery>;
export const ProjectByIdDocument = gql`
    query projectById($projectId: ID!) {
  projectById(projectId: $projectId) {
    ...Project
  }
}
    ${ProjectFragmentDoc}`;

/**
 * __useProjectByIdQuery__
 *
 * To run a query within a React component, call `useProjectByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectByIdQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables> & ({ variables: ProjectByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
      }
export function useProjectByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
        }
// @ts-ignore
export function useProjectByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectByIdQuery, ProjectByIdQueryVariables>;
export function useProjectByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectByIdQuery | undefined, ProjectByIdQueryVariables>;
export function useProjectByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectByIdQuery, ProjectByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectByIdQuery, ProjectByIdQueryVariables>(ProjectByIdDocument, options);
        }
export type ProjectByIdQueryHookResult = ReturnType<typeof useProjectByIdQuery>;
export type ProjectByIdLazyQueryHookResult = ReturnType<typeof useProjectByIdLazyQuery>;
export type ProjectByIdSuspenseQueryHookResult = ReturnType<typeof useProjectByIdSuspenseQuery>;
export const ProjectAnnotationStateDocument = gql`
    query projectAnnotationState($projectId: ID!) {
  projectById(projectId: $projectId) {
    id
    state {
      annotations {
        identifier
        groupIdentifier
        type
      }
      groups {
        type
        identifier
        name
        parentIdentifier
      }
      orderedIdentifiers {
        identifier
        index
      }
    }
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;

/**
 * __useProjectAnnotationStateQuery__
 *
 * To run a query within a React component, call `useProjectAnnotationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectAnnotationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectAnnotationStateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectAnnotationStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables> & ({ variables: ProjectAnnotationStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables>(ProjectAnnotationStateDocument, options);
      }
export function useProjectAnnotationStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables>(ProjectAnnotationStateDocument, options);
        }
// @ts-ignore
export function useProjectAnnotationStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables>;
export function useProjectAnnotationStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectAnnotationStateQuery | undefined, ProjectAnnotationStateQueryVariables>;
export function useProjectAnnotationStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectAnnotationStateQuery, ProjectAnnotationStateQueryVariables>(ProjectAnnotationStateDocument, options);
        }
export type ProjectAnnotationStateQueryHookResult = ReturnType<typeof useProjectAnnotationStateQuery>;
export type ProjectAnnotationStateLazyQueryHookResult = ReturnType<typeof useProjectAnnotationStateLazyQuery>;
export type ProjectAnnotationStateSuspenseQueryHookResult = ReturnType<typeof useProjectAnnotationStateSuspenseQuery>;
export const ProjectCalculationsDocument = gql`
    query projectCalculations($projectId: ID!) {
  projectById(projectId: $projectId) {
    id
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;

/**
 * __useProjectCalculationsQuery__
 *
 * To run a query within a React component, call `useProjectCalculationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCalculationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCalculationsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectCalculationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectCalculationsQuery, ProjectCalculationsQueryVariables> & ({ variables: ProjectCalculationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>(ProjectCalculationsDocument, options);
      }
export function useProjectCalculationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>(ProjectCalculationsDocument, options);
        }
// @ts-ignore
export function useProjectCalculationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>;
export function useProjectCalculationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectCalculationsQuery | undefined, ProjectCalculationsQueryVariables>;
export function useProjectCalculationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectCalculationsQuery, ProjectCalculationsQueryVariables>(ProjectCalculationsDocument, options);
        }
export type ProjectCalculationsQueryHookResult = ReturnType<typeof useProjectCalculationsQuery>;
export type ProjectCalculationsLazyQueryHookResult = ReturnType<typeof useProjectCalculationsLazyQuery>;
export type ProjectCalculationsSuspenseQueryHookResult = ReturnType<typeof useProjectCalculationsSuspenseQuery>;
export const ProjectExportsDocument = gql`
    query projectExports($projectId: ID!) {
  projectById(projectId: $projectId) {
    id
    exports {
      ...Export
    }
  }
}
    ${ExportFragmentDoc}`;

/**
 * __useProjectExportsQuery__
 *
 * To run a query within a React component, call `useProjectExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectExportsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectExportsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectExportsQuery, ProjectExportsQueryVariables> & ({ variables: ProjectExportsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectExportsQuery, ProjectExportsQueryVariables>(ProjectExportsDocument, options);
      }
export function useProjectExportsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectExportsQuery, ProjectExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectExportsQuery, ProjectExportsQueryVariables>(ProjectExportsDocument, options);
        }
// @ts-ignore
export function useProjectExportsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectExportsQuery, ProjectExportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectExportsQuery, ProjectExportsQueryVariables>;
export function useProjectExportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectExportsQuery, ProjectExportsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectExportsQuery | undefined, ProjectExportsQueryVariables>;
export function useProjectExportsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectExportsQuery, ProjectExportsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectExportsQuery, ProjectExportsQueryVariables>(ProjectExportsDocument, options);
        }
export type ProjectExportsQueryHookResult = ReturnType<typeof useProjectExportsQuery>;
export type ProjectExportsLazyQueryHookResult = ReturnType<typeof useProjectExportsLazyQuery>;
export type ProjectExportsSuspenseQueryHookResult = ReturnType<typeof useProjectExportsSuspenseQuery>;
export const ProjectDeleteExportDocument = gql`
    mutation projectDeleteExport($projectId: ID!, $exportId: String!) {
  projectDeleteExport(projectId: $projectId, exportId: $exportId) {
    id
    exports {
      ...Export
    }
  }
}
    ${ExportFragmentDoc}`;

/**
 * __useProjectDeleteExportMutation__
 *
 * To run a mutation, you first call `useProjectDeleteExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteExportMutation, { data, loading, error }] = useProjectDeleteExportMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      exportId: // value for 'exportId'
 *   },
 * });
 */
export function useProjectDeleteExportMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteExportMutation, ProjectDeleteExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteExportMutation, ProjectDeleteExportMutationVariables>(ProjectDeleteExportDocument, options);
      }
export type ProjectDeleteExportMutationHookResult = ReturnType<typeof useProjectDeleteExportMutation>;
export const ProjectMarkExportsSeenDocument = gql`
    mutation projectMarkExportsSeen($projectId: ID!, $exportIds: [String!]!) {
  projectMarkExportsSeen(projectId: $projectId, exportIds: $exportIds) {
    id
    exports {
      ...Export
    }
  }
}
    ${ExportFragmentDoc}`;

/**
 * __useProjectMarkExportsSeenMutation__
 *
 * To run a mutation, you first call `useProjectMarkExportsSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectMarkExportsSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectMarkExportsSeenMutation, { data, loading, error }] = useProjectMarkExportsSeenMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      exportIds: // value for 'exportIds'
 *   },
 * });
 */
export function useProjectMarkExportsSeenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectMarkExportsSeenMutation, ProjectMarkExportsSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectMarkExportsSeenMutation, ProjectMarkExportsSeenMutationVariables>(ProjectMarkExportsSeenDocument, options);
      }
export type ProjectMarkExportsSeenMutationHookResult = ReturnType<typeof useProjectMarkExportsSeenMutation>;
export const ProjectRequestUploadSasDocument = gql`
    query projectRequestUploadSAS($projectId: ID!) {
  projectRequestUploadSAS(projectId: $projectId)
}
    `;

/**
 * __useProjectRequestUploadSasQuery__
 *
 * To run a query within a React component, call `useProjectRequestUploadSasQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestUploadSasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequestUploadSasQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRequestUploadSasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables> & ({ variables: ProjectRequestUploadSasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>(ProjectRequestUploadSasDocument, options);
      }
export function useProjectRequestUploadSasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>(ProjectRequestUploadSasDocument, options);
        }
// @ts-ignore
export function useProjectRequestUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>;
export function useProjectRequestUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRequestUploadSasQuery | undefined, ProjectRequestUploadSasQueryVariables>;
export function useProjectRequestUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRequestUploadSasQuery, ProjectRequestUploadSasQueryVariables>(ProjectRequestUploadSasDocument, options);
        }
export type ProjectRequestUploadSasQueryHookResult = ReturnType<typeof useProjectRequestUploadSasQuery>;
export type ProjectRequestUploadSasLazyQueryHookResult = ReturnType<typeof useProjectRequestUploadSasLazyQuery>;
export type ProjectRequestUploadSasSuspenseQueryHookResult = ReturnType<typeof useProjectRequestUploadSasSuspenseQuery>;
export const ProjectShareDocument = gql`
    query projectShare($projectId: ID!) {
  projectById(projectId: $projectId) {
    ...ProjectShare
  }
}
    ${ProjectShareFragmentDoc}`;

/**
 * __useProjectShareQuery__
 *
 * To run a query within a React component, call `useProjectShareQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectShareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectShareQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectShareQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectShareQuery, ProjectShareQueryVariables> & ({ variables: ProjectShareQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectShareQuery, ProjectShareQueryVariables>(ProjectShareDocument, options);
      }
export function useProjectShareLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectShareQuery, ProjectShareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectShareQuery, ProjectShareQueryVariables>(ProjectShareDocument, options);
        }
// @ts-ignore
export function useProjectShareSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectShareQuery, ProjectShareQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectShareQuery, ProjectShareQueryVariables>;
export function useProjectShareSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectShareQuery, ProjectShareQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectShareQuery | undefined, ProjectShareQueryVariables>;
export function useProjectShareSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectShareQuery, ProjectShareQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectShareQuery, ProjectShareQueryVariables>(ProjectShareDocument, options);
        }
export type ProjectShareQueryHookResult = ReturnType<typeof useProjectShareQuery>;
export type ProjectShareLazyQueryHookResult = ReturnType<typeof useProjectShareLazyQuery>;
export type ProjectShareSuspenseQueryHookResult = ReturnType<typeof useProjectShareSuspenseQuery>;
export const ProjectShareSetDocument = gql`
    mutation projectShareSet($projectId: ID!, $enabled: Boolean!) {
  projectShareSet(projectId: $projectId, enabled: $enabled) {
    ...ProjectShare
  }
}
    ${ProjectShareFragmentDoc}`;

/**
 * __useProjectShareSetMutation__
 *
 * To run a mutation, you first call `useProjectShareSetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectShareSetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectShareSetMutation, { data, loading, error }] = useProjectShareSetMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useProjectShareSetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectShareSetMutation, ProjectShareSetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectShareSetMutation, ProjectShareSetMutationVariables>(ProjectShareSetDocument, options);
      }
export type ProjectShareSetMutationHookResult = ReturnType<typeof useProjectShareSetMutation>;
export const ProjectShareResetDocument = gql`
    mutation projectShareReset($projectId: ID!) {
  projectShareReset(projectId: $projectId) {
    ...ProjectShare
  }
}
    ${ProjectShareFragmentDoc}`;

/**
 * __useProjectShareResetMutation__
 *
 * To run a mutation, you first call `useProjectShareResetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectShareResetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectShareResetMutation, { data, loading, error }] = useProjectShareResetMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectShareResetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectShareResetMutation, ProjectShareResetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectShareResetMutation, ProjectShareResetMutationVariables>(ProjectShareResetDocument, options);
      }
export type ProjectShareResetMutationHookResult = ReturnType<typeof useProjectShareResetMutation>;
export const SharedProjectInfoDocument = gql`
    query sharedProjectInfo {
  sharedProjectInfo {
    projectId
    organisationId
    name
  }
}
    `;

/**
 * __useSharedProjectInfoQuery__
 *
 * To run a query within a React component, call `useSharedProjectInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useSharedProjectInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSharedProjectInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useSharedProjectInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>(SharedProjectInfoDocument, options);
      }
export function useSharedProjectInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>(SharedProjectInfoDocument, options);
        }
// @ts-ignore
export function useSharedProjectInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>;
export function useSharedProjectInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SharedProjectInfoQuery | undefined, SharedProjectInfoQueryVariables>;
export function useSharedProjectInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SharedProjectInfoQuery, SharedProjectInfoQueryVariables>(SharedProjectInfoDocument, options);
        }
export type SharedProjectInfoQueryHookResult = ReturnType<typeof useSharedProjectInfoQuery>;
export type SharedProjectInfoLazyQueryHookResult = ReturnType<typeof useSharedProjectInfoLazyQuery>;
export type SharedProjectInfoSuspenseQueryHookResult = ReturnType<typeof useSharedProjectInfoSuspenseQuery>;
export const ProjectRequestReadSasTokenDocument = gql`
    query projectRequestReadSASToken($projectId: ID!) {
  projectRequestReadSASToken(projectId: $projectId)
}
    `;

/**
 * __useProjectRequestReadSasTokenQuery__
 *
 * To run a query within a React component, call `useProjectRequestReadSasTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestReadSasTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequestReadSasTokenQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRequestReadSasTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables> & ({ variables: ProjectRequestReadSasTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>(ProjectRequestReadSasTokenDocument, options);
      }
export function useProjectRequestReadSasTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>(ProjectRequestReadSasTokenDocument, options);
        }
// @ts-ignore
export function useProjectRequestReadSasTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>;
export function useProjectRequestReadSasTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRequestReadSasTokenQuery | undefined, ProjectRequestReadSasTokenQueryVariables>;
export function useProjectRequestReadSasTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRequestReadSasTokenQuery, ProjectRequestReadSasTokenQueryVariables>(ProjectRequestReadSasTokenDocument, options);
        }
export type ProjectRequestReadSasTokenQueryHookResult = ReturnType<typeof useProjectRequestReadSasTokenQuery>;
export type ProjectRequestReadSasTokenLazyQueryHookResult = ReturnType<typeof useProjectRequestReadSasTokenLazyQuery>;
export type ProjectRequestReadSasTokenSuspenseQueryHookResult = ReturnType<typeof useProjectRequestReadSasTokenSuspenseQuery>;
export const ProjectStartDocument = gql`
    mutation projectStart($projectId: ID!, $fileNames: [String!]!, $cloudNames: [String!], $organisationId: ID!, $name: String!, $description: String!, $shouldMerge: Boolean) {
  projectStart(
    projectId: $projectId
    fileNames: $fileNames
    cloudNames: $cloudNames
    organisationId: $organisationId
    name: $name
    description: $description
    shouldMerge: $shouldMerge
  ) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;

/**
 * __useProjectStartMutation__
 *
 * To run a mutation, you first call `useProjectStartMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectStartMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectStartMutation, { data, loading, error }] = useProjectStartMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      fileNames: // value for 'fileNames'
 *      cloudNames: // value for 'cloudNames'
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      shouldMerge: // value for 'shouldMerge'
 *   },
 * });
 */
export function useProjectStartMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectStartMutation, ProjectStartMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectStartMutation, ProjectStartMutationVariables>(ProjectStartDocument, options);
      }
export type ProjectStartMutationHookResult = ReturnType<typeof useProjectStartMutation>;
export const ProjectRelaunchDocument = gql`
    mutation projectRelaunch($projectId: ID!) {
  projectRelaunch(projectId: $projectId) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;

/**
 * __useProjectRelaunchMutation__
 *
 * To run a mutation, you first call `useProjectRelaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectRelaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectRelaunchMutation, { data, loading, error }] = useProjectRelaunchMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRelaunchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectRelaunchMutation, ProjectRelaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectRelaunchMutation, ProjectRelaunchMutationVariables>(ProjectRelaunchDocument, options);
      }
export type ProjectRelaunchMutationHookResult = ReturnType<typeof useProjectRelaunchMutation>;
export const ProjectValidatePointCloudDocument = gql`
    mutation projectValidatePointCloud($projectId: ID!, $cloudName: String!) {
  projectValidatePointCloud(projectId: $projectId, cloudName: $cloudName) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;

/**
 * __useProjectValidatePointCloudMutation__
 *
 * To run a mutation, you first call `useProjectValidatePointCloudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectValidatePointCloudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectValidatePointCloudMutation, { data, loading, error }] = useProjectValidatePointCloudMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cloudName: // value for 'cloudName'
 *   },
 * });
 */
export function useProjectValidatePointCloudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectValidatePointCloudMutation, ProjectValidatePointCloudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectValidatePointCloudMutation, ProjectValidatePointCloudMutationVariables>(ProjectValidatePointCloudDocument, options);
      }
export type ProjectValidatePointCloudMutationHookResult = ReturnType<typeof useProjectValidatePointCloudMutation>;
export const ProjectStartWithPythagorasFilesDocument = gql`
    mutation projectStartWithPythagorasFiles($projectId: ID!, $cloudName: String!, $organisationId: ID!, $name: String!, $description: String!, $pointCount: BigInt) {
  projectStartWithPythagorasFiles(
    projectId: $projectId
    cloudName: $cloudName
    organisationId: $organisationId
    name: $name
    description: $description
    pointCount: $pointCount
  ) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;

/**
 * __useProjectStartWithPythagorasFilesMutation__
 *
 * To run a mutation, you first call `useProjectStartWithPythagorasFilesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectStartWithPythagorasFilesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectStartWithPythagorasFilesMutation, { data, loading, error }] = useProjectStartWithPythagorasFilesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cloudName: // value for 'cloudName'
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      pointCount: // value for 'pointCount'
 *   },
 * });
 */
export function useProjectStartWithPythagorasFilesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectStartWithPythagorasFilesMutation, ProjectStartWithPythagorasFilesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectStartWithPythagorasFilesMutation, ProjectStartWithPythagorasFilesMutationVariables>(ProjectStartWithPythagorasFilesDocument, options);
      }
export type ProjectStartWithPythagorasFilesMutationHookResult = ReturnType<typeof useProjectStartWithPythagorasFilesMutation>;
export const ProjectUpdateDocument = gql`
    mutation projectUpdate($projectId: ID!, $name: String!, $description: String!) {
  projectUpdate(projectId: $projectId, name: $name, description: $description) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;

/**
 * __useProjectUpdateMutation__
 *
 * To run a mutation, you first call `useProjectUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateMutation, { data, loading, error }] = useProjectUpdateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useProjectUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdateMutation, ProjectUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdateMutation, ProjectUpdateMutationVariables>(ProjectUpdateDocument, options);
      }
export type ProjectUpdateMutationHookResult = ReturnType<typeof useProjectUpdateMutation>;
export const ProjectUpdatePreviewImageDocument = gql`
    mutation projectUpdatePreviewImage($projectId: ID!, $previewImageFileName: String!) {
  projectUpdatePreviewImage(
    projectId: $projectId
    previewImageFileName: $previewImageFileName
  ) {
    ...Projects
  }
}
    ${ProjectsFragmentDoc}`;

/**
 * __useProjectUpdatePreviewImageMutation__
 *
 * To run a mutation, you first call `useProjectUpdatePreviewImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdatePreviewImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdatePreviewImageMutation, { data, loading, error }] = useProjectUpdatePreviewImageMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      previewImageFileName: // value for 'previewImageFileName'
 *   },
 * });
 */
export function useProjectUpdatePreviewImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdatePreviewImageMutation, ProjectUpdatePreviewImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdatePreviewImageMutation, ProjectUpdatePreviewImageMutationVariables>(ProjectUpdatePreviewImageDocument, options);
      }
export type ProjectUpdatePreviewImageMutationHookResult = ReturnType<typeof useProjectUpdatePreviewImageMutation>;
export const ProjectUpdateSettingsDocument = gql`
    mutation projectUpdateSettings($projectId: ID!, $settings: InputProjectSettings!) {
  projectUpdateSettings(projectId: $projectId, settings: $settings) {
    id
    settings {
      projectionSystem
    }
  }
}
    `;

/**
 * __useProjectUpdateSettingsMutation__
 *
 * To run a mutation, you first call `useProjectUpdateSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateSettingsMutation, { data, loading, error }] = useProjectUpdateSettingsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      settings: // value for 'settings'
 *   },
 * });
 */
export function useProjectUpdateSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdateSettingsMutation, ProjectUpdateSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdateSettingsMutation, ProjectUpdateSettingsMutationVariables>(ProjectUpdateSettingsDocument, options);
      }
export type ProjectUpdateSettingsMutationHookResult = ReturnType<typeof useProjectUpdateSettingsMutation>;
export const ProjectDeleteDocument = gql`
    mutation projectDelete($projectId: ID!) {
  projectDelete(projectId: $projectId)
}
    `;

/**
 * __useProjectDeleteMutation__
 *
 * To run a mutation, you first call `useProjectDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteMutation, { data, loading, error }] = useProjectDeleteMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteMutation, ProjectDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteMutation, ProjectDeleteMutationVariables>(ProjectDeleteDocument, options);
      }
export type ProjectDeleteMutationHookResult = ReturnType<typeof useProjectDeleteMutation>;
export const ProjectActivateDocument = gql`
    mutation projectActivate($projectId: ID!) {
  projectActivate(projectId: $projectId) {
    uploadStatus
  }
}
    `;

/**
 * __useProjectActivateMutation__
 *
 * To run a mutation, you first call `useProjectActivateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectActivateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectActivateMutation, { data, loading, error }] = useProjectActivateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectActivateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectActivateMutation, ProjectActivateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectActivateMutation, ProjectActivateMutationVariables>(ProjectActivateDocument, options);
      }
export type ProjectActivateMutationHookResult = ReturnType<typeof useProjectActivateMutation>;
export const SuperadminUnlockProjectDocument = gql`
    mutation superadminUnlockProject($projectId: ID!) {
  superadminUnlockProject(projectId: $projectId) {
    id
    uploadStatus
    creditsOutstanding
    creditsWaived
  }
}
    `;

/**
 * __useSuperadminUnlockProjectMutation__
 *
 * To run a mutation, you first call `useSuperadminUnlockProjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminUnlockProjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminUnlockProjectMutation, { data, loading, error }] = useSuperadminUnlockProjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSuperadminUnlockProjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminUnlockProjectMutation, SuperadminUnlockProjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminUnlockProjectMutation, SuperadminUnlockProjectMutationVariables>(SuperadminUnlockProjectDocument, options);
      }
export type SuperadminUnlockProjectMutationHookResult = ReturnType<typeof useSuperadminUnlockProjectMutation>;
export const SuperadminDebugSetProjectStateDocument = gql`
    mutation superadminDebugSetProjectState($projectId: ID!, $state: InputProjectDebugState!) {
  superadminDebugSetProjectState(projectId: $projectId, state: $state) {
    id
    uploadStatus
    creditsOutstanding
    creditsWaived
    creditBreakdown {
      pointCount
      required
      singleProjectMaxPoints
    }
    pointClouds {
      id
      pointCount
    }
  }
}
    `;

/**
 * __useSuperadminDebugSetProjectStateMutation__
 *
 * To run a mutation, you first call `useSuperadminDebugSetProjectStateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminDebugSetProjectStateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminDebugSetProjectStateMutation, { data, loading, error }] = useSuperadminDebugSetProjectStateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      state: // value for 'state'
 *   },
 * });
 */
export function useSuperadminDebugSetProjectStateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminDebugSetProjectStateMutation, SuperadminDebugSetProjectStateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminDebugSetProjectStateMutation, SuperadminDebugSetProjectStateMutationVariables>(SuperadminDebugSetProjectStateDocument, options);
      }
export type SuperadminDebugSetProjectStateMutationHookResult = ReturnType<typeof useSuperadminDebugSetProjectStateMutation>;
export const ProjectChargeCreditsDocument = gql`
    mutation projectChargeCredits($projectId: ID!) {
  projectChargeCredits(projectId: $projectId) {
    id
    uploadStatus
    creditsOutstanding
  }
}
    `;

/**
 * __useProjectChargeCreditsMutation__
 *
 * To run a mutation, you first call `useProjectChargeCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectChargeCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectChargeCreditsMutation, { data, loading, error }] = useProjectChargeCreditsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectChargeCreditsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectChargeCreditsMutation, ProjectChargeCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectChargeCreditsMutation, ProjectChargeCreditsMutationVariables>(ProjectChargeCreditsDocument, options);
      }
export type ProjectChargeCreditsMutationHookResult = ReturnType<typeof useProjectChargeCreditsMutation>;
export const ProjectDuplicateDocument = gql`
    mutation projectDuplicate($projectId: ID!, $name: String!, $description: String!) {
  projectDuplicate(projectId: $projectId, name: $name, description: $description) {
    id
  }
}
    `;

/**
 * __useProjectDuplicateMutation__
 *
 * To run a mutation, you first call `useProjectDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDuplicateMutation, { data, loading, error }] = useProjectDuplicateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useProjectDuplicateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDuplicateMutation, ProjectDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDuplicateMutation, ProjectDuplicateMutationVariables>(ProjectDuplicateDocument, options);
      }
export type ProjectDuplicateMutationHookResult = ReturnType<typeof useProjectDuplicateMutation>;
export const ProjectCopyToOrganisationDocument = gql`
    mutation projectCopyToOrganisation($projectId: ID!, $name: String!, $description: String, $targetOrganisationId: ID!) {
  projectCopyToOrganisation(
    projectId: $projectId
    name: $name
    description: $description
    targetOrganisationId: $targetOrganisationId
  ) {
    id
  }
}
    `;

/**
 * __useProjectCopyToOrganisationMutation__
 *
 * To run a mutation, you first call `useProjectCopyToOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCopyToOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCopyToOrganisationMutation, { data, loading, error }] = useProjectCopyToOrganisationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      targetOrganisationId: // value for 'targetOrganisationId'
 *   },
 * });
 */
export function useProjectCopyToOrganisationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectCopyToOrganisationMutation, ProjectCopyToOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectCopyToOrganisationMutation, ProjectCopyToOrganisationMutationVariables>(ProjectCopyToOrganisationDocument, options);
      }
export type ProjectCopyToOrganisationMutationHookResult = ReturnType<typeof useProjectCopyToOrganisationMutation>;
export const ProjectCloneFromCloudDocument = gql`
    mutation projectCloneFromCloud($projectId: ID!, $name: String!, $targetOrganisationId: ID!) {
  projectCloneFromCloud(
    projectId: $projectId
    name: $name
    targetOrganisationId: $targetOrganisationId
  ) {
    id
  }
}
    `;

/**
 * __useProjectCloneFromCloudMutation__
 *
 * To run a mutation, you first call `useProjectCloneFromCloudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCloneFromCloudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCloneFromCloudMutation, { data, loading, error }] = useProjectCloneFromCloudMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      targetOrganisationId: // value for 'targetOrganisationId'
 *   },
 * });
 */
export function useProjectCloneFromCloudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectCloneFromCloudMutation, ProjectCloneFromCloudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectCloneFromCloudMutation, ProjectCloneFromCloudMutationVariables>(ProjectCloneFromCloudDocument, options);
      }
export type ProjectCloneFromCloudMutationHookResult = ReturnType<typeof useProjectCloneFromCloudMutation>;
export const IsLocalStorageEnabledDocument = gql`
    query isLocalStorageEnabled {
  isLocalStorageEnabled
}
    `;

/**
 * __useIsLocalStorageEnabledQuery__
 *
 * To run a query within a React component, call `useIsLocalStorageEnabledQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsLocalStorageEnabledQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsLocalStorageEnabledQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsLocalStorageEnabledQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>(IsLocalStorageEnabledDocument, options);
      }
export function useIsLocalStorageEnabledLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>(IsLocalStorageEnabledDocument, options);
        }
// @ts-ignore
export function useIsLocalStorageEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>;
export function useIsLocalStorageEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<IsLocalStorageEnabledQuery | undefined, IsLocalStorageEnabledQueryVariables>;
export function useIsLocalStorageEnabledSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<IsLocalStorageEnabledQuery, IsLocalStorageEnabledQueryVariables>(IsLocalStorageEnabledDocument, options);
        }
export type IsLocalStorageEnabledQueryHookResult = ReturnType<typeof useIsLocalStorageEnabledQuery>;
export type IsLocalStorageEnabledLazyQueryHookResult = ReturnType<typeof useIsLocalStorageEnabledLazyQuery>;
export type IsLocalStorageEnabledSuspenseQueryHookResult = ReturnType<typeof useIsLocalStorageEnabledSuspenseQuery>;
export const ProjectConfirmPointCloudUploadDocument = gql`
    mutation projectConfirmPointCloudUpload($projectId: ID!, $fileNames: [String!]!, $shouldMerge: Boolean) {
  projectConfirmPointCloudUpload(
    projectId: $projectId
    fileNames: $fileNames
    shouldMerge: $shouldMerge
  )
}
    `;

/**
 * __useProjectConfirmPointCloudUploadMutation__
 *
 * To run a mutation, you first call `useProjectConfirmPointCloudUploadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectConfirmPointCloudUploadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectConfirmPointCloudUploadMutation, { data, loading, error }] = useProjectConfirmPointCloudUploadMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      fileNames: // value for 'fileNames'
 *      shouldMerge: // value for 'shouldMerge'
 *   },
 * });
 */
export function useProjectConfirmPointCloudUploadMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectConfirmPointCloudUploadMutation, ProjectConfirmPointCloudUploadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectConfirmPointCloudUploadMutation, ProjectConfirmPointCloudUploadMutationVariables>(ProjectConfirmPointCloudUploadDocument, options);
      }
export type ProjectConfirmPointCloudUploadMutationHookResult = ReturnType<typeof useProjectConfirmPointCloudUploadMutation>;
export const ProjectCreateAnnotationDocument = gql`
    mutation projectCreateAnnotation($projectId: ID!, $identifier: String!, $type: AnnotationType!, $groupIdentifier: String, $initialProperties: [PropertyUpdateInput!], $clientId: String) {
  projectCreateAnnotation(
    projectId: $projectId
    identifier: $identifier
    type: $type
    groupIdentifier: $groupIdentifier
    initialProperties: $initialProperties
    clientId: $clientId
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectCreateAnnotationMutation__
 *
 * To run a mutation, you first call `useProjectCreateAnnotationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCreateAnnotationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCreateAnnotationMutation, { data, loading, error }] = useProjectCreateAnnotationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifier: // value for 'identifier'
 *      type: // value for 'type'
 *      groupIdentifier: // value for 'groupIdentifier'
 *      initialProperties: // value for 'initialProperties'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useProjectCreateAnnotationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectCreateAnnotationMutation, ProjectCreateAnnotationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectCreateAnnotationMutation, ProjectCreateAnnotationMutationVariables>(ProjectCreateAnnotationDocument, options);
      }
export type ProjectCreateAnnotationMutationHookResult = ReturnType<typeof useProjectCreateAnnotationMutation>;
export const ProjectCreateGroupDocument = gql`
    mutation projectCreateGroup($projectId: ID!, $identifier: String!, $name: String!, $type: GroupType, $annotationIdentifiers: [String!]!, $parentIdentifier: String) {
  projectCreateGroup(
    projectId: $projectId
    identifier: $identifier
    name: $name
    type: $type
    annotationIdentifiers: $annotationIdentifiers
    parentIdentifier: $parentIdentifier
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectCreateGroupMutation__
 *
 * To run a mutation, you first call `useProjectCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCreateGroupMutation, { data, loading, error }] = useProjectCreateGroupMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifier: // value for 'identifier'
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      annotationIdentifiers: // value for 'annotationIdentifiers'
 *      parentIdentifier: // value for 'parentIdentifier'
 *   },
 * });
 */
export function useProjectCreateGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectCreateGroupMutation, ProjectCreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectCreateGroupMutation, ProjectCreateGroupMutationVariables>(ProjectCreateGroupDocument, options);
      }
export type ProjectCreateGroupMutationHookResult = ReturnType<typeof useProjectCreateGroupMutation>;
export const ProjectDeleteSelectedDocument = gql`
    mutation projectDeleteSelected($projectId: ID!, $annotationIdentifiers: [String!]!, $groupIdentifiers: [String!]!, $clientId: String) {
  projectDeleteSelected(
    projectId: $projectId
    annotationIdentifiers: $annotationIdentifiers
    groupIdentifiers: $groupIdentifiers
    clientId: $clientId
  ) {
    id
  }
}
    `;

/**
 * __useProjectDeleteSelectedMutation__
 *
 * To run a mutation, you first call `useProjectDeleteSelectedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteSelectedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteSelectedMutation, { data, loading, error }] = useProjectDeleteSelectedMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      annotationIdentifiers: // value for 'annotationIdentifiers'
 *      groupIdentifiers: // value for 'groupIdentifiers'
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useProjectDeleteSelectedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteSelectedMutation, ProjectDeleteSelectedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteSelectedMutation, ProjectDeleteSelectedMutationVariables>(ProjectDeleteSelectedDocument, options);
      }
export type ProjectDeleteSelectedMutationHookResult = ReturnType<typeof useProjectDeleteSelectedMutation>;
export const ProjectMoveAnnotationsToGroupDocument = gql`
    mutation projectMoveAnnotationsToGroup($projectId: ID!, $annotationIdentifiers: [String!]!, $groupIdentifier: String) {
  projectMoveAnnotationsToGroup(
    projectId: $projectId
    annotationIdentifiers: $annotationIdentifiers
    groupIdentifier: $groupIdentifier
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectMoveAnnotationsToGroupMutation__
 *
 * To run a mutation, you first call `useProjectMoveAnnotationsToGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectMoveAnnotationsToGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectMoveAnnotationsToGroupMutation, { data, loading, error }] = useProjectMoveAnnotationsToGroupMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      annotationIdentifiers: // value for 'annotationIdentifiers'
 *      groupIdentifier: // value for 'groupIdentifier'
 *   },
 * });
 */
export function useProjectMoveAnnotationsToGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectMoveAnnotationsToGroupMutation, ProjectMoveAnnotationsToGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectMoveAnnotationsToGroupMutation, ProjectMoveAnnotationsToGroupMutationVariables>(ProjectMoveAnnotationsToGroupDocument, options);
      }
export type ProjectMoveAnnotationsToGroupMutationHookResult = ReturnType<typeof useProjectMoveAnnotationsToGroupMutation>;
export const ProjectUngroupDocument = gql`
    mutation projectUngroup($projectId: ID!, $identifier: String!) {
  projectUngroup(projectId: $projectId, identifier: $identifier) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectUngroupMutation__
 *
 * To run a mutation, you first call `useProjectUngroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUngroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUngroupMutation, { data, loading, error }] = useProjectUngroupMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useProjectUngroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUngroupMutation, ProjectUngroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUngroupMutation, ProjectUngroupMutationVariables>(ProjectUngroupDocument, options);
      }
export type ProjectUngroupMutationHookResult = ReturnType<typeof useProjectUngroupMutation>;
export const ProjectUpdateOrderingDocument = gql`
    mutation projectUpdateOrdering($projectId: ID!, $identifiers: [UpdateOrderingIdentifier!]!, $toIndex: Int!, $toGroupIdentifier: String) {
  projectUpdateOrdering(
    projectId: $projectId
    identifiers: $identifiers
    toIndex: $toIndex
    toGroupIdentifier: $toGroupIdentifier
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectUpdateOrderingMutation__
 *
 * To run a mutation, you first call `useProjectUpdateOrderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateOrderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateOrderingMutation, { data, loading, error }] = useProjectUpdateOrderingMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifiers: // value for 'identifiers'
 *      toIndex: // value for 'toIndex'
 *      toGroupIdentifier: // value for 'toGroupIdentifier'
 *   },
 * });
 */
export function useProjectUpdateOrderingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdateOrderingMutation, ProjectUpdateOrderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdateOrderingMutation, ProjectUpdateOrderingMutationVariables>(ProjectUpdateOrderingDocument, options);
      }
export type ProjectUpdateOrderingMutationHookResult = ReturnType<typeof useProjectUpdateOrderingMutation>;
export const ProjectCreateCadLayerDocument = gql`
    mutation projectCreateCadLayer($projectId: ID!, $cadLayerId: String!, $name: String!, $fileName: String!) {
  projectCreateCadLayer(
    projectId: $projectId
    cadLayerId: $cadLayerId
    name: $name
    fileName: $fileName
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectCreateCadLayerMutation__
 *
 * To run a mutation, you first call `useProjectCreateCadLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCreateCadLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCreateCadLayerMutation, { data, loading, error }] = useProjectCreateCadLayerMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cadLayerId: // value for 'cadLayerId'
 *      name: // value for 'name'
 *      fileName: // value for 'fileName'
 *   },
 * });
 */
export function useProjectCreateCadLayerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectCreateCadLayerMutation, ProjectCreateCadLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectCreateCadLayerMutation, ProjectCreateCadLayerMutationVariables>(ProjectCreateCadLayerDocument, options);
      }
export type ProjectCreateCadLayerMutationHookResult = ReturnType<typeof useProjectCreateCadLayerMutation>;
export const ProjectDeleteCadLayerDocument = gql`
    mutation projectDeleteCadLayer($projectId: ID!, $cadLayerIdentifier: String!) {
  projectDeleteCadLayer(
    projectId: $projectId
    cadLayerIdentifier: $cadLayerIdentifier
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectDeleteCadLayerMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCadLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCadLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCadLayerMutation, { data, loading, error }] = useProjectDeleteCadLayerMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cadLayerIdentifier: // value for 'cadLayerIdentifier'
 *   },
 * });
 */
export function useProjectDeleteCadLayerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteCadLayerMutation, ProjectDeleteCadLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteCadLayerMutation, ProjectDeleteCadLayerMutationVariables>(ProjectDeleteCadLayerDocument, options);
      }
export type ProjectDeleteCadLayerMutationHookResult = ReturnType<typeof useProjectDeleteCadLayerMutation>;
export const ProjectDeleteCadObjectDocument = gql`
    mutation projectDeleteCadObject($projectId: ID!, $cadLayerIdentifier: String!, $index: Int!, $subIndex: Int) {
  projectDeleteCadObject(
    projectId: $projectId
    cadLayerIdentifier: $cadLayerIdentifier
    index: $index
    subIndex: $subIndex
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectDeleteCadObjectMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCadObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCadObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCadObjectMutation, { data, loading, error }] = useProjectDeleteCadObjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cadLayerIdentifier: // value for 'cadLayerIdentifier'
 *      index: // value for 'index'
 *      subIndex: // value for 'subIndex'
 *   },
 * });
 */
export function useProjectDeleteCadObjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteCadObjectMutation, ProjectDeleteCadObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteCadObjectMutation, ProjectDeleteCadObjectMutationVariables>(ProjectDeleteCadObjectDocument, options);
      }
export type ProjectDeleteCadObjectMutationHookResult = ReturnType<typeof useProjectDeleteCadObjectMutation>;
export const ProjectDeleteCadObjectGroupDocument = gql`
    mutation projectDeleteCadObjectGroup($projectId: ID!, $cadLayerIdentifier: String!, $index: Int!) {
  projectDeleteCadObjectGroup(
    projectId: $projectId
    cadLayerIdentifier: $cadLayerIdentifier
    index: $index
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectDeleteCadObjectGroupMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCadObjectGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCadObjectGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCadObjectGroupMutation, { data, loading, error }] = useProjectDeleteCadObjectGroupMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cadLayerIdentifier: // value for 'cadLayerIdentifier'
 *      index: // value for 'index'
 *   },
 * });
 */
export function useProjectDeleteCadObjectGroupMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteCadObjectGroupMutation, ProjectDeleteCadObjectGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteCadObjectGroupMutation, ProjectDeleteCadObjectGroupMutationVariables>(ProjectDeleteCadObjectGroupDocument, options);
      }
export type ProjectDeleteCadObjectGroupMutationHookResult = ReturnType<typeof useProjectDeleteCadObjectGroupMutation>;
export const ProjectHideCadObjectDocument = gql`
    mutation projectHideCadObject($projectId: ID!, $cadLayerIdentifier: String!, $index: Int!, $subIndex: Int, $isGroup: Boolean, $isLayer: Boolean, $visible: Boolean!) {
  projectHideCadObject(
    projectId: $projectId
    cadLayerIdentifier: $cadLayerIdentifier
    index: $index
    subIndex: $subIndex
    isGroup: $isGroup
    isLayer: $isLayer
    visible: $visible
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectHideCadObjectMutation__
 *
 * To run a mutation, you first call `useProjectHideCadObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectHideCadObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectHideCadObjectMutation, { data, loading, error }] = useProjectHideCadObjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cadLayerIdentifier: // value for 'cadLayerIdentifier'
 *      index: // value for 'index'
 *      subIndex: // value for 'subIndex'
 *      isGroup: // value for 'isGroup'
 *      isLayer: // value for 'isLayer'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useProjectHideCadObjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectHideCadObjectMutation, ProjectHideCadObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectHideCadObjectMutation, ProjectHideCadObjectMutationVariables>(ProjectHideCadObjectDocument, options);
      }
export type ProjectHideCadObjectMutationHookResult = ReturnType<typeof useProjectHideCadObjectMutation>;
export const ProjectConvertCadObjectDocument = gql`
    mutation projectConvertCadObject($projectId: ID!, $cadObjects: [InputCadObject!]!) {
  projectConvertCadObject(projectId: $projectId, cadObjects: $cadObjects) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectConvertCadObjectMutation__
 *
 * To run a mutation, you first call `useProjectConvertCadObjectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectConvertCadObjectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectConvertCadObjectMutation, { data, loading, error }] = useProjectConvertCadObjectMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cadObjects: // value for 'cadObjects'
 *   },
 * });
 */
export function useProjectConvertCadObjectMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectConvertCadObjectMutation, ProjectConvertCadObjectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectConvertCadObjectMutation, ProjectConvertCadObjectMutationVariables>(ProjectConvertCadObjectDocument, options);
      }
export type ProjectConvertCadObjectMutationHookResult = ReturnType<typeof useProjectConvertCadObjectMutation>;
export const ProjectCreateWmsLayerDocument = gql`
    mutation projectCreateWmsLayer($projectId: ID!, $layerId: String!, $name: String!, $url: String!, $username: String, $password: String, $layerName: String!, $type: WMSType!) {
  projectCreateWmsLayer(
    projectId: $projectId
    layerId: $layerId
    name: $name
    url: $url
    username: $username
    password: $password
    layerName: $layerName
    type: $type
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectCreateWmsLayerMutation__
 *
 * To run a mutation, you first call `useProjectCreateWmsLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCreateWmsLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCreateWmsLayerMutation, { data, loading, error }] = useProjectCreateWmsLayerMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      layerId: // value for 'layerId'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      layerName: // value for 'layerName'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProjectCreateWmsLayerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectCreateWmsLayerMutation, ProjectCreateWmsLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectCreateWmsLayerMutation, ProjectCreateWmsLayerMutationVariables>(ProjectCreateWmsLayerDocument, options);
      }
export type ProjectCreateWmsLayerMutationHookResult = ReturnType<typeof useProjectCreateWmsLayerMutation>;
export const ProjectDeleteWmsLayerDocument = gql`
    mutation projectDeleteWmsLayer($projectId: ID!, $wmsLayerIdentifier: String!) {
  projectDeleteWmsLayer(
    projectId: $projectId
    wmsLayerIdentifier: $wmsLayerIdentifier
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectDeleteWmsLayerMutation__
 *
 * To run a mutation, you first call `useProjectDeleteWmsLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteWmsLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteWmsLayerMutation, { data, loading, error }] = useProjectDeleteWmsLayerMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      wmsLayerIdentifier: // value for 'wmsLayerIdentifier'
 *   },
 * });
 */
export function useProjectDeleteWmsLayerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteWmsLayerMutation, ProjectDeleteWmsLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteWmsLayerMutation, ProjectDeleteWmsLayerMutationVariables>(ProjectDeleteWmsLayerDocument, options);
      }
export type ProjectDeleteWmsLayerMutationHookResult = ReturnType<typeof useProjectDeleteWmsLayerMutation>;
export const ProjectUpdateWmsLayerDocument = gql`
    mutation projectUpdateWmsLayer($projectId: ID!, $layerId: String!, $name: String!, $url: String!, $username: String, $password: String, $layerName: String!, $type: WMSType!) {
  projectUpdateWmsLayer(
    projectId: $projectId
    layerId: $layerId
    name: $name
    url: $url
    username: $username
    password: $password
    layerName: $layerName
    type: $type
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectUpdateWmsLayerMutation__
 *
 * To run a mutation, you first call `useProjectUpdateWmsLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateWmsLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateWmsLayerMutation, { data, loading, error }] = useProjectUpdateWmsLayerMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      layerId: // value for 'layerId'
 *      name: // value for 'name'
 *      url: // value for 'url'
 *      username: // value for 'username'
 *      password: // value for 'password'
 *      layerName: // value for 'layerName'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useProjectUpdateWmsLayerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdateWmsLayerMutation, ProjectUpdateWmsLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdateWmsLayerMutation, ProjectUpdateWmsLayerMutationVariables>(ProjectUpdateWmsLayerDocument, options);
      }
export type ProjectUpdateWmsLayerMutationHookResult = ReturnType<typeof useProjectUpdateWmsLayerMutation>;
export const ProjectUpdateWmsLayerOrderingDocument = gql`
    mutation projectUpdateWmsLayerOrdering($projectId: ID!, $identifiers: [String!]!, $toIndex: Int!) {
  projectUpdateWmsLayerOrdering(
    projectId: $projectId
    identifiers: $identifiers
    toIndex: $toIndex
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectUpdateWmsLayerOrderingMutation__
 *
 * To run a mutation, you first call `useProjectUpdateWmsLayerOrderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateWmsLayerOrderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateWmsLayerOrderingMutation, { data, loading, error }] = useProjectUpdateWmsLayerOrderingMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifiers: // value for 'identifiers'
 *      toIndex: // value for 'toIndex'
 *   },
 * });
 */
export function useProjectUpdateWmsLayerOrderingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdateWmsLayerOrderingMutation, ProjectUpdateWmsLayerOrderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdateWmsLayerOrderingMutation, ProjectUpdateWmsLayerOrderingMutationVariables>(ProjectUpdateWmsLayerOrderingDocument, options);
      }
export type ProjectUpdateWmsLayerOrderingMutationHookResult = ReturnType<typeof useProjectUpdateWmsLayerOrderingMutation>;
export const ProjectCreateOrthophotoLayerDocument = gql`
    mutation projectCreateOrthophotoLayer($projectId: ID!, $layerId: String!, $name: String!) {
  projectCreateOrthophotoLayer(
    projectId: $projectId
    layerId: $layerId
    name: $name
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectCreateOrthophotoLayerMutation__
 *
 * To run a mutation, you first call `useProjectCreateOrthophotoLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectCreateOrthophotoLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectCreateOrthophotoLayerMutation, { data, loading, error }] = useProjectCreateOrthophotoLayerMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      layerId: // value for 'layerId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useProjectCreateOrthophotoLayerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectCreateOrthophotoLayerMutation, ProjectCreateOrthophotoLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectCreateOrthophotoLayerMutation, ProjectCreateOrthophotoLayerMutationVariables>(ProjectCreateOrthophotoLayerDocument, options);
      }
export type ProjectCreateOrthophotoLayerMutationHookResult = ReturnType<typeof useProjectCreateOrthophotoLayerMutation>;
export const ProjectDeleteOrthophotoLayerDocument = gql`
    mutation projectDeleteOrthophotoLayer($projectId: ID!, $orthophotoLayerIdentifier: String!) {
  projectDeleteOrthophotoLayer(
    projectId: $projectId
    orthophotoLayerIdentifier: $orthophotoLayerIdentifier
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectDeleteOrthophotoLayerMutation__
 *
 * To run a mutation, you first call `useProjectDeleteOrthophotoLayerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteOrthophotoLayerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteOrthophotoLayerMutation, { data, loading, error }] = useProjectDeleteOrthophotoLayerMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      orthophotoLayerIdentifier: // value for 'orthophotoLayerIdentifier'
 *   },
 * });
 */
export function useProjectDeleteOrthophotoLayerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteOrthophotoLayerMutation, ProjectDeleteOrthophotoLayerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteOrthophotoLayerMutation, ProjectDeleteOrthophotoLayerMutationVariables>(ProjectDeleteOrthophotoLayerDocument, options);
      }
export type ProjectDeleteOrthophotoLayerMutationHookResult = ReturnType<typeof useProjectDeleteOrthophotoLayerMutation>;
export const ProjectUpdateOrthophotoLayerOrderingDocument = gql`
    mutation projectUpdateOrthophotoLayerOrdering($projectId: ID!, $identifiers: [String!]!, $toIndex: Int!) {
  projectUpdateOrthophotoLayerOrdering(
    projectId: $projectId
    identifiers: $identifiers
    toIndex: $toIndex
  ) {
    id
    state {
      ...ProjectState
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectUpdateOrthophotoLayerOrderingMutation__
 *
 * To run a mutation, you first call `useProjectUpdateOrthophotoLayerOrderingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateOrthophotoLayerOrderingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateOrthophotoLayerOrderingMutation, { data, loading, error }] = useProjectUpdateOrthophotoLayerOrderingMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifiers: // value for 'identifiers'
 *      toIndex: // value for 'toIndex'
 *   },
 * });
 */
export function useProjectUpdateOrthophotoLayerOrderingMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdateOrthophotoLayerOrderingMutation, ProjectUpdateOrthophotoLayerOrderingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdateOrthophotoLayerOrderingMutation, ProjectUpdateOrthophotoLayerOrderingMutationVariables>(ProjectUpdateOrthophotoLayerOrderingDocument, options);
      }
export type ProjectUpdateOrthophotoLayerOrderingMutationHookResult = ReturnType<typeof useProjectUpdateOrthophotoLayerOrderingMutation>;
export const ProjectUpdateEntityNameDocument = gql`
    mutation projectUpdateEntityName($projectId: ID!, $name: String!, $groupIdentifier: String, $pointCloudIdentifier: String, $cadLayerIdentifier: String, $wmsLayerIdentifier: String, $orthophotoLayerIdentifier: String) {
  projectUpdateEntityName(
    projectId: $projectId
    name: $name
    groupIdentifier: $groupIdentifier
    pointCloudIdentifier: $pointCloudIdentifier
    cadLayerIdentifier: $cadLayerIdentifier
    wmsLayerIdentifier: $wmsLayerIdentifier
    orthophotoLayerIdentifier: $orthophotoLayerIdentifier
  ) {
    id
    state {
      ...ProjectState
    }
    pointClouds {
      id
      displayName
    }
  }
}
    ${ProjectStateFragmentDoc}`;

/**
 * __useProjectUpdateEntityNameMutation__
 *
 * To run a mutation, you first call `useProjectUpdateEntityNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdateEntityNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdateEntityNameMutation, { data, loading, error }] = useProjectUpdateEntityNameMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      groupIdentifier: // value for 'groupIdentifier'
 *      pointCloudIdentifier: // value for 'pointCloudIdentifier'
 *      cadLayerIdentifier: // value for 'cadLayerIdentifier'
 *      wmsLayerIdentifier: // value for 'wmsLayerIdentifier'
 *      orthophotoLayerIdentifier: // value for 'orthophotoLayerIdentifier'
 *   },
 * });
 */
export function useProjectUpdateEntityNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdateEntityNameMutation, ProjectUpdateEntityNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdateEntityNameMutation, ProjectUpdateEntityNameMutationVariables>(ProjectUpdateEntityNameDocument, options);
      }
export type ProjectUpdateEntityNameMutationHookResult = ReturnType<typeof useProjectUpdateEntityNameMutation>;
export const ProjectToggleObjectVisibilityDocument = gql`
    mutation projectToggleObjectVisibility($projectId: ID!, $identifiers: [String!]!, $visible: Boolean!) {
  projectToggleObjectVisibility(
    projectId: $projectId
    identifiers: $identifiers
    visible: $visible
  ) {
    id
    state {
      annotations {
        identifier
      }
      wmsLayers {
        identifier
        visible
      }
      orthophotoLayers {
        identifier
        visible
      }
    }
    pointClouds {
      id
      visible
    }
    mapVisible
  }
}
    `;

/**
 * __useProjectToggleObjectVisibilityMutation__
 *
 * To run a mutation, you first call `useProjectToggleObjectVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectToggleObjectVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectToggleObjectVisibilityMutation, { data, loading, error }] = useProjectToggleObjectVisibilityMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifiers: // value for 'identifiers'
 *      visible: // value for 'visible'
 *   },
 * });
 */
export function useProjectToggleObjectVisibilityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectToggleObjectVisibilityMutation, ProjectToggleObjectVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectToggleObjectVisibilityMutation, ProjectToggleObjectVisibilityMutationVariables>(ProjectToggleObjectVisibilityDocument, options);
      }
export type ProjectToggleObjectVisibilityMutationHookResult = ReturnType<typeof useProjectToggleObjectVisibilityMutation>;
export const ProjectVolumeCalculateDocument = gql`
    mutation projectVolumeCalculate($projectId: ID!, $pointCloudId: ID!, $annotationIdentifier: String!, $referenceHeight: Float, $baseSurface: CalculationBaseSurfaces!, $classificationFilters: [Int!], $heightFilters: [Int], $intensityFilters: [Int], $resolutionFilter: Int, $clippingFilter: Int) {
  projectVolumeCalculate(
    projectId: $projectId
    pointCloudId: $pointCloudId
    annotationIdentifier: $annotationIdentifier
    referenceHeight: $referenceHeight
    baseSurface: $baseSurface
    classificationFilters: $classificationFilters
    heightFilters: $heightFilters
    intensityFilters: $intensityFilters
    resolutionFilter: $resolutionFilter
    clippingFilter: $clippingFilter
  ) {
    id
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;

/**
 * __useProjectVolumeCalculateMutation__
 *
 * To run a mutation, you first call `useProjectVolumeCalculateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectVolumeCalculateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectVolumeCalculateMutation, { data, loading, error }] = useProjectVolumeCalculateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      referenceHeight: // value for 'referenceHeight'
 *      baseSurface: // value for 'baseSurface'
 *      classificationFilters: // value for 'classificationFilters'
 *      heightFilters: // value for 'heightFilters'
 *      intensityFilters: // value for 'intensityFilters'
 *      resolutionFilter: // value for 'resolutionFilter'
 *      clippingFilter: // value for 'clippingFilter'
 *   },
 * });
 */
export function useProjectVolumeCalculateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectVolumeCalculateMutation, ProjectVolumeCalculateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectVolumeCalculateMutation, ProjectVolumeCalculateMutationVariables>(ProjectVolumeCalculateDocument, options);
      }
export type ProjectVolumeCalculateMutationHookResult = ReturnType<typeof useProjectVolumeCalculateMutation>;
export const ProjectExportPointcloudDocument = gql`
    mutation projectExportPointcloud($projectId: ID!, $pointCloudId: ID!, $fileType: FileTypes, $heightFilters: [Int], $intensityFilters: [Int], $classificationFilters: [Int], $resolutionFilter: Int, $clippingFilter: Int) {
  projectExportPointcloud(
    projectId: $projectId
    pointCloudId: $pointCloudId
    fileType: $fileType
    heightFilters: $heightFilters
    intensityFilters: $intensityFilters
    classificationFilters: $classificationFilters
    resolutionFilter: $resolutionFilter
    clippingFilter: $clippingFilter
  ) {
    id
    exports {
      ...Export
    }
  }
}
    ${ExportFragmentDoc}`;

/**
 * __useProjectExportPointcloudMutation__
 *
 * To run a mutation, you first call `useProjectExportPointcloudMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectExportPointcloudMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectExportPointcloudMutation, { data, loading, error }] = useProjectExportPointcloudMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *      fileType: // value for 'fileType'
 *      heightFilters: // value for 'heightFilters'
 *      intensityFilters: // value for 'intensityFilters'
 *      classificationFilters: // value for 'classificationFilters'
 *      resolutionFilter: // value for 'resolutionFilter'
 *      clippingFilter: // value for 'clippingFilter'
 *   },
 * });
 */
export function useProjectExportPointcloudMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectExportPointcloudMutation, ProjectExportPointcloudMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectExportPointcloudMutation, ProjectExportPointcloudMutationVariables>(ProjectExportPointcloudDocument, options);
      }
export type ProjectExportPointcloudMutationHookResult = ReturnType<typeof useProjectExportPointcloudMutation>;
export const ProjectProjectionCalculateDocument = gql`
    mutation projectProjectionCalculate($projectId: ID!, $pointCloudId: ID!, $annotationIdentifier: String!, $profileGroupIdentifier: String!, $classificationFilters: [Int!], $heightFilters: [Int], $intensityFilters: [Int], $resolutionFilter: Int, $clippingFilter: Int) {
  projectProjectionCalculate(
    projectId: $projectId
    pointCloudId: $pointCloudId
    annotationIdentifier: $annotationIdentifier
    profileGroupIdentifier: $profileGroupIdentifier
    classificationFilters: $classificationFilters
    heightFilters: $heightFilters
    intensityFilters: $intensityFilters
    resolutionFilter: $resolutionFilter
    clippingFilter: $clippingFilter
  ) {
    id
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;

/**
 * __useProjectProjectionCalculateMutation__
 *
 * To run a mutation, you first call `useProjectProjectionCalculateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectProjectionCalculateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectProjectionCalculateMutation, { data, loading, error }] = useProjectProjectionCalculateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *      annotationIdentifier: // value for 'annotationIdentifier'
 *      profileGroupIdentifier: // value for 'profileGroupIdentifier'
 *      classificationFilters: // value for 'classificationFilters'
 *      heightFilters: // value for 'heightFilters'
 *      intensityFilters: // value for 'intensityFilters'
 *      resolutionFilter: // value for 'resolutionFilter'
 *      clippingFilter: // value for 'clippingFilter'
 *   },
 * });
 */
export function useProjectProjectionCalculateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectProjectionCalculateMutation, ProjectProjectionCalculateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectProjectionCalculateMutation, ProjectProjectionCalculateMutationVariables>(ProjectProjectionCalculateDocument, options);
      }
export type ProjectProjectionCalculateMutationHookResult = ReturnType<typeof useProjectProjectionCalculateMutation>;
export const ProjectDeleteCalculationDocument = gql`
    mutation projectDeleteCalculation($projectId: ID!, $calculationId: ID!) {
  projectDeleteCalculation(projectId: $projectId, calculationId: $calculationId) {
    id
    calculations {
      ...Calculation
    }
  }
}
    ${CalculationFragmentDoc}`;

/**
 * __useProjectDeleteCalculationMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCalculationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCalculationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCalculationMutation, { data, loading, error }] = useProjectDeleteCalculationMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      calculationId: // value for 'calculationId'
 *   },
 * });
 */
export function useProjectDeleteCalculationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteCalculationMutation, ProjectDeleteCalculationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteCalculationMutation, ProjectDeleteCalculationMutationVariables>(ProjectDeleteCalculationDocument, options);
      }
export type ProjectDeleteCalculationMutationHookResult = ReturnType<typeof useProjectDeleteCalculationMutation>;
export const ProjectGenerateClassificationsDocument = gql`
    mutation projectGenerateClassifications($projectId: ID!, $cloudName: String!) {
  projectGenerateClassifications(projectId: $projectId, cloudName: $cloudName) {
    id
    pointClouds {
      hasClassifications
    }
  }
}
    `;

/**
 * __useProjectGenerateClassificationsMutation__
 *
 * To run a mutation, you first call `useProjectGenerateClassificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectGenerateClassificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectGenerateClassificationsMutation, { data, loading, error }] = useProjectGenerateClassificationsMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      cloudName: // value for 'cloudName'
 *   },
 * });
 */
export function useProjectGenerateClassificationsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectGenerateClassificationsMutation, ProjectGenerateClassificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectGenerateClassificationsMutation, ProjectGenerateClassificationsMutationVariables>(ProjectGenerateClassificationsDocument, options);
      }
export type ProjectGenerateClassificationsMutationHookResult = ReturnType<typeof useProjectGenerateClassificationsMutation>;
export const ProjectPointCloudDeleteDocument = gql`
    mutation projectPointCloudDelete($projectId: ID!, $pointCloudId: ID!) {
  projectPointCloudDelete(projectId: $projectId, pointCloudId: $pointCloudId) {
    id
    pointClouds {
      id
      hasClassifications
      hasSources
      uploadStatus
      cloudName
      availableClasses
      availableSources
      visible
      displayName
      pointCount
    }
    state {
      annotations {
        identifier
      }
    }
  }
}
    `;

/**
 * __useProjectPointCloudDeleteMutation__
 *
 * To run a mutation, you first call `useProjectPointCloudDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectPointCloudDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectPointCloudDeleteMutation, { data, loading, error }] = useProjectPointCloudDeleteMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *   },
 * });
 */
export function useProjectPointCloudDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectPointCloudDeleteMutation, ProjectPointCloudDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectPointCloudDeleteMutation, ProjectPointCloudDeleteMutationVariables>(ProjectPointCloudDeleteDocument, options);
      }
export type ProjectPointCloudDeleteMutationHookResult = ReturnType<typeof useProjectPointCloudDeleteMutation>;
export const PointCloudUploadStatusDocument = gql`
    query pointCloudUploadStatus($projectId: ID!) {
  projectById(projectId: $projectId) {
    id
    pointClouds {
      id
      uploadStatus
    }
  }
}
    `;

/**
 * __usePointCloudUploadStatusQuery__
 *
 * To run a query within a React component, call `usePointCloudUploadStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `usePointCloudUploadStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePointCloudUploadStatusQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function usePointCloudUploadStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables> & ({ variables: PointCloudUploadStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>(PointCloudUploadStatusDocument, options);
      }
export function usePointCloudUploadStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>(PointCloudUploadStatusDocument, options);
        }
// @ts-ignore
export function usePointCloudUploadStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>;
export function usePointCloudUploadStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PointCloudUploadStatusQuery | undefined, PointCloudUploadStatusQueryVariables>;
export function usePointCloudUploadStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PointCloudUploadStatusQuery, PointCloudUploadStatusQueryVariables>(PointCloudUploadStatusDocument, options);
        }
export type PointCloudUploadStatusQueryHookResult = ReturnType<typeof usePointCloudUploadStatusQuery>;
export type PointCloudUploadStatusLazyQueryHookResult = ReturnType<typeof usePointCloudUploadStatusLazyQuery>;
export type PointCloudUploadStatusSuspenseQueryHookResult = ReturnType<typeof usePointCloudUploadStatusSuspenseQuery>;
export const ProjectInitializeDocument = gql`
    mutation projectInitialize($organisationId: ID!) {
  projectInitialize(organisationId: $organisationId) {
    id
  }
}
    `;

/**
 * __useProjectInitializeMutation__
 *
 * To run a mutation, you first call `useProjectInitializeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectInitializeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectInitializeMutation, { data, loading, error }] = useProjectInitializeMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useProjectInitializeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectInitializeMutation, ProjectInitializeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectInitializeMutation, ProjectInitializeMutationVariables>(ProjectInitializeDocument, options);
      }
export type ProjectInitializeMutationHookResult = ReturnType<typeof useProjectInitializeMutation>;
export const ProjectAddCommentDocument = gql`
    mutation projectAddComment($projectId: ID!, $comment: String!, $referenceIdentifier: String!) {
  projectAddComment(
    projectId: $projectId
    comment: $comment
    referenceIdentifier: $referenceIdentifier
  ) {
    comments {
      id
    }
  }
}
    `;

/**
 * __useProjectAddCommentMutation__
 *
 * To run a mutation, you first call `useProjectAddCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddCommentMutation, { data, loading, error }] = useProjectAddCommentMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      comment: // value for 'comment'
 *      referenceIdentifier: // value for 'referenceIdentifier'
 *   },
 * });
 */
export function useProjectAddCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectAddCommentMutation, ProjectAddCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectAddCommentMutation, ProjectAddCommentMutationVariables>(ProjectAddCommentDocument, options);
      }
export type ProjectAddCommentMutationHookResult = ReturnType<typeof useProjectAddCommentMutation>;
export const ProjectDeleteCommentDocument = gql`
    mutation projectDeleteComment($commentId: ID!, $projectId: ID!) {
  projectDeleteComment(commentId: $commentId, projectId: $projectId) {
    id
    comments {
      id
    }
  }
}
    `;

/**
 * __useProjectDeleteCommentMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCommentMutation, { data, loading, error }] = useProjectDeleteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDeleteCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteCommentMutation, ProjectDeleteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteCommentMutation, ProjectDeleteCommentMutationVariables>(ProjectDeleteCommentDocument, options);
      }
export type ProjectDeleteCommentMutationHookResult = ReturnType<typeof useProjectDeleteCommentMutation>;
export const ProjectEditCommentDocument = gql`
    mutation projectEditComment($commentId: ID!, $projectId: ID!, $newComment: String!) {
  projectEditComment(
    commentId: $commentId
    projectId: $projectId
    updatedComment: $newComment
  ) {
    id
    comments {
      id
      __typename
      comment
    }
  }
}
    `;

/**
 * __useProjectEditCommentMutation__
 *
 * To run a mutation, you first call `useProjectEditCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditCommentMutation, { data, loading, error }] = useProjectEditCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *      projectId: // value for 'projectId'
 *      newComment: // value for 'newComment'
 *   },
 * });
 */
export function useProjectEditCommentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectEditCommentMutation, ProjectEditCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectEditCommentMutation, ProjectEditCommentMutationVariables>(ProjectEditCommentDocument, options);
      }
export type ProjectEditCommentMutationHookResult = ReturnType<typeof useProjectEditCommentMutation>;
export const ProjectAddCustomClassDocument = gql`
    mutation projectAddCustomClass($projectId: ID!, $name: String!, $color: InputColor!) {
  projectAddCustomClass(projectId: $projectId, name: $name, color: $color) {
    id
    customClasses {
      id
      name
      color {
        r
        g
        b
        a
      }
      code
    }
  }
}
    `;

/**
 * __useProjectAddCustomClassMutation__
 *
 * To run a mutation, you first call `useProjectAddCustomClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddCustomClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddCustomClassMutation, { data, loading, error }] = useProjectAddCustomClassMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      color: // value for 'color'
 *   },
 * });
 */
export function useProjectAddCustomClassMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectAddCustomClassMutation, ProjectAddCustomClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectAddCustomClassMutation, ProjectAddCustomClassMutationVariables>(ProjectAddCustomClassDocument, options);
      }
export type ProjectAddCustomClassMutationHookResult = ReturnType<typeof useProjectAddCustomClassMutation>;
export const ProjectDeleteCustomClassDocument = gql`
    mutation projectDeleteCustomClass($customClassId: ID!, $projectId: ID!) {
  projectDeleteCustomClass(customClassId: $customClassId, projectId: $projectId) {
    id
    customClasses {
      id
    }
  }
}
    `;

/**
 * __useProjectDeleteCustomClassMutation__
 *
 * To run a mutation, you first call `useProjectDeleteCustomClassMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectDeleteCustomClassMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectDeleteCustomClassMutation, { data, loading, error }] = useProjectDeleteCustomClassMutation({
 *   variables: {
 *      customClassId: // value for 'customClassId'
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectDeleteCustomClassMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectDeleteCustomClassMutation, ProjectDeleteCustomClassMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectDeleteCustomClassMutation, ProjectDeleteCustomClassMutationVariables>(ProjectDeleteCustomClassDocument, options);
      }
export type ProjectDeleteCustomClassMutationHookResult = ReturnType<typeof useProjectDeleteCustomClassMutation>;
export const ProjectEditCustomClassNameDocument = gql`
    mutation projectEditCustomClassName($customClassId: ID!, $projectId: ID!, $newName: String!) {
  projectEditCustomClassName(
    customClassId: $customClassId
    projectId: $projectId
    updatedName: $newName
  ) {
    id
    customClasses {
      id
      name
    }
  }
}
    `;

/**
 * __useProjectEditCustomClassNameMutation__
 *
 * To run a mutation, you first call `useProjectEditCustomClassNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditCustomClassNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditCustomClassNameMutation, { data, loading, error }] = useProjectEditCustomClassNameMutation({
 *   variables: {
 *      customClassId: // value for 'customClassId'
 *      projectId: // value for 'projectId'
 *      newName: // value for 'newName'
 *   },
 * });
 */
export function useProjectEditCustomClassNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectEditCustomClassNameMutation, ProjectEditCustomClassNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectEditCustomClassNameMutation, ProjectEditCustomClassNameMutationVariables>(ProjectEditCustomClassNameDocument, options);
      }
export type ProjectEditCustomClassNameMutationHookResult = ReturnType<typeof useProjectEditCustomClassNameMutation>;
export const ProjectEditCustomClassColorDocument = gql`
    mutation projectEditCustomClassColor($customClassId: ID!, $projectId: ID!, $newColor: InputColor!) {
  projectEditCustomClassColor(
    customClassId: $customClassId
    projectId: $projectId
    updatedColor: $newColor
  ) {
    id
    customClasses {
      id
      color {
        r
        g
        b
        a
      }
    }
  }
}
    `;

/**
 * __useProjectEditCustomClassColorMutation__
 *
 * To run a mutation, you first call `useProjectEditCustomClassColorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditCustomClassColorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditCustomClassColorMutation, { data, loading, error }] = useProjectEditCustomClassColorMutation({
 *   variables: {
 *      customClassId: // value for 'customClassId'
 *      projectId: // value for 'projectId'
 *      newColor: // value for 'newColor'
 *   },
 * });
 */
export function useProjectEditCustomClassColorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectEditCustomClassColorMutation, ProjectEditCustomClassColorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectEditCustomClassColorMutation, ProjectEditCustomClassColorMutationVariables>(ProjectEditCustomClassColorDocument, options);
      }
export type ProjectEditCustomClassColorMutationHookResult = ReturnType<typeof useProjectEditCustomClassColorMutation>;
export const ProjectEditLayerElevationDocument = gql`
    mutation projectEditLayerElevation($layerIds: [ID!]!, $projectId: ID!, $newElevation: Float!) {
  projectEditLayerElevation(
    layerIds: $layerIds
    projectId: $projectId
    newElevation: $newElevation
  ) {
    id
    state {
      orthophotoLayers {
        identifier
        elevation
      }
    }
  }
}
    `;

/**
 * __useProjectEditLayerElevationMutation__
 *
 * To run a mutation, you first call `useProjectEditLayerElevationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectEditLayerElevationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectEditLayerElevationMutation, { data, loading, error }] = useProjectEditLayerElevationMutation({
 *   variables: {
 *      layerIds: // value for 'layerIds'
 *      projectId: // value for 'projectId'
 *      newElevation: // value for 'newElevation'
 *   },
 * });
 */
export function useProjectEditLayerElevationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectEditLayerElevationMutation, ProjectEditLayerElevationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectEditLayerElevationMutation, ProjectEditLayerElevationMutationVariables>(ProjectEditLayerElevationDocument, options);
      }
export type ProjectEditLayerElevationMutationHookResult = ReturnType<typeof useProjectEditLayerElevationMutation>;
export const ProjectAddGuestDocument = gql`
    mutation projectAddGuest($projectId: ID!, $email: String!, $level: ProjectAccessLevel) {
  projectAddGuest(projectId: $projectId, email: $email, level: $level) {
    id
  }
}
    `;

/**
 * __useProjectAddGuestMutation__
 *
 * To run a mutation, you first call `useProjectAddGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectAddGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectAddGuestMutation, { data, loading, error }] = useProjectAddGuestMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      email: // value for 'email'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useProjectAddGuestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectAddGuestMutation, ProjectAddGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectAddGuestMutation, ProjectAddGuestMutationVariables>(ProjectAddGuestDocument, options);
      }
export type ProjectAddGuestMutationHookResult = ReturnType<typeof useProjectAddGuestMutation>;
export const ProjectSetGuestAccessLevelDocument = gql`
    mutation projectSetGuestAccessLevel($projectId: ID!, $userId: ID!, $level: ProjectAccessLevel!) {
  projectSetGuestAccessLevel(
    projectId: $projectId
    userId: $userId
    level: $level
  ) {
    id
  }
}
    `;

/**
 * __useProjectSetGuestAccessLevelMutation__
 *
 * To run a mutation, you first call `useProjectSetGuestAccessLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSetGuestAccessLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSetGuestAccessLevelMutation, { data, loading, error }] = useProjectSetGuestAccessLevelMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *      level: // value for 'level'
 *   },
 * });
 */
export function useProjectSetGuestAccessLevelMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectSetGuestAccessLevelMutation, ProjectSetGuestAccessLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectSetGuestAccessLevelMutation, ProjectSetGuestAccessLevelMutationVariables>(ProjectSetGuestAccessLevelDocument, options);
      }
export type ProjectSetGuestAccessLevelMutationHookResult = ReturnType<typeof useProjectSetGuestAccessLevelMutation>;
export const ProjectRemoveGuestDocument = gql`
    mutation projectRemoveGuest($projectId: ID!, $userId: ID!) {
  projectRemoveGuest(projectId: $projectId, userId: $userId) {
    id
  }
}
    `;

/**
 * __useProjectRemoveGuestMutation__
 *
 * To run a mutation, you first call `useProjectRemoveGuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectRemoveGuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectRemoveGuestMutation, { data, loading, error }] = useProjectRemoveGuestMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useProjectRemoveGuestMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectRemoveGuestMutation, ProjectRemoveGuestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectRemoveGuestMutation, ProjectRemoveGuestMutationVariables>(ProjectRemoveGuestDocument, options);
      }
export type ProjectRemoveGuestMutationHookResult = ReturnType<typeof useProjectRemoveGuestMutation>;
export const ProjectRequestDownloadTokenDocument = gql`
    query projectRequestDownloadToken($projectId: ID!) {
  projectRequestDownloadToken(projectId: $projectId)
}
    `;

/**
 * __useProjectRequestDownloadTokenQuery__
 *
 * To run a query within a React component, call `useProjectRequestDownloadTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectRequestDownloadTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectRequestDownloadTokenQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectRequestDownloadTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables> & ({ variables: ProjectRequestDownloadTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>(ProjectRequestDownloadTokenDocument, options);
      }
export function useProjectRequestDownloadTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>(ProjectRequestDownloadTokenDocument, options);
        }
// @ts-ignore
export function useProjectRequestDownloadTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>;
export function useProjectRequestDownloadTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectRequestDownloadTokenQuery | undefined, ProjectRequestDownloadTokenQueryVariables>;
export function useProjectRequestDownloadTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectRequestDownloadTokenQuery, ProjectRequestDownloadTokenQueryVariables>(ProjectRequestDownloadTokenDocument, options);
        }
export type ProjectRequestDownloadTokenQueryHookResult = ReturnType<typeof useProjectRequestDownloadTokenQuery>;
export type ProjectRequestDownloadTokenLazyQueryHookResult = ReturnType<typeof useProjectRequestDownloadTokenLazyQuery>;
export type ProjectRequestDownloadTokenSuspenseQueryHookResult = ReturnType<typeof useProjectRequestDownloadTokenSuspenseQuery>;
export const ProjectCommentsByObjectIdDocument = gql`
    query projectCommentsByObjectId($pagination: CursorPaginationInput, $projectId: ID!, $objectId: ID!) {
  projectCommentsByObjectId(
    pagination: $pagination
    projectId: $projectId
    objectId: $objectId
  ) {
    data {
      id
      updatedAt
      createdAt
      comment
      referenceIdentifier
      user {
        id
        name
      }
    }
    nextCursor
    hasMore
  }
}
    `;

/**
 * __useProjectCommentsByObjectIdQuery__
 *
 * To run a query within a React component, call `useProjectCommentsByObjectIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectCommentsByObjectIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectCommentsByObjectIdQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      projectId: // value for 'projectId'
 *      objectId: // value for 'objectId'
 *   },
 * });
 */
export function useProjectCommentsByObjectIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables> & ({ variables: ProjectCommentsByObjectIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables>(ProjectCommentsByObjectIdDocument, options);
      }
export function useProjectCommentsByObjectIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables>(ProjectCommentsByObjectIdDocument, options);
        }
// @ts-ignore
export function useProjectCommentsByObjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables>;
export function useProjectCommentsByObjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectCommentsByObjectIdQuery | undefined, ProjectCommentsByObjectIdQueryVariables>;
export function useProjectCommentsByObjectIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectCommentsByObjectIdQuery, ProjectCommentsByObjectIdQueryVariables>(ProjectCommentsByObjectIdDocument, options);
        }
export type ProjectCommentsByObjectIdQueryHookResult = ReturnType<typeof useProjectCommentsByObjectIdQuery>;
export type ProjectCommentsByObjectIdLazyQueryHookResult = ReturnType<typeof useProjectCommentsByObjectIdLazyQuery>;
export type ProjectCommentsByObjectIdSuspenseQueryHookResult = ReturnType<typeof useProjectCommentsByObjectIdSuspenseQuery>;
export const ProjectPointCloudRelaunchDocument = gql`
    mutation projectPointCloudRelaunch($projectId: ID!, $pointCloudId: ID!) {
  projectPointCloudRelaunch(projectId: $projectId, pointCloudId: $pointCloudId) {
    id
    uploadStatus
    pointClouds {
      id
      hasClassifications
      hasSources
      uploadStatus
      cloudName
      availableClasses
      availableSources
      visible
      displayName
      pointCount
    }
  }
}
    `;

/**
 * __useProjectPointCloudRelaunchMutation__
 *
 * To run a mutation, you first call `useProjectPointCloudRelaunchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectPointCloudRelaunchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectPointCloudRelaunchMutation, { data, loading, error }] = useProjectPointCloudRelaunchMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      pointCloudId: // value for 'pointCloudId'
 *   },
 * });
 */
export function useProjectPointCloudRelaunchMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectPointCloudRelaunchMutation, ProjectPointCloudRelaunchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectPointCloudRelaunchMutation, ProjectPointCloudRelaunchMutationVariables>(ProjectPointCloudRelaunchDocument, options);
      }
export type ProjectPointCloudRelaunchMutationHookResult = ReturnType<typeof useProjectPointCloudRelaunchMutation>;
export const ProjectSheetsDocument = gql`
    query projectSheets($projectId: ID!) {
  projectSheets(projectId: $projectId) {
    ...ProjectSheetFields
  }
}
    ${ProjectSheetFieldsFragmentDoc}`;

/**
 * __useProjectSheetsQuery__
 *
 * To run a query within a React component, call `useProjectSheetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSheetsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectSheetsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectSheetsQuery, ProjectSheetsQueryVariables> & ({ variables: ProjectSheetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectSheetsQuery, ProjectSheetsQueryVariables>(ProjectSheetsDocument, options);
      }
export function useProjectSheetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectSheetsQuery, ProjectSheetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectSheetsQuery, ProjectSheetsQueryVariables>(ProjectSheetsDocument, options);
        }
// @ts-ignore
export function useProjectSheetsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectSheetsQuery, ProjectSheetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectSheetsQuery, ProjectSheetsQueryVariables>;
export function useProjectSheetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectSheetsQuery, ProjectSheetsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectSheetsQuery | undefined, ProjectSheetsQueryVariables>;
export function useProjectSheetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectSheetsQuery, ProjectSheetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectSheetsQuery, ProjectSheetsQueryVariables>(ProjectSheetsDocument, options);
        }
export type ProjectSheetsQueryHookResult = ReturnType<typeof useProjectSheetsQuery>;
export type ProjectSheetsLazyQueryHookResult = ReturnType<typeof useProjectSheetsLazyQuery>;
export type ProjectSheetsSuspenseQueryHookResult = ReturnType<typeof useProjectSheetsSuspenseQuery>;
export const ProjectSheetDocument = gql`
    query projectSheet($projectId: ID!, $sheetId: ID!) {
  projectSheet(projectId: $projectId, sheetId: $sheetId) {
    ...ProjectSheetFields
  }
}
    ${ProjectSheetFieldsFragmentDoc}`;

/**
 * __useProjectSheetQuery__
 *
 * To run a query within a React component, call `useProjectSheetQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectSheetQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function useProjectSheetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectSheetQuery, ProjectSheetQueryVariables> & ({ variables: ProjectSheetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectSheetQuery, ProjectSheetQueryVariables>(ProjectSheetDocument, options);
      }
export function useProjectSheetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectSheetQuery, ProjectSheetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectSheetQuery, ProjectSheetQueryVariables>(ProjectSheetDocument, options);
        }
// @ts-ignore
export function useProjectSheetSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectSheetQuery, ProjectSheetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectSheetQuery, ProjectSheetQueryVariables>;
export function useProjectSheetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectSheetQuery, ProjectSheetQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectSheetQuery | undefined, ProjectSheetQueryVariables>;
export function useProjectSheetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectSheetQuery, ProjectSheetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectSheetQuery, ProjectSheetQueryVariables>(ProjectSheetDocument, options);
        }
export type ProjectSheetQueryHookResult = ReturnType<typeof useProjectSheetQuery>;
export type ProjectSheetLazyQueryHookResult = ReturnType<typeof useProjectSheetLazyQuery>;
export type ProjectSheetSuspenseQueryHookResult = ReturnType<typeof useProjectSheetSuspenseQuery>;
export const ProjectSheetCreateDocument = gql`
    mutation projectSheetCreate($projectId: ID!, $name: String!, $number: String, $templateSource: PrintTemplateSource!, $templateId: String!) {
  projectSheetCreate(
    projectId: $projectId
    name: $name
    number: $number
    templateSource: $templateSource
    templateId: $templateId
  ) {
    ...ProjectSheetFields
  }
}
    ${ProjectSheetFieldsFragmentDoc}`;

/**
 * __useProjectSheetCreateMutation__
 *
 * To run a mutation, you first call `useProjectSheetCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSheetCreateMutation, { data, loading, error }] = useProjectSheetCreateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      name: // value for 'name'
 *      number: // value for 'number'
 *      templateSource: // value for 'templateSource'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useProjectSheetCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectSheetCreateMutation, ProjectSheetCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectSheetCreateMutation, ProjectSheetCreateMutationVariables>(ProjectSheetCreateDocument, options);
      }
export type ProjectSheetCreateMutationHookResult = ReturnType<typeof useProjectSheetCreateMutation>;
export const ProjectSheetSaveDocument = gql`
    mutation projectSheetSave($projectId: ID!, $sheetId: ID!, $doc: JSON!, $expectedUpdatedAt: Date!) {
  projectSheetSave(
    projectId: $projectId
    sheetId: $sheetId
    doc: $doc
    expectedUpdatedAt: $expectedUpdatedAt
  ) {
    ...ProjectSheetFields
  }
}
    ${ProjectSheetFieldsFragmentDoc}`;

/**
 * __useProjectSheetSaveMutation__
 *
 * To run a mutation, you first call `useProjectSheetSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSheetSaveMutation, { data, loading, error }] = useProjectSheetSaveMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sheetId: // value for 'sheetId'
 *      doc: // value for 'doc'
 *      expectedUpdatedAt: // value for 'expectedUpdatedAt'
 *   },
 * });
 */
export function useProjectSheetSaveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectSheetSaveMutation, ProjectSheetSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectSheetSaveMutation, ProjectSheetSaveMutationVariables>(ProjectSheetSaveDocument, options);
      }
export type ProjectSheetSaveMutationHookResult = ReturnType<typeof useProjectSheetSaveMutation>;
export const ProjectSheetRenameDocument = gql`
    mutation projectSheetRename($projectId: ID!, $sheetId: ID!, $name: String!, $number: String) {
  projectSheetRename(
    projectId: $projectId
    sheetId: $sheetId
    name: $name
    number: $number
  ) {
    ...ProjectSheetFields
  }
}
    ${ProjectSheetFieldsFragmentDoc}`;

/**
 * __useProjectSheetRenameMutation__
 *
 * To run a mutation, you first call `useProjectSheetRenameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetRenameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSheetRenameMutation, { data, loading, error }] = useProjectSheetRenameMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sheetId: // value for 'sheetId'
 *      name: // value for 'name'
 *      number: // value for 'number'
 *   },
 * });
 */
export function useProjectSheetRenameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectSheetRenameMutation, ProjectSheetRenameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectSheetRenameMutation, ProjectSheetRenameMutationVariables>(ProjectSheetRenameDocument, options);
      }
export type ProjectSheetRenameMutationHookResult = ReturnType<typeof useProjectSheetRenameMutation>;
export const ProjectSheetDuplicateDocument = gql`
    mutation projectSheetDuplicate($projectId: ID!, $sheetId: ID!) {
  projectSheetDuplicate(projectId: $projectId, sheetId: $sheetId) {
    ...ProjectSheetFields
  }
}
    ${ProjectSheetFieldsFragmentDoc}`;

/**
 * __useProjectSheetDuplicateMutation__
 *
 * To run a mutation, you first call `useProjectSheetDuplicateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetDuplicateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSheetDuplicateMutation, { data, loading, error }] = useProjectSheetDuplicateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function useProjectSheetDuplicateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectSheetDuplicateMutation, ProjectSheetDuplicateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectSheetDuplicateMutation, ProjectSheetDuplicateMutationVariables>(ProjectSheetDuplicateDocument, options);
      }
export type ProjectSheetDuplicateMutationHookResult = ReturnType<typeof useProjectSheetDuplicateMutation>;
export const ProjectSheetDeleteDocument = gql`
    mutation projectSheetDelete($projectId: ID!, $sheetId: ID!) {
  projectSheetDelete(projectId: $projectId, sheetId: $sheetId)
}
    `;

/**
 * __useProjectSheetDeleteMutation__
 *
 * To run a mutation, you first call `useProjectSheetDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSheetDeleteMutation, { data, loading, error }] = useProjectSheetDeleteMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function useProjectSheetDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectSheetDeleteMutation, ProjectSheetDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectSheetDeleteMutation, ProjectSheetDeleteMutationVariables>(ProjectSheetDeleteDocument, options);
      }
export type ProjectSheetDeleteMutationHookResult = ReturnType<typeof useProjectSheetDeleteMutation>;
export const ProjectSheetUpgradeTemplateDocument = gql`
    mutation projectSheetUpgradeTemplate($projectId: ID!, $sheetId: ID!) {
  projectSheetUpgradeTemplate(projectId: $projectId, sheetId: $sheetId) {
    ...ProjectSheetFields
  }
}
    ${ProjectSheetFieldsFragmentDoc}`;

/**
 * __useProjectSheetUpgradeTemplateMutation__
 *
 * To run a mutation, you first call `useProjectSheetUpgradeTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetUpgradeTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSheetUpgradeTemplateMutation, { data, loading, error }] = useProjectSheetUpgradeTemplateMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function useProjectSheetUpgradeTemplateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectSheetUpgradeTemplateMutation, ProjectSheetUpgradeTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectSheetUpgradeTemplateMutation, ProjectSheetUpgradeTemplateMutationVariables>(ProjectSheetUpgradeTemplateDocument, options);
      }
export type ProjectSheetUpgradeTemplateMutationHookResult = ReturnType<typeof useProjectSheetUpgradeTemplateMutation>;
export const ProjectSheetMarkExportedDocument = gql`
    mutation projectSheetMarkExported($projectId: ID!, $sheetId: ID!) {
  projectSheetMarkExported(projectId: $projectId, sheetId: $sheetId) {
    ...ProjectSheetFields
  }
}
    ${ProjectSheetFieldsFragmentDoc}`;

/**
 * __useProjectSheetMarkExportedMutation__
 *
 * To run a mutation, you first call `useProjectSheetMarkExportedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectSheetMarkExportedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectSheetMarkExportedMutation, { data, loading, error }] = useProjectSheetMarkExportedMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      sheetId: // value for 'sheetId'
 *   },
 * });
 */
export function useProjectSheetMarkExportedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectSheetMarkExportedMutation, ProjectSheetMarkExportedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectSheetMarkExportedMutation, ProjectSheetMarkExportedMutationVariables>(ProjectSheetMarkExportedDocument, options);
      }
export type ProjectSheetMarkExportedMutationHookResult = ReturnType<typeof useProjectSheetMarkExportedMutation>;
export const ProjectPropertyUpdatesDocument = gql`
    subscription projectPropertyUpdates($projectId: ID!) {
  projectPropertyUpdates(projectId: $projectId) {
    identifier
    value
    valueType
    propertyType
    propertyIdentifier
  }
}
    `;

/**
 * __useProjectPropertyUpdatesSubscription__
 *
 * To run a query within a React component, call `useProjectPropertyUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useProjectPropertyUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPropertyUpdatesSubscription({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectPropertyUpdatesSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<ProjectPropertyUpdatesSubscription, ProjectPropertyUpdatesSubscriptionVariables> & ({ variables: ProjectPropertyUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<ProjectPropertyUpdatesSubscription, ProjectPropertyUpdatesSubscriptionVariables>(ProjectPropertyUpdatesDocument, options);
      }
export type ProjectPropertyUpdatesSubscriptionHookResult = ReturnType<typeof useProjectPropertyUpdatesSubscription>;
export const OrganizationPropertyUpdatesDocument = gql`
    subscription organizationPropertyUpdates($organizationId: ID!) {
  organizationPropertyUpdates(organizationId: $organizationId) {
    identifier
    value
    valueType
    propertyType
    propertyIdentifier
  }
}
    `;

/**
 * __useOrganizationPropertyUpdatesSubscription__
 *
 * To run a query within a React component, call `useOrganizationPropertyUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationPropertyUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationPropertyUpdatesSubscription({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationPropertyUpdatesSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<OrganizationPropertyUpdatesSubscription, OrganizationPropertyUpdatesSubscriptionVariables> & ({ variables: OrganizationPropertyUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<OrganizationPropertyUpdatesSubscription, OrganizationPropertyUpdatesSubscriptionVariables>(OrganizationPropertyUpdatesDocument, options);
      }
export type OrganizationPropertyUpdatesSubscriptionHookResult = ReturnType<typeof useOrganizationPropertyUpdatesSubscription>;
export const UserPropertyUpdatesDocument = gql`
    subscription userPropertyUpdates($userId: ID!) {
  userPropertyUpdates(userId: $userId) {
    identifier
    value
    valueType
    propertyType
    propertyIdentifier
  }
}
    `;

/**
 * __useUserPropertyUpdatesSubscription__
 *
 * To run a query within a React component, call `useUserPropertyUpdatesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserPropertyUpdatesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPropertyUpdatesSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserPropertyUpdatesSubscription(baseOptions: ApolloReactHooks.SubscriptionHookOptions<UserPropertyUpdatesSubscription, UserPropertyUpdatesSubscriptionVariables> & ({ variables: UserPropertyUpdatesSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useSubscription<UserPropertyUpdatesSubscription, UserPropertyUpdatesSubscriptionVariables>(UserPropertyUpdatesDocument, options);
      }
export type UserPropertyUpdatesSubscriptionHookResult = ReturnType<typeof useUserPropertyUpdatesSubscription>;
export const GetProjectPropertiesDocument = gql`
    query getProjectProperties($projectId: ID!) {
  projectById(projectId: $projectId) {
    id
    stateByUser {
      userId
      properties {
        propertyIdentifier
        properties {
          identifier
          value
          valueType
          createdAt
          updatedAt
        }
      }
    }
    state {
      properties {
        propertyIdentifier
        properties {
          identifier
          value
          valueType
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectPropertiesQuery__
 *
 * To run a query within a React component, call `useGetProjectPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPropertiesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectPropertiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables> & ({ variables: GetProjectPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables>(GetProjectPropertiesDocument, options);
      }
export function useGetProjectPropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables>(GetProjectPropertiesDocument, options);
        }
// @ts-ignore
export function useGetProjectPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables>;
export function useGetProjectPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetProjectPropertiesQuery | undefined, GetProjectPropertiesQueryVariables>;
export function useGetProjectPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectPropertiesQuery, GetProjectPropertiesQueryVariables>(GetProjectPropertiesDocument, options);
        }
export type GetProjectPropertiesQueryHookResult = ReturnType<typeof useGetProjectPropertiesQuery>;
export type GetProjectPropertiesLazyQueryHookResult = ReturnType<typeof useGetProjectPropertiesLazyQuery>;
export type GetProjectPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetProjectPropertiesSuspenseQuery>;
export const GetProjectPropertiesForObjectsDocument = gql`
    query getProjectPropertiesForObjects($projectId: ID!, $propertyIdentifiers: [String!]) {
  projectById(projectId: $projectId) {
    id
    stateByUser {
      userId
      properties(propertyIdentifiers: $propertyIdentifiers) {
        propertyIdentifier
        properties {
          identifier
          value
          valueType
          createdAt
          updatedAt
        }
      }
    }
    state {
      properties(propertyIdentifiers: $propertyIdentifiers) {
        propertyIdentifier
        properties {
          identifier
          value
          valueType
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useGetProjectPropertiesForObjectsQuery__
 *
 * To run a query within a React component, call `useGetProjectPropertiesForObjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPropertiesForObjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPropertiesForObjectsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      propertyIdentifiers: // value for 'propertyIdentifiers'
 *   },
 * });
 */
export function useGetProjectPropertiesForObjectsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables> & ({ variables: GetProjectPropertiesForObjectsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables>(GetProjectPropertiesForObjectsDocument, options);
      }
export function useGetProjectPropertiesForObjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables>(GetProjectPropertiesForObjectsDocument, options);
        }
// @ts-ignore
export function useGetProjectPropertiesForObjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables>;
export function useGetProjectPropertiesForObjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetProjectPropertiesForObjectsQuery | undefined, GetProjectPropertiesForObjectsQueryVariables>;
export function useGetProjectPropertiesForObjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectPropertiesForObjectsQuery, GetProjectPropertiesForObjectsQueryVariables>(GetProjectPropertiesForObjectsDocument, options);
        }
export type GetProjectPropertiesForObjectsQueryHookResult = ReturnType<typeof useGetProjectPropertiesForObjectsQuery>;
export type GetProjectPropertiesForObjectsLazyQueryHookResult = ReturnType<typeof useGetProjectPropertiesForObjectsLazyQuery>;
export type GetProjectPropertiesForObjectsSuspenseQueryHookResult = ReturnType<typeof useGetProjectPropertiesForObjectsSuspenseQuery>;
export const GetProjectPropertyStateDocument = gql`
    query getProjectPropertyState($projectId: ID!) {
  projectById(projectId: $projectId) {
    ...ProjectPropertyState
  }
}
    ${ProjectPropertyStateFragmentDoc}`;

/**
 * __useGetProjectPropertyStateQuery__
 *
 * To run a query within a React component, call `useGetProjectPropertyStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetProjectPropertyStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetProjectPropertyStateQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useGetProjectPropertyStateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables> & ({ variables: GetProjectPropertyStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables>(GetProjectPropertyStateDocument, options);
      }
export function useGetProjectPropertyStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables>(GetProjectPropertyStateDocument, options);
        }
// @ts-ignore
export function useGetProjectPropertyStateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables>;
export function useGetProjectPropertyStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetProjectPropertyStateQuery | undefined, GetProjectPropertyStateQueryVariables>;
export function useGetProjectPropertyStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetProjectPropertyStateQuery, GetProjectPropertyStateQueryVariables>(GetProjectPropertyStateDocument, options);
        }
export type GetProjectPropertyStateQueryHookResult = ReturnType<typeof useGetProjectPropertyStateQuery>;
export type GetProjectPropertyStateLazyQueryHookResult = ReturnType<typeof useGetProjectPropertyStateLazyQuery>;
export type GetProjectPropertyStateSuspenseQueryHookResult = ReturnType<typeof useGetProjectPropertyStateSuspenseQuery>;
export const ProjectUpdatePropertyDocument = gql`
    mutation projectUpdateProperty($projectId: ID!, $identifier: String!, $value: PropertyValue!, $propertyType: PropertyType!, $propertyIdentifier: String!, $valueType: PropertyValueType!) {
  projectUpdateProperty(
    projectId: $projectId
    identifier: $identifier
    value: $value
    propertyType: $propertyType
    propertyIdentifier: $propertyIdentifier
    valueType: $valueType
  ) {
    id
  }
}
    `;

/**
 * __useProjectUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useProjectUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectUpdatePropertyMutation, { data, loading, error }] = useProjectUpdatePropertyMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      identifier: // value for 'identifier'
 *      value: // value for 'value'
 *      propertyType: // value for 'propertyType'
 *      propertyIdentifier: // value for 'propertyIdentifier'
 *      valueType: // value for 'valueType'
 *   },
 * });
 */
export function useProjectUpdatePropertyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectUpdatePropertyMutation, ProjectUpdatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectUpdatePropertyMutation, ProjectUpdatePropertyMutationVariables>(ProjectUpdatePropertyDocument, options);
      }
export type ProjectUpdatePropertyMutationHookResult = ReturnType<typeof useProjectUpdatePropertyMutation>;
export const ProjectBatchUpdatePropertiesDocument = gql`
    mutation projectBatchUpdateProperties($projectId: ID!, $updates: [PropertyUpdateInput!]!) {
  projectBatchupdateProperties(projectId: $projectId, updates: $updates) {
    id
  }
}
    `;

/**
 * __useProjectBatchUpdatePropertiesMutation__
 *
 * To run a mutation, you first call `useProjectBatchUpdatePropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useProjectBatchUpdatePropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [projectBatchUpdatePropertiesMutation, { data, loading, error }] = useProjectBatchUpdatePropertiesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useProjectBatchUpdatePropertiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ProjectBatchUpdatePropertiesMutation, ProjectBatchUpdatePropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ProjectBatchUpdatePropertiesMutation, ProjectBatchUpdatePropertiesMutationVariables>(ProjectBatchUpdatePropertiesDocument, options);
      }
export type ProjectBatchUpdatePropertiesMutationHookResult = ReturnType<typeof useProjectBatchUpdatePropertiesMutation>;
export const GetOrganizationPropertiesDocument = gql`
    query getOrganizationProperties($organizationId: ID!) {
  organisationById(organisationId: $organizationId) {
    id
    properties {
      propertyIdentifier
      properties {
        identifier
        value
        valueType
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetOrganizationPropertiesQuery__
 *
 * To run a query within a React component, call `useGetOrganizationPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationPropertiesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationPropertiesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables> & ({ variables: GetOrganizationPropertiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables>(GetOrganizationPropertiesDocument, options);
      }
export function useGetOrganizationPropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables>(GetOrganizationPropertiesDocument, options);
        }
// @ts-ignore
export function useGetOrganizationPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables>;
export function useGetOrganizationPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetOrganizationPropertiesQuery | undefined, GetOrganizationPropertiesQueryVariables>;
export function useGetOrganizationPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetOrganizationPropertiesQuery, GetOrganizationPropertiesQueryVariables>(GetOrganizationPropertiesDocument, options);
        }
export type GetOrganizationPropertiesQueryHookResult = ReturnType<typeof useGetOrganizationPropertiesQuery>;
export type GetOrganizationPropertiesLazyQueryHookResult = ReturnType<typeof useGetOrganizationPropertiesLazyQuery>;
export type GetOrganizationPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationPropertiesSuspenseQuery>;
export const OrganizationUpdatePropertyDocument = gql`
    mutation organizationUpdateProperty($organizationId: ID!, $identifier: String!, $value: PropertyValue!, $propertyIdentifier: String!, $valueType: PropertyValueType!) {
  organizationUpdateProperty(
    organizationId: $organizationId
    identifier: $identifier
    value: $value
    propertyIdentifier: $propertyIdentifier
    valueType: $valueType
  )
}
    `;

/**
 * __useOrganizationUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useOrganizationUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationUpdatePropertyMutation, { data, loading, error }] = useOrganizationUpdatePropertyMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      identifier: // value for 'identifier'
 *      value: // value for 'value'
 *      propertyIdentifier: // value for 'propertyIdentifier'
 *      valueType: // value for 'valueType'
 *   },
 * });
 */
export function useOrganizationUpdatePropertyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganizationUpdatePropertyMutation, OrganizationUpdatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganizationUpdatePropertyMutation, OrganizationUpdatePropertyMutationVariables>(OrganizationUpdatePropertyDocument, options);
      }
export type OrganizationUpdatePropertyMutationHookResult = ReturnType<typeof useOrganizationUpdatePropertyMutation>;
export const OrganizationBatchUpdatePropertiesDocument = gql`
    mutation organizationBatchUpdateProperties($organizationId: ID!, $updates: [PropertyUpdateInput!]!) {
  organizationBatchUpdateProperties(
    organizationId: $organizationId
    updates: $updates
  )
}
    `;

/**
 * __useOrganizationBatchUpdatePropertiesMutation__
 *
 * To run a mutation, you first call `useOrganizationBatchUpdatePropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBatchUpdatePropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organizationBatchUpdatePropertiesMutation, { data, loading, error }] = useOrganizationBatchUpdatePropertiesMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useOrganizationBatchUpdatePropertiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganizationBatchUpdatePropertiesMutation, OrganizationBatchUpdatePropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganizationBatchUpdatePropertiesMutation, OrganizationBatchUpdatePropertiesMutationVariables>(OrganizationBatchUpdatePropertiesDocument, options);
      }
export type OrganizationBatchUpdatePropertiesMutationHookResult = ReturnType<typeof useOrganizationBatchUpdatePropertiesMutation>;
export const GetUserPropertiesDocument = gql`
    query getUserProperties {
  currentUser {
    id
    properties {
      propertyIdentifier
      properties {
        identifier
        value
        valueType
        createdAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetUserPropertiesQuery__
 *
 * To run a query within a React component, call `useGetUserPropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserPropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserPropertiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserPropertiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
      }
export function useGetUserPropertiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
        }
// @ts-ignore
export function useGetUserPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>;
export function useGetUserPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<GetUserPropertiesQuery | undefined, GetUserPropertiesQueryVariables>;
export function useGetUserPropertiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserPropertiesQuery, GetUserPropertiesQueryVariables>(GetUserPropertiesDocument, options);
        }
export type GetUserPropertiesQueryHookResult = ReturnType<typeof useGetUserPropertiesQuery>;
export type GetUserPropertiesLazyQueryHookResult = ReturnType<typeof useGetUserPropertiesLazyQuery>;
export type GetUserPropertiesSuspenseQueryHookResult = ReturnType<typeof useGetUserPropertiesSuspenseQuery>;
export const UserUpdatePropertyDocument = gql`
    mutation userUpdateProperty($identifier: String!, $value: PropertyValue!, $propertyIdentifier: String!, $valueType: PropertyValueType!) {
  userUpdateProperty(
    identifier: $identifier
    value: $value
    propertyIdentifier: $propertyIdentifier
    valueType: $valueType
  )
}
    `;

/**
 * __useUserUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useUserUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdatePropertyMutation, { data, loading, error }] = useUserUpdatePropertyMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      value: // value for 'value'
 *      propertyIdentifier: // value for 'propertyIdentifier'
 *      valueType: // value for 'valueType'
 *   },
 * });
 */
export function useUserUpdatePropertyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserUpdatePropertyMutation, UserUpdatePropertyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserUpdatePropertyMutation, UserUpdatePropertyMutationVariables>(UserUpdatePropertyDocument, options);
      }
export type UserUpdatePropertyMutationHookResult = ReturnType<typeof useUserUpdatePropertyMutation>;
export const UserBatchUpdatePropertiesDocument = gql`
    mutation userBatchUpdateProperties($updates: [PropertyUpdateInput!]!) {
  userBatchUpdateProperties(updates: $updates)
}
    `;

/**
 * __useUserBatchUpdatePropertiesMutation__
 *
 * To run a mutation, you first call `useUserBatchUpdatePropertiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBatchUpdatePropertiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBatchUpdatePropertiesMutation, { data, loading, error }] = useUserBatchUpdatePropertiesMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUserBatchUpdatePropertiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserBatchUpdatePropertiesMutation, UserBatchUpdatePropertiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserBatchUpdatePropertiesMutation, UserBatchUpdatePropertiesMutationVariables>(UserBatchUpdatePropertiesDocument, options);
      }
export type UserBatchUpdatePropertiesMutationHookResult = ReturnType<typeof useUserBatchUpdatePropertiesMutation>;
export const OrganisationReferralPayoutPdfDocument = gql`
    query organisationReferralPayoutPdf($organisationId: ID!, $payoutId: ID!) {
  organisationReferralPayoutPdf(
    organisationId: $organisationId
    payoutId: $payoutId
  ) {
    filename
    base64
  }
}
    `;

/**
 * __useOrganisationReferralPayoutPdfQuery__
 *
 * To run a query within a React component, call `useOrganisationReferralPayoutPdfQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationReferralPayoutPdfQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationReferralPayoutPdfQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      payoutId: // value for 'payoutId'
 *   },
 * });
 */
export function useOrganisationReferralPayoutPdfQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables> & ({ variables: OrganisationReferralPayoutPdfQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables>(OrganisationReferralPayoutPdfDocument, options);
      }
export function useOrganisationReferralPayoutPdfLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables>(OrganisationReferralPayoutPdfDocument, options);
        }
// @ts-ignore
export function useOrganisationReferralPayoutPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables>;
export function useOrganisationReferralPayoutPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationReferralPayoutPdfQuery | undefined, OrganisationReferralPayoutPdfQueryVariables>;
export function useOrganisationReferralPayoutPdfSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationReferralPayoutPdfQuery, OrganisationReferralPayoutPdfQueryVariables>(OrganisationReferralPayoutPdfDocument, options);
        }
export type OrganisationReferralPayoutPdfQueryHookResult = ReturnType<typeof useOrganisationReferralPayoutPdfQuery>;
export type OrganisationReferralPayoutPdfLazyQueryHookResult = ReturnType<typeof useOrganisationReferralPayoutPdfLazyQuery>;
export type OrganisationReferralPayoutPdfSuspenseQueryHookResult = ReturnType<typeof useOrganisationReferralPayoutPdfSuspenseQuery>;
export const ReferralInfoDocument = gql`
    query referralInfo($token: String!) {
  referralInfo(token: $token) {
    organisationName
  }
}
    `;

/**
 * __useReferralInfoQuery__
 *
 * To run a query within a React component, call `useReferralInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useReferralInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReferralInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useReferralInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ReferralInfoQuery, ReferralInfoQueryVariables> & ({ variables: ReferralInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ReferralInfoQuery, ReferralInfoQueryVariables>(ReferralInfoDocument, options);
      }
export function useReferralInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReferralInfoQuery, ReferralInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ReferralInfoQuery, ReferralInfoQueryVariables>(ReferralInfoDocument, options);
        }
// @ts-ignore
export function useReferralInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ReferralInfoQuery, ReferralInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReferralInfoQuery, ReferralInfoQueryVariables>;
export function useReferralInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReferralInfoQuery, ReferralInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ReferralInfoQuery | undefined, ReferralInfoQueryVariables>;
export function useReferralInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ReferralInfoQuery, ReferralInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ReferralInfoQuery, ReferralInfoQueryVariables>(ReferralInfoDocument, options);
        }
export type ReferralInfoQueryHookResult = ReturnType<typeof useReferralInfoQuery>;
export type ReferralInfoLazyQueryHookResult = ReturnType<typeof useReferralInfoLazyQuery>;
export type ReferralInfoSuspenseQueryHookResult = ReturnType<typeof useReferralInfoSuspenseQuery>;
export const OrganisationReferralOverviewDocument = gql`
    query organisationReferralOverview($organisationId: ID!) {
  organisationReferralOverview(organisationId: $organisationId) {
    ...ReferralOverviewFields
  }
}
    ${ReferralOverviewFieldsFragmentDoc}`;

/**
 * __useOrganisationReferralOverviewQuery__
 *
 * To run a query within a React component, call `useOrganisationReferralOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationReferralOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationReferralOverviewQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationReferralOverviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables> & ({ variables: OrganisationReferralOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables>(OrganisationReferralOverviewDocument, options);
      }
export function useOrganisationReferralOverviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables>(OrganisationReferralOverviewDocument, options);
        }
// @ts-ignore
export function useOrganisationReferralOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables>;
export function useOrganisationReferralOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationReferralOverviewQuery | undefined, OrganisationReferralOverviewQueryVariables>;
export function useOrganisationReferralOverviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationReferralOverviewQuery, OrganisationReferralOverviewQueryVariables>(OrganisationReferralOverviewDocument, options);
        }
export type OrganisationReferralOverviewQueryHookResult = ReturnType<typeof useOrganisationReferralOverviewQuery>;
export type OrganisationReferralOverviewLazyQueryHookResult = ReturnType<typeof useOrganisationReferralOverviewLazyQuery>;
export type OrganisationReferralOverviewSuspenseQueryHookResult = ReturnType<typeof useOrganisationReferralOverviewSuspenseQuery>;
export const OrganisationReferralCustomerCreateDocument = gql`
    mutation organisationReferralCustomerCreate($organisationId: ID!, $name: String!, $emails: [String!]!) {
  organisationReferralCustomerCreate(
    organisationId: $organisationId
    name: $name
    emails: $emails
  ) {
    ...ReferralOverviewFields
  }
}
    ${ReferralOverviewFieldsFragmentDoc}`;

/**
 * __useOrganisationReferralCustomerCreateMutation__
 *
 * To run a mutation, you first call `useOrganisationReferralCustomerCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationReferralCustomerCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationReferralCustomerCreateMutation, { data, loading, error }] = useOrganisationReferralCustomerCreateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useOrganisationReferralCustomerCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationReferralCustomerCreateMutation, OrganisationReferralCustomerCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationReferralCustomerCreateMutation, OrganisationReferralCustomerCreateMutationVariables>(OrganisationReferralCustomerCreateDocument, options);
      }
export type OrganisationReferralCustomerCreateMutationHookResult = ReturnType<typeof useOrganisationReferralCustomerCreateMutation>;
export const OrganisationReferralLinkGenerateDocument = gql`
    mutation organisationReferralLinkGenerate($organisationId: ID!) {
  organisationReferralLinkGenerate(organisationId: $organisationId) {
    ...ReferralOverviewFields
  }
}
    ${ReferralOverviewFieldsFragmentDoc}`;

/**
 * __useOrganisationReferralLinkGenerateMutation__
 *
 * To run a mutation, you first call `useOrganisationReferralLinkGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationReferralLinkGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationReferralLinkGenerateMutation, { data, loading, error }] = useOrganisationReferralLinkGenerateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationReferralLinkGenerateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationReferralLinkGenerateMutation, OrganisationReferralLinkGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationReferralLinkGenerateMutation, OrganisationReferralLinkGenerateMutationVariables>(OrganisationReferralLinkGenerateDocument, options);
      }
export type OrganisationReferralLinkGenerateMutationHookResult = ReturnType<typeof useOrganisationReferralLinkGenerateMutation>;
export const SuperadminReferralHistoryDocument = gql`
    query superadminReferralHistory($organisationId: ID!) {
  superadminReferralHistory(organisationId: $organisationId) {
    sales {
      ...ReferralSaleFields
    }
    payouts {
      ...ReferralPayoutFields
    }
  }
}
    ${ReferralSaleFieldsFragmentDoc}
${ReferralPayoutFieldsFragmentDoc}`;

/**
 * __useSuperadminReferralHistoryQuery__
 *
 * To run a query within a React component, call `useSuperadminReferralHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminReferralHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminReferralHistoryQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSuperadminReferralHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables> & ({ variables: SuperadminReferralHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables>(SuperadminReferralHistoryDocument, options);
      }
export function useSuperadminReferralHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables>(SuperadminReferralHistoryDocument, options);
        }
// @ts-ignore
export function useSuperadminReferralHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables>;
export function useSuperadminReferralHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminReferralHistoryQuery | undefined, SuperadminReferralHistoryQueryVariables>;
export function useSuperadminReferralHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminReferralHistoryQuery, SuperadminReferralHistoryQueryVariables>(SuperadminReferralHistoryDocument, options);
        }
export type SuperadminReferralHistoryQueryHookResult = ReturnType<typeof useSuperadminReferralHistoryQuery>;
export type SuperadminReferralHistoryLazyQueryHookResult = ReturnType<typeof useSuperadminReferralHistoryLazyQuery>;
export type SuperadminReferralHistorySuspenseQueryHookResult = ReturnType<typeof useSuperadminReferralHistorySuspenseQuery>;
export const SuperadminSetReferralSettingsDocument = gql`
    mutation superadminSetReferralSettings($organisationId: ID!, $input: InputReferralSettings!) {
  superadminSetReferralSettings(organisationId: $organisationId, input: $input) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminSetReferralSettingsMutation__
 *
 * To run a mutation, you first call `useSuperadminSetReferralSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminSetReferralSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminSetReferralSettingsMutation, { data, loading, error }] = useSuperadminSetReferralSettingsMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSuperadminSetReferralSettingsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminSetReferralSettingsMutation, SuperadminSetReferralSettingsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminSetReferralSettingsMutation, SuperadminSetReferralSettingsMutationVariables>(SuperadminSetReferralSettingsDocument, options);
      }
export type SuperadminSetReferralSettingsMutationHookResult = ReturnType<typeof useSuperadminSetReferralSettingsMutation>;
export const SuperadminCreateReferralPayoutDocument = gql`
    mutation superadminCreateReferralPayout($organisationId: ID!) {
  superadminCreateReferralPayout(organisationId: $organisationId) {
    ...ReferralPayoutFields
  }
}
    ${ReferralPayoutFieldsFragmentDoc}`;

/**
 * __useSuperadminCreateReferralPayoutMutation__
 *
 * To run a mutation, you first call `useSuperadminCreateReferralPayoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminCreateReferralPayoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminCreateReferralPayoutMutation, { data, loading, error }] = useSuperadminCreateReferralPayoutMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSuperadminCreateReferralPayoutMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminCreateReferralPayoutMutation, SuperadminCreateReferralPayoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminCreateReferralPayoutMutation, SuperadminCreateReferralPayoutMutationVariables>(SuperadminCreateReferralPayoutDocument, options);
      }
export type SuperadminCreateReferralPayoutMutationHookResult = ReturnType<typeof useSuperadminCreateReferralPayoutMutation>;
export const SuperadminReferralsDocument = gql`
    query superadminReferrals($organisationId: ID!, $search: String) {
  superadminReferrals(organisationId: $organisationId, search: $search) {
    referred {
      ...SuperadminReferralOrganisationFields
    }
    others {
      ...SuperadminReferralOrganisationFields
    }
    othersTotal
  }
}
    ${SuperadminReferralOrganisationFieldsFragmentDoc}`;

/**
 * __useSuperadminReferralsQuery__
 *
 * To run a query within a React component, call `useSuperadminReferralsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminReferralsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminReferralsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSuperadminReferralsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminReferralsQuery, SuperadminReferralsQueryVariables> & ({ variables: SuperadminReferralsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminReferralsQuery, SuperadminReferralsQueryVariables>(SuperadminReferralsDocument, options);
      }
export function useSuperadminReferralsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminReferralsQuery, SuperadminReferralsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminReferralsQuery, SuperadminReferralsQueryVariables>(SuperadminReferralsDocument, options);
        }
// @ts-ignore
export function useSuperadminReferralsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminReferralsQuery, SuperadminReferralsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminReferralsQuery, SuperadminReferralsQueryVariables>;
export function useSuperadminReferralsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminReferralsQuery, SuperadminReferralsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminReferralsQuery | undefined, SuperadminReferralsQueryVariables>;
export function useSuperadminReferralsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminReferralsQuery, SuperadminReferralsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminReferralsQuery, SuperadminReferralsQueryVariables>(SuperadminReferralsDocument, options);
        }
export type SuperadminReferralsQueryHookResult = ReturnType<typeof useSuperadminReferralsQuery>;
export type SuperadminReferralsLazyQueryHookResult = ReturnType<typeof useSuperadminReferralsLazyQuery>;
export type SuperadminReferralsSuspenseQueryHookResult = ReturnType<typeof useSuperadminReferralsSuspenseQuery>;
export const SuperadminSetPartnerLinkDocument = gql`
    mutation superadminSetPartnerLink($organisationId: ID!, $partnerOrganisationId: ID!, $linked: Boolean!) {
  superadminSetPartnerLink(
    organisationId: $organisationId
    partnerOrganisationId: $partnerOrganisationId
    linked: $linked
  ) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminSetPartnerLinkMutation__
 *
 * To run a mutation, you first call `useSuperadminSetPartnerLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminSetPartnerLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminSetPartnerLinkMutation, { data, loading, error }] = useSuperadminSetPartnerLinkMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      partnerOrganisationId: // value for 'partnerOrganisationId'
 *      linked: // value for 'linked'
 *   },
 * });
 */
export function useSuperadminSetPartnerLinkMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminSetPartnerLinkMutation, SuperadminSetPartnerLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminSetPartnerLinkMutation, SuperadminSetPartnerLinkMutationVariables>(SuperadminSetPartnerLinkDocument, options);
      }
export type SuperadminSetPartnerLinkMutationHookResult = ReturnType<typeof useSuperadminSetPartnerLinkMutation>;
export const SuperadminRefreshReferralsDocument = gql`
    mutation superadminRefreshReferrals($organisationId: ID!) {
  superadminRefreshReferrals(organisationId: $organisationId) {
    sales {
      ...ReferralSaleFields
    }
    payouts {
      ...ReferralPayoutFields
    }
  }
}
    ${ReferralSaleFieldsFragmentDoc}
${ReferralPayoutFieldsFragmentDoc}`;

/**
 * __useSuperadminRefreshReferralsMutation__
 *
 * To run a mutation, you first call `useSuperadminRefreshReferralsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminRefreshReferralsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminRefreshReferralsMutation, { data, loading, error }] = useSuperadminRefreshReferralsMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSuperadminRefreshReferralsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminRefreshReferralsMutation, SuperadminRefreshReferralsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminRefreshReferralsMutation, SuperadminRefreshReferralsMutationVariables>(SuperadminRefreshReferralsDocument, options);
      }
export type SuperadminRefreshReferralsMutationHookResult = ReturnType<typeof useSuperadminRefreshReferralsMutation>;
export const PartnerCustomerPlanChangePreviewDocument = gql`
    query partnerCustomerPlanChangePreview($organisationId: ID!, $customerOrganisationId: ID!, $subscriptionType: SubscriptionType!) {
  partnerCustomerPlanChangePreview(
    organisationId: $organisationId
    customerOrganisationId: $customerOrganisationId
    subscriptionType: $subscriptionType
  ) {
    kind
    subscriptionType
    effectiveAt
    scheduled
    endDate
    current {
      ...PlanTermStateFields
    }
    after {
      ...PlanTermStateFields
    }
    lines {
      subscriptionType
      from
      months
      totalCents
    }
    currentTermValueCents
    dueCents
    chargedCents
    priceLocked
    problems
  }
}
    ${PlanTermStateFieldsFragmentDoc}`;

/**
 * __usePartnerCustomerPlanChangePreviewQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerPlanChangePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerPlanChangePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerPlanChangePreviewQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customerOrganisationId: // value for 'customerOrganisationId'
 *      subscriptionType: // value for 'subscriptionType'
 *   },
 * });
 */
export function usePartnerCustomerPlanChangePreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables> & ({ variables: PartnerCustomerPlanChangePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables>(PartnerCustomerPlanChangePreviewDocument, options);
      }
export function usePartnerCustomerPlanChangePreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables>(PartnerCustomerPlanChangePreviewDocument, options);
        }
// @ts-ignore
export function usePartnerCustomerPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables>;
export function usePartnerCustomerPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PartnerCustomerPlanChangePreviewQuery | undefined, PartnerCustomerPlanChangePreviewQueryVariables>;
export function usePartnerCustomerPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PartnerCustomerPlanChangePreviewQuery, PartnerCustomerPlanChangePreviewQueryVariables>(PartnerCustomerPlanChangePreviewDocument, options);
        }
export type PartnerCustomerPlanChangePreviewQueryHookResult = ReturnType<typeof usePartnerCustomerPlanChangePreviewQuery>;
export type PartnerCustomerPlanChangePreviewLazyQueryHookResult = ReturnType<typeof usePartnerCustomerPlanChangePreviewLazyQuery>;
export type PartnerCustomerPlanChangePreviewSuspenseQueryHookResult = ReturnType<typeof usePartnerCustomerPlanChangePreviewSuspenseQuery>;
export const PartnerCustomerChangePlanDocument = gql`
    mutation partnerCustomerChangePlan($organisationId: ID!, $customerOrganisationId: ID!, $subscriptionType: SubscriptionType!) {
  partnerCustomerChangePlan(
    organisationId: $organisationId
    customerOrganisationId: $customerOrganisationId
    subscriptionType: $subscriptionType
  ) {
    ...ReferralOverviewFields
  }
}
    ${ReferralOverviewFieldsFragmentDoc}`;

/**
 * __usePartnerCustomerChangePlanMutation__
 *
 * To run a mutation, you first call `usePartnerCustomerChangePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerChangePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCustomerChangePlanMutation, { data, loading, error }] = usePartnerCustomerChangePlanMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customerOrganisationId: // value for 'customerOrganisationId'
 *      subscriptionType: // value for 'subscriptionType'
 *   },
 * });
 */
export function usePartnerCustomerChangePlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PartnerCustomerChangePlanMutation, PartnerCustomerChangePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PartnerCustomerChangePlanMutation, PartnerCustomerChangePlanMutationVariables>(PartnerCustomerChangePlanDocument, options);
      }
export type PartnerCustomerChangePlanMutationHookResult = ReturnType<typeof usePartnerCustomerChangePlanMutation>;
export const PartnerCustomerPurchaseCreditsDocument = gql`
    mutation partnerCustomerPurchaseCredits($organisationId: ID!, $customerOrganisationId: ID!, $amount: Int!) {
  partnerCustomerPurchaseCredits(
    organisationId: $organisationId
    customerOrganisationId: $customerOrganisationId
    amount: $amount
  ) {
    ...ReferralOverviewFields
  }
}
    ${ReferralOverviewFieldsFragmentDoc}`;

/**
 * __usePartnerCustomerPurchaseCreditsMutation__
 *
 * To run a mutation, you first call `usePartnerCustomerPurchaseCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerPurchaseCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCustomerPurchaseCreditsMutation, { data, loading, error }] = usePartnerCustomerPurchaseCreditsMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customerOrganisationId: // value for 'customerOrganisationId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function usePartnerCustomerPurchaseCreditsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PartnerCustomerPurchaseCreditsMutation, PartnerCustomerPurchaseCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PartnerCustomerPurchaseCreditsMutation, PartnerCustomerPurchaseCreditsMutationVariables>(PartnerCustomerPurchaseCreditsDocument, options);
      }
export type PartnerCustomerPurchaseCreditsMutationHookResult = ReturnType<typeof usePartnerCustomerPurchaseCreditsMutation>;
export const PartnerCustomerCancelSubscriptionDocument = gql`
    mutation partnerCustomerCancelSubscription($organisationId: ID!, $customerOrganisationId: ID!) {
  partnerCustomerCancelSubscription(
    organisationId: $organisationId
    customerOrganisationId: $customerOrganisationId
  ) {
    ...ReferralOverviewFields
  }
}
    ${ReferralOverviewFieldsFragmentDoc}`;

/**
 * __usePartnerCustomerCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `usePartnerCustomerCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCustomerCancelSubscriptionMutation, { data, loading, error }] = usePartnerCustomerCancelSubscriptionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customerOrganisationId: // value for 'customerOrganisationId'
 *   },
 * });
 */
export function usePartnerCustomerCancelSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PartnerCustomerCancelSubscriptionMutation, PartnerCustomerCancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PartnerCustomerCancelSubscriptionMutation, PartnerCustomerCancelSubscriptionMutationVariables>(PartnerCustomerCancelSubscriptionDocument, options);
      }
export type PartnerCustomerCancelSubscriptionMutationHookResult = ReturnType<typeof usePartnerCustomerCancelSubscriptionMutation>;
export const PartnerCustomerPauseSubscriptionDocument = gql`
    mutation partnerCustomerPauseSubscription($organisationId: ID!, $customerOrganisationId: ID!, $paused: Boolean!) {
  partnerCustomerPauseSubscription(
    organisationId: $organisationId
    customerOrganisationId: $customerOrganisationId
    paused: $paused
  ) {
    ...ReferralOverviewFields
  }
}
    ${ReferralOverviewFieldsFragmentDoc}`;

/**
 * __usePartnerCustomerPauseSubscriptionMutation__
 *
 * To run a mutation, you first call `usePartnerCustomerPauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerPauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCustomerPauseSubscriptionMutation, { data, loading, error }] = usePartnerCustomerPauseSubscriptionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customerOrganisationId: // value for 'customerOrganisationId'
 *      paused: // value for 'paused'
 *   },
 * });
 */
export function usePartnerCustomerPauseSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PartnerCustomerPauseSubscriptionMutation, PartnerCustomerPauseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PartnerCustomerPauseSubscriptionMutation, PartnerCustomerPauseSubscriptionMutationVariables>(PartnerCustomerPauseSubscriptionDocument, options);
      }
export type PartnerCustomerPauseSubscriptionMutationHookResult = ReturnType<typeof usePartnerCustomerPauseSubscriptionMutation>;
export const PartnerCustomerBillingDatePreviewDocument = gql`
    query partnerCustomerBillingDatePreview($organisationId: ID!, $customerOrganisationId: ID!, $renewalDate: Date!) {
  partnerCustomerBillingDatePreview(
    organisationId: $organisationId
    customerOrganisationId: $customerOrganisationId
    renewalDate: $renewalDate
  ) {
    renewalDate
    endDate
    currentEndDate
    subscriptionType
    monthsAdded
    dueCents
    chargedCents
    priceLocked
    problems
  }
}
    `;

/**
 * __usePartnerCustomerBillingDatePreviewQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerBillingDatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerBillingDatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerBillingDatePreviewQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customerOrganisationId: // value for 'customerOrganisationId'
 *      renewalDate: // value for 'renewalDate'
 *   },
 * });
 */
export function usePartnerCustomerBillingDatePreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables> & ({ variables: PartnerCustomerBillingDatePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables>(PartnerCustomerBillingDatePreviewDocument, options);
      }
export function usePartnerCustomerBillingDatePreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables>(PartnerCustomerBillingDatePreviewDocument, options);
        }
// @ts-ignore
export function usePartnerCustomerBillingDatePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables>;
export function usePartnerCustomerBillingDatePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PartnerCustomerBillingDatePreviewQuery | undefined, PartnerCustomerBillingDatePreviewQueryVariables>;
export function usePartnerCustomerBillingDatePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PartnerCustomerBillingDatePreviewQuery, PartnerCustomerBillingDatePreviewQueryVariables>(PartnerCustomerBillingDatePreviewDocument, options);
        }
export type PartnerCustomerBillingDatePreviewQueryHookResult = ReturnType<typeof usePartnerCustomerBillingDatePreviewQuery>;
export type PartnerCustomerBillingDatePreviewLazyQueryHookResult = ReturnType<typeof usePartnerCustomerBillingDatePreviewLazyQuery>;
export type PartnerCustomerBillingDatePreviewSuspenseQueryHookResult = ReturnType<typeof usePartnerCustomerBillingDatePreviewSuspenseQuery>;
export const PartnerCustomerSetBillingDateDocument = gql`
    mutation partnerCustomerSetBillingDate($organisationId: ID!, $customerOrganisationId: ID!, $renewalDate: Date!) {
  partnerCustomerSetBillingDate(
    organisationId: $organisationId
    customerOrganisationId: $customerOrganisationId
    renewalDate: $renewalDate
  ) {
    ...ReferralOverviewFields
  }
}
    ${ReferralOverviewFieldsFragmentDoc}`;

/**
 * __usePartnerCustomerSetBillingDateMutation__
 *
 * To run a mutation, you first call `usePartnerCustomerSetBillingDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerSetBillingDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCustomerSetBillingDateMutation, { data, loading, error }] = usePartnerCustomerSetBillingDateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customerOrganisationId: // value for 'customerOrganisationId'
 *      renewalDate: // value for 'renewalDate'
 *   },
 * });
 */
export function usePartnerCustomerSetBillingDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PartnerCustomerSetBillingDateMutation, PartnerCustomerSetBillingDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PartnerCustomerSetBillingDateMutation, PartnerCustomerSetBillingDateMutationVariables>(PartnerCustomerSetBillingDateDocument, options);
      }
export type PartnerCustomerSetBillingDateMutationHookResult = ReturnType<typeof usePartnerCustomerSetBillingDateMutation>;
export const PartnerCustomerInviteUsersDocument = gql`
    mutation partnerCustomerInviteUsers($organisationId: ID!, $customerOrganisationId: ID!, $emails: [String!]!) {
  partnerCustomerInviteUsers(
    organisationId: $organisationId
    customerOrganisationId: $customerOrganisationId
    emails: $emails
  )
}
    `;

/**
 * __usePartnerCustomerInviteUsersMutation__
 *
 * To run a mutation, you first call `usePartnerCustomerInviteUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerInviteUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partnerCustomerInviteUsersMutation, { data, loading, error }] = usePartnerCustomerInviteUsersMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customerOrganisationId: // value for 'customerOrganisationId'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function usePartnerCustomerInviteUsersMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PartnerCustomerInviteUsersMutation, PartnerCustomerInviteUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PartnerCustomerInviteUsersMutation, PartnerCustomerInviteUsersMutationVariables>(PartnerCustomerInviteUsersDocument, options);
      }
export type PartnerCustomerInviteUsersMutationHookResult = ReturnType<typeof usePartnerCustomerInviteUsersMutation>;
export const SuperadminSetOdooPartnerDocument = gql`
    mutation superadminSetOdooPartner($organisationId: ID!, $partnerId: Int) {
  superadminSetOdooPartner(organisationId: $organisationId, partnerId: $partnerId) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminSetOdooPartnerMutation__
 *
 * To run a mutation, you first call `useSuperadminSetOdooPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminSetOdooPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminSetOdooPartnerMutation, { data, loading, error }] = useSuperadminSetOdooPartnerMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      partnerId: // value for 'partnerId'
 *   },
 * });
 */
export function useSuperadminSetOdooPartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminSetOdooPartnerMutation, SuperadminSetOdooPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminSetOdooPartnerMutation, SuperadminSetOdooPartnerMutationVariables>(SuperadminSetOdooPartnerDocument, options);
      }
export type SuperadminSetOdooPartnerMutationHookResult = ReturnType<typeof useSuperadminSetOdooPartnerMutation>;
export const SuperadminCreateOdooPartnerDocument = gql`
    mutation superadminCreateOdooPartner($organisationId: ID!) {
  superadminCreateOdooPartner(organisationId: $organisationId) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminCreateOdooPartnerMutation__
 *
 * To run a mutation, you first call `useSuperadminCreateOdooPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminCreateOdooPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminCreateOdooPartnerMutation, { data, loading, error }] = useSuperadminCreateOdooPartnerMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSuperadminCreateOdooPartnerMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminCreateOdooPartnerMutation, SuperadminCreateOdooPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminCreateOdooPartnerMutation, SuperadminCreateOdooPartnerMutationVariables>(SuperadminCreateOdooPartnerDocument, options);
      }
export type SuperadminCreateOdooPartnerMutationHookResult = ReturnType<typeof useSuperadminCreateOdooPartnerMutation>;
export const SuperadminSetOdooOrderDocument = gql`
    mutation superadminSetOdooOrder($organisationId: ID!, $orderId: Int) {
  superadminSetOdooOrder(organisationId: $organisationId, orderId: $orderId) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminSetOdooOrderMutation__
 *
 * To run a mutation, you first call `useSuperadminSetOdooOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminSetOdooOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminSetOdooOrderMutation, { data, loading, error }] = useSuperadminSetOdooOrderMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      orderId: // value for 'orderId'
 *   },
 * });
 */
export function useSuperadminSetOdooOrderMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminSetOdooOrderMutation, SuperadminSetOdooOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminSetOdooOrderMutation, SuperadminSetOdooOrderMutationVariables>(SuperadminSetOdooOrderDocument, options);
      }
export type SuperadminSetOdooOrderMutationHookResult = ReturnType<typeof useSuperadminSetOdooOrderMutation>;
export const SuperadminCreateOdooInvoiceDocument = gql`
    mutation superadminCreateOdooInvoice($entryId: ID!) {
  superadminCreateOdooInvoice(entryId: $entryId) {
    ...SuperadminCreditLedgerEntryFields
  }
}
    ${SuperadminCreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useSuperadminCreateOdooInvoiceMutation__
 *
 * To run a mutation, you first call `useSuperadminCreateOdooInvoiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminCreateOdooInvoiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminCreateOdooInvoiceMutation, { data, loading, error }] = useSuperadminCreateOdooInvoiceMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *   },
 * });
 */
export function useSuperadminCreateOdooInvoiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminCreateOdooInvoiceMutation, SuperadminCreateOdooInvoiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminCreateOdooInvoiceMutation, SuperadminCreateOdooInvoiceMutationVariables>(SuperadminCreateOdooInvoiceDocument, options);
      }
export type SuperadminCreateOdooInvoiceMutationHookResult = ReturnType<typeof useSuperadminCreateOdooInvoiceMutation>;
export const SuperadminRefreshInvoicesDocument = gql`
    mutation superadminRefreshInvoices($organisationId: ID!) {
  superadminRefreshInvoices(organisationId: $organisationId)
}
    `;

/**
 * __useSuperadminRefreshInvoicesMutation__
 *
 * To run a mutation, you first call `useSuperadminRefreshInvoicesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminRefreshInvoicesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminRefreshInvoicesMutation, { data, loading, error }] = useSuperadminRefreshInvoicesMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSuperadminRefreshInvoicesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminRefreshInvoicesMutation, SuperadminRefreshInvoicesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminRefreshInvoicesMutation, SuperadminRefreshInvoicesMutationVariables>(SuperadminRefreshInvoicesDocument, options);
      }
export type SuperadminRefreshInvoicesMutationHookResult = ReturnType<typeof useSuperadminRefreshInvoicesMutation>;
export const SuperadminCreditLedgerDocument = gql`
    query superadminCreditLedger($organisationId: ID!, $pagination: CursorPaginationInput) {
  superadminCreditLedger(organisationId: $organisationId, pagination: $pagination) {
    data {
      ...SuperadminCreditLedgerEntryFields
      sentInvoiceNumber
      paymentStatus
    }
    nextCursor
    total
    hasMore
  }
}
    ${SuperadminCreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useSuperadminCreditLedgerQuery__
 *
 * To run a query within a React component, call `useSuperadminCreditLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminCreditLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminCreditLedgerQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSuperadminCreditLedgerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables> & ({ variables: SuperadminCreditLedgerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables>(SuperadminCreditLedgerDocument, options);
      }
export function useSuperadminCreditLedgerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables>(SuperadminCreditLedgerDocument, options);
        }
// @ts-ignore
export function useSuperadminCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables>;
export function useSuperadminCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminCreditLedgerQuery | undefined, SuperadminCreditLedgerQueryVariables>;
export function useSuperadminCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminCreditLedgerQuery, SuperadminCreditLedgerQueryVariables>(SuperadminCreditLedgerDocument, options);
        }
export type SuperadminCreditLedgerQueryHookResult = ReturnType<typeof useSuperadminCreditLedgerQuery>;
export type SuperadminCreditLedgerLazyQueryHookResult = ReturnType<typeof useSuperadminCreditLedgerLazyQuery>;
export type SuperadminCreditLedgerSuspenseQueryHookResult = ReturnType<typeof useSuperadminCreditLedgerSuspenseQuery>;
export const SuperadminFullCreditLedgerDocument = gql`
    query superadminFullCreditLedger($organisationId: ID!, $pagination: CursorPaginationInput) {
  superadminCreditLedger(
    organisationId: $organisationId
    pagination: $pagination
    includeCharges: true
  ) {
    data {
      ...SuperadminCreditLedgerEntryFields
      sentInvoiceNumber
      paymentStatus
      projectId
      projectName
      taskId
      pointCountTotal
      shortfall
    }
    nextCursor
    total
    hasMore
  }
}
    ${SuperadminCreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useSuperadminFullCreditLedgerQuery__
 *
 * To run a query within a React component, call `useSuperadminFullCreditLedgerQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminFullCreditLedgerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminFullCreditLedgerQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSuperadminFullCreditLedgerQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables> & ({ variables: SuperadminFullCreditLedgerQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables>(SuperadminFullCreditLedgerDocument, options);
      }
export function useSuperadminFullCreditLedgerLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables>(SuperadminFullCreditLedgerDocument, options);
        }
// @ts-ignore
export function useSuperadminFullCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables>;
export function useSuperadminFullCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminFullCreditLedgerQuery | undefined, SuperadminFullCreditLedgerQueryVariables>;
export function useSuperadminFullCreditLedgerSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminFullCreditLedgerQuery, SuperadminFullCreditLedgerQueryVariables>(SuperadminFullCreditLedgerDocument, options);
        }
export type SuperadminFullCreditLedgerQueryHookResult = ReturnType<typeof useSuperadminFullCreditLedgerQuery>;
export type SuperadminFullCreditLedgerLazyQueryHookResult = ReturnType<typeof useSuperadminFullCreditLedgerLazyQuery>;
export type SuperadminFullCreditLedgerSuspenseQueryHookResult = ReturnType<typeof useSuperadminFullCreditLedgerSuspenseQuery>;
export const SuperadminLiveGrantsDocument = gql`
    query superadminLiveGrants($organisationId: ID!) {
  superadminLiveGrants(organisationId: $organisationId) {
    ...CreditLedgerEntryFields
  }
}
    ${CreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useSuperadminLiveGrantsQuery__
 *
 * To run a query within a React component, call `useSuperadminLiveGrantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminLiveGrantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminLiveGrantsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSuperadminLiveGrantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables> & ({ variables: SuperadminLiveGrantsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables>(SuperadminLiveGrantsDocument, options);
      }
export function useSuperadminLiveGrantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables>(SuperadminLiveGrantsDocument, options);
        }
// @ts-ignore
export function useSuperadminLiveGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables>;
export function useSuperadminLiveGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminLiveGrantsQuery | undefined, SuperadminLiveGrantsQueryVariables>;
export function useSuperadminLiveGrantsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminLiveGrantsQuery, SuperadminLiveGrantsQueryVariables>(SuperadminLiveGrantsDocument, options);
        }
export type SuperadminLiveGrantsQueryHookResult = ReturnType<typeof useSuperadminLiveGrantsQuery>;
export type SuperadminLiveGrantsLazyQueryHookResult = ReturnType<typeof useSuperadminLiveGrantsLazyQuery>;
export type SuperadminLiveGrantsSuspenseQueryHookResult = ReturnType<typeof useSuperadminLiveGrantsSuspenseQuery>;
export const SuperadminRemoveCreditsDocument = gql`
    mutation superadminRemoveCredits($entryId: ID!, $amount: Int!) {
  superadminRemoveCredits(entryId: $entryId, amount: $amount) {
    ...CreditLedgerEntryFields
  }
}
    ${CreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useSuperadminRemoveCreditsMutation__
 *
 * To run a mutation, you first call `useSuperadminRemoveCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminRemoveCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminRemoveCreditsMutation, { data, loading, error }] = useSuperadminRemoveCreditsMutation({
 *   variables: {
 *      entryId: // value for 'entryId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useSuperadminRemoveCreditsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminRemoveCreditsMutation, SuperadminRemoveCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminRemoveCreditsMutation, SuperadminRemoveCreditsMutationVariables>(SuperadminRemoveCreditsDocument, options);
      }
export type SuperadminRemoveCreditsMutationHookResult = ReturnType<typeof useSuperadminRemoveCreditsMutation>;
export const SuperadminGrantCreditsDocument = gql`
    mutation superadminGrantCredits($organisationId: ID!, $amount: Int!, $expiresAt: Date, $note: String, $unitPriceCents: Int) {
  superadminGrantCredits(
    organisationId: $organisationId
    amount: $amount
    expiresAt: $expiresAt
    note: $note
    unitPriceCents: $unitPriceCents
  ) {
    ...SuperadminCreditLedgerEntryFields
  }
}
    ${SuperadminCreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useSuperadminGrantCreditsMutation__
 *
 * To run a mutation, you first call `useSuperadminGrantCreditsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminGrantCreditsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminGrantCreditsMutation, { data, loading, error }] = useSuperadminGrantCreditsMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      amount: // value for 'amount'
 *      expiresAt: // value for 'expiresAt'
 *      note: // value for 'note'
 *      unitPriceCents: // value for 'unitPriceCents'
 *   },
 * });
 */
export function useSuperadminGrantCreditsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminGrantCreditsMutation, SuperadminGrantCreditsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminGrantCreditsMutation, SuperadminGrantCreditsMutationVariables>(SuperadminGrantCreditsDocument, options);
      }
export type SuperadminGrantCreditsMutationHookResult = ReturnType<typeof useSuperadminGrantCreditsMutation>;
export const SuperadminOrganisationCreateDocument = gql`
    mutation superadminOrganisationCreate($name: String!, $emails: [String!]!) {
  superadminOrganisationCreate(name: $name, emails: $emails) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminOrganisationCreateMutation__
 *
 * To run a mutation, you first call `useSuperadminOrganisationCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminOrganisationCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminOrganisationCreateMutation, { data, loading, error }] = useSuperadminOrganisationCreateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      emails: // value for 'emails'
 *   },
 * });
 */
export function useSuperadminOrganisationCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminOrganisationCreateMutation, SuperadminOrganisationCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminOrganisationCreateMutation, SuperadminOrganisationCreateMutationVariables>(SuperadminOrganisationCreateDocument, options);
      }
export type SuperadminOrganisationCreateMutationHookResult = ReturnType<typeof useSuperadminOrganisationCreateMutation>;
export const SuperadminOrganisationsDocument = gql`
    query superadminOrganisations($pagination: CursorPaginationInput, $filters: InputSuperadminOrganisationFilters) {
  superadminOrganisations(pagination: $pagination, filters: $filters) {
    data {
      ...SuperadminOrganisation
    }
    nextCursor
    total
    hasMore
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminOrganisationsQuery__
 *
 * To run a query within a React component, call `useSuperadminOrganisationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminOrganisationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminOrganisationsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSuperadminOrganisationsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>(SuperadminOrganisationsDocument, options);
      }
export function useSuperadminOrganisationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>(SuperadminOrganisationsDocument, options);
        }
// @ts-ignore
export function useSuperadminOrganisationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>;
export function useSuperadminOrganisationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminOrganisationsQuery | undefined, SuperadminOrganisationsQueryVariables>;
export function useSuperadminOrganisationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminOrganisationsQuery, SuperadminOrganisationsQueryVariables>(SuperadminOrganisationsDocument, options);
        }
export type SuperadminOrganisationsQueryHookResult = ReturnType<typeof useSuperadminOrganisationsQuery>;
export type SuperadminOrganisationsLazyQueryHookResult = ReturnType<typeof useSuperadminOrganisationsLazyQuery>;
export type SuperadminOrganisationsSuspenseQueryHookResult = ReturnType<typeof useSuperadminOrganisationsSuspenseQuery>;
export const SuperadminOrganisationByIdDocument = gql`
    query superadminOrganisationById($organisationId: ID!) {
  organisationById(organisationId: $organisationId) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminOrganisationByIdQuery__
 *
 * To run a query within a React component, call `useSuperadminOrganisationByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminOrganisationByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminOrganisationByIdQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useSuperadminOrganisationByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables> & ({ variables: SuperadminOrganisationByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables>(SuperadminOrganisationByIdDocument, options);
      }
export function useSuperadminOrganisationByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables>(SuperadminOrganisationByIdDocument, options);
        }
// @ts-ignore
export function useSuperadminOrganisationByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables>;
export function useSuperadminOrganisationByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminOrganisationByIdQuery | undefined, SuperadminOrganisationByIdQueryVariables>;
export function useSuperadminOrganisationByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminOrganisationByIdQuery, SuperadminOrganisationByIdQueryVariables>(SuperadminOrganisationByIdDocument, options);
        }
export type SuperadminOrganisationByIdQueryHookResult = ReturnType<typeof useSuperadminOrganisationByIdQuery>;
export type SuperadminOrganisationByIdLazyQueryHookResult = ReturnType<typeof useSuperadminOrganisationByIdLazyQuery>;
export type SuperadminOrganisationByIdSuspenseQueryHookResult = ReturnType<typeof useSuperadminOrganisationByIdSuspenseQuery>;
export const SuperadminOrganisationsPerMonthDocument = gql`
    query superadminOrganisationsPerMonth($filters: InputSuperadminOrganisationFilters) {
  superadminOrganisationsPerMonth(filters: $filters) {
    month
    count
  }
}
    `;

/**
 * __useSuperadminOrganisationsPerMonthQuery__
 *
 * To run a query within a React component, call `useSuperadminOrganisationsPerMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminOrganisationsPerMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminOrganisationsPerMonthQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSuperadminOrganisationsPerMonthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>(SuperadminOrganisationsPerMonthDocument, options);
      }
export function useSuperadminOrganisationsPerMonthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>(SuperadminOrganisationsPerMonthDocument, options);
        }
// @ts-ignore
export function useSuperadminOrganisationsPerMonthSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>;
export function useSuperadminOrganisationsPerMonthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminOrganisationsPerMonthQuery | undefined, SuperadminOrganisationsPerMonthQueryVariables>;
export function useSuperadminOrganisationsPerMonthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminOrganisationsPerMonthQuery, SuperadminOrganisationsPerMonthQueryVariables>(SuperadminOrganisationsPerMonthDocument, options);
        }
export type SuperadminOrganisationsPerMonthQueryHookResult = ReturnType<typeof useSuperadminOrganisationsPerMonthQuery>;
export type SuperadminOrganisationsPerMonthLazyQueryHookResult = ReturnType<typeof useSuperadminOrganisationsPerMonthLazyQuery>;
export type SuperadminOrganisationsPerMonthSuspenseQueryHookResult = ReturnType<typeof useSuperadminOrganisationsPerMonthSuspenseQuery>;
export const SuperadminPlanChangePreviewDocument = gql`
    query superadminPlanChangePreview($organisationId: ID!, $subscriptionType: SubscriptionType!, $effectiveAt: Date, $endDate: Date, $chargeCents: Int, $customLimits: InputSubscriptionCustomLimits, $force: Boolean) {
  superadminPlanChangePreview(
    organisationId: $organisationId
    subscriptionType: $subscriptionType
    effectiveAt: $effectiveAt
    endDate: $endDate
    chargeCents: $chargeCents
    customLimits: $customLimits
    force: $force
  ) {
    kind
    subscriptionType
    effectiveAt
    scheduled
    alreadyScheduled
    endDate
    minEffectiveAt
    maxEffectiveAt
    changeMonth
    changePeriodStart
    changePeriodEnd
    current {
      ...PlanTermStateFields
    }
    after {
      ...PlanTermStateFields
    }
    next {
      ...PlanTermStateFields
    }
    lines {
      subscriptionType
      from
      to
      months
      monthlyPriceCents
      totalCents
    }
    totalValueCents
    currentTermValueCents
    alreadyPaidCents
    dueCents
    balanceCents
    chargedCents
    overridden
    priceLocked
    extraCredits
    extraCreditsAt
    extraCreditsExpireAt
    timeline {
      from
      to
      subscriptionType
      monthlyCredits
      extraCredits
      month
    }
    invoiceVia
    voidsCurrentTerm
    keepsPending
    supersedesPending
    problems
  }
}
    ${PlanTermStateFieldsFragmentDoc}`;

/**
 * __useSuperadminPlanChangePreviewQuery__
 *
 * To run a query within a React component, call `useSuperadminPlanChangePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminPlanChangePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminPlanChangePreviewQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      subscriptionType: // value for 'subscriptionType'
 *      effectiveAt: // value for 'effectiveAt'
 *      endDate: // value for 'endDate'
 *      chargeCents: // value for 'chargeCents'
 *      customLimits: // value for 'customLimits'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useSuperadminPlanChangePreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables> & ({ variables: SuperadminPlanChangePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables>(SuperadminPlanChangePreviewDocument, options);
      }
export function useSuperadminPlanChangePreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables>(SuperadminPlanChangePreviewDocument, options);
        }
// @ts-ignore
export function useSuperadminPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables>;
export function useSuperadminPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminPlanChangePreviewQuery | undefined, SuperadminPlanChangePreviewQueryVariables>;
export function useSuperadminPlanChangePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminPlanChangePreviewQuery, SuperadminPlanChangePreviewQueryVariables>(SuperadminPlanChangePreviewDocument, options);
        }
export type SuperadminPlanChangePreviewQueryHookResult = ReturnType<typeof useSuperadminPlanChangePreviewQuery>;
export type SuperadminPlanChangePreviewLazyQueryHookResult = ReturnType<typeof useSuperadminPlanChangePreviewLazyQuery>;
export type SuperadminPlanChangePreviewSuspenseQueryHookResult = ReturnType<typeof useSuperadminPlanChangePreviewSuspenseQuery>;
export const SuperadminUpdatePlanDocument = gql`
    mutation superadminUpdatePlan($organisationId: ID!, $customLimits: InputSubscriptionCustomLimits!, $subscriptionType: SubscriptionType!, $effectiveAt: Date, $endDate: Date, $chargeCents: Int, $force: Boolean) {
  superadminUpdatePlan(
    organisationId: $organisationId
    customLimits: $customLimits
    subscriptionType: $subscriptionType
    effectiveAt: $effectiveAt
    endDate: $endDate
    chargeCents: $chargeCents
    force: $force
  ) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminUpdatePlanMutation__
 *
 * To run a mutation, you first call `useSuperadminUpdatePlanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminUpdatePlanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminUpdatePlanMutation, { data, loading, error }] = useSuperadminUpdatePlanMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      customLimits: // value for 'customLimits'
 *      subscriptionType: // value for 'subscriptionType'
 *      effectiveAt: // value for 'effectiveAt'
 *      endDate: // value for 'endDate'
 *      chargeCents: // value for 'chargeCents'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useSuperadminUpdatePlanMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminUpdatePlanMutation, SuperadminUpdatePlanMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminUpdatePlanMutation, SuperadminUpdatePlanMutationVariables>(SuperadminUpdatePlanDocument, options);
      }
export type SuperadminUpdatePlanMutationHookResult = ReturnType<typeof useSuperadminUpdatePlanMutation>;
export const SuperadminBillingDatePreviewDocument = gql`
    query superadminBillingDatePreview($organisationId: ID!, $renewalDate: Date!, $chargeCents: Int) {
  superadminBillingDatePreview(
    organisationId: $organisationId
    renewalDate: $renewalDate
    chargeCents: $chargeCents
  ) {
    renewalDate
    endDate
    currentEndDate
    subscriptionType
    monthsAdded
    monthlyPriceCents
    dueCents
    chargedCents
    overridden
    priceLocked
    odooLinked
    movesPendingChange
    problems
  }
}
    `;

/**
 * __useSuperadminBillingDatePreviewQuery__
 *
 * To run a query within a React component, call `useSuperadminBillingDatePreviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminBillingDatePreviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminBillingDatePreviewQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      renewalDate: // value for 'renewalDate'
 *      chargeCents: // value for 'chargeCents'
 *   },
 * });
 */
export function useSuperadminBillingDatePreviewQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables> & ({ variables: SuperadminBillingDatePreviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables>(SuperadminBillingDatePreviewDocument, options);
      }
export function useSuperadminBillingDatePreviewLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables>(SuperadminBillingDatePreviewDocument, options);
        }
// @ts-ignore
export function useSuperadminBillingDatePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables>;
export function useSuperadminBillingDatePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminBillingDatePreviewQuery | undefined, SuperadminBillingDatePreviewQueryVariables>;
export function useSuperadminBillingDatePreviewSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminBillingDatePreviewQuery, SuperadminBillingDatePreviewQueryVariables>(SuperadminBillingDatePreviewDocument, options);
        }
export type SuperadminBillingDatePreviewQueryHookResult = ReturnType<typeof useSuperadminBillingDatePreviewQuery>;
export type SuperadminBillingDatePreviewLazyQueryHookResult = ReturnType<typeof useSuperadminBillingDatePreviewLazyQuery>;
export type SuperadminBillingDatePreviewSuspenseQueryHookResult = ReturnType<typeof useSuperadminBillingDatePreviewSuspenseQuery>;
export const SuperadminSetBillingDateDocument = gql`
    mutation superadminSetBillingDate($organisationId: ID!, $renewalDate: Date!, $chargeCents: Int) {
  superadminSetBillingDate(
    organisationId: $organisationId
    renewalDate: $renewalDate
    chargeCents: $chargeCents
  ) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminSetBillingDateMutation__
 *
 * To run a mutation, you first call `useSuperadminSetBillingDateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminSetBillingDateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminSetBillingDateMutation, { data, loading, error }] = useSuperadminSetBillingDateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      renewalDate: // value for 'renewalDate'
 *      chargeCents: // value for 'chargeCents'
 *   },
 * });
 */
export function useSuperadminSetBillingDateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminSetBillingDateMutation, SuperadminSetBillingDateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminSetBillingDateMutation, SuperadminSetBillingDateMutationVariables>(SuperadminSetBillingDateDocument, options);
      }
export type SuperadminSetBillingDateMutationHookResult = ReturnType<typeof useSuperadminSetBillingDateMutation>;
export const SuperadminPauseSubscriptionDocument = gql`
    mutation superadminPauseSubscription($organisationId: ID!, $paused: Boolean!) {
  superadminPauseSubscription(organisationId: $organisationId, paused: $paused) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminPauseSubscriptionMutation__
 *
 * To run a mutation, you first call `useSuperadminPauseSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminPauseSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminPauseSubscriptionMutation, { data, loading, error }] = useSuperadminPauseSubscriptionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      paused: // value for 'paused'
 *   },
 * });
 */
export function useSuperadminPauseSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminPauseSubscriptionMutation, SuperadminPauseSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminPauseSubscriptionMutation, SuperadminPauseSubscriptionMutationVariables>(SuperadminPauseSubscriptionDocument, options);
      }
export type SuperadminPauseSubscriptionMutationHookResult = ReturnType<typeof useSuperadminPauseSubscriptionMutation>;
export const SuperadminCancelSubscriptionDocument = gql`
    mutation superadminCancelSubscription($organisationId: ID!, $immediately: Boolean) {
  superadminCancelSubscription(
    organisationId: $organisationId
    immediately: $immediately
  ) {
    ...SuperadminOrganisation
  }
}
    ${SuperadminOrganisationFragmentDoc}`;

/**
 * __useSuperadminCancelSubscriptionMutation__
 *
 * To run a mutation, you first call `useSuperadminCancelSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSuperadminCancelSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [superadminCancelSubscriptionMutation, { data, loading, error }] = useSuperadminCancelSubscriptionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      immediately: // value for 'immediately'
 *   },
 * });
 */
export function useSuperadminCancelSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SuperadminCancelSubscriptionMutation, SuperadminCancelSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SuperadminCancelSubscriptionMutation, SuperadminCancelSubscriptionMutationVariables>(SuperadminCancelSubscriptionDocument, options);
      }
export type SuperadminCancelSubscriptionMutationHookResult = ReturnType<typeof useSuperadminCancelSubscriptionMutation>;
export const SuperadminFailedPointCloudsDocument = gql`
    query superadminFailedPointClouds($status: FailedPointCloudStatus, $pagination: CursorPaginationInput) {
  superadminFailedPointClouds(status: $status, pagination: $pagination) {
    data {
      id
      projectId
      organisationId
      projectName
      organisationName
      cloudName
      displayName
      fileNames
      sizeBytes
      status
      failureCount
      firstFailedAt
      lastFailedAt
      lastJobId
      lastError
      resolvedAt
      deletedAt
    }
    nextCursor
    total
    hasMore
  }
}
    `;

/**
 * __useSuperadminFailedPointCloudsQuery__
 *
 * To run a query within a React component, call `useSuperadminFailedPointCloudsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminFailedPointCloudsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminFailedPointCloudsQuery({
 *   variables: {
 *      status: // value for 'status'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSuperadminFailedPointCloudsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>(SuperadminFailedPointCloudsDocument, options);
      }
export function useSuperadminFailedPointCloudsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>(SuperadminFailedPointCloudsDocument, options);
        }
// @ts-ignore
export function useSuperadminFailedPointCloudsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>;
export function useSuperadminFailedPointCloudsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminFailedPointCloudsQuery | undefined, SuperadminFailedPointCloudsQueryVariables>;
export function useSuperadminFailedPointCloudsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminFailedPointCloudsQuery, SuperadminFailedPointCloudsQueryVariables>(SuperadminFailedPointCloudsDocument, options);
        }
export type SuperadminFailedPointCloudsQueryHookResult = ReturnType<typeof useSuperadminFailedPointCloudsQuery>;
export type SuperadminFailedPointCloudsLazyQueryHookResult = ReturnType<typeof useSuperadminFailedPointCloudsLazyQuery>;
export type SuperadminFailedPointCloudsSuspenseQueryHookResult = ReturnType<typeof useSuperadminFailedPointCloudsSuspenseQuery>;
export const SuperadminFailedPointCloudCountsDocument = gql`
    query superadminFailedPointCloudCounts {
  superadminFailedPointCloudCounts {
    failed
    resolved
    deleted
  }
}
    `;

/**
 * __useSuperadminFailedPointCloudCountsQuery__
 *
 * To run a query within a React component, call `useSuperadminFailedPointCloudCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminFailedPointCloudCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminFailedPointCloudCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperadminFailedPointCloudCountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>(SuperadminFailedPointCloudCountsDocument, options);
      }
export function useSuperadminFailedPointCloudCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>(SuperadminFailedPointCloudCountsDocument, options);
        }
// @ts-ignore
export function useSuperadminFailedPointCloudCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>;
export function useSuperadminFailedPointCloudCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminFailedPointCloudCountsQuery | undefined, SuperadminFailedPointCloudCountsQueryVariables>;
export function useSuperadminFailedPointCloudCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminFailedPointCloudCountsQuery, SuperadminFailedPointCloudCountsQueryVariables>(SuperadminFailedPointCloudCountsDocument, options);
        }
export type SuperadminFailedPointCloudCountsQueryHookResult = ReturnType<typeof useSuperadminFailedPointCloudCountsQuery>;
export type SuperadminFailedPointCloudCountsLazyQueryHookResult = ReturnType<typeof useSuperadminFailedPointCloudCountsLazyQuery>;
export type SuperadminFailedPointCloudCountsSuspenseQueryHookResult = ReturnType<typeof useSuperadminFailedPointCloudCountsSuspenseQuery>;
export const SuperadminInvoicesDocument = gql`
    query superadminInvoices($status: InvoiceTrackingStatus, $pagination: CursorPaginationInput) {
  superadminInvoices(status: $status, pagination: $pagination) {
    data {
      status
      organisation {
        id
        name
      }
      entry {
        ...SuperadminCreditLedgerEntryFields
        odooInvoiceNumber
      }
    }
    nextCursor
    total
    hasMore
  }
}
    ${SuperadminCreditLedgerEntryFieldsFragmentDoc}`;

/**
 * __useSuperadminInvoicesQuery__
 *
 * To run a query within a React component, call `useSuperadminInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminInvoicesQuery({
 *   variables: {
 *      status: // value for 'status'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useSuperadminInvoicesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>(SuperadminInvoicesDocument, options);
      }
export function useSuperadminInvoicesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>(SuperadminInvoicesDocument, options);
        }
// @ts-ignore
export function useSuperadminInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>;
export function useSuperadminInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminInvoicesQuery | undefined, SuperadminInvoicesQueryVariables>;
export function useSuperadminInvoicesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminInvoicesQuery, SuperadminInvoicesQueryVariables>(SuperadminInvoicesDocument, options);
        }
export type SuperadminInvoicesQueryHookResult = ReturnType<typeof useSuperadminInvoicesQuery>;
export type SuperadminInvoicesLazyQueryHookResult = ReturnType<typeof useSuperadminInvoicesLazyQuery>;
export type SuperadminInvoicesSuspenseQueryHookResult = ReturnType<typeof useSuperadminInvoicesSuspenseQuery>;
export const SuperadminInvoiceCountsDocument = gql`
    query superadminInvoiceCounts {
  superadminInvoiceCounts {
    noInvoice
    draft
    unpaid
    paid
    cancelled
  }
}
    `;

/**
 * __useSuperadminInvoiceCountsQuery__
 *
 * To run a query within a React component, call `useSuperadminInvoiceCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminInvoiceCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminInvoiceCountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSuperadminInvoiceCountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>(SuperadminInvoiceCountsDocument, options);
      }
export function useSuperadminInvoiceCountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>(SuperadminInvoiceCountsDocument, options);
        }
// @ts-ignore
export function useSuperadminInvoiceCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>;
export function useSuperadminInvoiceCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminInvoiceCountsQuery | undefined, SuperadminInvoiceCountsQueryVariables>;
export function useSuperadminInvoiceCountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminInvoiceCountsQuery, SuperadminInvoiceCountsQueryVariables>(SuperadminInvoiceCountsDocument, options);
        }
export type SuperadminInvoiceCountsQueryHookResult = ReturnType<typeof useSuperadminInvoiceCountsQuery>;
export type SuperadminInvoiceCountsLazyQueryHookResult = ReturnType<typeof useSuperadminInvoiceCountsLazyQuery>;
export type SuperadminInvoiceCountsSuspenseQueryHookResult = ReturnType<typeof useSuperadminInvoiceCountsSuspenseQuery>;
export const SuperadminProjectSourceFilesDocument = gql`
    query superadminProjectSourceFiles($projectId: ID!) {
  superadminProjectSourceFiles(projectId: $projectId) {
    name
    sizeBytes
    url
  }
}
    `;

/**
 * __useSuperadminProjectSourceFilesQuery__
 *
 * To run a query within a React component, call `useSuperadminProjectSourceFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuperadminProjectSourceFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuperadminProjectSourceFilesQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useSuperadminProjectSourceFilesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables> & ({ variables: SuperadminProjectSourceFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables>(SuperadminProjectSourceFilesDocument, options);
      }
export function useSuperadminProjectSourceFilesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables>(SuperadminProjectSourceFilesDocument, options);
        }
// @ts-ignore
export function useSuperadminProjectSourceFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables>;
export function useSuperadminProjectSourceFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<SuperadminProjectSourceFilesQuery | undefined, SuperadminProjectSourceFilesQueryVariables>;
export function useSuperadminProjectSourceFilesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SuperadminProjectSourceFilesQuery, SuperadminProjectSourceFilesQueryVariables>(SuperadminProjectSourceFilesDocument, options);
        }
export type SuperadminProjectSourceFilesQueryHookResult = ReturnType<typeof useSuperadminProjectSourceFilesQuery>;
export type SuperadminProjectSourceFilesLazyQueryHookResult = ReturnType<typeof useSuperadminProjectSourceFilesLazyQuery>;
export type SuperadminProjectSourceFilesSuspenseQueryHookResult = ReturnType<typeof useSuperadminProjectSourceFilesSuspenseQuery>;
export const OrganisationTemplateLibraryDocument = gql`
    query organisationTemplateLibrary($organisationId: ID!, $includeArchived: Boolean) {
  organisationTemplateLibrary(
    organisationId: $organisationId
    includeArchived: $includeArchived
  ) {
    ...TemplateLibraryFields
  }
}
    ${TemplateLibraryFieldsFragmentDoc}`;

/**
 * __useOrganisationTemplateLibraryQuery__
 *
 * To run a query within a React component, call `useOrganisationTemplateLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTemplateLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationTemplateLibraryQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      includeArchived: // value for 'includeArchived'
 *   },
 * });
 */
export function useOrganisationTemplateLibraryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables> & ({ variables: OrganisationTemplateLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables>(OrganisationTemplateLibraryDocument, options);
      }
export function useOrganisationTemplateLibraryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables>(OrganisationTemplateLibraryDocument, options);
        }
// @ts-ignore
export function useOrganisationTemplateLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables>;
export function useOrganisationTemplateLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationTemplateLibraryQuery | undefined, OrganisationTemplateLibraryQueryVariables>;
export function useOrganisationTemplateLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationTemplateLibraryQuery, OrganisationTemplateLibraryQueryVariables>(OrganisationTemplateLibraryDocument, options);
        }
export type OrganisationTemplateLibraryQueryHookResult = ReturnType<typeof useOrganisationTemplateLibraryQuery>;
export type OrganisationTemplateLibraryLazyQueryHookResult = ReturnType<typeof useOrganisationTemplateLibraryLazyQuery>;
export type OrganisationTemplateLibrarySuspenseQueryHookResult = ReturnType<typeof useOrganisationTemplateLibrarySuspenseQuery>;
export const ProjectTemplateLibraryDocument = gql`
    query projectTemplateLibrary($projectId: ID!) {
  projectTemplateLibrary(projectId: $projectId) {
    ...TemplateLibraryFields
  }
}
    ${TemplateLibraryFieldsFragmentDoc}`;

/**
 * __useProjectTemplateLibraryQuery__
 *
 * To run a query within a React component, call `useProjectTemplateLibraryQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectTemplateLibraryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectTemplateLibraryQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectTemplateLibraryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables> & ({ variables: ProjectTemplateLibraryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables>(ProjectTemplateLibraryDocument, options);
      }
export function useProjectTemplateLibraryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables>(ProjectTemplateLibraryDocument, options);
        }
// @ts-ignore
export function useProjectTemplateLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables>;
export function useProjectTemplateLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectTemplateLibraryQuery | undefined, ProjectTemplateLibraryQueryVariables>;
export function useProjectTemplateLibrarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectTemplateLibraryQuery, ProjectTemplateLibraryQueryVariables>(ProjectTemplateLibraryDocument, options);
        }
export type ProjectTemplateLibraryQueryHookResult = ReturnType<typeof useProjectTemplateLibraryQuery>;
export type ProjectTemplateLibraryLazyQueryHookResult = ReturnType<typeof useProjectTemplateLibraryLazyQuery>;
export type ProjectTemplateLibrarySuspenseQueryHookResult = ReturnType<typeof useProjectTemplateLibrarySuspenseQuery>;
export const ProjectPrintTemplateVersionDocument = gql`
    query projectPrintTemplateVersion($projectId: ID!, $templateId: ID!, $version: Int!) {
  projectPrintTemplateVersion(
    projectId: $projectId
    templateId: $templateId
    version: $version
  ) {
    ...PrintTemplateVersionFields
  }
}
    ${PrintTemplateVersionFieldsFragmentDoc}`;

/**
 * __useProjectPrintTemplateVersionQuery__
 *
 * To run a query within a React component, call `useProjectPrintTemplateVersionQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectPrintTemplateVersionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectPrintTemplateVersionQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      templateId: // value for 'templateId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useProjectPrintTemplateVersionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables> & ({ variables: ProjectPrintTemplateVersionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables>(ProjectPrintTemplateVersionDocument, options);
      }
export function useProjectPrintTemplateVersionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables>(ProjectPrintTemplateVersionDocument, options);
        }
// @ts-ignore
export function useProjectPrintTemplateVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables>;
export function useProjectPrintTemplateVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectPrintTemplateVersionQuery | undefined, ProjectPrintTemplateVersionQueryVariables>;
export function useProjectPrintTemplateVersionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectPrintTemplateVersionQuery, ProjectPrintTemplateVersionQueryVariables>(ProjectPrintTemplateVersionDocument, options);
        }
export type ProjectPrintTemplateVersionQueryHookResult = ReturnType<typeof useProjectPrintTemplateVersionQuery>;
export type ProjectPrintTemplateVersionLazyQueryHookResult = ReturnType<typeof useProjectPrintTemplateVersionLazyQuery>;
export type ProjectPrintTemplateVersionSuspenseQueryHookResult = ReturnType<typeof useProjectPrintTemplateVersionSuspenseQuery>;
export const PrintTemplateDocument = gql`
    query printTemplate($organisationId: ID!, $templateId: ID!) {
  printTemplate(organisationId: $organisationId, templateId: $templateId) {
    ...PrintTemplateFields
  }
}
    ${PrintTemplateFieldsFragmentDoc}`;

/**
 * __usePrintTemplateQuery__
 *
 * To run a query within a React component, call `usePrintTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintTemplateQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePrintTemplateQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrintTemplateQuery, PrintTemplateQueryVariables> & ({ variables: PrintTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrintTemplateQuery, PrintTemplateQueryVariables>(PrintTemplateDocument, options);
      }
export function usePrintTemplateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrintTemplateQuery, PrintTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrintTemplateQuery, PrintTemplateQueryVariables>(PrintTemplateDocument, options);
        }
// @ts-ignore
export function usePrintTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PrintTemplateQuery, PrintTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PrintTemplateQuery, PrintTemplateQueryVariables>;
export function usePrintTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrintTemplateQuery, PrintTemplateQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PrintTemplateQuery | undefined, PrintTemplateQueryVariables>;
export function usePrintTemplateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrintTemplateQuery, PrintTemplateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrintTemplateQuery, PrintTemplateQueryVariables>(PrintTemplateDocument, options);
        }
export type PrintTemplateQueryHookResult = ReturnType<typeof usePrintTemplateQuery>;
export type PrintTemplateLazyQueryHookResult = ReturnType<typeof usePrintTemplateLazyQuery>;
export type PrintTemplateSuspenseQueryHookResult = ReturnType<typeof usePrintTemplateSuspenseQuery>;
export const PrintTemplateVersionsDocument = gql`
    query printTemplateVersions($organisationId: ID!, $templateId: ID!) {
  printTemplateVersions(organisationId: $organisationId, templateId: $templateId) {
    ...PrintTemplateVersionFields
  }
}
    ${PrintTemplateVersionFieldsFragmentDoc}`;

/**
 * __usePrintTemplateVersionsQuery__
 *
 * To run a query within a React component, call `usePrintTemplateVersionsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateVersionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrintTemplateVersionsQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePrintTemplateVersionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables> & ({ variables: PrintTemplateVersionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables>(PrintTemplateVersionsDocument, options);
      }
export function usePrintTemplateVersionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables>(PrintTemplateVersionsDocument, options);
        }
// @ts-ignore
export function usePrintTemplateVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables>;
export function usePrintTemplateVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<PrintTemplateVersionsQuery | undefined, PrintTemplateVersionsQueryVariables>;
export function usePrintTemplateVersionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<PrintTemplateVersionsQuery, PrintTemplateVersionsQueryVariables>(PrintTemplateVersionsDocument, options);
        }
export type PrintTemplateVersionsQueryHookResult = ReturnType<typeof usePrintTemplateVersionsQuery>;
export type PrintTemplateVersionsLazyQueryHookResult = ReturnType<typeof usePrintTemplateVersionsLazyQuery>;
export type PrintTemplateVersionsSuspenseQueryHookResult = ReturnType<typeof usePrintTemplateVersionsSuspenseQuery>;
export const OrganisationTemplateLibraryUploadSasDocument = gql`
    query organisationTemplateLibraryUploadSAS($organisationId: ID!) {
  organisationTemplateLibraryUploadSAS(organisationId: $organisationId)
}
    `;

/**
 * __useOrganisationTemplateLibraryUploadSasQuery__
 *
 * To run a query within a React component, call `useOrganisationTemplateLibraryUploadSasQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTemplateLibraryUploadSasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationTemplateLibraryUploadSasQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationTemplateLibraryUploadSasQuery(baseOptions: ApolloReactHooks.QueryHookOptions<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables> & ({ variables: OrganisationTemplateLibraryUploadSasQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables>(OrganisationTemplateLibraryUploadSasDocument, options);
      }
export function useOrganisationTemplateLibraryUploadSasLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables>(OrganisationTemplateLibraryUploadSasDocument, options);
        }
// @ts-ignore
export function useOrganisationTemplateLibraryUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables>;
export function useOrganisationTemplateLibraryUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<OrganisationTemplateLibraryUploadSasQuery | undefined, OrganisationTemplateLibraryUploadSasQueryVariables>;
export function useOrganisationTemplateLibraryUploadSasSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<OrganisationTemplateLibraryUploadSasQuery, OrganisationTemplateLibraryUploadSasQueryVariables>(OrganisationTemplateLibraryUploadSasDocument, options);
        }
export type OrganisationTemplateLibraryUploadSasQueryHookResult = ReturnType<typeof useOrganisationTemplateLibraryUploadSasQuery>;
export type OrganisationTemplateLibraryUploadSasLazyQueryHookResult = ReturnType<typeof useOrganisationTemplateLibraryUploadSasLazyQuery>;
export type OrganisationTemplateLibraryUploadSasSuspenseQueryHookResult = ReturnType<typeof useOrganisationTemplateLibraryUploadSasSuspenseQuery>;
export const PrintTemplateCreateDocument = gql`
    mutation printTemplateCreate($organisationId: ID!, $name: String!, $spec: JSON!, $basedOnBuiltinId: String, $duplicateOfTemplateId: ID) {
  printTemplateCreate(
    organisationId: $organisationId
    name: $name
    spec: $spec
    basedOnBuiltinId: $basedOnBuiltinId
    duplicateOfTemplateId: $duplicateOfTemplateId
  ) {
    ...PrintTemplateFields
  }
}
    ${PrintTemplateFieldsFragmentDoc}`;

/**
 * __usePrintTemplateCreateMutation__
 *
 * To run a mutation, you first call `usePrintTemplateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateCreateMutation, { data, loading, error }] = usePrintTemplateCreateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      name: // value for 'name'
 *      spec: // value for 'spec'
 *      basedOnBuiltinId: // value for 'basedOnBuiltinId'
 *      duplicateOfTemplateId: // value for 'duplicateOfTemplateId'
 *   },
 * });
 */
export function usePrintTemplateCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateCreateMutation, PrintTemplateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateCreateMutation, PrintTemplateCreateMutationVariables>(PrintTemplateCreateDocument, options);
      }
export type PrintTemplateCreateMutationHookResult = ReturnType<typeof usePrintTemplateCreateMutation>;
export const PrintTemplateUpdateDetailsDocument = gql`
    mutation printTemplateUpdateDetails($organisationId: ID!, $templateId: ID!, $name: String!, $description: String) {
  printTemplateUpdateDetails(
    organisationId: $organisationId
    templateId: $templateId
    name: $name
    description: $description
  ) {
    ...PrintTemplateFields
  }
}
    ${PrintTemplateFieldsFragmentDoc}`;

/**
 * __usePrintTemplateUpdateDetailsMutation__
 *
 * To run a mutation, you first call `usePrintTemplateUpdateDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateUpdateDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateUpdateDetailsMutation, { data, loading, error }] = usePrintTemplateUpdateDetailsMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *   },
 * });
 */
export function usePrintTemplateUpdateDetailsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateUpdateDetailsMutation, PrintTemplateUpdateDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateUpdateDetailsMutation, PrintTemplateUpdateDetailsMutationVariables>(PrintTemplateUpdateDetailsDocument, options);
      }
export type PrintTemplateUpdateDetailsMutationHookResult = ReturnType<typeof usePrintTemplateUpdateDetailsMutation>;
export const PrintTemplateSaveDraftDocument = gql`
    mutation printTemplateSaveDraft($organisationId: ID!, $templateId: ID!, $spec: JSON!) {
  printTemplateSaveDraft(
    organisationId: $organisationId
    templateId: $templateId
    spec: $spec
  ) {
    ...PrintTemplateFields
  }
}
    ${PrintTemplateFieldsFragmentDoc}`;

/**
 * __usePrintTemplateSaveDraftMutation__
 *
 * To run a mutation, you first call `usePrintTemplateSaveDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateSaveDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateSaveDraftMutation, { data, loading, error }] = usePrintTemplateSaveDraftMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *      spec: // value for 'spec'
 *   },
 * });
 */
export function usePrintTemplateSaveDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateSaveDraftMutation, PrintTemplateSaveDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateSaveDraftMutation, PrintTemplateSaveDraftMutationVariables>(PrintTemplateSaveDraftDocument, options);
      }
export type PrintTemplateSaveDraftMutationHookResult = ReturnType<typeof usePrintTemplateSaveDraftMutation>;
export const PrintTemplatePublishDocument = gql`
    mutation printTemplatePublish($organisationId: ID!, $templateId: ID!) {
  printTemplatePublish(organisationId: $organisationId, templateId: $templateId) {
    ...PrintTemplateFields
  }
}
    ${PrintTemplateFieldsFragmentDoc}`;

/**
 * __usePrintTemplatePublishMutation__
 *
 * To run a mutation, you first call `usePrintTemplatePublishMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplatePublishMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplatePublishMutation, { data, loading, error }] = usePrintTemplatePublishMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePrintTemplatePublishMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplatePublishMutation, PrintTemplatePublishMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplatePublishMutation, PrintTemplatePublishMutationVariables>(PrintTemplatePublishDocument, options);
      }
export type PrintTemplatePublishMutationHookResult = ReturnType<typeof usePrintTemplatePublishMutation>;
export const PrintTemplateDiscardDraftDocument = gql`
    mutation printTemplateDiscardDraft($organisationId: ID!, $templateId: ID!) {
  printTemplateDiscardDraft(
    organisationId: $organisationId
    templateId: $templateId
  ) {
    ...PrintTemplateFields
  }
}
    ${PrintTemplateFieldsFragmentDoc}`;

/**
 * __usePrintTemplateDiscardDraftMutation__
 *
 * To run a mutation, you first call `usePrintTemplateDiscardDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateDiscardDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateDiscardDraftMutation, { data, loading, error }] = usePrintTemplateDiscardDraftMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePrintTemplateDiscardDraftMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateDiscardDraftMutation, PrintTemplateDiscardDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateDiscardDraftMutation, PrintTemplateDiscardDraftMutationVariables>(PrintTemplateDiscardDraftDocument, options);
      }
export type PrintTemplateDiscardDraftMutationHookResult = ReturnType<typeof usePrintTemplateDiscardDraftMutation>;
export const PrintTemplateRestoreVersionDocument = gql`
    mutation printTemplateRestoreVersion($organisationId: ID!, $templateId: ID!, $version: Int!) {
  printTemplateRestoreVersion(
    organisationId: $organisationId
    templateId: $templateId
    version: $version
  ) {
    ...PrintTemplateFields
  }
}
    ${PrintTemplateFieldsFragmentDoc}`;

/**
 * __usePrintTemplateRestoreVersionMutation__
 *
 * To run a mutation, you first call `usePrintTemplateRestoreVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateRestoreVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateRestoreVersionMutation, { data, loading, error }] = usePrintTemplateRestoreVersionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function usePrintTemplateRestoreVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateRestoreVersionMutation, PrintTemplateRestoreVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateRestoreVersionMutation, PrintTemplateRestoreVersionMutationVariables>(PrintTemplateRestoreVersionDocument, options);
      }
export type PrintTemplateRestoreVersionMutationHookResult = ReturnType<typeof usePrintTemplateRestoreVersionMutation>;
export const PrintTemplateDeleteVersionDocument = gql`
    mutation printTemplateDeleteVersion($organisationId: ID!, $templateId: ID!, $version: Int!) {
  printTemplateDeleteVersion(
    organisationId: $organisationId
    templateId: $templateId
    version: $version
  )
}
    `;

/**
 * __usePrintTemplateDeleteVersionMutation__
 *
 * To run a mutation, you first call `usePrintTemplateDeleteVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateDeleteVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateDeleteVersionMutation, { data, loading, error }] = usePrintTemplateDeleteVersionMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function usePrintTemplateDeleteVersionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateDeleteVersionMutation, PrintTemplateDeleteVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateDeleteVersionMutation, PrintTemplateDeleteVersionMutationVariables>(PrintTemplateDeleteVersionDocument, options);
      }
export type PrintTemplateDeleteVersionMutationHookResult = ReturnType<typeof usePrintTemplateDeleteVersionMutation>;
export const PrintTemplateSetArchivedDocument = gql`
    mutation printTemplateSetArchived($organisationId: ID!, $templateId: ID!, $archived: Boolean!) {
  printTemplateSetArchived(
    organisationId: $organisationId
    templateId: $templateId
    archived: $archived
  ) {
    ...PrintTemplateFields
  }
}
    ${PrintTemplateFieldsFragmentDoc}`;

/**
 * __usePrintTemplateSetArchivedMutation__
 *
 * To run a mutation, you first call `usePrintTemplateSetArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateSetArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateSetArchivedMutation, { data, loading, error }] = usePrintTemplateSetArchivedMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *      archived: // value for 'archived'
 *   },
 * });
 */
export function usePrintTemplateSetArchivedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateSetArchivedMutation, PrintTemplateSetArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateSetArchivedMutation, PrintTemplateSetArchivedMutationVariables>(PrintTemplateSetArchivedDocument, options);
      }
export type PrintTemplateSetArchivedMutationHookResult = ReturnType<typeof usePrintTemplateSetArchivedMutation>;
export const PrintTemplateDeleteDocument = gql`
    mutation printTemplateDelete($organisationId: ID!, $templateId: ID!) {
  printTemplateDelete(organisationId: $organisationId, templateId: $templateId)
}
    `;

/**
 * __usePrintTemplateDeleteMutation__
 *
 * To run a mutation, you first call `usePrintTemplateDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateDeleteMutation, { data, loading, error }] = usePrintTemplateDeleteMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function usePrintTemplateDeleteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateDeleteMutation, PrintTemplateDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateDeleteMutation, PrintTemplateDeleteMutationVariables>(PrintTemplateDeleteDocument, options);
      }
export type PrintTemplateDeleteMutationHookResult = ReturnType<typeof usePrintTemplateDeleteMutation>;
export const PrintTemplateAttachAssetDocument = gql`
    mutation printTemplateAttachAsset($organisationId: ID!, $templateId: ID!, $kind: PrintTemplateAssetKind!, $blobName: String!, $originalName: String!) {
  printTemplateAttachAsset(
    organisationId: $organisationId
    templateId: $templateId
    kind: $kind
    blobName: $blobName
    originalName: $originalName
  ) {
    id
    kind
    originalName
    contentType
    size
    url
    createdAt
  }
}
    `;

/**
 * __usePrintTemplateAttachAssetMutation__
 *
 * To run a mutation, you first call `usePrintTemplateAttachAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateAttachAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateAttachAssetMutation, { data, loading, error }] = usePrintTemplateAttachAssetMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      templateId: // value for 'templateId'
 *      kind: // value for 'kind'
 *      blobName: // value for 'blobName'
 *      originalName: // value for 'originalName'
 *   },
 * });
 */
export function usePrintTemplateAttachAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateAttachAssetMutation, PrintTemplateAttachAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateAttachAssetMutation, PrintTemplateAttachAssetMutationVariables>(PrintTemplateAttachAssetDocument, options);
      }
export type PrintTemplateAttachAssetMutationHookResult = ReturnType<typeof usePrintTemplateAttachAssetMutation>;
export const OrganisationTemplateLibraryUpdateConfigDocument = gql`
    mutation organisationTemplateLibraryUpdateConfig($organisationId: ID!, $config: TemplateLibraryConfigInput!) {
  organisationTemplateLibraryUpdateConfig(
    organisationId: $organisationId
    config: $config
  ) {
    ...TemplateLibraryConfigFields
  }
}
    ${TemplateLibraryConfigFieldsFragmentDoc}`;

/**
 * __useOrganisationTemplateLibraryUpdateConfigMutation__
 *
 * To run a mutation, you first call `useOrganisationTemplateLibraryUpdateConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTemplateLibraryUpdateConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTemplateLibraryUpdateConfigMutation, { data, loading, error }] = useOrganisationTemplateLibraryUpdateConfigMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useOrganisationTemplateLibraryUpdateConfigMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationTemplateLibraryUpdateConfigMutation, OrganisationTemplateLibraryUpdateConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationTemplateLibraryUpdateConfigMutation, OrganisationTemplateLibraryUpdateConfigMutationVariables>(OrganisationTemplateLibraryUpdateConfigDocument, options);
      }
export type OrganisationTemplateLibraryUpdateConfigMutationHookResult = ReturnType<typeof useOrganisationTemplateLibraryUpdateConfigMutation>;
export const OrganisationTemplateLibrarySetLogoDocument = gql`
    mutation organisationTemplateLibrarySetLogo($organisationId: ID!, $blobName: String, $originalName: String) {
  organisationTemplateLibrarySetLogo(
    organisationId: $organisationId
    blobName: $blobName
    originalName: $originalName
  ) {
    ...TemplateLibraryConfigFields
  }
}
    ${TemplateLibraryConfigFieldsFragmentDoc}`;

/**
 * __useOrganisationTemplateLibrarySetLogoMutation__
 *
 * To run a mutation, you first call `useOrganisationTemplateLibrarySetLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationTemplateLibrarySetLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationTemplateLibrarySetLogoMutation, { data, loading, error }] = useOrganisationTemplateLibrarySetLogoMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      blobName: // value for 'blobName'
 *      originalName: // value for 'originalName'
 *   },
 * });
 */
export function useOrganisationTemplateLibrarySetLogoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationTemplateLibrarySetLogoMutation, OrganisationTemplateLibrarySetLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationTemplateLibrarySetLogoMutation, OrganisationTemplateLibrarySetLogoMutationVariables>(OrganisationTemplateLibrarySetLogoDocument, options);
      }
export type OrganisationTemplateLibrarySetLogoMutationHookResult = ReturnType<typeof useOrganisationTemplateLibrarySetLogoMutation>;
export const OrganisationPrintFontAttachDocument = gql`
    mutation organisationPrintFontAttach($organisationId: ID!, $blobName: String!, $originalName: String!, $family: String!, $weight: PrintFontWeight!, $italic: Boolean!) {
  organisationPrintFontAttach(
    organisationId: $organisationId
    blobName: $blobName
    originalName: $originalName
    family: $family
    weight: $weight
    italic: $italic
  ) {
    ...TemplateLibraryConfigFields
  }
}
    ${TemplateLibraryConfigFieldsFragmentDoc}`;

/**
 * __useOrganisationPrintFontAttachMutation__
 *
 * To run a mutation, you first call `useOrganisationPrintFontAttachMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPrintFontAttachMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationPrintFontAttachMutation, { data, loading, error }] = useOrganisationPrintFontAttachMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      blobName: // value for 'blobName'
 *      originalName: // value for 'originalName'
 *      family: // value for 'family'
 *      weight: // value for 'weight'
 *      italic: // value for 'italic'
 *   },
 * });
 */
export function useOrganisationPrintFontAttachMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationPrintFontAttachMutation, OrganisationPrintFontAttachMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationPrintFontAttachMutation, OrganisationPrintFontAttachMutationVariables>(OrganisationPrintFontAttachDocument, options);
      }
export type OrganisationPrintFontAttachMutationHookResult = ReturnType<typeof useOrganisationPrintFontAttachMutation>;
export const OrganisationPrintFontRemoveDocument = gql`
    mutation organisationPrintFontRemove($organisationId: ID!, $fontId: ID!) {
  organisationPrintFontRemove(organisationId: $organisationId, fontId: $fontId) {
    ...TemplateLibraryConfigFields
  }
}
    ${TemplateLibraryConfigFieldsFragmentDoc}`;

/**
 * __useOrganisationPrintFontRemoveMutation__
 *
 * To run a mutation, you first call `useOrganisationPrintFontRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOrganisationPrintFontRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [organisationPrintFontRemoveMutation, { data, loading, error }] = useOrganisationPrintFontRemoveMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      fontId: // value for 'fontId'
 *   },
 * });
 */
export function useOrganisationPrintFontRemoveMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<OrganisationPrintFontRemoveMutation, OrganisationPrintFontRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<OrganisationPrintFontRemoveMutation, OrganisationPrintFontRemoveMutationVariables>(OrganisationPrintFontRemoveDocument, options);
      }
export type OrganisationPrintFontRemoveMutationHookResult = ReturnType<typeof useOrganisationPrintFontRemoveMutation>;
export const PrintTemplateGenerateDocument = gql`
    mutation printTemplateGenerate($organisationId: ID!, $prompt: String!, $spec: JSON, $image: String, $progressChannel: String) {
  printTemplateGenerate(
    organisationId: $organisationId
    prompt: $prompt
    spec: $spec
    image: $image
    progressChannel: $progressChannel
  ) {
    spec
    summary
    name
  }
}
    `;

/**
 * __usePrintTemplateGenerateMutation__
 *
 * To run a mutation, you first call `usePrintTemplateGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintTemplateGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printTemplateGenerateMutation, { data, loading, error }] = usePrintTemplateGenerateMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      prompt: // value for 'prompt'
 *      spec: // value for 'spec'
 *      image: // value for 'image'
 *      progressChannel: // value for 'progressChannel'
 *   },
 * });
 */
export function usePrintTemplateGenerateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintTemplateGenerateMutation, PrintTemplateGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintTemplateGenerateMutation, PrintTemplateGenerateMutationVariables>(PrintTemplateGenerateDocument, options);
      }
export type PrintTemplateGenerateMutationHookResult = ReturnType<typeof usePrintTemplateGenerateMutation>;
export const UsersDocument = gql`
    query users($organisationId: ID!) {
  usersByOrganisationId(organisationId: $organisationId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUsersQuery__
 *
 * To run a query within a React component, call `useUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsersQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useUsersQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UsersQuery, UsersQueryVariables> & ({ variables: UsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
      }
export function useUsersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
// @ts-ignore
export function useUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersQuery, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UsersQuery | undefined, UsersQueryVariables>;
export function useUsersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UsersQuery, UsersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UsersQuery, UsersQueryVariables>(UsersDocument, options);
        }
export type UsersQueryHookResult = ReturnType<typeof useUsersQuery>;
export type UsersLazyQueryHookResult = ReturnType<typeof useUsersLazyQuery>;
export type UsersSuspenseQueryHookResult = ReturnType<typeof useUsersSuspenseQuery>;
export const CurrentUserDocument = gql`
    query currentUser {
  currentUser {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useCurrentUserQuery__
 *
 * To run a query within a React component, call `useCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
      }
export function useCurrentUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
// @ts-ignore
export function useCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentUserQuery, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<CurrentUserQuery | undefined, CurrentUserQueryVariables>;
export function useCurrentUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CurrentUserQuery, CurrentUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CurrentUserQuery, CurrentUserQueryVariables>(CurrentUserDocument, options);
        }
export type CurrentUserQueryHookResult = ReturnType<typeof useCurrentUserQuery>;
export type CurrentUserLazyQueryHookResult = ReturnType<typeof useCurrentUserLazyQuery>;
export type CurrentUserSuspenseQueryHookResult = ReturnType<typeof useCurrentUserSuspenseQuery>;
export const UserAddToOrganisationDocument = gql`
    mutation userAddToOrganisation($organisationId: ID!, $email: String!, $role: UserRole!) {
  userAddToOrganisation(
    organisationId: $organisationId
    email: $email
    role: $role
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserAddToOrganisationMutation__
 *
 * To run a mutation, you first call `useUserAddToOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAddToOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAddToOrganisationMutation, { data, loading, error }] = useUserAddToOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserAddToOrganisationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserAddToOrganisationMutation, UserAddToOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserAddToOrganisationMutation, UserAddToOrganisationMutationVariables>(UserAddToOrganisationDocument, options);
      }
export type UserAddToOrganisationMutationHookResult = ReturnType<typeof useUserAddToOrganisationMutation>;
export const UserResendInvitationDocument = gql`
    mutation userResendInvitation($organisationId: ID!, $userId: ID!) {
  userResendInvitation(organisationId: $organisationId, userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserResendInvitationMutation__
 *
 * To run a mutation, you first call `useUserResendInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserResendInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userResendInvitationMutation, { data, loading, error }] = useUserResendInvitationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserResendInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserResendInvitationMutation, UserResendInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserResendInvitationMutation, UserResendInvitationMutationVariables>(UserResendInvitationDocument, options);
      }
export type UserResendInvitationMutationHookResult = ReturnType<typeof useUserResendInvitationMutation>;
export const UserDeleteFromOrganisationDocument = gql`
    mutation userDeleteFromOrganisation($organisationId: ID!, $userId: ID!) {
  userDeleteFromOrganisation(organisationId: $organisationId, userId: $userId)
}
    `;

/**
 * __useUserDeleteFromOrganisationMutation__
 *
 * To run a mutation, you first call `useUserDeleteFromOrganisationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDeleteFromOrganisationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDeleteFromOrganisationMutation, { data, loading, error }] = useUserDeleteFromOrganisationMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDeleteFromOrganisationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserDeleteFromOrganisationMutation, UserDeleteFromOrganisationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserDeleteFromOrganisationMutation, UserDeleteFromOrganisationMutationVariables>(UserDeleteFromOrganisationDocument, options);
      }
export type UserDeleteFromOrganisationMutationHookResult = ReturnType<typeof useUserDeleteFromOrganisationMutation>;
export const UserChangeRoleDocument = gql`
    mutation userChangeRole($organisationId: ID!, $userId: ID!, $role: UserRole!) {
  userChangeRole(organisationId: $organisationId, userId: $userId, role: $role) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserChangeRoleMutation__
 *
 * To run a mutation, you first call `useUserChangeRoleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeRoleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeRoleMutation, { data, loading, error }] = useUserChangeRoleMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUserChangeRoleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserChangeRoleMutation, UserChangeRoleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserChangeRoleMutation, UserChangeRoleMutationVariables>(UserChangeRoleDocument, options);
      }
export type UserChangeRoleMutationHookResult = ReturnType<typeof useUserChangeRoleMutation>;
export const UserDisableDocument = gql`
    mutation userDisable($organisationId: ID!, $userId: ID!) {
  userDisable(organisationId: $organisationId, userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserDisableMutation__
 *
 * To run a mutation, you first call `useUserDisableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserDisableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userDisableMutation, { data, loading, error }] = useUserDisableMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserDisableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserDisableMutation, UserDisableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserDisableMutation, UserDisableMutationVariables>(UserDisableDocument, options);
      }
export type UserDisableMutationHookResult = ReturnType<typeof useUserDisableMutation>;
export const UserEnableDocument = gql`
    mutation userEnable($organisationId: ID!, $userId: ID!) {
  userEnable(organisationId: $organisationId, userId: $userId) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserEnableMutation__
 *
 * To run a mutation, you first call `useUserEnableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserEnableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userEnableMutation, { data, loading, error }] = useUserEnableMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserEnableMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserEnableMutation, UserEnableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserEnableMutation, UserEnableMutationVariables>(UserEnableDocument, options);
      }
export type UserEnableMutationHookResult = ReturnType<typeof useUserEnableMutation>;
export const UserInviteInfoDocument = gql`
    query userInviteInfo($token: String!) {
  userInviteInfo(token: $token) {
    email
    organisationName
    isNewUser
    inviteId
  }
}
    `;

/**
 * __useUserInviteInfoQuery__
 *
 * To run a query within a React component, call `useUserInviteInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInviteInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInviteInfoQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useUserInviteInfoQuery(baseOptions: ApolloReactHooks.QueryHookOptions<UserInviteInfoQuery, UserInviteInfoQueryVariables> & ({ variables: UserInviteInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<UserInviteInfoQuery, UserInviteInfoQueryVariables>(UserInviteInfoDocument, options);
      }
export function useUserInviteInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<UserInviteInfoQuery, UserInviteInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<UserInviteInfoQuery, UserInviteInfoQueryVariables>(UserInviteInfoDocument, options);
        }
// @ts-ignore
export function useUserInviteInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<UserInviteInfoQuery, UserInviteInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserInviteInfoQuery, UserInviteInfoQueryVariables>;
export function useUserInviteInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserInviteInfoQuery, UserInviteInfoQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<UserInviteInfoQuery | undefined, UserInviteInfoQueryVariables>;
export function useUserInviteInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<UserInviteInfoQuery, UserInviteInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<UserInviteInfoQuery, UserInviteInfoQueryVariables>(UserInviteInfoDocument, options);
        }
export type UserInviteInfoQueryHookResult = ReturnType<typeof useUserInviteInfoQuery>;
export type UserInviteInfoLazyQueryHookResult = ReturnType<typeof useUserInviteInfoLazyQuery>;
export type UserInviteInfoSuspenseQueryHookResult = ReturnType<typeof useUserInviteInfoSuspenseQuery>;
export const UserAcceptInvitationDocument = gql`
    mutation userAcceptInvitation($inviteId: String!, $userEmail: String!, $user: InputUser) {
  userAcceptInvitation(inviteId: $inviteId, userEmail: $userEmail, user: $user)
}
    `;

/**
 * __useUserAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useUserAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userAcceptInvitationMutation, { data, loading, error }] = useUserAcceptInvitationMutation({
 *   variables: {
 *      inviteId: // value for 'inviteId'
 *      userEmail: // value for 'userEmail'
 *      user: // value for 'user'
 *   },
 * });
 */
export function useUserAcceptInvitationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserAcceptInvitationMutation, UserAcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserAcceptInvitationMutation, UserAcceptInvitationMutationVariables>(UserAcceptInvitationDocument, options);
      }
export type UserAcceptInvitationMutationHookResult = ReturnType<typeof useUserAcceptInvitationMutation>;
export const UserUpdateDocument = gql`
    mutation userUpdate($firstName: String!, $lastName: String!, $email: String!) {
  userUpdate(firstName: $firstName, lastName: $lastName, email: $email) {
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useUserUpdateMutation__
 *
 * To run a mutation, you first call `useUserUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateMutation, { data, loading, error }] = useUserUpdateMutation({
 *   variables: {
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useUserUpdateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserUpdateMutation, UserUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserUpdateMutation, UserUpdateMutationVariables>(UserUpdateDocument, options);
      }
export type UserUpdateMutationHookResult = ReturnType<typeof useUserUpdateMutation>;
export const UserUpdateFavoritesDocument = gql`
    mutation userUpdateFavorites($projectId: ID!, $inFavorites: Boolean!) {
  userUpdateFavorites(projectId: $projectId, inFavorites: $inFavorites) {
    id
    favoriteProjectIds
  }
}
    `;

/**
 * __useUserUpdateFavoritesMutation__
 *
 * To run a mutation, you first call `useUserUpdateFavoritesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserUpdateFavoritesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userUpdateFavoritesMutation, { data, loading, error }] = useUserUpdateFavoritesMutation({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      inFavorites: // value for 'inFavorites'
 *   },
 * });
 */
export function useUserUpdateFavoritesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserUpdateFavoritesMutation, UserUpdateFavoritesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserUpdateFavoritesMutation, UserUpdateFavoritesMutationVariables>(UserUpdateFavoritesDocument, options);
      }
export type UserUpdateFavoritesMutationHookResult = ReturnType<typeof useUserUpdateFavoritesMutation>;
export const UserChangeUnitsDocument = gql`
    mutation userChangeUnits($inUnit: MeasurementUnits!) {
  userChangeUnits(inUnit: $inUnit) {
    id
    measurementUnit
  }
}
    `;

/**
 * __useUserChangeUnitsMutation__
 *
 * To run a mutation, you first call `useUserChangeUnitsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeUnitsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeUnitsMutation, { data, loading, error }] = useUserChangeUnitsMutation({
 *   variables: {
 *      inUnit: // value for 'inUnit'
 *   },
 * });
 */
export function useUserChangeUnitsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserChangeUnitsMutation, UserChangeUnitsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserChangeUnitsMutation, UserChangeUnitsMutationVariables>(UserChangeUnitsDocument, options);
      }
export type UserChangeUnitsMutationHookResult = ReturnType<typeof useUserChangeUnitsMutation>;
export const UserChangeDateFormatDocument = gql`
    mutation userChangeDateFormat($inFormat: DateFormats!) {
  userChangeDateFormat(inFormat: $inFormat) {
    id
    dateFormat
  }
}
    `;

/**
 * __useUserChangeDateFormatMutation__
 *
 * To run a mutation, you first call `useUserChangeDateFormatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeDateFormatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeDateFormatMutation, { data, loading, error }] = useUserChangeDateFormatMutation({
 *   variables: {
 *      inFormat: // value for 'inFormat'
 *   },
 * });
 */
export function useUserChangeDateFormatMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserChangeDateFormatMutation, UserChangeDateFormatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserChangeDateFormatMutation, UserChangeDateFormatMutationVariables>(UserChangeDateFormatDocument, options);
      }
export type UserChangeDateFormatMutationHookResult = ReturnType<typeof useUserChangeDateFormatMutation>;
export const UserChangeLanguageDocument = gql`
    mutation userChangeLanguage($language: Language!) {
  userChangeLanguage(language: $language) {
    id
    language
  }
}
    `;

/**
 * __useUserChangeLanguageMutation__
 *
 * To run a mutation, you first call `useUserChangeLanguageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserChangeLanguageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userChangeLanguageMutation, { data, loading, error }] = useUserChangeLanguageMutation({
 *   variables: {
 *      language: // value for 'language'
 *   },
 * });
 */
export function useUserChangeLanguageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserChangeLanguageMutation, UserChangeLanguageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserChangeLanguageMutation, UserChangeLanguageMutationVariables>(UserChangeLanguageDocument, options);
      }
export type UserChangeLanguageMutationHookResult = ReturnType<typeof useUserChangeLanguageMutation>;
export const UserSetTemplateLibraryAccessDocument = gql`
    mutation userSetTemplateLibraryAccess($organisationId: ID!, $userId: ID!, $enabled: Boolean!) {
  userSetTemplateLibraryAccess(
    organisationId: $organisationId
    userId: $userId
    enabled: $enabled
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserSetTemplateLibraryAccessMutation__
 *
 * To run a mutation, you first call `useUserSetTemplateLibraryAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSetTemplateLibraryAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSetTemplateLibraryAccessMutation, { data, loading, error }] = useUserSetTemplateLibraryAccessMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUserSetTemplateLibraryAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserSetTemplateLibraryAccessMutation, UserSetTemplateLibraryAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserSetTemplateLibraryAccessMutation, UserSetTemplateLibraryAccessMutationVariables>(UserSetTemplateLibraryAccessDocument, options);
      }
export type UserSetTemplateLibraryAccessMutationHookResult = ReturnType<typeof useUserSetTemplateLibraryAccessMutation>;
export const UserSetObjectLibraryAccessDocument = gql`
    mutation userSetObjectLibraryAccess($organisationId: ID!, $userId: ID!, $enabled: Boolean!) {
  userSetObjectLibraryAccess(
    organisationId: $organisationId
    userId: $userId
    enabled: $enabled
  ) {
    ...User
  }
}
    ${UserFragmentDoc}`;

/**
 * __useUserSetObjectLibraryAccessMutation__
 *
 * To run a mutation, you first call `useUserSetObjectLibraryAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserSetObjectLibraryAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userSetObjectLibraryAccessMutation, { data, loading, error }] = useUserSetObjectLibraryAccessMutation({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *      userId: // value for 'userId'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useUserSetObjectLibraryAccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UserSetObjectLibraryAccessMutation, UserSetObjectLibraryAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UserSetObjectLibraryAccessMutation, UserSetObjectLibraryAccessMutationVariables>(UserSetObjectLibraryAccessDocument, options);
      }
export type UserSetObjectLibraryAccessMutationHookResult = ReturnType<typeof useUserSetObjectLibraryAccessMutation>;